import { jsx as f, jsxs as U, Fragment as He } from "react/jsx-runtime";
import * as Y from "react";
import re, { useState as ee, useEffect as de, useRef as le, useMemo as St, useLayoutEffect as yr, useReducer as Ro, createRef as Do, useCallback as Po, useContext as wo } from "react";
import Lo from "react-dom";
function $i(n) {
  var t, r, a = "";
  if (typeof n == "string" || typeof n == "number")
    a += n;
  else if (typeof n == "object")
    if (Array.isArray(n))
      for (t = 0; t < n.length; t++)
        n[t] && (r = $i(n[t])) && (a && (a += " "), a += r);
    else
      for (t in n)
        n[t] && (a && (a += " "), a += t);
  return a;
}
function C() {
  for (var n, t, r = 0, a = ""; r < arguments.length; )
    (n = arguments[r++]) && (t = $i(n)) && (a && (a += " "), a += t);
  return a;
}
const Be = {
  COMPONENT: "js-fmc-accordion",
  PANEL: "fmc-accordion__panel",
  BUTTON: "fmc-accordion__button",
  BUTTON_TITLE: "fmc-accordion__button-icon",
  BUTTON_TITLE_TEXT: "fmc-accordion__button-text",
  BUTTON_DESCRIPTION_TEXT: "fmc-accordion__button-description-text",
  BUTTON_DESCRIPTION: "fmc-accordion__button__description",
  BUTTON_DESCRIPTION_LABEL: "fmc-accordion__button__description_label",
  BUTTON_DESCRIPTION_LABEL_FEEDBACK: "fmc-accordion__button__description_label_feedback",
  BUTTON_LABEL_TEXT_SUCCESS: "fmc-accordion__button-label-text-success",
  BUTTON_LABEL_TEXT_ERROR: "fmc-accordion__button-label-text-error",
  BUTTON_TITLE_WRAPPER: "fmc-accordion__button-title-wrapper",
  FEEDBACK: "fmc-accordion-feedback",
  BODY: "fmc-accordion__body",
  CONTENT: "fmc-accordion__content",
  ACTIVE: "fmc-accordion--active",
  EXPANDED: "fmc-accordion--expanded"
}, Ur = {
  DARK: "dark",
  LIGHT: "light"
}, Hr = {
  SUCCESS: "success",
  ERROR: "error"
}, xo = "ACCORDION_DATA_TEST_ID", m1 = ({
  background: n,
  foreground: t,
  dataTestId: r = xo,
  children: a,
  className: i
}) => /* @__PURE__ */ f(
  "div",
  {
    "data-testid": `${r}_MAIN`,
    className: C(
      Be.COMPONENT,
      "fmc-accordion",
      n === Ur.DARK ? "fds-color__bg--dark" : "fds-color__bg--light",
      t === Ur.LIGHT ? "fmc-accordion--light" : "fmc-accordion--dark",
      i
    ),
    children: a
  }
), Wr = {
  BODY: "fmc-accordion__body",
  CONTENT: "fmc-accordion__content"
};
function Vr() {
  const { innerWidth: n, innerHeight: t } = window;
  return {
    width: n,
    height: t
  };
}
function Er() {
  const [n, t] = ee(Vr());
  return de(() => {
    function r() {
      t(Vr());
    }
    return window.addEventListener("resize", r), () => window.removeEventListener("resize", r);
  }, []), n;
}
const Fo = "COLLAPSE_DATA_TEST_ID", Mo = ({
  index: n = 0,
  children: t,
  dataTestId: r = Fo,
  isOpen: a,
  className: i
}) => {
  const [o, s] = ee(0), l = le(null), d = le(null), { width: c } = Er();
  de(() => {
    const p = l?.current?.getBoundingClientRect()?.height;
    p !== void 0 && s(p);
  }, [o, a, c]);
  const u = {
    height: `${a ? o : 0}px`
  }, h = {
    visibility: `${a ? "visible" : "hidden"}`
  };
  return /* @__PURE__ */ f(
    "div",
    {
      style: u,
      className: C(Wr.BODY, i),
      ref: d,
      "data-testid": `${r}_BODY`,
      children: /* @__PURE__ */ f(
        "div",
        {
          className: Wr.CONTENT,
          "aria-labelledby": "panel-button",
          id: `panel-${n}-content`,
          "aria-hidden": !a,
          style: h,
          ref: l,
          "data-testid": `${r}_CONTENT`,
          children: t
        }
      )
    }
  );
}, ko = "ICON_DATA_TEST_ID", Zt = ({
  name: n,
  disabled: t = !1,
  size: r = 16,
  onClick: a,
  className: i,
  dataTestId: o = ko,
  ...s
}) => /* @__PURE__ */ f(
  a ? "button" : "span",
  {
    className: C(
      `fds-font fds-icon--${r} fds-font--ford-icons__${n}`,
      t && "fds-font--color__disabled cxc-icon--disabled",
      i
    ),
    disabled: t,
    onClick: a,
    "data-testid": o,
    ...s
  }
), Bo = "ACCORDION_PANEL_DATA_TEST_ID", $1 = ({
  index: n,
  titleText: t,
  descriptionText: r,
  labelText: a,
  feedbackText: i,
  icon: o,
  children: s,
  className: l,
  initiallyOpen: d = !1,
  dataTestId: c = Bo,
  onClick: u
}) => {
  const h = le(null), [p, m] = ee(d), _ = p, T = le(null), y = (b) => {
    u && u(b, !p), m(!p);
  }, v = /* @__PURE__ */ f(Zt, { name: _ ? "chevron-up" : "chevron-down" }), g = () => a === Hr.SUCCESS ? /* @__PURE__ */ U(
    "span",
    {
      className: Be.BUTTON_LABEL_TEXT_SUCCESS,
      "data-testid": `${c}_${n}_LABEL_SUCCESS`,
      children: [
        "Completed",
        /* @__PURE__ */ f("span", { className: "fds-font fds-icon--16 fds-font--ford-icons__check-filled" })
      ]
    }
  ) : a === Hr.ERROR ? /* @__PURE__ */ U(
    "span",
    {
      className: Be.BUTTON_LABEL_TEXT_ERROR,
      "data-testid": `${c}_${n}_LABEL_ERROR`,
      children: [
        "Required",
        " ",
        /* @__PURE__ */ f("span", { className: "fds-font fds-icon--16 fds-font--ford-icons__warning-filled" })
      ]
    }
  ) : null, S = () => /* @__PURE__ */ U("span", { className: Be.BUTTON_TITLE_WRAPPER, children: [
    /* @__PURE__ */ f(g, {}),
    /* @__PURE__ */ f(
      "span",
      {
        className: Be.BUTTON_TITLE_TEXT,
        "data-testid": `${c}_${n}_TITLE`,
        children: t
      }
    ),
    r && /* @__PURE__ */ f(
      "span",
      {
        className: Be.BUTTON_DESCRIPTION_TEXT,
        "data-testid": `${c}_${n}_DESCRIPTION`,
        children: r
      }
    ),
    i && /* @__PURE__ */ f("span", { className: "fmc-accordion-feedback-mobile", children: i })
  ] });
  return /* @__PURE__ */ U(
    "div",
    {
      className: C(Be.PANEL, l),
      "data-testid": `${c}_${n}_PANEL`,
      ref: h,
      children: [
        /* @__PURE__ */ U(
          "button",
          {
            type: "button",
            onClick: y,
            className: C(
              Be.BUTTON,
              (r || a || i) && Be.BUTTON_DESCRIPTION,
              r && a && !i && Be.BUTTON_DESCRIPTION_LABEL,
              r && a && i && Be.BUTTON_DESCRIPTION_LABEL_FEEDBACK
            ),
            id: `panel-${n}-button`,
            "aria-controls": `panel-${n}-content`,
            "aria-expanded": _,
            "aria-hidden": !_,
            ref: T,
            "data-testid": `${c}_${n}_BUTTON`,
            children: [
              o ? /* @__PURE__ */ U("span", { className: Be.BUTTON_TITLE, children: [
                /* @__PURE__ */ f(
                  "span",
                  {
                    className: o,
                    "data-testid": `${c}_${n}_ICON`
                  }
                ),
                /* @__PURE__ */ f(S, {})
              ] }) : /* @__PURE__ */ f(S, {}),
              i ? /* @__PURE__ */ U("span", { className: Be.FEEDBACK, children: [
                /* @__PURE__ */ f(
                  "span",
                  {
                    className: "feedback-text",
                    "data-testid": `${c}_${n}_FEEDBACK`,
                    children: i
                  }
                ),
                v
              ] }) : v
            ]
          }
        ),
        /* @__PURE__ */ f(
          Mo,
          {
            index: n,
            dataTestId: `ACCORDION_PANEL_DATA_TEST_ID_${n}`,
            isOpen: _,
            children: s
          }
        )
      ]
    }
  );
}, Fe = {
  ACTIVITY_INDICATOR: "fds-activity-indicator",
  CIRCULAR_INDICATOR: "cxc-activity-indicator--circular",
  PROGRESS_WRAPPER: "cxc-activity-indicator__progress-wrapper",
  PROGRESS_LINE: "cxc-activity-indicator__progress-line",
  LINE_DETERMINATE: "cxc-activity-indicator__progress-line_line--determinate",
  DISPLAY_PERCENT: "cxc-activity-indicator__display-percent",
  PROGRESS_INDICATOR_BACKGROUND_COLOR_LIGHT: "fds-color__bg--light",
  PROGRESS_INDICATOR_FLEX: "fds-flex",
  PROGRESS_LINE_SVG: "cxc-activity-indicator__progress-line_svg",
  PROGRESS_LINE_SVG_DETERMINATE: "cxc-activity-indicator__progress-line_svg--determinate",
  CIRCULAR_LINE_ANIMATION_DETERMINATE: "cxc-activity-indicator__animation--circular--determinate",
  FMC_ACTIVITY_CIRCLE: "fmc-activity-circle",
  FMC_ACTIVITY_CIRCLE_PROGRESS: "fmc-activity-circle__progress"
}, _i = 23, Cn = 2 * Math.PI * _i, Uo = 80, Ho = 0.0625, Wo = 3 * Ho, Vo = 1024, ve = {
  UP: 38,
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39,
  TAB: 9,
  ENTER: 13,
  HOME: 36,
  END: 35,
  SPACE: 32,
  ESC: 27
};
function Go(n) {
  return new Promise((t) => {
    setTimeout(t, n);
  });
}
const ze = function() {
  let n = 0;
  const t = (/* @__PURE__ */ new Date()).getTime();
  return function(r) {
    const a = (/* @__PURE__ */ new Date()).getTime() - t, i = Math.floor(Math.random() * 1e3);
    r = r !== void 0 ? String(r) : "";
    const o = (r && "-") + n + "-" + a + "-" + i;
    return n += 1, r + o;
  };
}(), br = (n) => Cn * ((100 - n) / 100), Ko = (n, t) => `@keyframes cxc-activity-indicator__animation--circular--determinate-${t}   {
    0% {
      stroke-dashoffset: ${Cn} ;
    }
    ${n}% {
      stroke-dashoffset: ${br(n)} ;
    }
  }`, jo = (n, t) => `@-webkit-keyframes cxc-activity-indicator__animation--circular--determinate-${t} {
    0% {
      stroke-dashoffset: ${Cn};
    }
    ${n}% {
      stroke-dashoffset: ${br(n)};
    }
  }`, Yo = (n, t) => `
  .cxc-activity-indicator__progress-line_line--determinate-${t} {
    stroke-width: ${Wo}rem;
    stroke-dasharray: ${Cn};
    stroke-dashoffset: ${n};
    animation: cxc-activity-indicator__animation--circular--determinate-${t} linear 1;
    stroke-linecap: round;
    stroke: var(--fds-color--primary);
  }
  `, zo = (n, t) => {
  const r = br(n), a = Ko(n, t), i = jo(n, t), o = Yo(r, t), s = document.styleSheets?.[0]?.cssRules;
  for (let l = 0; l < s?.length; l++)
    //@ts-ignore
    (s[l].name === `${Fe.CIRCULAR_LINE_ANIMATION_DETERMINATE}-${t}` || //@ts-ignore
    s[l].selectorText === `.${Fe.LINE_DETERMINATE}-${t}`) && document.styleSheets[0].deleteRule(l);
  document.styleSheets?.[0]?.insertRule(a, 0), document.styleSheets?.[0]?.insertRule(i, 1), n > 0 && document.styleSheets?.[0]?.insertRule(o, 2);
}, Gr = "CIRCULAR_ACTIVITY_INDICATOR_DATA_TEST_ID", Xo = "SVG_DATA_TEST_ID", qo = "INDETERMINATE_TEST_ID", _1 = ({
  dataTestId: n = Gr,
  className: t,
  value: r,
  diameter: a = Uo,
  loadingMessage: i = "loading"
}) => {
  const o = r !== void 0, s = St(() => ze(), []);
  return Y.useEffect(() => {
    o && zo(r, s);
  }, [o, r, s]), // eslint-disable-next-line react/jsx-no-useless-fragment
  /* @__PURE__ */ f(He, { children: o ? /* @__PURE__ */ U(
    "div",
    {
      className: C(
        Fe.ACTIVITY_INDICATOR,
        Fe.CIRCULAR_INDICATOR,
        Fe.PROGRESS_INDICATOR_BACKGROUND_COLOR_LIGHT,
        Fe.PROGRESS_INDICATOR_FLEX,
        t
      ),
      "data-aria-loading-message": "Please wait while page loads.",
      "data-aria-loading-complete-message": "Loading live region is complete.",
      "data-aria-determinate-percent-message": "loaded",
      role: "progressbar",
      "aria-label": "progressbar",
      "aria-busy": !0,
      "data-testid": n,
      "aria-live": "polite",
      "aria-valuenow": r,
      children: [
        /* @__PURE__ */ f(
          "div",
          {
            className: C(Fe.PROGRESS_WRAPPER),
            style: {
              //@ts-ignore
              "--circle-width": `${a}px`,
              "--circle-height": `${a}px`,
              "--progress-wrapper-width": `${a * 1.08}px`,
              "--progress-wrapper-height": `${a * 1.08}px`
            },
            children: /* @__PURE__ */ f("div", { className: C(Fe.PROGRESS_LINE), children: /* @__PURE__ */ f(
              "svg",
              {
                className: C(
                  Fe.PROGRESS_LINE_SVG,
                  Fe.PROGRESS_LINE_SVG_DETERMINATE
                ),
                viewBox: "25 25 50 50",
                "data-testid": Xo,
                children: /* @__PURE__ */ f(
                  "circle",
                  {
                    className: `${Fe.LINE_DETERMINATE}-${s}`,
                    cx: "50",
                    cy: "50",
                    r: _i,
                    fill: "none",
                    strokeMiterlimit: "10"
                  }
                )
              }
            ) })
          }
        ),
        /* @__PURE__ */ f("div", { className: C(Fe.DISPLAY_PERCENT), children: r })
      ]
    }
  ) : /* @__PURE__ */ f(
    "div",
    {
      "aria-label": i,
      role: "progressbar",
      "aria-live": "polite",
      "aria-busy": !0,
      className: Fe.FMC_ACTIVITY_CIRCLE,
      style: {
        //@ts-ignore
        "--circle-diameter": `${a}px`
      },
      children: /* @__PURE__ */ f(
        "div",
        {
          className: Fe.FMC_ACTIVITY_CIRCLE_PROGRESS,
          "data-testid": n === Gr ? qo : n
        }
      )
    }
  ) });
}, Mt = {
  FMC_ACTIVITY: "fmc-activity",
  FMC_ACTIVITY_PROGRESS: "fmc-activity__progress",
  FMC_ACTIVITY_PROGRESS__PERCENT: "fmc-activity__progress--percent",
  FMC_ACTIVITY__TEXT: "fmc-activity__text",
  FDS_TYPE__CAPTION: "fds-type--caption"
}, Zo = "LINEAR_ACTIVITY_INDICATOR_DATA_TEST_ID", g1 = ({
  dataTestId: n = Zo,
  className: t,
  value: r
}) => {
  const a = r !== void 0;
  return /* @__PURE__ */ f(He, { children: /* @__PURE__ */ U("div", { className: Mt.FMC_ACTIVITY, children: [
    /* @__PURE__ */ f(
      "div",
      {
        className: C(
          Mt.FMC_ACTIVITY_PROGRESS,
          a && Mt.FMC_ACTIVITY_PROGRESS__PERCENT,
          t
        ),
        style: { width: a ? `${r}%` : "" },
        role: "progressbar",
        "aria-busy": !0,
        "data-testid": n
      }
    ),
    a && /* @__PURE__ */ f(
      "p",
      {
        className: C(
          Mt.FMC_ACTIVITY__TEXT,
          Mt.FDS_TYPE__CAPTION
        ),
        children: r
      }
    )
  ] }) });
}, Jo = "BADGE_DATA_TEST_ID", rn = {
  BADGE: "fmc-badge",
  DARK_MODE: "fmc-badge--dark",
  ICON: "fds-icon",
  ICON_FONT_PREFIX: "fds-font--ford-icons__"
}, T1 = ({
  text: n,
  icon: t,
  mode: r = "light",
  className: a,
  dataTestId: i = Jo
}) => /* @__PURE__ */ U("div", { role: "note", className: C(rn.BADGE, r == "dark" && rn.DARK_MODE, a), "data-testid": i, children: [
  t && /* @__PURE__ */ f("span", { className: `${rn.ICON} ${rn.ICON_FONT_PREFIX}${t}` }),
  n
] }), Te = {
  COMPONENT: "fmc-billboard",
  IMAGE: "fmc-billboard__image",
  JUSTIFY_START: "fmc-billboard--justify-start",
  JUSTIFY_CENTER: "fmc-billboard--justify-center",
  JUSTIFY_END: "fmc-billboard--justify-end",
  ALIGN_START: "fmc-billboard--align-start",
  ALIGN_CENTER: "fmc-billboard--align-center",
  ALIGN_END: "fmc-billboard--align-end",
  SPLIT_RIGHT: "fmc-billboard--split-image-right",
  SPLIT_BOTTOM: "fmc-billboard--split-image-bottom",
  SPLIT_TOP: "fmc-billboard--split-image-top",
  SPLIT_LEFT: "fmc-billboard--split-image-left",
  MASK: "fmc-billboard__scrim",
  MASK_TOP: "fmc-billboard--scrim-top",
  MASK_BOTTOM: "fmc-billboard--scrim-bottom",
  MASK_LEFT: "fmc-billboard--scrim-left",
  MASK_RIGHT: "fmc-billboard--scrim-right",
  MASK_FULL: "fmc-billboard--scrim-full",
  WHITE: "fmc-billboard--scrim-white",
  DARK: "fmc-billboard--scrim-dark",
  BLACK: "fmc-billboard--scrim-black",
  CONTENT: "fmc-billboard__content",
  CENTER: "fds-align--center",
  CONTENT_TITLE: "cxc-billboard__content--title",
  CONTENT_BODY: "cxc-billboard__content--body",
  CONTENT_DISCLAIMER: "cxc-billboard__content--disclaimer",
  CONTENT_BUTTON: "cxc-billboard__content--button",
  SIZE_TWO_THIRDS: "fmc-billboard--height-67vh",
  SIZE_ONE_THIRD: "fmc-billboard--height-33vh"
}, gi = ({
  validationMessage: n,
  validationMessageType: t,
  className: r,
  ...a
}) => n && n !== "" ? /* @__PURE__ */ f(
  "p",
  {
    style: {
      textAlign: "left",
      display: "flex",
      ...a.styles
    },
    className: C(
      "fds-validation__message",
      t === "error" && "fds-validation__message--error",
      t === "success" && "fds-validation__message--success",
      t === "default" && "fds-validation__message--default",
      r
    ),
    "data-testid": "validation_message_test_id",
    children: n
  }
) : null;
const Je = {
  BUTTON: "fmc-button",
  OUTLINED: "fmc-button--outlined",
  SPINNER: "cxc-spinner",
  STANDARD_BUTTON: "fds-standard-button",
  STANDARD_BUTTON_HIDDEN: "std-visually-hidden",
  BUTTON_TEXT_INVISIBLE: "cxc-standard-button__text--invisible",
  NO_SHADOW: "fmc-button--no-shadow",
  HIGHLIGHTED: "cxc-standard-button--highlighted",
  ICON_LEFT_OFFSET: "fds-icon--offset-left",
  ICON_RIGHT_OFFSET: "fds-icon--offset-right"
}, Qo = "STANDARD_BUTTON_TEST_ID", es = ({
  Element: n,
  type: t,
  target: r,
  href: a
}) => ({
  typeButtonProps: n === "button" && {
    type: t
  },
  typeLinkProps: n === "a" && {
    target: r,
    href: a
  }
}), Ot = ({
  disabled: n = !1,
  outlined: t = !1,
  onClick: r,
  title: a,
  mode: i = "light",
  loading: o = !1,
  className: s,
  enableValidation: l = !1,
  validationMessage: d,
  validationMessageType: c,
  loadingMessage: u,
  type: h = "button",
  htmlTitle: p,
  href: m,
  as: _,
  target: T = "_self",
  icon: y,
  iconName: v,
  iconAlignment: g,
  isHighlighted: S,
  ariaLabel: b,
  dataTestId: $ = Qo,
  ...P
}) => {
  let G;
  const w = _ || "button", { typeButtonProps: D, typeLinkProps: H } = es({
    Element: w,
    target: T,
    type: h,
    href: m
  }), W = {
    onClick: r,
    title: p,
    "aria-disabled": n,
    disabled: n || o
  }, B = (y || v) && g === "left", I = (y || v) && g === "right", A = { maxWidth: "16px", maxHeight: "16px" };
  return (B || I) && (G = /* @__PURE__ */ U(
    "span",
    {
      className: g === "left" ? Je.ICON_LEFT_OFFSET : Je.ICON_RIGHT_OFFSET,
      children: [
        y && Y.cloneElement(y, {
          style: A
        }),
        v && /* @__PURE__ */ f(Zt, { name: v })
      ]
    }
  )), /* @__PURE__ */ U(He, { children: [
    /* @__PURE__ */ U("div", { className: Je.STANDARD_BUTTON, "data-testid": $, children: [
      /* @__PURE__ */ f("div", { className: Je.STANDARD_BUTTON_HIDDEN, "aria-live": "polite", children: o && u }),
      /* @__PURE__ */ f(
        w,
        {
          className: C(
            Je.BUTTON,
            t && Je.OUTLINED,
            Je.NO_SHADOW,
            S && Je.HIGHLIGHTED,
            s
          ),
          ...D,
          ...H,
          ...W,
          ...P,
          ...i === "dark" && { "data-dark": !0 },
          "aria-label": b,
          children: /* @__PURE__ */ U(He, { children: [
            B && !o && G,
            /* @__PURE__ */ U("span", { className: C(o && Je.BUTTON_TEXT_INVISIBLE), children: [
              a,
              o && /* @__PURE__ */ f("span", { className: Je.SPINNER })
            ] }),
            I && !o && G
          ] })
        }
      )
    ] }),
    l && /* @__PURE__ */ f(
      gi,
      {
        validationMessage: d,
        validationMessageType: c
      }
    )
  ] });
}, Ie = {
  BUTTON: "fmc-text-button",
  BUTTON_TEXT: "fds-text-button__text",
  HOVER: "fmc-button--hover",
  ACTIVE: "fmc-button--active",
  FOCUSED: "fmc-text-button--focus",
  DISABLED: "fmc-text-button--disabled",
  TOUCH: "fmc-text-button--touch",
  REMOVE_UNDERLINE: "fmc-text-button--remove-underline",
  OUTLINED: "fmc-button--outlined",
  LIGHT_BACKGROUND: "fds-color__bg--light",
  DARK_BACKGROUND: "fds-color__bg--dark",
  SPINNER: "cxc-spinner",
  NO_SHADOW: "fmc-button--no-shadow",
  ICON_WRAPPER: "fmc-text-button__chevron",
  ICON: "fds-icon",
  ICON_LEFT: "fds-icon--offset-left",
  ICON_RIGHT: "fds-icon--offset-right",
  ICON_CHEVRON_FILLED_LEFT: "fds-font--ford-icons__chevron-filled-left",
  ICON_CHEVRON_FILLED_RIGHT: "fds-font--ford-icons__chevron-filled-right"
}, ts = "TEXT_BUTTON_TEST_ID", Ti = ({
  disabled: n = !1,
  onClick: t,
  title: r,
  mode: a = "light",
  loading: i = !1,
  chevronLeft: o = !1,
  chevronRight: s = !1,
  className: l,
  type: d = "button",
  as: c,
  href: u = "",
  target: h = "_self",
  isAnchorUnderlined: p = !0,
  dataTestId: m = ts,
  ariaLabel: _,
  ...T
}) => {
  const [y, v] = ee(!1), [g, S] = ee(!1), b = c || "button", $ = (I) => {
    if (t)
      return t(I);
  }, P = {
    className: Ie.BUTTON,
    disabled: n || i,
    onClick: $,
    "aria-label": _
  }, G = () => {
    v(!1), S(!1);
  }, w = () => {
    S(!0);
  }, D = () => {
    S(!1);
  }, H = (I) => {
    I.key === "Tab" && v(!0);
  }, W = b === "button" && {
    type: d
  }, B = b === "a" && {
    target: h,
    href: u
  };
  return (
    // TODO: Refactor to button instead of div
    /* @__PURE__ */ f(
      "div",
      {
        "data-testid": m,
        className: C(
          Ie.BUTTON,
          a === "light" && Ie.LIGHT_BACKGROUND,
          a === "dark" && Ie.DARK_BACKGROUND,
          g && Ie.HOVER,
          y && Ie.FOCUSED,
          (n || i) && Ie.DISABLED,
          !p && Ie.REMOVE_UNDERLINE,
          l
        ),
        onKeyUp: H,
        onBlur: G,
        onMouseOut: D,
        onMouseOver: w,
        onFocus: w,
        children: /* @__PURE__ */ U(
          b,
          {
            ...W,
            ...B,
            ...P,
            ...T,
            ...a == "dark" && { "data-dark": !0 },
            children: [
              o && !s && /* @__PURE__ */ f("span", { className: C(Ie.ICON_WRAPPER, Ie.ICON_LEFT), children: /* @__PURE__ */ f(
                "span",
                {
                  className: C(Ie.ICON, Ie.ICON_CHEVRON_FILLED_LEFT)
                }
              ) }),
              /* @__PURE__ */ f("span", { className: Ie.BUTTON_TEXT, children: r }),
              s && !o && /* @__PURE__ */ f("span", { className: C(Ie.ICON_WRAPPER, Ie.ICON_RIGHT), children: /* @__PURE__ */ f(
                "span",
                {
                  className: C(
                    Ie.ICON,
                    Ie.ICON_CHEVRON_FILLED_RIGHT
                  )
                }
              ) })
            ]
          }
        )
      }
    )
  );
}, an = {
  BUTTON: "fmc-fab",
  BUTTON_SINGLE_ICON: "fds-icon fds-font--ford-icons__chat fds-icon--24",
  BUTTON_MULTIPLE_ICON: "fds-icon fds-font--ford-icons__chevron-up fds-icon--24",
  BUTTON_TEXT: "fmc-fab__text",
  BUTTON_FIXED: "fmc-fabs fmc-fabs--fixed",
  DISABLED: "disabled"
}, ns = "FLOATING_ACTION_BUTTON_TEST_ID", v1 = ({
  disabled: n = !1,
  onClick: t,
  title: r = "",
  fixed: a = !1,
  mode: i = "light",
  className: o,
  type: s = "button",
  icon: l = "",
  dataTestId: d = ns,
  ...c
}) => {
  function u() {
    t && t();
  }
  const h = () => /* @__PURE__ */ U(
    "button",
    {
      "data-testid": d,
      ...c,
      className: C(an.BUTTON),
      onClick: u,
      disabled: n,
      type: s,
      children: [
        /* @__PURE__ */ f(
          "span",
          {
            className: C(
              `fds-icon ${l || "fds-font--ford-icons__chat"} fds-icon--24`
            )
          }
        ),
        /* @__PURE__ */ f("span", { "data-testid": an.BUTTON_TEXT, className: an.BUTTON_TEXT, children: r })
      ]
    }
  );
  return a ? /* @__PURE__ */ f("div", { className: an.BUTTON_FIXED, children: /* @__PURE__ */ f(h, {}) }) : /* @__PURE__ */ f(h, {});
}, rs = {
  BUTTON: "cxc-icon-button",
  DISABLED: "disabled"
}, as = "ICON_BUTTON_TEST_ID", y1 = ({
  disabled: n = !1,
  onClick: t,
  mode: r = "light",
  className: a,
  type: i = "button",
  size: o = "medium",
  icon: s,
  dataTestId: l = as,
  ...d
}) => {
  function c() {
    t && t();
  }
  let u = "", h = "", p = "", m = "", _ = "", T = "8px";
  switch (o) {
    case "large":
      u = "32px", h = "32px", p = "8px", m = "48px", _ = "48px";
      break;
    case "small":
      u = "20px", h = "20px", p = "6px", m = "32px", _ = "32px";
      break;
    case "extra-small":
      u = "16px", h = "16px", p = "4px", m = "24px", _ = "24px", T = "6px";
      break;
    case "medium":
    default:
      u = "24px", h = "24px", p = "8px", m = "40px", _ = "40px";
      break;
  }
  const y = {
    width: u,
    height: h,
    margin: p
  }, v = s && Y.cloneElement(s, {
    style: y
  });
  return /* @__PURE__ */ f(
    "button",
    {
      "data-testid": l,
      ...r === "dark" && { "data-dark": !0 },
      style: {
        "--cxc-icon-button-width": m,
        "--cxc-icon-button-height": _,
        "--cxc-icon-button-border-radius": T
      },
      ...d,
      className: C(rs.BUTTON),
      onClick: c,
      disabled: n,
      type: i,
      children: v
    }
  );
}, Cr = ({
  id: n,
  links: t,
  ariaLabel: r,
  className: a = ""
}) => {
  const i = (o) => {
    const s = o.length;
    return o.map((l, d) => /* @__PURE__ */ U(
      "button",
      {
        tabIndex: 0,
        onClick: (c) => l.onClick && l.onClick(c),
        onKeyDown: (c) => {
          c.code === "Enter" && l.onClick && l.onClick(c);
        },
        id: l.id,
        "aria-label": l.ariaLabel,
        children: [
          l.linkTitle,
          s - 1 > d && ","
        ]
      }
    ));
  };
  return t.length > 0 ? /* @__PURE__ */ f(
    "div",
    {
      id: n,
      className: `media_disclosure_button_root ${a}`,
      "aria-label": r,
      children: i(t)
    }
  ) : null;
}, is = (n) => n.charAt(0) !== "/";
function os({
  containerId: n,
  style: t,
  title: r,
  onClick: a,
  as: i,
  target: o,
  mode: s = "light",
  ariaLabel: l,
  isHighlighted: d,
  iconAlignment: c,
  ...u
}) {
  const h = o ? {
    to: o,
    href: o,
    target: is(o) ? "_blank" : "_self"
  } : {};
  if (t === "standard" || t === "primary")
    return /* @__PURE__ */ f(
      Ot,
      {
        id: n,
        title: r,
        onClick: a,
        as: i,
        mode: s,
        ariaLabel: l,
        isHighlighted: d,
        iconAlignment: c,
        ...h,
        ...u
      }
    );
  if (t === "outlined")
    return /* @__PURE__ */ f(
      Ot,
      {
        id: n,
        outlined: !0,
        title: r,
        onClick: a,
        as: i,
        mode: s,
        ariaLabel: l,
        isHighlighted: d,
        iconAlignment: c,
        ...h,
        ...u
      }
    );
  if (t === "text" || t === "secondary")
    return /* @__PURE__ */ f(
      Ti,
      {
        id: n,
        title: r,
        onClick: a,
        as: i,
        mode: s,
        ariaLabel: l,
        ...h,
        style: { margin: 0, height: "40px" },
        ...u
      }
    );
}
const ss = "TYPOGRAPHY_WRAPPER_TEST_ID", ls = ({
  children: n,
  variant: t = "body",
  className: r,
  mode: a = "light",
  upperCase: i = !1,
  center: o = !1,
  style: s,
  dataTestId: l
}) => {
  function d(p) {
    switch (p) {
      case "caption":
        return "p";
      case "display1":
        return "h1";
      case "display2":
        return "h2";
      case "display3":
        return "h3";
      case "title1":
        return "h4";
      case "title2":
        return "h5";
      case "title3":
        return "h6";
      default:
        return "p";
    }
  }
  const c = (p) => p === "caption" ? "p" : p === "display1" ? "h1" : p === "display2" ? "h2" : p === "display3" ? "h3" : p === "title1" ? "h4" : p === "title2" ? "h5" : p === "title3" ? "h6" : "p", u = d(t), h = c(t);
  return /* @__PURE__ */ f(
    "div",
    {
      className: C(a === "light" ? "fds-bg--light" : "fds-bg--dark"),
      "data-testid": ss,
      children: /* @__PURE__ */ f(
        u,
        {
          className: C(
            i && "fds-transform--uppercase",
            o && "cxc-center-text",
            t === "display1" && "fmc-type--heading1",
            t === "display2" && "fmc-type--heading2",
            t === "display3" && "fmc-type--heading3",
            t === "title1" && "fmc-type--heading4",
            t === "title2" && "fmc-type--heading5",
            t === "title3" && "fmc-type--heading6",
            t === "subtitle1" && "fmc-type--subtitle1",
            t === "subtitle2" && "fmc-type--subtitle2",
            t === "body1" && "fmc-type--body1",
            t === "body2" && "fmc-type--body2",
            t === "button" && "fmc-type--content1",
            t === "caption" && "fmc-type--content2",
            r
          ),
          style: s,
          role: h,
          "data-testid": l,
          children: n
        }
      )
    }
  );
}, ds = "BILL_DATA_TEST_ID", Kr = ({
  splitScreen: n,
  disclosureLinks: t
}) => (n === "image left" || n === "image top") && t && /* @__PURE__ */ f(
  Cr,
  {
    id: t.id,
    ariaLabel: t.ariaLabel,
    className: t.className,
    links: t.links
  }
), kt = ({
  maskColor: n,
  justifyContent: t,
  alignContent: r
}) => {
  const a = [];
  return n && (n === "dark" ? a.push(Te.DARK) : n === "white" ? a.push(Te.WHITE) : n === "black" && a.push(Te.BLACK)), t && (t === "center" ? a.push(Te.JUSTIFY_CENTER) : t === "start" ? a.push(Te.JUSTIFY_START) : a.push(Te.JUSTIFY_END)), r && (r === "center" ? a.push(Te.ALIGN_CENTER) : r === "start" ? a.push(Te.ALIGN_START) : a.push(Te.ALIGN_END)), a;
}, E1 = ({
  maskColor: n = "dark",
  maskLocation: t = "bottom",
  justifyContent: r = "center",
  alignContent: a = "center",
  image: i,
  title: o,
  body: s,
  splitScreen: l = "none",
  height: d = "fullscreen",
  buttons: c = [],
  disclaimer: u = "",
  className: h,
  disclosureLinks: p,
  dataTestId: m = ds
}) => {
  let _;
  return u && (_ = /* @__PURE__ */ f(
    "div",
    {
      className: C(
        Te.CONTENT_DISCLAIMER,
        ...kt({ maskColor: n })
      ),
      "data-testid": `${m}_DISCLAIMER`,
      children: u
    }
  )), /* @__PURE__ */ U(
    "div",
    {
      id: "FDSBillboard",
      "data-testid": m,
      className: C(
        Te.COMPONENT,
        ...kt({ justifyContent: r, alignContent: a }),
        d === "two-thirds" && Te.SIZE_TWO_THIRDS,
        d === "one-third" && Te.SIZE_ONE_THIRD,
        l === "image right" && Te.SPLIT_RIGHT,
        l === "image left" && Te.SPLIT_LEFT,
        l === "image bottom" && Te.SPLIT_BOTTOM,
        l === "image top" && Te.SPLIT_TOP,
        h
      ),
      children: [
        /* @__PURE__ */ f(
          "div",
          {
            "data-testid": `${m}_MASK`,
            className: C(
              n !== "none" ? Te.MASK : "",
              ...kt({ maskColor: n }),
              t === "top" && Te.MASK_TOP,
              t === "bottom" && Te.MASK_BOTTOM,
              t === "left" && Te.MASK_LEFT,
              t === "right" && Te.MASK_RIGHT,
              t === "full" && Te.MASK_FULL
            )
          }
        ),
        /* @__PURE__ */ f(
          "div",
          {
            "data-testid": `${m}_IMAGE`,
            className: Te.IMAGE,
            style: {
              backgroundImage: "url(" + i + ")"
            },
            children: Kr({ splitScreen: l, disclosureLinks: p })
          }
        ),
        Kr({ splitScreen: l, disclosureLinks: p }),
        /* @__PURE__ */ U(
          "div",
          {
            "data-testid": `${m}_CONTENT`,
            className: `${Te.CONTENT} ${Te.CENTER}`,
            children: [
              /* @__PURE__ */ f(
                ls,
                {
                  variant: "display3",
                  dataTestId: `${m}_TITLE`,
                  className: C(...kt({ maskColor: n }), Te.CONTENT_TITLE),
                  children: o
                }
              ),
              /* @__PURE__ */ f(
                "p",
                {
                  "data-testid": `${m}_BODY`,
                  className: C(...kt({ maskColor: n }), Te.CONTENT_BODY),
                  children: s
                }
              ),
              c && c.length > 0 && /* @__PURE__ */ f("div", { children: c.map((T, y) => /* @__PURE__ */ f(
                "div",
                {
                  className: Te.CONTENT_BUTTON,
                  "data-testid": `${m}_BUTTON_${y}`,
                  children: os({
                    mode: n === "white" ? "light" : "dark",
                    ...T
                  })
                },
                `button-${T.containerId}`
              )) }),
              u && _
            ]
          }
        )
      ]
    }
  );
}, ue = {
  GROUP: "fmc-cards",
  COMPONENT: "fmc-cards__card",
  SELECTED: "fmc-cards__card--selected",
  VIDEO: "fmc-cards__video",
  VIDEO_COVER: "fmc-cards__video-cover",
  VIDEO_FULL: "fmc-cards__video--full",
  VIDEO_PLAYING: "fmc-cards__video--playing",
  CAROUSEL: "fmc-cards__video--playing",
  TITLE: "fmc-cards__title",
  SUBTITLE: "fmc-cards__subtitle",
  MEDIA: "fmc-cards__media-area",
  IMAGE: "fmc-cards__image",
  IMAGE_WRAPPER: "fmc-cards__image-wrapper",
  CONTENT_WRAPPER: "fmc-cards__content-wrapper",
  CONTENT: "fmc-cards__content",
  BODY: "fmc-cards__body",
  FOOTER: "fmc-cards__footer",
  HORIZONTAL: "fmc-cards__card--horizontal",
  HORIZONTAL_25: "fmc-cards__card--horizontal-25",
  HORIZONTAL_75: "fmc-cards__card--horizontal-75",
  HORIZONTAL_REVERSE: "fmc-cards__card--horizontal-reverse",
  QUIET: "fmc-cards__card--quiet",
  QUIET_CARD: "fmc-cards__quiet-card",
  ALERT: "fmc-cards__alert",
  ALERT_SUCCESS: "fmc-cards__alert--success",
  ALERT_ERROR: "fmc-cards__alert--error",
  ALERT_CAUTION: "fmc-cards__alert--caution",
  UPPER_CASE: "fds-transform--uppercase",
  // ======================
  FOOTER_BUTTON_CONTAINER: "fmc-cards__button-container",
  TITLE_CONTAINER: "fmc-cards__title-container",
  OVERFLOW_MENU_CONTAINER: "fmc-cards__overflow-menu__container",
  OVERFLOW_MENU_ICON: "fmc-cards__overflow-menu__icon"
}, Ce = {
  CARD_DEFAULT_DATA_TEST_ID: "CARD_DATA_TEST_ID",
  CARD_IMAGE_MDEIA_TEST_ID: "CARD_IMAGE_MEDIA_TEST_ID",
  CARD_IMAGE_TEST_ID: "CARD_IMAGE_TEST_ID",
  CARD_VIDEO_MEDIA_TEST_ID: "CARD_VIDEO_MEDIA_TEST_ID",
  CARD_VIDEO_COVER_TEST_ID: "CARD_VIDEO_COVER_TEST_ID",
  CARD_HTML5_VIDEO_TEST_ID: "CARD_HTML5_VIDEO_TEST_ID",
  CARD_HTML5_VIDEO_TRACK_TEST_ID: "CARD_HTML5_VIDEO_TRACK_TEST_ID",
  CARD_HTML5_VIDEO_SROUCE_TEST_ID: "CARD_HTML5_VIDEO_SROUCE_TEST_ID",
  CARD_ALERT_TEST_ID: "CARD_ALERT_TEST_ID",
  CARD_FOOTER_TEST_ID: "CARD_FOOTER_TEST_ID",
  CARD_BUTTON_ONE_TEST_ID: "CARD_BUTTON_ONE_TEST_ID",
  CARD_BUTTON_TWO_TEST_ID: "CARD_BUTTON_TWO_TEST_ID",
  CARD_BUTTON_THREE_TEST_ID: "CARD_BUTTON_THREE_TEST_ID",
  CARD_CONTENT_WRAPPER_TEST_ID: "CARD_CONTENT_WRAPPER_TEST_ID",
  CARD_CONTENT_TEST_ID: "CARD_CONTENT_TEST_ID",
  CARD_TITLE_CONTAINER_TEST_ID: "CARD_TITLE_CONTAINER_TEST_ID",
  CARD_TITLE_TEST_ID: "CARD_TITLE_TEST_ID",
  CARD_OVERFLOW_MENU_CONTAINER_TEST_ID: "CARD_OVERFLOW_MENU_CONTAINER_TEST_ID",
  CARD_OVERFLOW_MENU_ICON_TEST_ID: "CARD_OVERFLOW_MENU_ICON_TEST_ID",
  CARD_SUBTITLE_TEST_ID: "CARD_SUBTITLE_TEST_ID",
  CARD_CONTENT_BODY_TEST_ID: "CARD_CONTENT_BODY_TEST_ID"
}, vi = Y.createContext({ isQuiet: !1 }), b1 = ({
  children: n,
  cardClassName: t,
  span: r,
  isHorizontal: a = !1,
  isQuiet: i = !1,
  imageRightAligned: o = !1,
  imageHorizontalSpan: s,
  isSelected: l = !1,
  dataTestId: d = Ce.CARD_DEFAULT_DATA_TEST_ID
}) => {
  const c = s === 3 ? ue.HORIZONTAL_25 : s === 9 ? ue.HORIZONTAL_75 : void 0, u = r ? `fds-layout-grid__cell--span-${r}` : a ? "fds-layout-grid__cell--span-12" : "fds-layout-grid__cell--span-4";
  return /* @__PURE__ */ f(
    "div",
    {
      id: "FDSCard",
      "data-testid": d,
      className: C(
        ue.COMPONENT,
        a && ue.HORIZONTAL,
        a && c,
        a && o && ue.HORIZONTAL_REVERSE,
        i && ue.QUIET,
        l && ue.SELECTED,
        u,
        t
      ),
      children: /* @__PURE__ */ f(vi.Provider, { value: { isQuiet: i }, children: n })
    }
  );
}, C1 = ({
  alertLabel: n,
  alertType: t = "default",
  className: r,
  dataTestId: a = Ce.CARD_ALERT_TEST_ID
}) => /* @__PURE__ */ f(
  "div",
  {
    role: "alert",
    "data-testid": a,
    className: C(
      ue.ALERT,
      t === "success" && ue.ALERT_SUCCESS,
      t === "caution" && ue.ALERT_CAUTION,
      t === "error" && ue.ALERT_ERROR,
      r
    ),
    children: n
  }
), cs = "DISCLOSURE_CONTENT_TEST_ID", us = "fds-disclosure-content", yi = ({
  id: n,
  disclosureContent: t,
  disclosureTitleColor: r,
  className: a,
  style: i
}) => {
  const o = {
    "--disclosure-content-color": r
  };
  return /* @__PURE__ */ f(
    "div",
    {
      id: n,
      "data-testid": `${cs}_disclosure_content`,
      className: C(us, a),
      style: { ...o, ...i },
      children: t
    }
  );
}, N1 = ({
  children: n,
  title: t,
  isTitleLowercased: r,
  subtitle: a,
  overflowMenu: i,
  footer: o,
  buttonOneText: s,
  buttonOneOnClick: l,
  buttonOneStyle: d = "primary",
  buttonTwoText: c,
  buttonTwoOnClick: u,
  buttonTwoStyle: h = "outlined",
  buttonThreeText: p,
  buttonThreeOnClick: m,
  buttonThreeStyle: _ = "secondary",
  className: T,
  dataTestId: y = Ce.CARD_CONTENT_WRAPPER_TEST_ID,
  disclosureContent: v
}) => {
  Y.useContext(vi);
  const g = (b, $) => {
    if (b === "primary")
      return /* @__PURE__ */ f(Ot, { ...$ });
    if (b === "outlined")
      return /* @__PURE__ */ f(Ot, { outlined: !0, ...$ });
    if (b === "secondary")
      return /* @__PURE__ */ f(Ti, { chevronRight: !0, ...$ });
  }, S = o ? (
    // Custom footer
    /* @__PURE__ */ f(
      "div",
      {
        "data-testid": Ce.CARD_FOOTER_TEST_ID,
        "aria-label": "Card footer",
        className: C(ue.FOOTER),
        children: o
      }
    )
  ) : (
    // Built-in footer buttons
    (s || c || p) && /* @__PURE__ */ U(
      "div",
      {
        "data-testid": Ce.CARD_FOOTER_TEST_ID,
        "aria-label": "Card footer",
        className: C(ue.FOOTER),
        children: [
          s && /* @__PURE__ */ f(
            "div",
            {
              "data-testid": Ce.CARD_BUTTON_ONE_TEST_ID,
              className: C(ue.FOOTER_BUTTON_CONTAINER),
              children: g(d, {
                title: s,
                onClick: l
              })
            }
          ),
          s && c && /* @__PURE__ */ f(
            "div",
            {
              "data-testid": Ce.CARD_BUTTON_TWO_TEST_ID,
              className: C(ue.FOOTER_BUTTON_CONTAINER),
              children: g(h, {
                title: c,
                onClick: u
              })
            }
          ),
          s && c && p && /* @__PURE__ */ f(
            "div",
            {
              "data-testid": Ce.CARD_BUTTON_THREE_TEST_ID,
              className: C(ue.FOOTER_BUTTON_CONTAINER),
              children: g(_, {
                title: p,
                onClick: m
              })
            }
          )
        ]
      }
    )
  );
  return /* @__PURE__ */ f(
    "div",
    {
      "data-testid": y,
      "aria-label": "Card content",
      className: C(ue.CONTENT_WRAPPER, T),
      children: /* @__PURE__ */ U(
        "div",
        {
          "data-testid": Ce.CARD_CONTENT_TEST_ID,
          className: C(ue.CONTENT),
          children: [
            /* @__PURE__ */ U(
              "div",
              {
                "data-testid": Ce.CARD_TITLE_CONTAINER_TEST_ID,
                className: C(ue.TITLE_CONTAINER),
                children: [
                  /* @__PURE__ */ f(
                    "h2",
                    {
                      "data-testid": Ce.CARD_TITLE_TEST_ID,
                      className: C(
                        ue.TITLE,
                        !r && ue.UPPER_CASE
                      ),
                      children: t
                    }
                  ),
                  i
                ]
              }
            ),
            a && /* @__PURE__ */ f(
              "h3",
              {
                "data-testid": Ce.CARD_SUBTITLE_TEST_ID,
                className: C(ue.SUBTITLE),
                children: a
              }
            ),
            /* @__PURE__ */ f(
              "div",
              {
                "data-testid": Ce.CARD_CONTENT_BODY_TEST_ID,
                className: C(ue.BODY),
                children: n
              }
            ),
            S,
            v && /* @__PURE__ */ f(
              yi,
              {
                disclosureContent: v?.disclosureContent,
                id: v?.id,
                className: v?.className,
                disclosureTitleColor: v?.disclosureTitleColor,
                style: v?.style
              }
            )
          ]
        }
      )
    }
  );
}, S1 = ({
  children: n,
  imageSrc: t,
  imageAlt: r,
  imagePosition: a = "center center",
  className: i,
  dataTestId: o = Ce.CARD_IMAGE_MDEIA_TEST_ID,
  disclosureLinks: s
}) => /* @__PURE__ */ U(
  "div",
  {
    "data-testid": o,
    "aria-label": "Image media",
    className: C(ue.MEDIA, i),
    children: [
      /* @__PURE__ */ f(
        "img",
        {
          "data-testid": Ce.CARD_IMAGE_TEST_ID,
          className: C(ue.IMAGE),
          src: t || "https://via.placeholder.com/350x150",
          alt: r || "",
          style: { objectPosition: a }
        }
      ),
      s && /* @__PURE__ */ f(
        Cr,
        {
          id: s.id,
          ariaLabel: s.ariaLabel,
          className: s.className,
          links: s.links
        }
      ),
      n
    ]
  }
), fs = (n) => n && /* @__PURE__ */ f(
  Cr,
  {
    id: n.id,
    ariaLabel: n.ariaLabel,
    className: n.className,
    links: n.links
  }
), O1 = ({
  children: n,
  videoCover: t,
  videoCoverPosition: r = "center center",
  videoSize: a = "wide",
  isVideoPlaying: i = !1,
  videoTrackProps: o,
  videoSources: s,
  videoRef: l,
  onPlayCustomVideoMedia: d,
  className: c,
  dataTestId: u = Ce.CARD_VIDEO_MEDIA_TEST_ID,
  disclosureLinks: h,
  ...p
}) => {
  const [m, _] = Y.useState(!1), T = Y.useRef(null);
  Y.useEffect(() => {
    T?.current && m && T.current.play();
  }, [m]);
  const y = () => {
    n && d ? d() : T?.current?.paused && _(!0);
  };
  return /* @__PURE__ */ U(
    "div",
    {
      "data-testid": u,
      "aria-label": "Video media",
      role: "button",
      tabIndex: 0,
      className: C(
        ue.MEDIA,
        ue.VIDEO,
        a === "full" && ue.VIDEO_FULL,
        (i || m) && ue.VIDEO_PLAYING,
        c
      ),
      onClick: y,
      onKeyPress: (v) => v.key === "Enter" && y(),
      children: [
        /* @__PURE__ */ f(
          "div",
          {
            "data-testid": Ce.CARD_VIDEO_COVER_TEST_ID,
            className: C(ue.VIDEO_COVER),
            style: t ? {
              backgroundImage: `url(${t})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: r || "center center",
              zIndex: i || m ? 0 : 1
            } : void 0
          }
        ),
        fs(h),
        n,
        !n && s ? /* @__PURE__ */ U(
          "video",
          {
            "data-testid": Ce.CARD_HTML5_VIDEO_TEST_ID,
            width: "100%",
            ref: void 0,
            controls: i || m,
            style: { zIndex: i || m ? 1 : 0 },
            ...p,
            children: [
              /* @__PURE__ */ f(
                "track",
                {
                  "data-testid": Ce.CARD_HTML5_VIDEO_TRACK_TEST_ID,
                  default: !0,
                  kind: "captions",
                  ...o
                }
              ),
              s.map((v, g) => /* @__PURE__ */ f(
                "source",
                {
                  "data-testid": `${Ce.CARD_HTML5_VIDEO_SROUCE_TEST_ID}_${g}`,
                  ...v
                },
                g
              )),
              "Sorry, your browser doesn't support embedded videos."
            ]
          }
        ) : null
      ]
    }
  );
}, A1 = ({
  children: n,
  cardOverflowMenuContainerClassName: t,
  overflowMenuContainerStyle: r,
  onClickOverflowMenuIcon: a,
  dataTestId: i = Ce.CARD_OVERFLOW_MENU_CONTAINER_TEST_ID
}) => /* @__PURE__ */ U(
  "div",
  {
    "data-testid": i,
    className: C(
      ue.OVERFLOW_MENU_CONTAINER,
      t
    ),
    style: r,
    children: [
      /* @__PURE__ */ f(
        "span",
        {
          "data-testid": Ce.CARD_OVERFLOW_MENU_ICON_TEST_ID,
          "aria-label": "Ellipsis icon",
          role: "button",
          tabIndex: 0,
          className: C(ue.OVERFLOW_MENU_ICON),
          onClick: a,
          onKeyPress: (o) => o.key === "Enter" && a?.(),
          children: /* @__PURE__ */ f("span", { className: "fds-icon fds-icon--24 fds-font--ford-icons__ellipsis" })
        }
      ),
      n
    ]
  }
), hs = "CARD_GROUP_DATA_TEST_ID", ps = ({
  children: n,
  cardGroupClassName: t,
  dataTestId: r = hs
}) => /* @__PURE__ */ f(
  "div",
  {
    id: "FDSCardGroup",
    "data-testid": r,
    className: C(
      ue.GROUP,
      // Conditional statement added because Card Carousel style conflicts with fds-layout-grid style
      {
        ["fds-layout-grid__inner"]: t != "fmc-card-carousel-group"
      },
      t
    ),
    children: n
  }
), Se = {
  COMPONENT: "js-fmc-carousel-container fmc-carousel-container",
  CAROUSEL: "fmc-carousel",
  CARD_CAROUSEL: "fmc-card-carousel",
  CARD_CAROUSEL_GROUP: "fmc-card-carousel-group",
  CAROUSEL_INDICATOR: "fmc-carousel-indicator",
  CAROUSEL_INDICATOR_BILLBOARD: "fmc-billboard-carousel",
  CAROUSEL_INDICATOR_WRAPPER: "fmc-carousel-indicator-wrapper",
  DIRECTIONAL_BUTTON: "fmc-carousel-indicator__directional-button",
  DISABLED_DIRECTIONAL_BUTTON: "fmc-carousel-indicator__button--disabled",
  DIRECTIONAL_BUTTON_PREVIOUS: "fmc-carousel-indicator__directional-button--previous",
  DIRECTIONAL_BUTTON_NEXT: "fmc-carousel-indicator__directional-button--next",
  PAGINATION: "fmc-carousel-indicator__pagination",
  PAGINATION_TEXT: "fmc-carousel-indicator__pagination-text",
  SLIDE_IMAGE: "fmc-carousel__image",
  ACTIVE_PANCAKE_BUTTON: "fmc-carousel-indicator__button--active",
  PANCAKE_BUTTON: "fmc-carousel-indicator__pancake-button",
  PANCAKE_BUTTONS: "fmc-carousel-indicator__pancake-buttons",
  PANCAKE: "fmc-carousel-indicator__pancake",
  INLINE_DIRECTIONAL_BUTTONS: "fmc-carousel-container--inline-directional-buttons"
};
function st() {
  return st = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
    }
    return n;
  }, st.apply(this, arguments);
}
function pt(n) {
  "@babel/helpers - typeof";
  return pt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pt(n);
}
function ms(n, t) {
  if (pt(n) !== "object" || n === null)
    return n;
  var r = n[Symbol.toPrimitive];
  if (r !== void 0) {
    var a = r.call(n, t || "default");
    if (pt(a) !== "object")
      return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(n);
}
function Ei(n) {
  var t = ms(n, "string");
  return pt(t) === "symbol" ? t : String(t);
}
function ae(n, t, r) {
  return t = Ei(t), t in n ? Object.defineProperty(n, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[t] = r, n;
}
function jr(n, t) {
  var r = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    t && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function M(n) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jr(Object(r), !0).forEach(function(a) {
      ae(n, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : jr(Object(r)).forEach(function(a) {
      Object.defineProperty(n, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return n;
}
function Rt(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Yr(n, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, Ei(a.key), a);
  }
}
function Dt(n, t, r) {
  return t && Yr(n.prototype, t), r && Yr(n, r), Object.defineProperty(n, "prototype", {
    writable: !1
  }), n;
}
function ie(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function Qn(n, t) {
  return Qn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, i) {
    return a.__proto__ = i, a;
  }, Qn(n, t);
}
function Pt(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: n,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(n, "prototype", {
    writable: !1
  }), t && Qn(n, t);
}
function pn(n) {
  return pn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, pn(n);
}
function $s() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _s(n, t) {
  if (t && (pt(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ie(n);
}
function wt(n) {
  var t = $s();
  return function() {
    var a = pn(n), i;
    if (t) {
      var o = pn(this).constructor;
      i = Reflect.construct(a, arguments, o);
    } else
      i = a.apply(this, arguments);
    return _s(this, i);
  };
}
function gs(n, t) {
  if (n == null)
    return {};
  var r = {}, a = Object.keys(n), i, o;
  for (o = 0; o < a.length; o++)
    i = a[o], !(t.indexOf(i) >= 0) && (r[i] = n[i]);
  return r;
}
function Ts(n, t) {
  if (n == null)
    return {};
  var r = gs(n, t), a, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);
    for (i = 0; i < o.length; i++)
      a = o[i], !(t.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(n, a) && (r[a] = n[a]);
  }
  return r;
}
var vs = {
  animating: !1,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: !1,
  edgeDragged: !1,
  initialized: !1,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: !1,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: !1,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: !1,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
function ys(n, t, r) {
  var a = r || {}, i = a.noTrailing, o = i === void 0 ? !1 : i, s = a.noLeading, l = s === void 0 ? !1 : s, d = a.debounceMode, c = d === void 0 ? void 0 : d, u, h = !1, p = 0;
  function m() {
    u && clearTimeout(u);
  }
  function _(y) {
    var v = y || {}, g = v.upcomingOnly, S = g === void 0 ? !1 : g;
    m(), h = !S;
  }
  function T() {
    for (var y = arguments.length, v = new Array(y), g = 0; g < y; g++)
      v[g] = arguments[g];
    var S = this, b = Date.now() - p;
    if (h)
      return;
    function $() {
      p = Date.now(), t.apply(S, v);
    }
    function P() {
      u = void 0;
    }
    !l && c && !u && $(), m(), c === void 0 && b > n ? l ? (p = Date.now(), o || (u = setTimeout(c ? P : $, n))) : $() : o !== !0 && (u = setTimeout(c ? P : $, c === void 0 ? n - b : n));
  }
  return T.cancel = _, T;
}
function Es(n, t, r) {
  var a = r || {}, i = a.atBegin, o = i === void 0 ? !1 : i;
  return ys(n, t, {
    debounceMode: o !== !1
  });
}
function Nr(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function bs(n) {
  if (n.__esModule)
    return n;
  var t = n.default;
  if (typeof t == "function") {
    var r = function a() {
      if (this instanceof a) {
        var i = [null];
        i.push.apply(i, arguments);
        var o = Function.bind.apply(t, i);
        return new o();
      }
      return t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(n).forEach(function(a) {
    var i = Object.getOwnPropertyDescriptor(n, a);
    Object.defineProperty(r, a, i.get ? i : {
      enumerable: !0,
      get: function() {
        return n[a];
      }
    });
  }), r;
}
var bi = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(n) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var a = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var s = typeof o;
          if (s === "string" || s === "number")
            a.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var l = r.apply(null, o);
              l && a.push(l);
            }
          } else if (s === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              a.push(o.toString());
              continue;
            }
            for (var d in o)
              t.call(o, d) && o[d] && a.push(d);
          }
        }
      }
      return a.join(" ");
    }
    n.exports ? (r.default = r, n.exports = r) : window.classNames = r;
  })();
})(bi);
var Cs = bi.exports;
const ct = /* @__PURE__ */ Nr(Cs);
function er(n, t, r) {
  return Math.max(t, Math.min(n, r));
}
var Ct = function(t) {
  var r = ["onTouchStart", "onTouchMove", "onWheel"];
  r.includes(t._reactName) || t.preventDefault();
}, mn = function(t) {
  for (var r = [], a = Ci(t), i = Ni(t), o = a; o < i; o++)
    t.lazyLoadedList.indexOf(o) < 0 && r.push(o);
  return r;
}, Ci = function(t) {
  return t.currentSlide - Ns(t);
}, Ni = function(t) {
  return t.currentSlide + Ss(t);
}, Ns = function(t) {
  return t.centerMode ? Math.floor(t.slidesToShow / 2) + (parseInt(t.centerPadding) > 0 ? 1 : 0) : 0;
}, Ss = function(t) {
  return t.centerMode ? Math.floor((t.slidesToShow - 1) / 2) + 1 + (parseInt(t.centerPadding) > 0 ? 1 : 0) : t.slidesToShow;
}, tr = function(t) {
  return t && t.offsetWidth || 0;
}, Sr = function(t) {
  return t && t.offsetHeight || 0;
}, Si = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a, i, o, s;
  return a = t.startX - t.curX, i = t.startY - t.curY, o = Math.atan2(i, a), s = Math.round(o * 180 / Math.PI), s < 0 && (s = 360 - Math.abs(s)), s <= 45 && s >= 0 || s <= 360 && s >= 315 ? "left" : s >= 135 && s <= 225 ? "right" : r === !0 ? s >= 35 && s <= 135 ? "up" : "down" : "vertical";
}, Nn = function(t) {
  var r = !0;
  return t.infinite || (t.centerMode && t.currentSlide >= t.slideCount - 1 || t.slideCount <= t.slidesToShow || t.currentSlide >= t.slideCount - t.slidesToShow) && (r = !1), r;
}, Ln = function(t, r) {
  var a = {};
  return r.forEach(function(i) {
    return a[i] = t[i];
  }), a;
}, Os = function(t) {
  var r = re.Children.count(t.children), a = t.listRef, i = Math.ceil(tr(a)), o = t.trackRef && t.trackRef.node, s = Math.ceil(tr(o)), l;
  if (t.vertical)
    l = i;
  else {
    var d = t.centerMode && parseInt(t.centerPadding) * 2;
    typeof t.centerPadding == "string" && t.centerPadding.slice(-1) === "%" && (d *= i / 100), l = Math.ceil((i - d) / t.slidesToShow);
  }
  var c = a && Sr(a.querySelector('[data-index="0"]')), u = c * t.slidesToShow, h = t.currentSlide === void 0 ? t.initialSlide : t.currentSlide;
  t.rtl && t.currentSlide === void 0 && (h = r - 1 - t.initialSlide);
  var p = t.lazyLoadedList || [], m = mn(M(M({}, t), {}, {
    currentSlide: h,
    lazyLoadedList: p
  }));
  p = p.concat(m);
  var _ = {
    slideCount: r,
    slideWidth: l,
    listWidth: i,
    trackWidth: s,
    currentSlide: h,
    slideHeight: c,
    listHeight: u,
    lazyLoadedList: p
  };
  return t.autoplaying === null && t.autoplay && (_.autoplaying = "playing"), _;
}, As = function(t) {
  var r = t.waitForAnimate, a = t.animating, i = t.fade, o = t.infinite, s = t.index, l = t.slideCount, d = t.lazyLoad, c = t.currentSlide, u = t.centerMode, h = t.slidesToScroll, p = t.slidesToShow, m = t.useCSS, _ = t.lazyLoadedList;
  if (r && a)
    return {};
  var T = s, y, v, g, S = {}, b = {}, $ = o ? s : er(s, 0, l - 1);
  if (i) {
    if (!o && (s < 0 || s >= l))
      return {};
    s < 0 ? T = s + l : s >= l && (T = s - l), d && _.indexOf(T) < 0 && (_ = _.concat(T)), S = {
      animating: !0,
      currentSlide: T,
      lazyLoadedList: _,
      targetSlide: T
    }, b = {
      animating: !1,
      targetSlide: T
    };
  } else
    y = T, T < 0 ? (y = T + l, o ? l % h !== 0 && (y = l - l % h) : y = 0) : !Nn(t) && T > c ? T = y = c : u && T >= l ? (T = o ? l : l - 1, y = o ? 0 : l - 1) : T >= l && (y = T - l, o ? l % h !== 0 && (y = 0) : y = l - p), !o && T + p >= l && (y = l - p), v = Kt(M(M({}, t), {}, {
      slideIndex: T
    })), g = Kt(M(M({}, t), {}, {
      slideIndex: y
    })), o || (v === g && (T = y), v = g), d && (_ = _.concat(mn(M(M({}, t), {}, {
      currentSlide: T
    })))), m ? (S = {
      animating: !0,
      currentSlide: y,
      trackStyle: Oi(M(M({}, t), {}, {
        left: v
      })),
      lazyLoadedList: _,
      targetSlide: $
    }, b = {
      animating: !1,
      currentSlide: y,
      trackStyle: Gt(M(M({}, t), {}, {
        left: g
      })),
      swipeLeft: null,
      targetSlide: $
    }) : S = {
      currentSlide: y,
      trackStyle: Gt(M(M({}, t), {}, {
        left: g
      })),
      lazyLoadedList: _,
      targetSlide: $
    };
  return {
    state: S,
    nextState: b
  };
}, Is = function(t, r) {
  var a, i, o, s, l, d = t.slidesToScroll, c = t.slidesToShow, u = t.slideCount, h = t.currentSlide, p = t.targetSlide, m = t.lazyLoad, _ = t.infinite;
  if (s = u % d !== 0, a = s ? 0 : (u - h) % d, r.message === "previous")
    o = a === 0 ? d : c - a, l = h - o, m && !_ && (i = h - o, l = i === -1 ? u - 1 : i), _ || (l = p - d);
  else if (r.message === "next")
    o = a === 0 ? d : a, l = h + o, m && !_ && (l = (h + d) % u + a), _ || (l = p + d);
  else if (r.message === "dots")
    l = r.index * r.slidesToScroll;
  else if (r.message === "children") {
    if (l = r.index, _) {
      var T = Fs(M(M({}, t), {}, {
        targetSlide: l
      }));
      l > r.currentSlide && T === "left" ? l = l - u : l < r.currentSlide && T === "right" && (l = l + u);
    }
  } else
    r.message === "index" && (l = Number(r.index));
  return l;
}, Rs = function(t, r, a) {
  return t.target.tagName.match("TEXTAREA|INPUT|SELECT") || !r ? "" : t.keyCode === 37 ? a ? "next" : "previous" : t.keyCode === 39 ? a ? "previous" : "next" : "";
}, Ds = function(t, r, a) {
  return t.target.tagName === "IMG" && Ct(t), !r || !a && t.type.indexOf("mouse") !== -1 ? "" : {
    dragging: !0,
    touchObject: {
      startX: t.touches ? t.touches[0].pageX : t.clientX,
      startY: t.touches ? t.touches[0].pageY : t.clientY,
      curX: t.touches ? t.touches[0].pageX : t.clientX,
      curY: t.touches ? t.touches[0].pageY : t.clientY
    }
  };
}, Ps = function(t, r) {
  var a = r.scrolling, i = r.animating, o = r.vertical, s = r.swipeToSlide, l = r.verticalSwiping, d = r.rtl, c = r.currentSlide, u = r.edgeFriction, h = r.edgeDragged, p = r.onEdge, m = r.swiped, _ = r.swiping, T = r.slideCount, y = r.slidesToScroll, v = r.infinite, g = r.touchObject, S = r.swipeEvent, b = r.listHeight, $ = r.listWidth;
  if (!a) {
    if (i)
      return Ct(t);
    o && s && l && Ct(t);
    var P, G = {}, w = Kt(r);
    g.curX = t.touches ? t.touches[0].pageX : t.clientX, g.curY = t.touches ? t.touches[0].pageY : t.clientY, g.swipeLength = Math.round(Math.sqrt(Math.pow(g.curX - g.startX, 2)));
    var D = Math.round(Math.sqrt(Math.pow(g.curY - g.startY, 2)));
    if (!l && !_ && D > 10)
      return {
        scrolling: !0
      };
    l && (g.swipeLength = D);
    var H = (d ? -1 : 1) * (g.curX > g.startX ? 1 : -1);
    l && (H = g.curY > g.startY ? 1 : -1);
    var W = Math.ceil(T / y), B = Si(r.touchObject, l), I = g.swipeLength;
    return v || (c === 0 && (B === "right" || B === "down") || c + 1 >= W && (B === "left" || B === "up") || !Nn(r) && (B === "left" || B === "up")) && (I = g.swipeLength * u, h === !1 && p && (p(B), G.edgeDragged = !0)), !m && S && (S(B), G.swiped = !0), o ? P = w + I * (b / $) * H : d ? P = w - I * H : P = w + I * H, l && (P = w + I * H), G = M(M({}, G), {}, {
      touchObject: g,
      swipeLeft: P,
      trackStyle: Gt(M(M({}, r), {}, {
        left: P
      }))
    }), Math.abs(g.curX - g.startX) < Math.abs(g.curY - g.startY) * 0.8 || g.swipeLength > 10 && (G.swiping = !0, Ct(t)), G;
  }
}, ws = function(t, r) {
  var a = r.dragging, i = r.swipe, o = r.touchObject, s = r.listWidth, l = r.touchThreshold, d = r.verticalSwiping, c = r.listHeight, u = r.swipeToSlide, h = r.scrolling, p = r.onSwipe, m = r.targetSlide, _ = r.currentSlide, T = r.infinite;
  if (!a)
    return i && Ct(t), {};
  var y = d ? c / l : s / l, v = Si(o, d), g = {
    dragging: !1,
    edgeDragged: !1,
    scrolling: !1,
    swiping: !1,
    swiped: !1,
    swipeLeft: null,
    touchObject: {}
  };
  if (h || !o.swipeLength)
    return g;
  if (o.swipeLength > y) {
    Ct(t), p && p(v);
    var S, b, $ = T ? _ : m;
    switch (v) {
      case "left":
      case "up":
        b = $ + Xr(r), S = u ? zr(r, b) : b, g.currentDirection = 0;
        break;
      case "right":
      case "down":
        b = $ - Xr(r), S = u ? zr(r, b) : b, g.currentDirection = 1;
        break;
      default:
        S = $;
    }
    g.triggerSlideHandler = S;
  } else {
    var P = Kt(r);
    g.trackStyle = Oi(M(M({}, r), {}, {
      left: P
    }));
  }
  return g;
}, Ls = function(t) {
  for (var r = t.infinite ? t.slideCount * 2 : t.slideCount, a = t.infinite ? t.slidesToShow * -1 : 0, i = t.infinite ? t.slidesToShow * -1 : 0, o = []; a < r; )
    o.push(a), a = i + t.slidesToScroll, i += Math.min(t.slidesToScroll, t.slidesToShow);
  return o;
}, zr = function(t, r) {
  var a = Ls(t), i = 0;
  if (r > a[a.length - 1])
    r = a[a.length - 1];
  else
    for (var o in a) {
      if (r < a[o]) {
        r = i;
        break;
      }
      i = a[o];
    }
  return r;
}, Xr = function(t) {
  var r = t.centerMode ? t.slideWidth * Math.floor(t.slidesToShow / 2) : 0;
  if (t.swipeToSlide) {
    var a, i = t.listRef, o = i.querySelectorAll && i.querySelectorAll(".slick-slide") || [];
    if (Array.from(o).every(function(d) {
      if (t.vertical) {
        if (d.offsetTop + Sr(d) / 2 > t.swipeLeft * -1)
          return a = d, !1;
      } else if (d.offsetLeft - r + tr(d) / 2 > t.swipeLeft * -1)
        return a = d, !1;
      return !0;
    }), !a)
      return 0;
    var s = t.rtl === !0 ? t.slideCount - t.currentSlide : t.currentSlide, l = Math.abs(a.dataset.index - s) || 1;
    return l;
  } else
    return t.slidesToScroll;
}, Or = function(t, r) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    r.reduce(function(a, i) {
      return a && t.hasOwnProperty(i);
    }, !0) ? null : console.error("Keys Missing:", t)
  );
}, Gt = function(t) {
  Or(t, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var r, a, i = t.slideCount + 2 * t.slidesToShow;
  t.vertical ? a = i * t.slideHeight : r = xs(t) * t.slideWidth;
  var o = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (t.useTransform) {
    var s = t.vertical ? "translate3d(0px, " + t.left + "px, 0px)" : "translate3d(" + t.left + "px, 0px, 0px)", l = t.vertical ? "translate3d(0px, " + t.left + "px, 0px)" : "translate3d(" + t.left + "px, 0px, 0px)", d = t.vertical ? "translateY(" + t.left + "px)" : "translateX(" + t.left + "px)";
    o = M(M({}, o), {}, {
      WebkitTransform: s,
      transform: l,
      msTransform: d
    });
  } else
    t.vertical ? o.top = t.left : o.left = t.left;
  return t.fade && (o = {
    opacity: 1
  }), r && (o.width = r), a && (o.height = a), window && !window.addEventListener && window.attachEvent && (t.vertical ? o.marginTop = t.left + "px" : o.marginLeft = t.left + "px"), o;
}, Oi = function(t) {
  Or(t, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var r = Gt(t);
  return t.useTransform ? (r.WebkitTransition = "-webkit-transform " + t.speed + "ms " + t.cssEase, r.transition = "transform " + t.speed + "ms " + t.cssEase) : t.vertical ? r.transition = "top " + t.speed + "ms " + t.cssEase : r.transition = "left " + t.speed + "ms " + t.cssEase, r;
}, Kt = function(t) {
  if (t.unslick)
    return 0;
  Or(t, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var r = t.slideIndex, a = t.trackRef, i = t.infinite, o = t.centerMode, s = t.slideCount, l = t.slidesToShow, d = t.slidesToScroll, c = t.slideWidth, u = t.listWidth, h = t.variableWidth, p = t.slideHeight, m = t.fade, _ = t.vertical, T = 0, y, v, g = 0;
  if (m || t.slideCount === 1)
    return 0;
  var S = 0;
  if (i ? (S = -tt(t), s % d !== 0 && r + d > s && (S = -(r > s ? l - (r - s) : s % d)), o && (S += parseInt(l / 2))) : (s % d !== 0 && r + d > s && (S = l - s % d), o && (S = parseInt(l / 2))), T = S * c, g = S * p, _ ? y = r * p * -1 + g : y = r * c * -1 + T, h === !0) {
    var b, $ = a && a.node;
    if (b = r + tt(t), v = $ && $.childNodes[b], y = v ? v.offsetLeft * -1 : 0, o === !0) {
      b = i ? r + tt(t) : r, v = $ && $.children[b], y = 0;
      for (var P = 0; P < b; P++)
        y -= $ && $.children[P] && $.children[P].offsetWidth;
      y -= parseInt(t.centerPadding), y += v && (u - v.offsetWidth) / 2;
    }
  }
  return y;
}, tt = function(t) {
  return t.unslick || !t.infinite ? 0 : t.variableWidth ? t.slideCount : t.slidesToShow + (t.centerMode ? 1 : 0);
}, cn = function(t) {
  return t.unslick || !t.infinite ? 0 : t.slideCount;
}, xs = function(t) {
  return t.slideCount === 1 ? 1 : tt(t) + t.slideCount + cn(t);
}, Fs = function(t) {
  return t.targetSlide > t.currentSlide ? t.targetSlide > t.currentSlide + Ms(t) ? "left" : "right" : t.targetSlide < t.currentSlide - ks(t) ? "right" : "left";
}, Ms = function(t) {
  var r = t.slidesToShow, a = t.centerMode, i = t.rtl, o = t.centerPadding;
  if (a) {
    var s = (r - 1) / 2 + 1;
    return parseInt(o) > 0 && (s += 1), i && r % 2 === 0 && (s += 1), s;
  }
  return i ? 0 : r - 1;
}, ks = function(t) {
  var r = t.slidesToShow, a = t.centerMode, i = t.rtl, o = t.centerPadding;
  if (a) {
    var s = (r - 1) / 2 + 1;
    return parseInt(o) > 0 && (s += 1), !i && r % 2 === 0 && (s += 1), s;
  }
  return i ? r - 1 : 0;
}, qr = function() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}, xn = function(t) {
  var r, a, i, o, s;
  t.rtl ? s = t.slideCount - 1 - t.index : s = t.index, i = s < 0 || s >= t.slideCount, t.centerMode ? (o = Math.floor(t.slidesToShow / 2), a = (s - t.currentSlide) % t.slideCount === 0, s > t.currentSlide - o - 1 && s <= t.currentSlide + o && (r = !0)) : r = t.currentSlide <= s && s < t.currentSlide + t.slidesToShow;
  var l;
  t.targetSlide < 0 ? l = t.targetSlide + t.slideCount : t.targetSlide >= t.slideCount ? l = t.targetSlide - t.slideCount : l = t.targetSlide;
  var d = s === l;
  return {
    "slick-slide": !0,
    "slick-active": r,
    "slick-center": a,
    "slick-cloned": i,
    "slick-current": d
    // dubious in case of RTL
  };
}, Bs = function(t) {
  var r = {};
  return (t.variableWidth === void 0 || t.variableWidth === !1) && (r.width = t.slideWidth), t.fade && (r.position = "relative", t.vertical && t.slideHeight ? r.top = -t.index * parseInt(t.slideHeight) : r.left = -t.index * parseInt(t.slideWidth), r.opacity = t.currentSlide === t.index ? 1 : 0, t.useCSS && (r.transition = "opacity " + t.speed + "ms " + t.cssEase + ", visibility " + t.speed + "ms " + t.cssEase)), r;
}, Fn = function(t, r) {
  return t.key + "-" + r;
}, Us = function(t) {
  var r, a = [], i = [], o = [], s = re.Children.count(t.children), l = Ci(t), d = Ni(t);
  return re.Children.forEach(t.children, function(c, u) {
    var h, p = {
      message: "children",
      index: u,
      slidesToScroll: t.slidesToScroll,
      currentSlide: t.currentSlide
    };
    !t.lazyLoad || t.lazyLoad && t.lazyLoadedList.indexOf(u) >= 0 ? h = c : h = /* @__PURE__ */ re.createElement("div", null);
    var m = Bs(M(M({}, t), {}, {
      index: u
    })), _ = h.props.className || "", T = xn(M(M({}, t), {}, {
      index: u
    }));
    if (a.push(/* @__PURE__ */ re.cloneElement(h, {
      key: "original" + Fn(h, u),
      "data-index": u,
      className: ct(T, _),
      tabIndex: "-1",
      "aria-hidden": !T["slick-active"],
      style: M(M({
        outline: "none"
      }, h.props.style || {}), m),
      onClick: function(g) {
        h.props && h.props.onClick && h.props.onClick(g), t.focusOnSelect && t.focusOnSelect(p);
      }
    })), t.infinite && t.fade === !1) {
      var y = s - u;
      y <= tt(t) && s !== t.slidesToShow && (r = -y, r >= l && (h = c), T = xn(M(M({}, t), {}, {
        index: r
      })), i.push(/* @__PURE__ */ re.cloneElement(h, {
        key: "precloned" + Fn(h, r),
        "data-index": r,
        tabIndex: "-1",
        className: ct(T, _),
        "aria-hidden": !T["slick-active"],
        style: M(M({}, h.props.style || {}), m),
        onClick: function(g) {
          h.props && h.props.onClick && h.props.onClick(g), t.focusOnSelect && t.focusOnSelect(p);
        }
      }))), s !== t.slidesToShow && (r = s + u, r < d && (h = c), T = xn(M(M({}, t), {}, {
        index: r
      })), o.push(/* @__PURE__ */ re.cloneElement(h, {
        key: "postcloned" + Fn(h, r),
        "data-index": r,
        tabIndex: "-1",
        className: ct(T, _),
        "aria-hidden": !T["slick-active"],
        style: M(M({}, h.props.style || {}), m),
        onClick: function(g) {
          h.props && h.props.onClick && h.props.onClick(g), t.focusOnSelect && t.focusOnSelect(p);
        }
      })));
    }
  }), t.rtl ? i.concat(a, o).reverse() : i.concat(a, o);
}, Hs = /* @__PURE__ */ function(n) {
  Pt(r, n);
  var t = wt(r);
  function r() {
    var a;
    Rt(this, r);
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return a = t.call.apply(t, [this].concat(o)), ae(ie(a), "node", null), ae(ie(a), "handleRef", function(l) {
      a.node = l;
    }), a;
  }
  return Dt(r, [{
    key: "render",
    value: function() {
      var i = Us(this.props), o = this.props, s = o.onMouseEnter, l = o.onMouseOver, d = o.onMouseLeave, c = {
        onMouseEnter: s,
        onMouseOver: l,
        onMouseLeave: d
      };
      return /* @__PURE__ */ re.createElement("div", st({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, c), i);
    }
  }]), r;
}(re.PureComponent), Ws = function(t) {
  var r;
  return t.infinite ? r = Math.ceil(t.slideCount / t.slidesToScroll) : r = Math.ceil((t.slideCount - t.slidesToShow) / t.slidesToScroll) + 1, r;
}, Vs = /* @__PURE__ */ function(n) {
  Pt(r, n);
  var t = wt(r);
  function r() {
    return Rt(this, r), t.apply(this, arguments);
  }
  return Dt(r, [{
    key: "clickHandler",
    value: function(i, o) {
      o.preventDefault(), this.props.clickHandler(i);
    }
  }, {
    key: "render",
    value: function() {
      for (var i = this.props, o = i.onMouseEnter, s = i.onMouseOver, l = i.onMouseLeave, d = i.infinite, c = i.slidesToScroll, u = i.slidesToShow, h = i.slideCount, p = i.currentSlide, m = Ws({
        slideCount: h,
        slidesToScroll: c,
        slidesToShow: u,
        infinite: d
      }), _ = {
        onMouseEnter: o,
        onMouseOver: s,
        onMouseLeave: l
      }, T = [], y = 0; y < m; y++) {
        var v = (y + 1) * c - 1, g = d ? v : er(v, 0, h - 1), S = g - (c - 1), b = d ? S : er(S, 0, h - 1), $ = ct({
          "slick-active": d ? p >= b && p <= g : p === b
        }), P = {
          message: "dots",
          index: y,
          slidesToScroll: c,
          currentSlide: p
        }, G = this.clickHandler.bind(this, P);
        T = T.concat(/* @__PURE__ */ re.createElement("li", {
          key: y,
          className: $
        }, /* @__PURE__ */ re.cloneElement(this.props.customPaging(y), {
          onClick: G
        })));
      }
      return /* @__PURE__ */ re.cloneElement(this.props.appendDots(T), M({
        className: this.props.dotsClass
      }, _));
    }
  }]), r;
}(re.PureComponent), Gs = /* @__PURE__ */ function(n) {
  Pt(r, n);
  var t = wt(r);
  function r() {
    return Rt(this, r), t.apply(this, arguments);
  }
  return Dt(r, [{
    key: "clickHandler",
    value: function(i, o) {
      o && o.preventDefault(), this.props.clickHandler(i, o);
    }
  }, {
    key: "render",
    value: function() {
      var i = {
        "slick-arrow": !0,
        "slick-prev": !0
      }, o = this.clickHandler.bind(this, {
        message: "previous"
      });
      !this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow) && (i["slick-disabled"] = !0, o = null);
      var s = {
        key: "0",
        "data-role": "none",
        className: ct(i),
        style: {
          display: "block"
        },
        onClick: o
      }, l = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, d;
      return this.props.prevArrow ? d = /* @__PURE__ */ re.cloneElement(this.props.prevArrow, M(M({}, s), l)) : d = /* @__PURE__ */ re.createElement("button", st({
        key: "0",
        type: "button"
      }, s), " ", "Previous"), d;
    }
  }]), r;
}(re.PureComponent), Ks = /* @__PURE__ */ function(n) {
  Pt(r, n);
  var t = wt(r);
  function r() {
    return Rt(this, r), t.apply(this, arguments);
  }
  return Dt(r, [{
    key: "clickHandler",
    value: function(i, o) {
      o && o.preventDefault(), this.props.clickHandler(i, o);
    }
  }, {
    key: "render",
    value: function() {
      var i = {
        "slick-arrow": !0,
        "slick-next": !0
      }, o = this.clickHandler.bind(this, {
        message: "next"
      });
      Nn(this.props) || (i["slick-disabled"] = !0, o = null);
      var s = {
        key: "1",
        "data-role": "none",
        className: ct(i),
        style: {
          display: "block"
        },
        onClick: o
      }, l = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, d;
      return this.props.nextArrow ? d = /* @__PURE__ */ re.cloneElement(this.props.nextArrow, M(M({}, s), l)) : d = /* @__PURE__ */ re.createElement("button", st({
        key: "1",
        type: "button"
      }, s), " ", "Next"), d;
    }
  }]), r;
}(re.PureComponent), Ai = function() {
  if (typeof Map < "u")
    return Map;
  function n(t, r) {
    var a = -1;
    return t.some(function(i, o) {
      return i[0] === r ? (a = o, !0) : !1;
    }), a;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(r) {
        var a = n(this.__entries__, r), i = this.__entries__[a];
        return i && i[1];
      }, t.prototype.set = function(r, a) {
        var i = n(this.__entries__, r);
        ~i ? this.__entries__[i][1] = a : this.__entries__.push([r, a]);
      }, t.prototype.delete = function(r) {
        var a = this.__entries__, i = n(a, r);
        ~i && a.splice(i, 1);
      }, t.prototype.has = function(r) {
        return !!~n(this.__entries__, r);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(r, a) {
        a === void 0 && (a = null);
        for (var i = 0, o = this.__entries__; i < o.length; i++) {
          var s = o[i];
          r.call(a, s[1], s[0]);
        }
      }, t;
    }()
  );
}(), nr = typeof window < "u" && typeof document < "u" && window.document === document, $n = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), js = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind($n) : function(n) {
    return setTimeout(function() {
      return n(Date.now());
    }, 1e3 / 60);
  };
}(), Ys = 2;
function zs(n, t) {
  var r = !1, a = !1, i = 0;
  function o() {
    r && (r = !1, n()), a && l();
  }
  function s() {
    js(o);
  }
  function l() {
    var d = Date.now();
    if (r) {
      if (d - i < Ys)
        return;
      a = !0;
    } else
      r = !0, a = !1, setTimeout(s, t);
    i = d;
  }
  return l;
}
var Xs = 20, qs = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], Zs = typeof MutationObserver < "u", Js = (
  /** @class */
  function() {
    function n() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = zs(this.refresh.bind(this), Xs);
    }
    return n.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, n.prototype.removeObserver = function(t) {
      var r = this.observers_, a = r.indexOf(t);
      ~a && r.splice(a, 1), !r.length && this.connected_ && this.disconnect_();
    }, n.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, n.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(r) {
        return r.gatherActive(), r.hasActive();
      });
      return t.forEach(function(r) {
        return r.broadcastActive();
      }), t.length > 0;
    }, n.prototype.connect_ = function() {
      !nr || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Zs ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, n.prototype.disconnect_ = function() {
      !nr || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, n.prototype.onTransitionEnd_ = function(t) {
      var r = t.propertyName, a = r === void 0 ? "" : r, i = qs.some(function(o) {
        return !!~a.indexOf(o);
      });
      i && this.refresh();
    }, n.getInstance = function() {
      return this.instance_ || (this.instance_ = new n()), this.instance_;
    }, n.instance_ = null, n;
  }()
), Ii = function(n, t) {
  for (var r = 0, a = Object.keys(t); r < a.length; r++) {
    var i = a[r];
    Object.defineProperty(n, i, {
      value: t[i],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return n;
}, At = function(n) {
  var t = n && n.ownerDocument && n.ownerDocument.defaultView;
  return t || $n;
}, Ri = Sn(0, 0, 0, 0);
function _n(n) {
  return parseFloat(n) || 0;
}
function Zr(n) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return t.reduce(function(a, i) {
    var o = n["border-" + i + "-width"];
    return a + _n(o);
  }, 0);
}
function Qs(n) {
  for (var t = ["top", "right", "bottom", "left"], r = {}, a = 0, i = t; a < i.length; a++) {
    var o = i[a], s = n["padding-" + o];
    r[o] = _n(s);
  }
  return r;
}
function el(n) {
  var t = n.getBBox();
  return Sn(0, 0, t.width, t.height);
}
function tl(n) {
  var t = n.clientWidth, r = n.clientHeight;
  if (!t && !r)
    return Ri;
  var a = At(n).getComputedStyle(n), i = Qs(a), o = i.left + i.right, s = i.top + i.bottom, l = _n(a.width), d = _n(a.height);
  if (a.boxSizing === "border-box" && (Math.round(l + o) !== t && (l -= Zr(a, "left", "right") + o), Math.round(d + s) !== r && (d -= Zr(a, "top", "bottom") + s)), !rl(n)) {
    var c = Math.round(l + o) - t, u = Math.round(d + s) - r;
    Math.abs(c) !== 1 && (l -= c), Math.abs(u) !== 1 && (d -= u);
  }
  return Sn(i.left, i.top, l, d);
}
var nl = function() {
  return typeof SVGGraphicsElement < "u" ? function(n) {
    return n instanceof At(n).SVGGraphicsElement;
  } : function(n) {
    return n instanceof At(n).SVGElement && typeof n.getBBox == "function";
  };
}();
function rl(n) {
  return n === At(n).document.documentElement;
}
function al(n) {
  return nr ? nl(n) ? el(n) : tl(n) : Ri;
}
function il(n) {
  var t = n.x, r = n.y, a = n.width, i = n.height, o = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, s = Object.create(o.prototype);
  return Ii(s, {
    x: t,
    y: r,
    width: a,
    height: i,
    top: r,
    right: t + a,
    bottom: i + r,
    left: t
  }), s;
}
function Sn(n, t, r, a) {
  return { x: n, y: t, width: r, height: a };
}
var ol = (
  /** @class */
  function() {
    function n(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Sn(0, 0, 0, 0), this.target = t;
    }
    return n.prototype.isActive = function() {
      var t = al(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, n.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, n;
  }()
), sl = (
  /** @class */
  function() {
    function n(t, r) {
      var a = il(r);
      Ii(this, { target: t, contentRect: a });
    }
    return n;
  }()
), ll = (
  /** @class */
  function() {
    function n(t, r, a) {
      if (this.activeObservations_ = [], this.observations_ = new Ai(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = r, this.callbackCtx_ = a;
    }
    return n.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof At(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) || (r.set(t, new ol(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, n.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof At(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) && (r.delete(t), r.size || this.controller_.removeObserver(this));
      }
    }, n.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, n.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(r) {
        r.isActive() && t.activeObservations_.push(r);
      });
    }, n.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, r = this.activeObservations_.map(function(a) {
          return new sl(a.target, a.broadcastRect());
        });
        this.callback_.call(t, r, t), this.clearActive();
      }
    }, n.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, n.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, n;
  }()
), Di = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new Ai(), Pi = (
  /** @class */
  function() {
    function n(t) {
      if (!(this instanceof n))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var r = Js.getInstance(), a = new ll(t, r, this);
      Di.set(this, a);
    }
    return n;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(n) {
  Pi.prototype[n] = function() {
    var t;
    return (t = Di.get(this))[n].apply(t, arguments);
  };
});
var dl = function() {
  return typeof $n.ResizeObserver < "u" ? $n.ResizeObserver : Pi;
}(), cl = ["animating"], ul = /* @__PURE__ */ function(n) {
  Pt(r, n);
  var t = wt(r);
  function r(a) {
    var i;
    Rt(this, r), i = t.call(this, a), ae(ie(i), "listRefHandler", function(s) {
      return i.list = s;
    }), ae(ie(i), "trackRefHandler", function(s) {
      return i.track = s;
    }), ae(ie(i), "adaptHeight", function() {
      if (i.props.adaptiveHeight && i.list) {
        var s = i.list.querySelector('[data-index="'.concat(i.state.currentSlide, '"]'));
        i.list.style.height = Sr(s) + "px";
      }
    }), ae(ie(i), "componentDidMount", function() {
      if (i.props.onInit && i.props.onInit(), i.props.lazyLoad) {
        var s = mn(M(M({}, i.props), i.state));
        s.length > 0 && (i.setState(function(d) {
          return {
            lazyLoadedList: d.lazyLoadedList.concat(s)
          };
        }), i.props.onLazyLoad && i.props.onLazyLoad(s));
      }
      var l = M({
        listRef: i.list,
        trackRef: i.track
      }, i.props);
      i.updateState(l, !0, function() {
        i.adaptHeight(), i.props.autoplay && i.autoPlay("playing");
      }), i.props.lazyLoad === "progressive" && (i.lazyLoadTimer = setInterval(i.progressiveLazyLoad, 1e3)), i.ro = new dl(function() {
        i.state.animating ? (i.onWindowResized(!1), i.callbackTimers.push(setTimeout(function() {
          return i.onWindowResized();
        }, i.props.speed))) : i.onWindowResized();
      }), i.ro.observe(i.list), document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(d) {
        d.onfocus = i.props.pauseOnFocus ? i.onSlideFocus : null, d.onblur = i.props.pauseOnFocus ? i.onSlideBlur : null;
      }), window.addEventListener ? window.addEventListener("resize", i.onWindowResized) : window.attachEvent("onresize", i.onWindowResized);
    }), ae(ie(i), "componentWillUnmount", function() {
      i.animationEndCallback && clearTimeout(i.animationEndCallback), i.lazyLoadTimer && clearInterval(i.lazyLoadTimer), i.callbackTimers.length && (i.callbackTimers.forEach(function(s) {
        return clearTimeout(s);
      }), i.callbackTimers = []), window.addEventListener ? window.removeEventListener("resize", i.onWindowResized) : window.detachEvent("onresize", i.onWindowResized), i.autoplayTimer && clearInterval(i.autoplayTimer), i.ro.disconnect();
    }), ae(ie(i), "componentDidUpdate", function(s) {
      if (i.checkImagesLoad(), i.props.onReInit && i.props.onReInit(), i.props.lazyLoad) {
        var l = mn(M(M({}, i.props), i.state));
        l.length > 0 && (i.setState(function(u) {
          return {
            lazyLoadedList: u.lazyLoadedList.concat(l)
          };
        }), i.props.onLazyLoad && i.props.onLazyLoad(l));
      }
      i.adaptHeight();
      var d = M(M({
        listRef: i.list,
        trackRef: i.track
      }, i.props), i.state), c = i.didPropsChange(s);
      c && i.updateState(d, c, function() {
        i.state.currentSlide >= re.Children.count(i.props.children) && i.changeSlide({
          message: "index",
          index: re.Children.count(i.props.children) - i.props.slidesToShow,
          currentSlide: i.state.currentSlide
        }), (s.autoplay !== i.props.autoplay || s.autoplaySpeed !== i.props.autoplaySpeed) && (!s.autoplay && i.props.autoplay ? i.autoPlay("playing") : i.props.autoplay ? i.autoPlay("update") : i.pause("paused"));
      });
    }), ae(ie(i), "onWindowResized", function(s) {
      i.debouncedResize && i.debouncedResize.cancel(), i.debouncedResize = Es(50, function() {
        return i.resizeWindow(s);
      }), i.debouncedResize();
    }), ae(ie(i), "resizeWindow", function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, l = !!(i.track && i.track.node);
      if (l) {
        var d = M(M({
          listRef: i.list,
          trackRef: i.track
        }, i.props), i.state);
        i.updateState(d, s, function() {
          i.props.autoplay ? i.autoPlay("update") : i.pause("paused");
        }), i.setState({
          animating: !1
        }), clearTimeout(i.animationEndCallback), delete i.animationEndCallback;
      }
    }), ae(ie(i), "updateState", function(s, l, d) {
      var c = Os(s);
      s = M(M(M({}, s), c), {}, {
        slideIndex: c.currentSlide
      });
      var u = Kt(s);
      s = M(M({}, s), {}, {
        left: u
      });
      var h = Gt(s);
      (l || re.Children.count(i.props.children) !== re.Children.count(s.children)) && (c.trackStyle = h), i.setState(c, d);
    }), ae(ie(i), "ssrInit", function() {
      if (i.props.variableWidth) {
        var s = 0, l = 0, d = [], c = tt(M(M(M({}, i.props), i.state), {}, {
          slideCount: i.props.children.length
        })), u = cn(M(M(M({}, i.props), i.state), {}, {
          slideCount: i.props.children.length
        }));
        i.props.children.forEach(function(G) {
          d.push(G.props.style.width), s += G.props.style.width;
        });
        for (var h = 0; h < c; h++)
          l += d[d.length - 1 - h], s += d[d.length - 1 - h];
        for (var p = 0; p < u; p++)
          s += d[p];
        for (var m = 0; m < i.state.currentSlide; m++)
          l += d[m];
        var _ = {
          width: s + "px",
          left: -l + "px"
        };
        if (i.props.centerMode) {
          var T = "".concat(d[i.state.currentSlide], "px");
          _.left = "calc(".concat(_.left, " + (100% - ").concat(T, ") / 2 ) ");
        }
        return {
          trackStyle: _
        };
      }
      var y = re.Children.count(i.props.children), v = M(M(M({}, i.props), i.state), {}, {
        slideCount: y
      }), g = tt(v) + cn(v) + y, S = 100 / i.props.slidesToShow * g, b = 100 / g, $ = -b * (tt(v) + i.state.currentSlide) * S / 100;
      i.props.centerMode && ($ += (100 - b * S / 100) / 2);
      var P = {
        width: S + "%",
        left: $ + "%"
      };
      return {
        slideWidth: b + "%",
        trackStyle: P
      };
    }), ae(ie(i), "checkImagesLoad", function() {
      var s = i.list && i.list.querySelectorAll && i.list.querySelectorAll(".slick-slide img") || [], l = s.length, d = 0;
      Array.prototype.forEach.call(s, function(c) {
        var u = function() {
          return ++d && d >= l && i.onWindowResized();
        };
        if (!c.onclick)
          c.onclick = function() {
            return c.parentNode.focus();
          };
        else {
          var h = c.onclick;
          c.onclick = function(p) {
            h(p), c.parentNode.focus();
          };
        }
        c.onload || (i.props.lazyLoad ? c.onload = function() {
          i.adaptHeight(), i.callbackTimers.push(setTimeout(i.onWindowResized, i.props.speed));
        } : (c.onload = u, c.onerror = function() {
          u(), i.props.onLazyLoadError && i.props.onLazyLoadError();
        }));
      });
    }), ae(ie(i), "progressiveLazyLoad", function() {
      for (var s = [], l = M(M({}, i.props), i.state), d = i.state.currentSlide; d < i.state.slideCount + cn(l); d++)
        if (i.state.lazyLoadedList.indexOf(d) < 0) {
          s.push(d);
          break;
        }
      for (var c = i.state.currentSlide - 1; c >= -tt(l); c--)
        if (i.state.lazyLoadedList.indexOf(c) < 0) {
          s.push(c);
          break;
        }
      s.length > 0 ? (i.setState(function(u) {
        return {
          lazyLoadedList: u.lazyLoadedList.concat(s)
        };
      }), i.props.onLazyLoad && i.props.onLazyLoad(s)) : i.lazyLoadTimer && (clearInterval(i.lazyLoadTimer), delete i.lazyLoadTimer);
    }), ae(ie(i), "slideHandler", function(s) {
      var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, d = i.props, c = d.asNavFor, u = d.beforeChange, h = d.onLazyLoad, p = d.speed, m = d.afterChange, _ = i.state.currentSlide, T = As(M(M(M({
        index: s
      }, i.props), i.state), {}, {
        trackRef: i.track,
        useCSS: i.props.useCSS && !l
      })), y = T.state, v = T.nextState;
      if (y) {
        u && u(_, y.currentSlide);
        var g = y.lazyLoadedList.filter(function(S) {
          return i.state.lazyLoadedList.indexOf(S) < 0;
        });
        h && g.length > 0 && h(g), !i.props.waitForAnimate && i.animationEndCallback && (clearTimeout(i.animationEndCallback), m && m(_), delete i.animationEndCallback), i.setState(y, function() {
          c && i.asNavForIndex !== s && (i.asNavForIndex = s, c.innerSlider.slideHandler(s)), v && (i.animationEndCallback = setTimeout(function() {
            var S = v.animating, b = Ts(v, cl);
            i.setState(b, function() {
              i.callbackTimers.push(setTimeout(function() {
                return i.setState({
                  animating: S
                });
              }, 10)), m && m(y.currentSlide), delete i.animationEndCallback;
            });
          }, p));
        });
      }
    }), ae(ie(i), "changeSlide", function(s) {
      var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, d = M(M({}, i.props), i.state), c = Is(d, s);
      if (!(c !== 0 && !c) && (l === !0 ? i.slideHandler(c, l) : i.slideHandler(c), i.props.autoplay && i.autoPlay("update"), i.props.focusOnSelect)) {
        var u = i.list.querySelectorAll(".slick-current");
        u[0] && u[0].focus();
      }
    }), ae(ie(i), "clickHandler", function(s) {
      i.clickable === !1 && (s.stopPropagation(), s.preventDefault()), i.clickable = !0;
    }), ae(ie(i), "keyHandler", function(s) {
      var l = Rs(s, i.props.accessibility, i.props.rtl);
      l !== "" && i.changeSlide({
        message: l
      });
    }), ae(ie(i), "selectHandler", function(s) {
      i.changeSlide(s);
    }), ae(ie(i), "disableBodyScroll", function() {
      var s = function(d) {
        d = d || window.event, d.preventDefault && d.preventDefault(), d.returnValue = !1;
      };
      window.ontouchmove = s;
    }), ae(ie(i), "enableBodyScroll", function() {
      window.ontouchmove = null;
    }), ae(ie(i), "swipeStart", function(s) {
      i.props.verticalSwiping && i.disableBodyScroll();
      var l = Ds(s, i.props.swipe, i.props.draggable);
      l !== "" && i.setState(l);
    }), ae(ie(i), "swipeMove", function(s) {
      var l = Ps(s, M(M(M({}, i.props), i.state), {}, {
        trackRef: i.track,
        listRef: i.list,
        slideIndex: i.state.currentSlide
      }));
      l && (l.swiping && (i.clickable = !1), i.setState(l));
    }), ae(ie(i), "swipeEnd", function(s) {
      var l = ws(s, M(M(M({}, i.props), i.state), {}, {
        trackRef: i.track,
        listRef: i.list,
        slideIndex: i.state.currentSlide
      }));
      if (l) {
        var d = l.triggerSlideHandler;
        delete l.triggerSlideHandler, i.setState(l), d !== void 0 && (i.slideHandler(d), i.props.verticalSwiping && i.enableBodyScroll());
      }
    }), ae(ie(i), "touchEnd", function(s) {
      i.swipeEnd(s), i.clickable = !0;
    }), ae(ie(i), "slickPrev", function() {
      i.callbackTimers.push(setTimeout(function() {
        return i.changeSlide({
          message: "previous"
        });
      }, 0));
    }), ae(ie(i), "slickNext", function() {
      i.callbackTimers.push(setTimeout(function() {
        return i.changeSlide({
          message: "next"
        });
      }, 0));
    }), ae(ie(i), "slickGoTo", function(s) {
      var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (s = Number(s), isNaN(s))
        return "";
      i.callbackTimers.push(setTimeout(function() {
        return i.changeSlide({
          message: "index",
          index: s,
          currentSlide: i.state.currentSlide
        }, l);
      }, 0));
    }), ae(ie(i), "play", function() {
      var s;
      if (i.props.rtl)
        s = i.state.currentSlide - i.props.slidesToScroll;
      else if (Nn(M(M({}, i.props), i.state)))
        s = i.state.currentSlide + i.props.slidesToScroll;
      else
        return !1;
      i.slideHandler(s);
    }), ae(ie(i), "autoPlay", function(s) {
      i.autoplayTimer && clearInterval(i.autoplayTimer);
      var l = i.state.autoplaying;
      if (s === "update") {
        if (l === "hovered" || l === "focused" || l === "paused")
          return;
      } else if (s === "leave") {
        if (l === "paused" || l === "focused")
          return;
      } else if (s === "blur" && (l === "paused" || l === "hovered"))
        return;
      i.autoplayTimer = setInterval(i.play, i.props.autoplaySpeed + 50), i.setState({
        autoplaying: "playing"
      });
    }), ae(ie(i), "pause", function(s) {
      i.autoplayTimer && (clearInterval(i.autoplayTimer), i.autoplayTimer = null);
      var l = i.state.autoplaying;
      s === "paused" ? i.setState({
        autoplaying: "paused"
      }) : s === "focused" ? (l === "hovered" || l === "playing") && i.setState({
        autoplaying: "focused"
      }) : l === "playing" && i.setState({
        autoplaying: "hovered"
      });
    }), ae(ie(i), "onDotsOver", function() {
      return i.props.autoplay && i.pause("hovered");
    }), ae(ie(i), "onDotsLeave", function() {
      return i.props.autoplay && i.state.autoplaying === "hovered" && i.autoPlay("leave");
    }), ae(ie(i), "onTrackOver", function() {
      return i.props.autoplay && i.pause("hovered");
    }), ae(ie(i), "onTrackLeave", function() {
      return i.props.autoplay && i.state.autoplaying === "hovered" && i.autoPlay("leave");
    }), ae(ie(i), "onSlideFocus", function() {
      return i.props.autoplay && i.pause("focused");
    }), ae(ie(i), "onSlideBlur", function() {
      return i.props.autoplay && i.state.autoplaying === "focused" && i.autoPlay("blur");
    }), ae(ie(i), "render", function() {
      var s = ct("slick-slider", i.props.className, {
        "slick-vertical": i.props.vertical,
        "slick-initialized": !0
      }), l = M(M({}, i.props), i.state), d = Ln(l, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]), c = i.props.pauseOnHover;
      d = M(M({}, d), {}, {
        onMouseEnter: c ? i.onTrackOver : null,
        onMouseLeave: c ? i.onTrackLeave : null,
        onMouseOver: c ? i.onTrackOver : null,
        focusOnSelect: i.props.focusOnSelect && i.clickable ? i.selectHandler : null
      });
      var u;
      if (i.props.dots === !0 && i.state.slideCount >= i.props.slidesToShow) {
        var h = Ln(l, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]), p = i.props.pauseOnDotsHover;
        h = M(M({}, h), {}, {
          clickHandler: i.changeSlide,
          onMouseEnter: p ? i.onDotsLeave : null,
          onMouseOver: p ? i.onDotsOver : null,
          onMouseLeave: p ? i.onDotsLeave : null
        }), u = /* @__PURE__ */ re.createElement(Vs, h);
      }
      var m, _, T = Ln(l, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      T.clickHandler = i.changeSlide, i.props.arrows && (m = /* @__PURE__ */ re.createElement(Gs, T), _ = /* @__PURE__ */ re.createElement(Ks, T));
      var y = null;
      i.props.vertical && (y = {
        height: i.state.listHeight
      });
      var v = null;
      i.props.vertical === !1 ? i.props.centerMode === !0 && (v = {
        padding: "0px " + i.props.centerPadding
      }) : i.props.centerMode === !0 && (v = {
        padding: i.props.centerPadding + " 0px"
      });
      var g = M(M({}, y), v), S = i.props.touchMove, b = {
        className: "slick-list",
        style: g,
        onClick: i.clickHandler,
        onMouseDown: S ? i.swipeStart : null,
        onMouseMove: i.state.dragging && S ? i.swipeMove : null,
        onMouseUp: S ? i.swipeEnd : null,
        onMouseLeave: i.state.dragging && S ? i.swipeEnd : null,
        onTouchStart: S ? i.swipeStart : null,
        onTouchMove: i.state.dragging && S ? i.swipeMove : null,
        onTouchEnd: S ? i.touchEnd : null,
        onTouchCancel: i.state.dragging && S ? i.swipeEnd : null,
        onKeyDown: i.props.accessibility ? i.keyHandler : null
      }, $ = {
        className: s,
        dir: "ltr",
        style: i.props.style
      };
      return i.props.unslick && (b = {
        className: "slick-list"
      }, $ = {
        className: s,
        style: i.props.style
      }), /* @__PURE__ */ re.createElement("div", $, i.props.unslick ? "" : m, /* @__PURE__ */ re.createElement("div", st({
        ref: i.listRefHandler
      }, b), /* @__PURE__ */ re.createElement(Hs, st({
        ref: i.trackRefHandler
      }, d), i.props.children)), i.props.unslick ? "" : _, i.props.unslick ? "" : u);
    }), i.list = null, i.track = null, i.state = M(M({}, vs), {}, {
      currentSlide: i.props.initialSlide,
      slideCount: re.Children.count(i.props.children)
    }), i.callbackTimers = [], i.clickable = !0, i.debouncedResize = null;
    var o = i.ssrInit();
    return i.state = M(M({}, i.state), o), i;
  }
  return Dt(r, [{
    key: "didPropsChange",
    value: function(i) {
      for (var o = !1, s = 0, l = Object.keys(this.props); s < l.length; s++) {
        var d = l[s];
        if (!i.hasOwnProperty(d)) {
          o = !0;
          break;
        }
        if (!(pt(i[d]) === "object" || typeof i[d] == "function") && i[d] !== this.props[d]) {
          o = !0;
          break;
        }
      }
      return o || re.Children.count(this.props.children) !== re.Children.count(i.children);
    }
  }]), r;
}(re.Component), fl = function(n) {
  return n.replace(/[A-Z]/g, function(t) {
    return "-" + t.toLowerCase();
  }).toLowerCase();
}, hl = fl, pl = hl, ml = function(n) {
  var t = /[height|width]$/;
  return t.test(n);
}, Jr = function(n) {
  var t = "", r = Object.keys(n);
  return r.forEach(function(a, i) {
    var o = n[a];
    a = pl(a), ml(a) && typeof o == "number" && (o = o + "px"), o === !0 ? t += a : o === !1 ? t += "not " + a : t += "(" + a + ": " + o + ")", i < r.length - 1 && (t += " and ");
  }), t;
}, $l = function(n) {
  var t = "";
  return typeof n == "string" ? n : n instanceof Array ? (n.forEach(function(r, a) {
    t += Jr(r), a < n.length - 1 && (t += ", ");
  }), t) : Jr(n);
}, _l = $l;
const Mn = /* @__PURE__ */ Nr(_l);
var Qr = {
  accessibility: !0,
  adaptiveHeight: !1,
  afterChange: null,
  appendDots: function(t) {
    return /* @__PURE__ */ re.createElement("ul", {
      style: {
        display: "block"
      }
    }, t);
  },
  arrows: !0,
  autoplay: !1,
  autoplaySpeed: 3e3,
  beforeChange: null,
  centerMode: !1,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function(t) {
    return /* @__PURE__ */ re.createElement("button", null, t + 1);
  },
  dots: !1,
  dotsClass: "slick-dots",
  draggable: !0,
  easing: "linear",
  edgeFriction: 0.35,
  fade: !1,
  focusOnSelect: !1,
  infinite: !0,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: !1,
  pauseOnFocus: !1,
  pauseOnHover: !0,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: !1,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: !0,
  swipeEvent: null,
  swipeToSlide: !1,
  touchMove: !0,
  touchThreshold: 5,
  useCSS: !0,
  useTransform: !0,
  variableWidth: !1,
  vertical: !1,
  waitForAnimate: !0
}, gl = /* @__PURE__ */ function(n) {
  Pt(r, n);
  var t = wt(r);
  function r(a) {
    var i;
    return Rt(this, r), i = t.call(this, a), ae(ie(i), "innerSliderRefHandler", function(o) {
      return i.innerSlider = o;
    }), ae(ie(i), "slickPrev", function() {
      return i.innerSlider.slickPrev();
    }), ae(ie(i), "slickNext", function() {
      return i.innerSlider.slickNext();
    }), ae(ie(i), "slickGoTo", function(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      return i.innerSlider.slickGoTo(o, s);
    }), ae(ie(i), "slickPause", function() {
      return i.innerSlider.pause("paused");
    }), ae(ie(i), "slickPlay", function() {
      return i.innerSlider.autoPlay("play");
    }), i.state = {
      breakpoint: null
    }, i._responsiveMediaHandlers = [], i;
  }
  return Dt(r, [{
    key: "media",
    value: function(i, o) {
      var s = window.matchMedia(i), l = function(c) {
        var u = c.matches;
        u && o();
      };
      s.addListener(l), l(s), this._responsiveMediaHandlers.push({
        mql: s,
        query: i,
        listener: l
      });
    }
    // handles responsive breakpoints
  }, {
    key: "componentDidMount",
    value: function() {
      var i = this;
      if (this.props.responsive) {
        var o = this.props.responsive.map(function(l) {
          return l.breakpoint;
        });
        o.sort(function(l, d) {
          return l - d;
        }), o.forEach(function(l, d) {
          var c;
          d === 0 ? c = Mn({
            minWidth: 0,
            maxWidth: l
          }) : c = Mn({
            minWidth: o[d - 1] + 1,
            maxWidth: l
          }), qr() && i.media(c, function() {
            i.setState({
              breakpoint: l
            });
          });
        });
        var s = Mn({
          minWidth: o.slice(-1)[0]
        });
        qr() && this.media(s, function() {
          i.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._responsiveMediaHandlers.forEach(function(i) {
        i.mql.removeListener(i.listener);
      });
    }
  }, {
    key: "render",
    value: function() {
      var i = this, o, s;
      this.state.breakpoint ? (s = this.props.responsive.filter(function(y) {
        return y.breakpoint === i.state.breakpoint;
      }), o = s[0].settings === "unslick" ? "unslick" : M(M(M({}, Qr), this.props), s[0].settings)) : o = M(M({}, Qr), this.props), o.centerMode && (o.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(o.slidesToScroll)), o.slidesToScroll = 1), o.fade && (o.slidesToShow > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(o.slidesToShow)), o.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(o.slidesToScroll)), o.slidesToShow = 1, o.slidesToScroll = 1);
      var l = re.Children.toArray(this.props.children);
      l = l.filter(function(y) {
        return typeof y == "string" ? !!y.trim() : !!y;
      }), o.variableWidth && (o.rows > 1 || o.slidesPerRow > 1) && (console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1"), o.variableWidth = !1);
      for (var d = [], c = null, u = 0; u < l.length; u += o.rows * o.slidesPerRow) {
        for (var h = [], p = u; p < u + o.rows * o.slidesPerRow; p += o.slidesPerRow) {
          for (var m = [], _ = p; _ < p + o.slidesPerRow && (o.variableWidth && l[_].props.style && (c = l[_].props.style.width), !(_ >= l.length)); _ += 1)
            m.push(/* @__PURE__ */ re.cloneElement(l[_], {
              key: 100 * u + 10 * p + _,
              tabIndex: -1,
              style: {
                width: "".concat(100 / o.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          h.push(/* @__PURE__ */ re.createElement("div", {
            key: 10 * u + p
          }, m));
        }
        o.variableWidth ? d.push(/* @__PURE__ */ re.createElement("div", {
          key: u,
          style: {
            width: c
          }
        }, h)) : d.push(/* @__PURE__ */ re.createElement("div", {
          key: u
        }, h));
      }
      if (o === "unslick") {
        var T = "regular slider " + (this.props.className || "");
        return /* @__PURE__ */ re.createElement("div", {
          className: T
        }, l);
      } else
        d.length <= o.slidesToShow && (o.unslick = !0);
      return /* @__PURE__ */ re.createElement(ul, st({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, o), d);
    }
  }]), r;
}(re.Component);
const Tl = "CAROUSEL_INDICATOR_DATA_TEST_ID_NEXT_BUTTON", vl = "CAROUSEL_INDICATOR_DATA_TEST_ID_PREV_BUTTON", yl = (n) => `CAROUSEL_INDICATOR_TEST_ID_PANCAKE_BUTTON_${n}`, El = "CAROUSEL_INDICATOR_TEST_ID_NO_PANCAKE_BUTTON", Ar = ({
  billboard: n,
  children: t,
  className: r,
  currentSlideIndex: a = 0,
  inlineDirectionalButtons: i = !1,
  numOfSlides: o = 1,
  numOfDisplayedSlides: s = 1,
  noPancakes: l = !1,
  settings: d = {
    dots: !1,
    arrows: !1,
    infinite: !1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  }
}) => {
  const [c, u] = ee(
    a
  ), h = !c, p = c === o - s, [m, _] = ee(null), T = ($) => {
    m.slickGoTo($);
  }, y = [];
  for (let $ = 0; $ < o; $++)
    y.push(
      /* @__PURE__ */ f(
        "li",
        {
          className: C(
            $ === c && Se.ACTIVE_PANCAKE_BUTTON
          ),
          children: /* @__PURE__ */ f(
            "button",
            {
              className: Se.PANCAKE_BUTTON,
              onClick: () => T($),
              "aria-label": `Click or press enter to view ${$ + 1} of ${o}`,
              "data-testid": yl($ + 1),
              children: /* @__PURE__ */ f("span", { className: Se.PANCAKE })
            }
          )
        },
        $
      )
    );
  const v = /* @__PURE__ */ f("ul", { className: Se.PANCAKE_BUTTONS, children: y }), g = c + 1, S = /* @__PURE__ */ f(
    "div",
    {
      "data-testid": El,
      role: "button",
      className: Se.PAGINATION_TEXT,
      "aria-label": `You are currently on Slide ${g} of ${o}`,
      tabIndex: 0,
      onKeyUp: ($) => {
        ["Enter", " "].includes($.key) && !p && T(c + 1);
      },
      children: s > 1 ? `${g} - ${c + s} of ${o}` : `${g} / ${o}`
    }
  );
  window.onkeydown = ($) => !($.key === " " && $.target?.className === Se.PAGINATION_TEXT);
  const b = /* @__PURE__ */ U(He, { children: [
    /* @__PURE__ */ f(
      "button",
      {
        className: C(
          Se.DIRECTIONAL_BUTTON,
          Se.DIRECTIONAL_BUTTON_PREVIOUS,
          h && Se.DISABLED_DIRECTIONAL_BUTTON
        ),
        onClick: () => T(c - 1),
        disabled: h,
        "aria-label": "previous button",
        "data-testid": vl
      }
    ),
    /* @__PURE__ */ f("div", { className: Se.PAGINATION, children: o > 4 || l ? S : v }),
    /* @__PURE__ */ f(
      "button",
      {
        className: C(
          Se.DIRECTIONAL_BUTTON,
          Se.DIRECTIONAL_BUTTON_NEXT,
          p && Se.DISABLED_DIRECTIONAL_BUTTON
        ),
        disabled: p,
        onClick: () => T(c + 1),
        "aria-label": "next button",
        "data-testid": Tl
      }
    )
  ] });
  return /* @__PURE__ */ U(
    "div",
    {
      className: C(
        Se.COMPONENT,
        i && Se.INLINE_DIRECTIONAL_BUTTONS,
        n && Se.CAROUSEL_INDICATOR_BILLBOARD,
        r
      ),
      children: [
        /* @__PURE__ */ f(
          gl,
          {
            ...d,
            initialSlide: c,
            ref: ($) => _($),
            afterChange: ($) => {
              u($);
            },
            children: t
          }
        ),
        /* @__PURE__ */ f("div", { className: Se.CAROUSEL_INDICATOR, children: n ? /* @__PURE__ */ f("div", { className: Se.CAROUSEL_INDICATOR_WRAPPER, children: b }) : b })
      ]
    }
  );
}, I1 = ({
  className: n,
  currentSlideIndex: t = 0,
  children: r = []
}) => {
  const a = Array.isArray(r);
  return /* @__PURE__ */ f(
    Ar,
    {
      billboard: !0,
      className: n,
      currentSlideIndex: t,
      numOfSlides: a ? r.length : 1,
      children: (a ? r : [r]).map((i, o) => /* @__PURE__ */ f(
        "div",
        {
          className: Se.SLIDE_IMAGE,
          children: i
        },
        `billboard-slide-wrapper-${o + 1}`
      ))
    }
  );
}, bl = 1024, R1 = ({
  className: n,
  currentSlideIndex: t = 0,
  children: r = []
}) => {
  le(null);
  const { width: a } = Er(), i = a < bl, o = Array.isArray(r), s = {
    dots: !1,
    arrows: !1,
    infinite: !1,
    speed: 500,
    slidesToShow: i ? 1 : 3,
    slidesToScroll: 1
  };
  return /* @__PURE__ */ f(
    Ar,
    {
      className: n,
      currentSlideIndex: t,
      noPancakes: !0,
      numOfSlides: o ? r.length : 1,
      numOfDisplayedSlides: i ? 1 : 3,
      settings: s,
      children: (o ? r : [r]).map((l, d) => /* @__PURE__ */ f(
        ps,
        {
          cardGroupClassName: Se.CARD_CAROUSEL_GROUP,
          children: l
        },
        `CardCarousel-CardGroup-${d + 1}`
      ))
    }
  );
}, D1 = ({
  className: n,
  currentSlideIndex: t = 0,
  inlineDirectionalButtons: r,
  children: a = []
}) => /* @__PURE__ */ f(He, { children: /* @__PURE__ */ f(
  Ar,
  {
    className: n,
    currentSlideIndex: t,
    inlineDirectionalButtons: r,
    numOfSlides: a.length,
    children: a
  }
) }), P1 = ({
  notificationStyle: n = "default",
  message: t = "",
  visible: r = !1,
  className: a,
  onDismiss: i
}) => {
  const [o, s] = Y.useState(!1), l = Y.useRef(0);
  function d() {
    i && i();
  }
  return Y.useEffect(() => {
    l.current > 2 && s(!r), l.current++;
  }, [r]), /* @__PURE__ */ f("div", { className: "fds-app", "aria-hidden": !r, children: /* @__PURE__ */ f("div", { className: C("fds-banner-notification__section", a), children: /* @__PURE__ */ f(
    "div",
    {
      "aria-live": "assertive",
      "aria-atomic": "true",
      className: C(
        "fds-banner-notification__section__type--dismissible"
      ),
      children: /* @__PURE__ */ U(
        "div",
        {
          id: "FDSDismissibleSuccessNotification",
          className: C(
            "fds-banner-notification",
            "fds-banner-notification__type--dismissible",
            n === "warning" && "fds-banner-notification__style--warning",
            n === "error" && "fds-banner-notification__style--error",
            n === "default" && "fds-banner-notification__style--default",
            n === "success" && "fds-banner-notification__style--success",
            o && "fds-banner-notification--hide",
            r === !0 && "fds-banner-notification--show"
          ),
          "data-testid": "BANNERNOTIFICATION_DATA_TEST_ID",
          children: [
            /* @__PURE__ */ f("div", { className: "fds-banner-notification__wrapper", children: /* @__PURE__ */ f("span", { className: "fds-banner-notification__content", children: /* @__PURE__ */ f("span", { className: "fds-banner-notification__text", children: t }) }) }),
            /* @__PURE__ */ f(
              "button",
              {
                className: "fds-banner-notification__close-button fds-font--ford-icons__clear fds-icon",
                "aria-label": "Close notification",
                onClick: d,
                "data-testid": "BANNER_NOTIFICATION_CLOSE_BUTTON_DATA_TEST_ID",
                "aria-hidden": !r,
                style: { visibility: r ? "visible" : "hidden" }
              }
            )
          ]
        }
      )
    }
  ) }) });
}, w1 = () => {
  const [n, t] = ee(void 0), [r, a] = ee("default"), [i, o] = ee(""), s = () => t(!n), l = async () => {
    n === !0 && (d(), await Go(600)), t(!0);
  }, d = () => {
    n && t(!1);
  };
  return {
    visible: n,
    notificationStyle: r,
    notificationMessage: i,
    setNotificationStyle: a,
    setNotificationMessage: o,
    toggleNotification: s,
    showNotification: l,
    hideNotification: d
  };
}, Cl = "BREADCRUMBS_DATA_TEST_ID", L1 = ({
  className: n,
  children: t,
  dataTestId: r = Cl
}) => /* @__PURE__ */ f("div", { className: C(n), children: /* @__PURE__ */ f("nav", { "aria-label": "breadcrumbs", children: /* @__PURE__ */ f("ul", { className: "fmc-breadcrumbs", "data-testid": r, children: t }) }) }), Nl = ({
  children: n,
  className: t,
  dataTestId: r = "BREADCRUMB__ITEM_DATA_TEST_ID"
}) => /* @__PURE__ */ f("div", { className: C(t), "data-testid": r, children: n });
Nl.displayName = "BreadcrumbItem";
const ea = {
  ANCHOR_TAG: "a",
  SPAN_TAG: "span"
}, Sl = ({
  key: n,
  href: t,
  as: r,
  children: a,
  active: i = !1,
  className: o,
  dataTestId: s = "BREADCRUMB__LINK_DATA_TEST_ID",
  ...l
}) => {
  const c = i ? /* @__PURE__ */ f(
    "span",
    {
      className: C(
        "fmc-breadcrumbs__text",
        "fmc-breadcrumbs__text__last",
        o
      ),
      "data-testid": s,
      "aria-current": "page",
      role: ea.SPAN_TAG,
      children: a
    },
    n
  ) : /* @__PURE__ */ f(
    r || "a",
    {
      href: t,
      className: "fmc-breadcrumbs__link",
      ...l,
      role: ea.ANCHOR_TAG,
      children: /* @__PURE__ */ f(
        "span",
        {
          className: C("fmc-breadcrumbs__text", o),
          "data-testid": s,
          children: a
        },
        n
      )
    }
  );
  return /* @__PURE__ */ f("li", { children: c });
};
Sl.displayName = "BreadcrumbLink";
const Ol = 100, Al = 50, mt = "SINGLE_DATE", Jt = "RANGE", jt = "MUTLI_DATE", ta = (n, t) => Array.from(Array(n).keys()).map((r) => ({
  value: r + 1,
  id: `${t}-${r}`
})), Ve = (n, t) => !n || !t ? !1 : n.day === t.day && n.month === t.month && n.year === t.year, Bt = (n) => ({ ...n }), Il = (n) => JSON.parse(JSON.stringify(n, (t, r) => typeof r > "u" ? null : r)), rr = (n, t) => {
  const r = t === "NEXT" ? 1 : -1;
  let a = n.month + r, i = n.year;
  return a < 1 && (a = 12, i -= 1), a > 12 && (a = 1, i += 1), { year: i, month: a, day: 1 };
}, Ut = (n, t) => Object.prototype.hasOwnProperty.call(n || {}, t), It = (n) => {
  if (Array.isArray(n))
    return jt;
  if (Ut(n, "from") && Ut(n, "to"))
    return Jt;
  if (!n || Ut(n, "year") && Ut(n, "month") && Ut(n, "day"))
    return mt;
  throw new TypeError(
    "The passed value is malformed! Please make sure you're using one of the valid value types for date picker."
  );
}, Rl = (n) => n && n[0].toUpperCase() + n.slice(1) || "", Dl = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], Pl = (n = "en-US", t = "long") => {
  const r = new Intl.DateTimeFormat(n, { month: t }).format;
  return Dl.map((a) => Rl(r(new Date(Date.UTC(2021, (a + 1) % 12)))));
}, wl = [0, 1, 2, 3, 4, 5, 6], Ll = (n = "es-US", t = "long") => {
  const r = new Intl.DateTimeFormat(n, { weekday: t }).format;
  return wl.map((a) => {
    const i = r(new Date(Date.UTC(2021, 5, a)));
    return {
      name: r(new Date(Date.UTC(2021, 5, a))),
      short: i.charAt(0).toUpperCase(),
      isWeekend: !(a % 6)
    };
  });
}, wi = (n) => typeof n == "string" ? {
  months: Pl(n),
  weekDays: Ll(n),
  weekStartingIndex: 0,
  getToday(t) {
    return t;
  },
  toNativeDate(t) {
    return new Date(t.year, t.month - 1, t.day);
  },
  getMonthLength(t) {
    return new Date(t.year, t.month, 0).getDate();
  },
  transformDigit(t) {
    return t;
  },
  nextMonth: "Next Month",
  previousMonth: "Previous Month",
  openMonthSelector: "Open Month Selector",
  openYearSelector: "Open Year Selector",
  closeMonthSelector: "Close Month Selector",
  closeYearSelector: "Close Year Selector",
  from: "from",
  to: "to",
  defaultPlaceholder: "Select...",
  digitSeparator: "/",
  yearLetterSkip: 0,
  isRtl: !1
} : n, xl = (n = "en_US") => {
  const {
    months: t,
    getToday: r,
    toNativeDate: a,
    getMonthLength: i,
    weekStartingIndex: o,
    transformDigit: s
  } = typeof n == "string" ? wi(n) : n;
  return {
    getToday: () => {
      const m = /* @__PURE__ */ new Date(), _ = m.getFullYear(), T = m.getMonth() + 1, y = m.getDate();
      return r({ year: _, month: T, day: y });
    },
    getMonthName: (m) => t[m - 1],
    getMonthNumber: (m) => t.indexOf(m) + 1,
    getMonthLength: i,
    getMonthFirstWeekday: (m) => (a({ ...m, day: 1 }).getDay() + o) % 7,
    isBeforeDate: (m, _) => !m || !_ ? !1 : a(m) < a(_),
    checkDayInDayRange: ({ day: m, from: _, to: T }) => {
      if (!m || !_ || !T)
        return !1;
      const y = a(m), v = a(_), g = a(T);
      return y > v && y < g;
    },
    getLanguageDigits: s
  };
}, Qt = (n) => St(() => xl(n), [n]), en = (n) => St(() => wi(n), [n]), Li = ({ parent: n, isInitialActiveChild: t, activeDate: r, monthChangeDirection: a }) => {
  if (!n)
    return t ? r : rr(r, "NEXT");
  const i = n.children[t ? 0 : 1];
  return i.classList.contains("-shown") || i.classList.contains("-shownAnimated") ? r : rr(r, a);
}, xi = ({ parent: n, direction: t }) => {
  const r = Array.from(n.children), a = r.find((d) => d.classList.contains("-shown")), i = r.find((d) => d !== a), o = a.classList[0], s = t === "NEXT", l = (d) => d ? "-hiddenNext" : "-hiddenPrevious";
  i.style.transition = "none", a.style.transition = "", a.className = `${o} ${l(!s)}`, i.className = `${o} ${l(s)}`, i.classList.add("-shownAnimated");
}, ar = ({ target: n }) => {
  n.classList.remove("-hiddenNext"), n.classList.remove("-hiddenPrevious"), n.classList.replace("-shownAnimated", "-shown");
}, Fl = ({
  maximumDate: n,
  minimumDate: t,
  onMonthChange: r,
  activeDate: a,
  monthChangeDirection: i,
  onMonthSelect: o,
  onYearSelect: s,
  isMonthSelectorOpen: l,
  isYearSelectorOpen: d,
  locale: c
}) => {
  const u = le(null), h = le(null), { getMonthName: p, isBeforeDate: m, getLanguageDigits: _ } = Qt(c), {
    isRtl: T,
    nextMonth: y,
    previousMonth: v,
    openMonthSelector: g,
    closeMonthSelector: S,
    openYearSelector: b,
    closeYearSelector: $
  } = en(c);
  de(() => {
    i && xi({
      direction: i,
      parent: h.current
    });
  }, [i]);
  const P = (B, I) => {
    B ? (I.removeAttribute("aria-hidden"), I.setAttribute("tabindex", "0")) : (I.setAttribute("aria-hidden", !0), I.setAttribute("tabindex", "-1"));
  };
  de(() => {
    const B = l || d, I = u.current.querySelector(
      ".Calendar__monthYear.-shown .Calendar__monthText"
    ), A = I.nextSibling, N = (z) => z.classList.contains("-activeBackground");
    if (!B && !N(I) && !N(A))
      return;
    const E = [
      ...u.current.querySelectorAll(".Calendar__monthArrowWrapper")
    ], x = l || N(I), X = x ? I : A, O = x ? A : I;
    let R = x ? 1 : -1;
    T && (R *= -1);
    const J = B ? 1 : 0.95, Z = B ? `${R * O.offsetWidth / 2}` : 0;
    B ? O.setAttribute("aria-hidden", !0) : O.removeAttribute("aria-hidden"), O.setAttribute("tabindex", B ? "-1" : "0"), O.style.transform = "", X.style.transform = `scale(${J}) ${Z ? `translateX(${Z}px)` : ""}`, X.classList.toggle("-activeBackground"), O.classList.toggle("-hidden"), E.forEach((z) => {
      const k = z.classList.contains("-hidden");
      z.classList.toggle("-hidden"), P(k, z);
    });
  }, [l, d]);
  const G = (B) => {
    const I = Li({
      isInitialActiveChild: B,
      monthChangeDirection: i,
      activeDate: a,
      parent: h.current
    }), A = _(I.year);
    return { month: p(I.month), year: A };
  }, w = n && m(n, {
    ...a,
    month: a.month + 1,
    day: 1
  }), D = t && (m({ ...a, day: 1 }, t) || Ve(t, { ...a, day: 1 })), H = (B) => {
    Array.from(
      h.current.children
    ).some((A) => A.classList.contains("-shownAnimated")) || r(B);
  }, W = [!0, !1].map((B) => {
    const { month: I, year: A } = G(B), N = I === p(a.month), L = {
      ...N ? {} : { "aria-hidden": !0 }
    };
    return /* @__PURE__ */ U(
      "div",
      {
        onAnimationEnd: ar,
        className: `Calendar__monthYear ${B ? "-shown" : "-hiddenNext"}`,
        role: "presentation",
        ...L,
        children: [
          /* @__PURE__ */ f(
            "button",
            {
              onClick: o,
              type: "button",
              className: "Calendar__monthText",
              "aria-label": l ? S : g,
              tabIndex: N ? "0" : "-1",
              ...L,
              children: I
            }
          ),
          /* @__PURE__ */ f(
            "button",
            {
              onClick: s,
              type: "button",
              className: "Calendar__yearText",
              "aria-label": d ? $ : b,
              tabIndex: N ? "0" : "-1",
              ...L,
              children: A
            }
          )
        ]
      },
      String(B)
    );
  });
  return /* @__PURE__ */ U("div", { ref: u, className: "Calendar__header", children: [
    /* @__PURE__ */ f(
      "button",
      {
        className: "Calendar__monthArrowWrapper -right",
        onClick: () => {
          H("PREVIOUS");
        },
        "aria-label": v,
        type: "button",
        disabled: D,
        children: /* @__PURE__ */ f("span", { className: "Calendar__monthArrow" })
      }
    ),
    /* @__PURE__ */ U(
      "div",
      {
        className: "Calendar__monthYearContainer",
        ref: h,
        "data-testid": "month-year-container",
        children: [
          " ",
          W
        ]
      }
    ),
    /* @__PURE__ */ f(
      "button",
      {
        className: "Calendar__monthArrowWrapper -left",
        onClick: () => {
          H("NEXT");
        },
        "aria-label": y,
        type: "button",
        disabled: w,
        children: /* @__PURE__ */ f("span", { className: "Calendar__monthArrow" })
      }
    )
  ] });
}, Ir = (n, { allowVerticalArrows: t }) => {
  const {
    nextSibling: r,
    previousSibling: a,
    downSibling: i,
    upSibling: o,
    focusIfAvailable: s
  } = Ml();
  switch (n.key) {
    case "ArrowRight":
      s(r);
      break;
    case "ArrowLeft":
      s(a);
      break;
    case "ArrowDown":
      t && s(i);
      break;
    case "ArrowUp":
      t && s(o);
      break;
  }
}, Ml = () => {
  const { activeElement: n } = document, t = (m, _) => m ? m.children[_] : null, r = (m) => m && (m.hasAttribute("aria-hidden") ? null : m), { nextSibling: a, previousSibling: i } = n.parentElement, o = r(
    n.nextSibling || t(a, 0)
  ), s = i ? i.children.length - 1 : 0, l = r(
    n.previousSibling || t(i, s)
  ), d = (m) => t(
    m,
    Array.from(n.parentElement.children).indexOf(n)
  ), c = r(d(a)), u = r(d(i));
  return n.dataset.isDefaultSelectable === "true" || (n.tabIndex = "-1"), {
    nextSibling: o,
    previousSibling: l,
    downSibling: c,
    upSibling: u,
    focusIfAvailable: (m) => {
      e.preventDefault(), m && (m.setAttribute("tabindex", "0"), m.focus());
    }
  };
}, kl = ({ activeDate: n, maximumDate: t, minimumDate: r, onMonthSelect: a, isOpen: i, locale: o }) => {
  const s = le(null);
  de(() => {
    const p = i ? "add" : "remove";
    s.current.classList[p]("-open");
  }, [i]);
  const { getMonthNumber: l, isBeforeDate: d } = Qt(o), { months: c } = en(o);
  return /* @__PURE__ */ f(
    "div",
    {
      role: "presentation",
      className: "Calendar__monthSelectorAnimationWrapper",
      ...i ? {} : { "aria-hidden": !0 },
      children: /* @__PURE__ */ f(
        "div",
        {
          role: "presentation",
          "data-testid": "month-selector-wrapper",
          className: "Calendar__monthSelectorWrapper",
          onKeyDown: (p) => {
            Ir(p, { allowVerticalArrows: !1 });
          },
          children: /* @__PURE__ */ f("ul", { ref: s, className: "Calendar__monthSelector", "data-testid": "month-selector", children: (() => c.map((p) => {
            const m = l(p), _ = { day: 1, month: m, year: n.year }, T = t && d(t, { ..._, month: m }), y = r && (d({ ..._, month: m + 1 }, r) || Ve({ ..._, month: m + 1 }, r)), v = m === n.month;
            return /* @__PURE__ */ f(
              "li",
              {
                className: `Calendar__monthSelectorItem ${v ? "-active" : ""}`,
                children: /* @__PURE__ */ f(
                  "button",
                  {
                    tabIndex: v && i ? "0" : "-1",
                    onClick: () => {
                      a(m);
                    },
                    className: "Calendar__monthSelectorItemText",
                    type: "button",
                    disabled: T || y,
                    "aria-pressed": v,
                    "data-is-default-selectable": v,
                    children: p
                  }
                )
              },
              p
            );
          }))() })
        }
      )
    }
  );
}, Fi = ({
  isOpen: n,
  activeDate: t,
  onYearSelect: r,
  selectorStartingYear: a,
  selectorEndingYear: i,
  maximumDate: o,
  minimumDate: s,
  locale: l
}) => {
  const d = le(null), c = le(null), { getLanguageDigits: u, getToday: h } = Qt(l), p = a || h().year - Ol, m = i || h().year + Al, _ = [];
  for (let v = p; v <= m; v += 1)
    _.push(v);
  return de(() => {
    const v = n ? "add" : "remove", g = d.current.querySelector(
      ".Calendar__yearSelectorItem.-active"
    );
    if (!g)
      throw new RangeError(
        "Provided value for year is out of selectable year range. You're probably using a wrong locale prop value or your provided value's locale is different from the date picker locale. Try changing the 'locale' prop or the value you've provided."
      );
    d.current.classList[v]("-faded"), c.current.scrollTop = g.offsetTop - g.offsetHeight * 5, c.current.classList[v]("-open");
  }, [n]), /* @__PURE__ */ f(
    "div",
    {
      className: "Calendar__yearSelectorAnimationWrapper",
      role: "presentation",
      ...n ? {} : { "aria-hidden": !0 },
      children: /* @__PURE__ */ f(
        "div",
        {
          ref: d,
          className: "Calendar__yearSelectorWrapper",
          role: "presentation",
          "data-testid": "year-selector-wrapper",
          onKeyDown: (v) => {
            Ir(v, { allowVerticalArrows: !1 });
          },
          children: /* @__PURE__ */ f("ul", { ref: c, className: "Calendar__yearSelector", "data-testid": "year-selector", children: (() => _.map((v) => {
            const g = o && v > o.year, S = s && v < s.year, b = t.year === v;
            return /* @__PURE__ */ f("li", { className: `Calendar__yearSelectorItem ${b ? "-active" : ""}`, children: /* @__PURE__ */ f(
              "button",
              {
                tabIndex: b && n ? "0" : "-1",
                className: "Calendar__yearSelectorText",
                type: "button",
                onClick: () => {
                  r(v);
                },
                disabled: g || S,
                "aria-pressed": b,
                "data-is-default-selectable": b,
                children: u(v)
              }
            ) }, v);
          }))() })
        }
      )
    }
  );
};
Fi.defaultProps = {
  selectorStartingYear: 0,
  selectorEndingYear: 0
};
const Mi = ({
  activeDate: n,
  value: t,
  monthChangeDirection: r,
  onSlideChange: a,
  disabledDays: i,
  onDisabledDayError: o,
  minimumDate: s,
  maximumDate: l,
  onChange: d,
  locale: c,
  calendarTodayClassName: u,
  calendarSelectedDayClassName: h,
  calendarRangeStartClassName: p,
  calendarRangeEndClassName: m,
  calendarRangeBetweenClassName: _,
  shouldHighlightWeekends: T,
  isQuickSelectorOpen: y,
  customDaysClassName: v
}) => {
  const g = le(null), { isRtl: S, weekDays: b } = en(c), {
    getToday: $,
    isBeforeDate: P,
    checkDayInDayRange: G,
    getMonthFirstWeekday: w,
    getMonthLength: D,
    getLanguageDigits: H,
    getMonthName: W
  } = Qt(c), B = $();
  de(() => {
    r && xi({
      direction: r,
      parent: g.current
    });
  }, [r]);
  const I = (k) => {
    const F = Il(t), K = F.from && F.to ? { from: null, to: null } : F, q = K.from ? "to" : "from";
    K[q] = k;
    const { from: j, to: te } = K;
    P(K.to, K.from) && (K.from = te, K.to = j);
    const se = (ye) => G({
      day: ye,
      from: K.from,
      to: K.to
    }), V = i.find(se);
    return V ? (o(V), t) : K;
  }, A = (k) => {
    const F = t.some((j) => Ve(j, k)), K = [...t, k], q = t.filter((j) => !Ve(j, k));
    return F ? q : K;
  }, N = (k) => {
    const K = (() => {
      switch (It(t)) {
        case mt:
          return k;
        case Jt:
          return I(k);
        case jt:
          return A(k);
      }
    })();
    d(K);
  }, L = (k) => {
    const F = It(t);
    if (F === mt)
      return Ve(k, t);
    if (F === jt)
      return t.some((K) => Ve(K, k));
  }, E = (k) => {
    const F = Ve(k, B), K = L(k), { from: q, to: j } = t || {}, te = Ve(k, q), se = Ve(k, j), V = G({ day: k, from: q, to: j });
    return { isToday: F, isSelected: K, isStartingDayRange: te, isEndingDayRange: se, isWithinRange: V };
  }, x = (k) => {
    const {
      isToday: F,
      isSelected: K,
      isStartingDayRange: q,
      isEndingDayRange: j,
      isWithinRange: te
    } = E(k), se = v?.find((ye) => Ve(k, ye));
    return "".concat(F && !K ? ` -today ${u}` : "").concat(k.isStandard ? "" : " -blank").concat(k.isWeekend && T ? " -weekend" : "").concat(se ? ` ${se.className}` : "").concat(K ? ` -selected ${h}` : "").concat(q ? ` -selectedStart ${p}` : "").concat(j ? ` -selectedEnd ${m}` : "").concat(te ? ` -selectedBetween ${_}` : "").concat(k.isDisabled ? " -disabled" : "");
  }, X = (k) => {
    const F = ta(w(k), "starting-blank"), K = ta(D(k)).map((j) => ({
      ...j,
      isStandard: !0,
      month: k.month,
      year: k.year
    }));
    return [...F, ...K];
  }, O = ({ isDisabled: k, ...F }) => {
    k ? o(F) : N(F);
  }, R = ({
    isOnActiveSlide: k,
    isStandard: F,
    isSelected: K,
    isStartingDayRange: q,
    isToday: j,
    day: te
  }) => {
    if (y || !k || !F)
      return !1;
    if (K || q || j || te === 1)
      return !0;
  }, J = ({ id: k, value: F, month: K, year: q, isStandard: j }, te) => {
    const se = { day: F, month: K, year: q }, V = i.some((Me) => Ve(se, Me)), ye = P(se, s), De = P(l, se), me = V || j && (ye || De), Ae = b.some(
      (Me, Tt) => Me.isWeekend && Tt === te
    ), xe = x({ ...se, isWeekend: Ae, isStandard: j, isDisabled: me }), We = `${b[te].name}, ${F} ${W(K)} ${q}`, rt = K === n.month, Q = E(se), { isSelected: fe, isStartingDayRange: Oe, isEndingDayRange: Pe, isWithinRange: ne } = Q, he = R({
      ...se,
      ...Q,
      isOnActiveSlide: rt,
      isStandard: j
    });
    return /* @__PURE__ */ f(
      "div",
      {
        tabIndex: he ? "0" : "-1",
        className: `Calendar__day -${S ? "rtl" : "ltr"} ${xe}`,
        onClick: () => {
          O({ ...se, isDisabled: me });
        },
        onKeyDown: ({ key: Me }) => {
          Me === "Enter" && O({ ...se, isDisabled: me });
        },
        "aria-disabled": me,
        "aria-label": We,
        "aria-selected": fe || Oe || Pe || ne,
        ...!j || !rt || y ? { "aria-hidden": !0 } : {},
        role: "gridcell",
        "data-is-default-selectable": he,
        children: j ? H(F) : ""
      },
      k
    );
  }, Z = (k) => {
    const F = Li({
      activeDate: n,
      isInitialActiveChild: k,
      monthChangeDirection: r,
      parent: g.current
    }), K = X(F), q = (j) => {
      const te = K.slice(j * 7, j * 7 + 7).map(J);
      return /* @__PURE__ */ f("div", { className: "Calendar__weekRow", role: "row", children: te }, String(j));
    };
    return Array.from(Array(6).keys()).map(q);
  };
  return /* @__PURE__ */ U(
    "div",
    {
      ref: g,
      className: "Calendar__sectionWrapper",
      role: "presentation",
      "data-testid": "days-section-wrapper",
      onKeyDown: (k) => {
        Ir(k, { allowVerticalArrows: !0 });
      },
      children: [
        /* @__PURE__ */ f(
          "div",
          {
            onAnimationEnd: (k) => {
              ar(k), a();
            },
            className: "Calendar__section -shown",
            role: "rowgroup",
            children: Z(!0)
          }
        ),
        /* @__PURE__ */ f(
          "div",
          {
            onAnimationEnd: (k) => {
              ar(k), a();
            },
            className: "Calendar__section -hiddenNext",
            role: "rowgroup",
            children: Z(!1)
          }
        )
      ]
    }
  );
};
Mi.defaultProps = {
  onChange: () => {
  },
  onDisabledDayError: () => {
  },
  disabledDays: [],
  calendarTodayClassName: "",
  calendarSelectedDayClassName: "",
  calendarRangeStartClassName: "",
  calendarRangeBetweenClassName: "",
  calendarRangeEndClassName: "",
  shouldHighlightWeekends: !1
};
const Bl = ({
  value: n,
  onChange: t,
  onDisabledDayError: r,
  calendarClassName: a,
  calendarTodayClassName: i,
  calendarSelectedDayClassName: o,
  // calendarRangeStartClassName,
  // calendarRangeBetweenClassName,
  // calendarRangeEndClassName,
  disabledDays: s,
  colorPrimary: l,
  colorPrimaryLight: d,
  // slideAnimationDuration,
  minimumDate: c,
  maximumDate: u,
  selectorStartingYear: h,
  selectorEndingYear: p,
  locale: m,
  shouldHighlightWeekends: _,
  // renderFooter,
  customDaysClassName: T
}) => {
  const y = le(null), [v, g] = ee({
    activeDate: {},
    monthChangeDirection: "",
    isMonthSelectorOpen: !1,
    isYearSelectorOpen: !1
  });
  de(() => {
    const x = (X) => {
      X.key === "Tab" && y.current.classList.remove("-noFocusOutline");
    };
    return y.current?.addEventListener(
      "keyup",
      () => x,
      !1
    ), () => {
      y.current?.removeEventListener(
        "keyup",
        () => x,
        !1
      );
    };
  });
  const { getToday: S } = Qt(m), { weekDays: b, isRtl: $ } = en(m), P = S(), G = (x) => () => {
    g({
      ...v,
      [x]: !v[x]
    });
  }, w = G("isMonthSelectorOpen"), D = G("isYearSelectorOpen"), H = () => {
    const x = It(n);
    return x === jt && n.length ? Bt(n[0]) : x === mt && n ? Bt(n) : x === Jt && n.from ? Bt(n.from) : Bt(P);
  }, W = Object.keys(v.activeDate).length > 0 ? Bt(v.activeDate) : H(), B = b.map((x) => /* @__PURE__ */ f("abbr", { title: x.name, className: "Calendar__weekDay", children: x.short }, x.name)), I = (x) => {
    g({
      ...v,
      monthChangeDirection: x
    });
  }, A = () => {
    g({
      ...v,
      activeDate: rr(
        W,
        v.monthChangeDirection
      ),
      monthChangeDirection: ""
    });
  }, N = (x) => {
    g({
      ...v,
      activeDate: { ...W, month: x },
      isMonthSelectorOpen: !1
    });
  }, L = (x) => {
    g({
      ...v,
      activeDate: { ...W, year: x },
      isYearSelectorOpen: !1
    });
  }, E = {
    "--cl-color-primary": l,
    "--cl-color-primary-light": d
    //    '--animation-duration': slideAnimationDuration,
  };
  return /* @__PURE__ */ U(
    "div",
    {
      className: `Calendar -noFocusOutline ${a} -${$ ? "rtl" : "ltr"}`,
      role: "grid",
      style: E,
      ref: y,
      children: [
        /* @__PURE__ */ f(
          Fl,
          {
            maximumDate: u,
            minimumDate: c,
            activeDate: W,
            onMonthChange: I,
            onMonthSelect: w,
            onYearSelect: D,
            monthChangeDirection: v.monthChangeDirection,
            isMonthSelectorOpen: v.isMonthSelectorOpen,
            isYearSelectorOpen: v.isYearSelectorOpen,
            locale: m
          }
        ),
        /* @__PURE__ */ f(
          kl,
          {
            isOpen: v.isMonthSelectorOpen,
            activeDate: W,
            onMonthSelect: N,
            maximumDate: u,
            minimumDate: c,
            locale: m
          }
        ),
        /* @__PURE__ */ f(
          Fi,
          {
            isOpen: v.isYearSelectorOpen,
            activeDate: W,
            onYearSelect: L,
            selectorStartingYear: h,
            selectorEndingYear: p,
            maximumDate: u,
            minimumDate: c,
            locale: m
          }
        ),
        /* @__PURE__ */ f("div", { className: "Calendar__weekDays", children: B }),
        /* @__PURE__ */ f(
          Mi,
          {
            activeDate: W,
            value: n,
            monthChangeDirection: v.monthChangeDirection,
            onSlideChange: A,
            disabledDays: s,
            onDisabledDayError: r,
            minimumDate: c,
            maximumDate: u,
            onChange: t,
            calendarTodayClassName: i,
            calendarSelectedDayClassName: o,
            locale: m,
            shouldHighlightWeekends: _,
            customDaysClassName: T,
            isQuickSelectorOpen: v.isYearSelectorOpen || v.isMonthSelectorOpen
          }
        )
      ]
    }
  );
}, Ul = re.forwardRef(
  ({
    value: n,
    inputId: t,
    isDisabled: r = !1,
    inputPlaceholder: a,
    dateFormatOptions: i,
    inputClassName: o,
    inputName: s,
    formatInputText: l,
    // renderInput,
    locale: d,
    hasError: c,
    message: u
  }, h) => {
    const {
      from: p,
      to: m,
      // yearLetterSkip,
      // digitSeparator,
      defaultPlaceholder: _
      // isRtl,
    } = en(d), T = (b) => {
      if (!b)
        return "";
      const $ = new Date(b.year, b.month - 1, b.day), P = i || {
        day: "numeric",
        month: "numeric",
        year: "numeric"
      };
      return $.toLocaleDateString(d, P);
    }, y = (b) => {
      if (!b.from || !b.to)
        return "";
      const { from: $, to: P } = b, G = new Date($.year, $.month - 1, $.day), w = new Intl.DateTimeFormat("en-US").format(G).toString(), D = new Date($.year, $.month - 1, $.day), H = new Intl.DateTimeFormat("en-US").format(D).toString();
      return `${p} ${w} ${m} ${H}`;
    }, v = () => {
      if (l)
        return l();
      switch (It(n)) {
        case mt:
          return T(n);
        case Jt:
          return y(n);
        default:
          return "";
      }
    }, g = a || _;
    return (() => (
      // renderInput({ref}) ||
      /* @__PURE__ */ U("div", { children: [
        /* @__PURE__ */ U(
          "div",
          {
            className: C(
              "fmc-floating-label",
              c && "fmc-floating-label--error"
            ),
            children: [
              /* @__PURE__ */ f(
                "input",
                {
                  "data-testid": "datepicker-input",
                  readOnly: !0,
                  ref: h,
                  id: t,
                  type: "text",
                  value: v(),
                  name: s,
                  placeholder: g,
                  className: C(
                    c && "fmc-input--error",
                    "fmc-input",
                    o
                  ),
                  "aria-label": g,
                  disabled: r
                }
              ),
              /* @__PURE__ */ f("label", { htmlFor: t, children: /* @__PURE__ */ f("span", { className: "fmc-floating-label__text", children: g }) })
            ]
          }
        ),
        c && u && /* @__PURE__ */ f("div", { className: C("cxc-date-picker-input__status"), children: /* @__PURE__ */ f(
          "span",
          {
            className: "cxc-date-picker-input__message",
            "aria-live": "polite",
            role: "alert",
            children: u
          }
        ) })
      ] })
    ))();
  }
), Hl = "CalendarInput", x1 = ({
  value: n,
  isDisabled: t = !1,
  onChange: r,
  formatInputText: a,
  inputPlaceholder: i,
  inputClassName: o,
  inputName: s,
  // renderInput,
  wrapperClassName: l,
  calendarClassName: d,
  calendarTodayClassName: c,
  calendarSelectedDayClassName: u,
  // calendarRangeStartClassName,
  // calendarRangeBetweenClassName,
  // calendarRangeEndClassName,
  calendarPopperPosition: h,
  disabledDays: p,
  onDisabledDayError: m,
  colorPrimary: _ = "#1700f4",
  colorPrimaryLight: T,
  //slideAnimationDuration,
  minimumDate: y,
  maximumDate: v,
  selectorStartingYear: g,
  selectorEndingYear: S,
  locale: b,
  shouldHighlightWeekends: $,
  // renderFooter,
  customDaysClassName: P,
  dateFormatOptions: G,
  hasError: w,
  message: D
}) => {
  const H = le(null), W = le(null), B = le(ze(Hl)), I = le(!1), [A, N] = ee(!1);
  de(() => {
    const O = () => {
      N(!1);
    };
    return window.addEventListener("blur", O, !1), () => {
      window.removeEventListener("blur", O, !1);
    };
  }, []), de(() => {
    const O = It(n);
    if (O === jt)
      return;
    (O === mt ? !A : !A && n.from && n.to) && W.current.blur();
  }, [n, A]);
  const L = (O) => {
    if (O.persist(), !A)
      return;
    const R = H.current.contains(
      O.relatedTarget
    );
    I.current ? (I.current = !1, W.current.focus()) : R && O.relatedTarget ? O.relatedTarget.focus() : N(!1);
  }, E = () => {
    I.current || N(!0);
  };
  yr(() => {
    if (!A)
      return;
    const { left: O, width: R, height: J, top: Z } = H.current.getBoundingClientRect(), { clientWidth: z, clientHeight: k } = document.documentElement, F = O + R > z, K = O < 0, q = Z + J > k, j = () => {
      const te = O + R - z;
      if (!F && !K)
        return "";
      const se = Math.abs(O);
      return F ? `calc(50% - ${te}px)` : `calc(50% + ${K ? se : 0}px)`;
    };
    H.current.style.left = j(), (h === "auto" && q || h === "top") && H?.current?.classList?.add("-top");
  }, [A]);
  const x = (O) => {
    const R = It(n);
    r && r(O), (R === mt || R === Jt) && N(!1);
  }, X = (O) => {
    switch (O.key) {
      case "Enter":
        N(!0);
        break;
      case "Escape":
        N(!1), I.current = !0;
        break;
    }
  };
  return de(() => {
    !A && I.current && (W?.current?.focus(), I.current = !1);
  }, [I, A]), /* @__PURE__ */ U(
    "div",
    {
      onFocus: E,
      onBlur: L,
      onKeyUp: X,
      className: `DatePicker ${l}`,
      role: "presentation",
      children: [
        /* @__PURE__ */ f(
          Ul,
          {
            ref: W,
            isDisabled: t,
            formatInputText: a,
            value: n,
            inputPlaceholder: i,
            inputClassName: o,
            inputName: s,
            locale: b,
            dateFormatOptions: G,
            hasError: w,
            message: D,
            inputId: B.current
          }
        ),
        A && !t && /* @__PURE__ */ U(He, { children: [
          /* @__PURE__ */ f(
            "div",
            {
              ref: H,
              className: "DatePicker__calendarContainer",
              "data-testid": "calendar-container",
              role: "presentation",
              onMouseDown: () => {
                I.current = !0;
              },
              children: /* @__PURE__ */ f(
                Bl,
                {
                  value: n,
                  onChange: x,
                  calendarClassName: d,
                  calendarTodayClassName: c,
                  calendarSelectedDayClassName: u,
                  disabledDays: p,
                  colorPrimary: _,
                  colorPrimaryLight: T,
                  onDisabledDayError: m,
                  minimumDate: y,
                  maximumDate: v,
                  selectorStartingYear: g,
                  selectorEndingYear: S,
                  locale: b,
                  shouldHighlightWeekends: $,
                  customDaysClassName: P
                }
              )
            }
          ),
          /* @__PURE__ */ f("div", { className: "DatePicker__calendarArrow" })
        ] })
      ]
    }
  );
};
var ir = { exports: {} }, $t = {}, or = { exports: {} }, on = { exports: {} }, $e = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var na;
function Wl() {
  if (na)
    return $e;
  na = 1;
  var n = typeof Symbol == "function" && Symbol.for, t = n ? Symbol.for("react.element") : 60103, r = n ? Symbol.for("react.portal") : 60106, a = n ? Symbol.for("react.fragment") : 60107, i = n ? Symbol.for("react.strict_mode") : 60108, o = n ? Symbol.for("react.profiler") : 60114, s = n ? Symbol.for("react.provider") : 60109, l = n ? Symbol.for("react.context") : 60110, d = n ? Symbol.for("react.async_mode") : 60111, c = n ? Symbol.for("react.concurrent_mode") : 60111, u = n ? Symbol.for("react.forward_ref") : 60112, h = n ? Symbol.for("react.suspense") : 60113, p = n ? Symbol.for("react.suspense_list") : 60120, m = n ? Symbol.for("react.memo") : 60115, _ = n ? Symbol.for("react.lazy") : 60116, T = n ? Symbol.for("react.block") : 60121, y = n ? Symbol.for("react.fundamental") : 60117, v = n ? Symbol.for("react.responder") : 60118, g = n ? Symbol.for("react.scope") : 60119;
  function S($) {
    if (typeof $ == "object" && $ !== null) {
      var P = $.$$typeof;
      switch (P) {
        case t:
          switch ($ = $.type, $) {
            case d:
            case c:
            case a:
            case o:
            case i:
            case h:
              return $;
            default:
              switch ($ = $ && $.$$typeof, $) {
                case l:
                case u:
                case _:
                case m:
                case s:
                  return $;
                default:
                  return P;
              }
          }
        case r:
          return P;
      }
    }
  }
  function b($) {
    return S($) === c;
  }
  return $e.AsyncMode = d, $e.ConcurrentMode = c, $e.ContextConsumer = l, $e.ContextProvider = s, $e.Element = t, $e.ForwardRef = u, $e.Fragment = a, $e.Lazy = _, $e.Memo = m, $e.Portal = r, $e.Profiler = o, $e.StrictMode = i, $e.Suspense = h, $e.isAsyncMode = function($) {
    return b($) || S($) === d;
  }, $e.isConcurrentMode = b, $e.isContextConsumer = function($) {
    return S($) === l;
  }, $e.isContextProvider = function($) {
    return S($) === s;
  }, $e.isElement = function($) {
    return typeof $ == "object" && $ !== null && $.$$typeof === t;
  }, $e.isForwardRef = function($) {
    return S($) === u;
  }, $e.isFragment = function($) {
    return S($) === a;
  }, $e.isLazy = function($) {
    return S($) === _;
  }, $e.isMemo = function($) {
    return S($) === m;
  }, $e.isPortal = function($) {
    return S($) === r;
  }, $e.isProfiler = function($) {
    return S($) === o;
  }, $e.isStrictMode = function($) {
    return S($) === i;
  }, $e.isSuspense = function($) {
    return S($) === h;
  }, $e.isValidElementType = function($) {
    return typeof $ == "string" || typeof $ == "function" || $ === a || $ === c || $ === o || $ === i || $ === h || $ === p || typeof $ == "object" && $ !== null && ($.$$typeof === _ || $.$$typeof === m || $.$$typeof === s || $.$$typeof === l || $.$$typeof === u || $.$$typeof === y || $.$$typeof === v || $.$$typeof === g || $.$$typeof === T);
  }, $e.typeOf = S, $e;
}
var _e = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ra;
function Vl() {
  return ra || (ra = 1, process.env.NODE_ENV !== "production" && function() {
    var n = typeof Symbol == "function" && Symbol.for, t = n ? Symbol.for("react.element") : 60103, r = n ? Symbol.for("react.portal") : 60106, a = n ? Symbol.for("react.fragment") : 60107, i = n ? Symbol.for("react.strict_mode") : 60108, o = n ? Symbol.for("react.profiler") : 60114, s = n ? Symbol.for("react.provider") : 60109, l = n ? Symbol.for("react.context") : 60110, d = n ? Symbol.for("react.async_mode") : 60111, c = n ? Symbol.for("react.concurrent_mode") : 60111, u = n ? Symbol.for("react.forward_ref") : 60112, h = n ? Symbol.for("react.suspense") : 60113, p = n ? Symbol.for("react.suspense_list") : 60120, m = n ? Symbol.for("react.memo") : 60115, _ = n ? Symbol.for("react.lazy") : 60116, T = n ? Symbol.for("react.block") : 60121, y = n ? Symbol.for("react.fundamental") : 60117, v = n ? Symbol.for("react.responder") : 60118, g = n ? Symbol.for("react.scope") : 60119;
    function S(V) {
      return typeof V == "string" || typeof V == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      V === a || V === c || V === o || V === i || V === h || V === p || typeof V == "object" && V !== null && (V.$$typeof === _ || V.$$typeof === m || V.$$typeof === s || V.$$typeof === l || V.$$typeof === u || V.$$typeof === y || V.$$typeof === v || V.$$typeof === g || V.$$typeof === T);
    }
    function b(V) {
      if (typeof V == "object" && V !== null) {
        var ye = V.$$typeof;
        switch (ye) {
          case t:
            var De = V.type;
            switch (De) {
              case d:
              case c:
              case a:
              case o:
              case i:
              case h:
                return De;
              default:
                var Ze = De && De.$$typeof;
                switch (Ze) {
                  case l:
                  case u:
                  case _:
                  case m:
                  case s:
                    return Ze;
                  default:
                    return ye;
                }
            }
          case r:
            return ye;
        }
      }
    }
    var $ = d, P = c, G = l, w = s, D = t, H = u, W = a, B = _, I = m, A = r, N = o, L = i, E = h, x = !1;
    function X(V) {
      return x || (x = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), O(V) || b(V) === d;
    }
    function O(V) {
      return b(V) === c;
    }
    function R(V) {
      return b(V) === l;
    }
    function J(V) {
      return b(V) === s;
    }
    function Z(V) {
      return typeof V == "object" && V !== null && V.$$typeof === t;
    }
    function z(V) {
      return b(V) === u;
    }
    function k(V) {
      return b(V) === a;
    }
    function F(V) {
      return b(V) === _;
    }
    function K(V) {
      return b(V) === m;
    }
    function q(V) {
      return b(V) === r;
    }
    function j(V) {
      return b(V) === o;
    }
    function te(V) {
      return b(V) === i;
    }
    function se(V) {
      return b(V) === h;
    }
    _e.AsyncMode = $, _e.ConcurrentMode = P, _e.ContextConsumer = G, _e.ContextProvider = w, _e.Element = D, _e.ForwardRef = H, _e.Fragment = W, _e.Lazy = B, _e.Memo = I, _e.Portal = A, _e.Profiler = N, _e.StrictMode = L, _e.Suspense = E, _e.isAsyncMode = X, _e.isConcurrentMode = O, _e.isContextConsumer = R, _e.isContextProvider = J, _e.isElement = Z, _e.isForwardRef = z, _e.isFragment = k, _e.isLazy = F, _e.isMemo = K, _e.isPortal = q, _e.isProfiler = j, _e.isStrictMode = te, _e.isSuspense = se, _e.isValidElementType = S, _e.typeOf = b;
  }()), _e;
}
var aa;
function ki() {
  return aa || (aa = 1, process.env.NODE_ENV === "production" ? on.exports = Wl() : on.exports = Vl()), on.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var kn, ia;
function Gl() {
  if (ia)
    return kn;
  ia = 1;
  var n = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function a(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, l = 0; l < 10; l++)
        s["_" + String.fromCharCode(l)] = l;
      var d = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return kn = i() ? Object.assign : function(o, s) {
    for (var l, d = a(o), c, u = 1; u < arguments.length; u++) {
      l = Object(arguments[u]);
      for (var h in l)
        t.call(l, h) && (d[h] = l[h]);
      if (n) {
        c = n(l);
        for (var p = 0; p < c.length; p++)
          r.call(l, c[p]) && (d[c[p]] = l[c[p]]);
      }
    }
    return d;
  }, kn;
}
var Bn, oa;
function Rr() {
  if (oa)
    return Bn;
  oa = 1;
  var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Bn = n, Bn;
}
var Un, sa;
function Bi() {
  return sa || (sa = 1, Un = Function.call.bind(Object.prototype.hasOwnProperty)), Un;
}
var Hn, la;
function Kl() {
  if (la)
    return Hn;
  la = 1;
  var n = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Rr(), r = {}, a = Bi();
    n = function(o) {
      var s = "Warning: " + o;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(o, s, l, d, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in o)
        if (a(o, u)) {
          var h;
          try {
            if (typeof o[u] != "function") {
              var p = Error(
                (d || "React class") + ": " + l + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            h = o[u](s, u, d, l, null, t);
          } catch (_) {
            h = _;
          }
          if (h && !(h instanceof Error) && n(
            (d || "React class") + ": type specification of " + l + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in r)) {
            r[h.message] = !0;
            var m = c ? c() : "";
            n(
              "Failed " + l + " type: " + h.message + (m ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Hn = i, Hn;
}
var Wn, da;
function jl() {
  if (da)
    return Wn;
  da = 1;
  var n = ki(), t = Gl(), r = Rr(), a = Bi(), i = Kl(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(l) {
    var d = "Warning: " + l;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return Wn = function(l, d) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function h(O) {
      var R = O && (c && O[c] || O[u]);
      if (typeof R == "function")
        return R;
    }
    var p = "<<anonymous>>", m = {
      array: v("array"),
      bigint: v("bigint"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: g(),
      arrayOf: S,
      element: b(),
      elementType: $(),
      instanceOf: P,
      node: H(),
      objectOf: w,
      oneOf: G,
      oneOfType: D,
      shape: B,
      exact: I
    };
    function _(O, R) {
      return O === R ? O !== 0 || 1 / O === 1 / R : O !== O && R !== R;
    }
    function T(O, R) {
      this.message = O, this.data = R && typeof R == "object" ? R : {}, this.stack = "";
    }
    T.prototype = Error.prototype;
    function y(O) {
      if (process.env.NODE_ENV !== "production")
        var R = {}, J = 0;
      function Z(k, F, K, q, j, te, se) {
        if (q = q || p, te = te || K, se !== r) {
          if (d) {
            var V = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw V.name = "Invariant Violation", V;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ye = q + ":" + K;
            !R[ye] && // Avoid spamming the console because they are often not actionable except for lib authors
            J < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + te + "` prop on `" + q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), R[ye] = !0, J++);
          }
        }
        return F[K] == null ? k ? F[K] === null ? new T("The " + j + " `" + te + "` is marked as required " + ("in `" + q + "`, but its value is `null`.")) : new T("The " + j + " `" + te + "` is marked as required in " + ("`" + q + "`, but its value is `undefined`.")) : null : O(F, K, q, j, te);
      }
      var z = Z.bind(null, !1);
      return z.isRequired = Z.bind(null, !0), z;
    }
    function v(O) {
      function R(J, Z, z, k, F, K) {
        var q = J[Z], j = L(q);
        if (j !== O) {
          var te = E(q);
          return new T(
            "Invalid " + k + " `" + F + "` of type " + ("`" + te + "` supplied to `" + z + "`, expected ") + ("`" + O + "`."),
            { expectedType: O }
          );
        }
        return null;
      }
      return y(R);
    }
    function g() {
      return y(s);
    }
    function S(O) {
      function R(J, Z, z, k, F) {
        if (typeof O != "function")
          return new T("Property `" + F + "` of component `" + z + "` has invalid PropType notation inside arrayOf.");
        var K = J[Z];
        if (!Array.isArray(K)) {
          var q = L(K);
          return new T("Invalid " + k + " `" + F + "` of type " + ("`" + q + "` supplied to `" + z + "`, expected an array."));
        }
        for (var j = 0; j < K.length; j++) {
          var te = O(K, j, z, k, F + "[" + j + "]", r);
          if (te instanceof Error)
            return te;
        }
        return null;
      }
      return y(R);
    }
    function b() {
      function O(R, J, Z, z, k) {
        var F = R[J];
        if (!l(F)) {
          var K = L(F);
          return new T("Invalid " + z + " `" + k + "` of type " + ("`" + K + "` supplied to `" + Z + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(O);
    }
    function $() {
      function O(R, J, Z, z, k) {
        var F = R[J];
        if (!n.isValidElementType(F)) {
          var K = L(F);
          return new T("Invalid " + z + " `" + k + "` of type " + ("`" + K + "` supplied to `" + Z + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(O);
    }
    function P(O) {
      function R(J, Z, z, k, F) {
        if (!(J[Z] instanceof O)) {
          var K = O.name || p, q = X(J[Z]);
          return new T("Invalid " + k + " `" + F + "` of type " + ("`" + q + "` supplied to `" + z + "`, expected ") + ("instance of `" + K + "`."));
        }
        return null;
      }
      return y(R);
    }
    function G(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function R(J, Z, z, k, F) {
        for (var K = J[Z], q = 0; q < O.length; q++)
          if (_(K, O[q]))
            return null;
        var j = JSON.stringify(O, function(se, V) {
          var ye = E(V);
          return ye === "symbol" ? String(V) : V;
        });
        return new T("Invalid " + k + " `" + F + "` of value `" + String(K) + "` " + ("supplied to `" + z + "`, expected one of " + j + "."));
      }
      return y(R);
    }
    function w(O) {
      function R(J, Z, z, k, F) {
        if (typeof O != "function")
          return new T("Property `" + F + "` of component `" + z + "` has invalid PropType notation inside objectOf.");
        var K = J[Z], q = L(K);
        if (q !== "object")
          return new T("Invalid " + k + " `" + F + "` of type " + ("`" + q + "` supplied to `" + z + "`, expected an object."));
        for (var j in K)
          if (a(K, j)) {
            var te = O(K, j, z, k, F + "." + j, r);
            if (te instanceof Error)
              return te;
          }
        return null;
      }
      return y(R);
    }
    function D(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var R = 0; R < O.length; R++) {
        var J = O[R];
        if (typeof J != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + x(J) + " at index " + R + "."
          ), s;
      }
      function Z(z, k, F, K, q) {
        for (var j = [], te = 0; te < O.length; te++) {
          var se = O[te], V = se(z, k, F, K, q, r);
          if (V == null)
            return null;
          V.data && a(V.data, "expectedType") && j.push(V.data.expectedType);
        }
        var ye = j.length > 0 ? ", expected one of type [" + j.join(", ") + "]" : "";
        return new T("Invalid " + K + " `" + q + "` supplied to " + ("`" + F + "`" + ye + "."));
      }
      return y(Z);
    }
    function H() {
      function O(R, J, Z, z, k) {
        return A(R[J]) ? null : new T("Invalid " + z + " `" + k + "` supplied to " + ("`" + Z + "`, expected a ReactNode."));
      }
      return y(O);
    }
    function W(O, R, J, Z, z) {
      return new T(
        (O || "React class") + ": " + R + " type `" + J + "." + Z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + z + "`."
      );
    }
    function B(O) {
      function R(J, Z, z, k, F) {
        var K = J[Z], q = L(K);
        if (q !== "object")
          return new T("Invalid " + k + " `" + F + "` of type `" + q + "` " + ("supplied to `" + z + "`, expected `object`."));
        for (var j in O) {
          var te = O[j];
          if (typeof te != "function")
            return W(z, k, F, j, E(te));
          var se = te(K, j, z, k, F + "." + j, r);
          if (se)
            return se;
        }
        return null;
      }
      return y(R);
    }
    function I(O) {
      function R(J, Z, z, k, F) {
        var K = J[Z], q = L(K);
        if (q !== "object")
          return new T("Invalid " + k + " `" + F + "` of type `" + q + "` " + ("supplied to `" + z + "`, expected `object`."));
        var j = t({}, J[Z], O);
        for (var te in j) {
          var se = O[te];
          if (a(O, te) && typeof se != "function")
            return W(z, k, F, te, E(se));
          if (!se)
            return new T(
              "Invalid " + k + " `" + F + "` key `" + te + "` supplied to `" + z + "`.\nBad object: " + JSON.stringify(J[Z], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(O), null, "  ")
            );
          var V = se(K, te, z, k, F + "." + te, r);
          if (V)
            return V;
        }
        return null;
      }
      return y(R);
    }
    function A(O) {
      switch (typeof O) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !O;
        case "object":
          if (Array.isArray(O))
            return O.every(A);
          if (O === null || l(O))
            return !0;
          var R = h(O);
          if (R) {
            var J = R.call(O), Z;
            if (R !== O.entries) {
              for (; !(Z = J.next()).done; )
                if (!A(Z.value))
                  return !1;
            } else
              for (; !(Z = J.next()).done; ) {
                var z = Z.value;
                if (z && !A(z[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function N(O, R) {
      return O === "symbol" ? !0 : R ? R["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && R instanceof Symbol : !1;
    }
    function L(O) {
      var R = typeof O;
      return Array.isArray(O) ? "array" : O instanceof RegExp ? "object" : N(R, O) ? "symbol" : R;
    }
    function E(O) {
      if (typeof O > "u" || O === null)
        return "" + O;
      var R = L(O);
      if (R === "object") {
        if (O instanceof Date)
          return "date";
        if (O instanceof RegExp)
          return "regexp";
      }
      return R;
    }
    function x(O) {
      var R = E(O);
      switch (R) {
        case "array":
        case "object":
          return "an " + R;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + R;
        default:
          return R;
      }
    }
    function X(O) {
      return !O.constructor || !O.constructor.name ? p : O.constructor.name;
    }
    return m.checkPropTypes = i, m.resetWarningCache = i.resetWarningCache, m.PropTypes = m, m;
  }, Wn;
}
var Vn, ca;
function Yl() {
  if (ca)
    return Vn;
  ca = 1;
  var n = Rr();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Vn = function() {
    function a(s, l, d, c, u, h) {
      if (h !== n) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    a.isRequired = a;
    function i() {
      return a;
    }
    var o = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: i,
      element: a,
      elementType: a,
      instanceOf: i,
      node: a,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Vn;
}
if (process.env.NODE_ENV !== "production") {
  var zl = ki(), Xl = !0;
  or.exports = jl()(zl.isElement, Xl);
} else
  or.exports = Yl()();
var Ui = or.exports, sr = { exports: {} }, Xe = {}, lr = { exports: {} };
(function(n, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var r = "none", a = "contents", i = /input|select|textarea|button|object|iframe/;
  function o(h, p) {
    return p.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    h.scrollWidth <= 0 && h.scrollHeight <= 0;
  }
  function s(h) {
    var p = h.offsetWidth <= 0 && h.offsetHeight <= 0;
    if (p && !h.innerHTML)
      return !0;
    try {
      var m = window.getComputedStyle(h), _ = m.getPropertyValue("display");
      return p ? _ !== a && o(h, m) : _ === r;
    } catch {
      return console.warn("Failed to inspect element style"), !1;
    }
  }
  function l(h) {
    for (var p = h, m = h.getRootNode && h.getRootNode(); p && p !== document.body; ) {
      if (m && p === m && (p = m.host.parentNode), s(p))
        return !1;
      p = p.parentNode;
    }
    return !0;
  }
  function d(h, p) {
    var m = h.nodeName.toLowerCase(), _ = i.test(m) && !h.disabled || m === "a" && h.href || p;
    return _ && l(h);
  }
  function c(h) {
    var p = h.getAttribute("tabindex");
    p === null && (p = void 0);
    var m = isNaN(p);
    return (m || p >= 0) && d(h, !m);
  }
  function u(h) {
    var p = [].slice.call(h.querySelectorAll("*"), 0).reduce(function(m, _) {
      return m.concat(_.shadowRoot ? u(_.shadowRoot) : [_]);
    }, []);
    return p.filter(c);
  }
  n.exports = t.default;
})(lr, lr.exports);
var Hi = lr.exports;
Object.defineProperty(Xe, "__esModule", {
  value: !0
});
Xe.resetState = Ql;
Xe.log = ed;
Xe.handleBlur = Yt;
Xe.handleFocus = zt;
Xe.markForFocusLater = td;
Xe.returnFocus = nd;
Xe.popWithoutFocus = rd;
Xe.setupScopedFocus = ad;
Xe.teardownScopedFocus = id;
var ql = Hi, Zl = Jl(ql);
function Jl(n) {
  return n && n.__esModule ? n : { default: n };
}
var _t = [], Et = null, dr = !1;
function Ql() {
  _t = [];
}
function ed() {
  process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), _t.forEach(function(n) {
    var t = n || {};
    console.log(t.nodeName, t.className, t.id);
  }), console.log("end focusManager ----------"));
}
function Yt() {
  dr = !0;
}
function zt() {
  if (dr) {
    if (dr = !1, !Et)
      return;
    setTimeout(function() {
      if (!Et.contains(document.activeElement)) {
        var n = (0, Zl.default)(Et)[0] || Et;
        n.focus();
      }
    }, 0);
  }
}
function td() {
  _t.push(document.activeElement);
}
function nd() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = null;
  try {
    _t.length !== 0 && (t = _t.pop(), t.focus({ preventScroll: n }));
    return;
  } catch {
    console.warn(["You tried to return focus to", t, "but it is not in the DOM anymore"].join(" "));
  }
}
function rd() {
  _t.length > 0 && _t.pop();
}
function ad(n) {
  Et = n, window.addEventListener ? (window.addEventListener("blur", Yt, !1), document.addEventListener("focus", zt, !0)) : (window.attachEvent("onBlur", Yt), document.attachEvent("onFocus", zt));
}
function id() {
  Et = null, window.addEventListener ? (window.removeEventListener("blur", Yt), document.removeEventListener("focus", zt)) : (window.detachEvent("onBlur", Yt), document.detachEvent("onFocus", zt));
}
var cr = { exports: {} };
(function(n, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = Hi, a = i(r);
  function i(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function o() {
    var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return l.activeElement.shadowRoot ? o(l.activeElement.shadowRoot) : l.activeElement;
  }
  function s(l, d) {
    var c = (0, a.default)(l);
    if (!c.length) {
      d.preventDefault();
      return;
    }
    var u = void 0, h = d.shiftKey, p = c[0], m = c[c.length - 1], _ = o();
    if (l === _) {
      if (!h)
        return;
      u = m;
    }
    if (m === _ && !h && (u = p), p === _ && h && (u = m), u) {
      d.preventDefault(), u.focus();
      return;
    }
    var T = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), y = T != null && T[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (y) {
      var v = c.indexOf(_);
      if (v > -1 && (v += h ? -1 : 1), u = c[v], typeof u > "u") {
        d.preventDefault(), u = h ? m : p, u.focus();
        return;
      }
      d.preventDefault(), u.focus();
    }
  }
  n.exports = t.default;
})(cr, cr.exports);
var od = cr.exports, qe = {}, sd = process.env.NODE_ENV !== "production", Wi = function() {
};
if (sd) {
  var ld = function(t, r) {
    var a = arguments.length;
    r = new Array(a > 1 ? a - 1 : 0);
    for (var i = 1; i < a; i++)
      r[i - 1] = arguments[i];
    var o = 0, s = "Warning: " + t.replace(/%s/g, function() {
      return r[o++];
    });
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  };
  Wi = function(n, t, r) {
    var a = arguments.length;
    r = new Array(a > 2 ? a - 2 : 0);
    for (var i = 2; i < a; i++)
      r[i - 2] = arguments[i];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    n || ld.apply(null, [t].concat(r));
  };
}
var dd = Wi, je = {}, Vi = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(n) {
  (function() {
    var t = !!(typeof window < "u" && window.document && window.document.createElement), r = {
      canUseDOM: t,
      canUseWorkers: typeof Worker < "u",
      canUseEventListeners: t && !!(window.addEventListener || window.attachEvent),
      canUseViewport: t && !!window.screen
    };
    n.exports ? n.exports = r : window.ExecutionEnvironment = r;
  })();
})(Vi);
var cd = Vi.exports;
Object.defineProperty(je, "__esModule", {
  value: !0
});
je.canUseDOM = je.SafeNodeList = je.SafeHTMLCollection = void 0;
var ud = cd, fd = hd(ud);
function hd(n) {
  return n && n.__esModule ? n : { default: n };
}
var On = fd.default, pd = On.canUseDOM ? window.HTMLElement : {};
je.SafeHTMLCollection = On.canUseDOM ? window.HTMLCollection : {};
je.SafeNodeList = On.canUseDOM ? window.NodeList : {};
je.canUseDOM = On.canUseDOM;
je.default = pd;
Object.defineProperty(qe, "__esModule", {
  value: !0
});
qe.resetState = Td;
qe.log = vd;
qe.assertNodeList = Gi;
qe.setElement = yd;
qe.validateElement = Dr;
qe.hide = Ed;
qe.show = bd;
qe.documentNotReadyOrSSRTesting = Cd;
var md = dd, $d = gd(md), _d = je;
function gd(n) {
  return n && n.__esModule ? n : { default: n };
}
var Ue = null;
function Td() {
  Ue && (Ue.removeAttribute ? Ue.removeAttribute("aria-hidden") : Ue.length != null ? Ue.forEach(function(n) {
    return n.removeAttribute("aria-hidden");
  }) : document.querySelectorAll(Ue).forEach(function(n) {
    return n.removeAttribute("aria-hidden");
  })), Ue = null;
}
function vd() {
  if (process.env.NODE_ENV !== "production") {
    var n = Ue || {};
    console.log("ariaAppHider ----------"), console.log(n.nodeName, n.className, n.id), console.log("end ariaAppHider ----------");
  }
}
function Gi(n, t) {
  if (!n || !n.length)
    throw new Error("react-modal: No elements were found for selector " + t + ".");
}
function yd(n) {
  var t = n;
  if (typeof t == "string" && _d.canUseDOM) {
    var r = document.querySelectorAll(t);
    Gi(r, t), t = r;
  }
  return Ue = t || Ue, Ue;
}
function Dr(n) {
  var t = n || Ue;
  return t ? Array.isArray(t) || t instanceof HTMLCollection || t instanceof NodeList ? t : [t] : ((0, $d.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
}
function Ed(n) {
  var t = !0, r = !1, a = void 0;
  try {
    for (var i = Dr(n)[Symbol.iterator](), o; !(t = (o = i.next()).done); t = !0) {
      var s = o.value;
      s.setAttribute("aria-hidden", "true");
    }
  } catch (l) {
    r = !0, a = l;
  } finally {
    try {
      !t && i.return && i.return();
    } finally {
      if (r)
        throw a;
    }
  }
}
function bd(n) {
  var t = !0, r = !1, a = void 0;
  try {
    for (var i = Dr(n)[Symbol.iterator](), o; !(t = (o = i.next()).done); t = !0) {
      var s = o.value;
      s.removeAttribute("aria-hidden");
    }
  } catch (l) {
    r = !0, a = l;
  } finally {
    try {
      !t && i.return && i.return();
    } finally {
      if (r)
        throw a;
    }
  }
}
function Cd() {
  Ue = null;
}
var Lt = {};
Object.defineProperty(Lt, "__esModule", {
  value: !0
});
Lt.resetState = Nd;
Lt.log = Sd;
var ut = {}, ft = {};
function ua(n, t) {
  n.classList.remove(t);
}
function Nd() {
  var n = document.getElementsByTagName("html")[0];
  for (var t in ut)
    ua(n, ut[t]);
  var r = document.body;
  for (var a in ft)
    ua(r, ft[a]);
  ut = {}, ft = {};
}
function Sd() {
  if (process.env.NODE_ENV !== "production") {
    var n = document.getElementsByTagName("html")[0].className, t = `Show tracked classes:

`;
    t += "<html /> (" + n + `):
  `;
    for (var r in ut)
      t += "  " + r + " " + ut[r] + `
  `;
    n = document.body.className, t += `

doc.body (` + n + `):
  `;
    for (var a in ft)
      t += "  " + a + " " + ft[a] + `
  `;
    t += `
`, console.log(t);
  }
}
var Od = function(t, r) {
  return t[r] || (t[r] = 0), t[r] += 1, r;
}, Ad = function(t, r) {
  return t[r] && (t[r] -= 1), r;
}, Id = function(t, r, a) {
  a.forEach(function(i) {
    Od(r, i), t.add(i);
  });
}, Rd = function(t, r, a) {
  a.forEach(function(i) {
    Ad(r, i), r[i] === 0 && t.remove(i);
  });
};
Lt.add = function(t, r) {
  return Id(t.classList, t.nodeName.toLowerCase() == "html" ? ut : ft, r.split(" "));
};
Lt.remove = function(t, r) {
  return Rd(t.classList, t.nodeName.toLowerCase() == "html" ? ut : ft, r.split(" "));
};
var xt = {};
Object.defineProperty(xt, "__esModule", {
  value: !0
});
xt.log = Pd;
xt.resetState = wd;
function Dd(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var Ki = function n() {
  var t = this;
  Dd(this, n), this.register = function(r) {
    if (t.openInstances.indexOf(r) !== -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
      return;
    }
    t.openInstances.push(r), t.emit("register");
  }, this.deregister = function(r) {
    var a = t.openInstances.indexOf(r);
    if (a === -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + r + " as it was never registered");
      return;
    }
    t.openInstances.splice(a, 1), t.emit("deregister");
  }, this.subscribe = function(r) {
    t.subscribers.push(r);
  }, this.emit = function(r) {
    t.subscribers.forEach(function(a) {
      return a(
        r,
        // shallow copy to avoid accidental mutation
        t.openInstances.slice()
      );
    });
  }, this.openInstances = [], this.subscribers = [];
}, gn = new Ki();
function Pd() {
  console.log("portalOpenInstances ----------"), console.log(gn.openInstances.length), gn.openInstances.forEach(function(n) {
    return console.log(n);
  }), console.log("end portalOpenInstances ----------");
}
function wd() {
  gn = new Ki();
}
xt.default = gn;
var Pr = {};
Object.defineProperty(Pr, "__esModule", {
  value: !0
});
Pr.resetState = Md;
Pr.log = kd;
var Ld = xt, xd = Fd(Ld);
function Fd(n) {
  return n && n.__esModule ? n : { default: n };
}
var we = void 0, Ke = void 0, ht = [];
function Md() {
  for (var n = [we, Ke], t = 0; t < n.length; t++) {
    var r = n[t];
    r && r.parentNode && r.parentNode.removeChild(r);
  }
  we = Ke = null, ht = [];
}
function kd() {
  console.log("bodyTrap ----------"), console.log(ht.length);
  for (var n = [we, Ke], t = 0; t < n.length; t++) {
    var r = n[t], a = r || {};
    console.log(a.nodeName, a.className, a.id);
  }
  console.log("edn bodyTrap ----------");
}
function fa() {
  if (ht.length === 0) {
    process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
    return;
  }
  ht[ht.length - 1].focusContent();
}
function Bd(n, t) {
  !we && !Ke && (we = document.createElement("div"), we.setAttribute("data-react-modal-body-trap", ""), we.style.position = "absolute", we.style.opacity = "0", we.setAttribute("tabindex", "0"), we.addEventListener("focus", fa), Ke = we.cloneNode(), Ke.addEventListener("focus", fa)), ht = t, ht.length > 0 ? (document.body.firstChild !== we && document.body.insertBefore(we, document.body.firstChild), document.body.lastChild !== Ke && document.body.appendChild(Ke)) : (we.parentElement && we.parentElement.removeChild(we), Ke.parentElement && Ke.parentElement.removeChild(Ke));
}
xd.default.subscribe(Bd);
(function(n, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = Object.assign || function(A) {
    for (var N = 1; N < arguments.length; N++) {
      var L = arguments[N];
      for (var E in L)
        Object.prototype.hasOwnProperty.call(L, E) && (A[E] = L[E]);
    }
    return A;
  }, a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
    return typeof A;
  } : function(A) {
    return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
  }, i = function() {
    function A(N, L) {
      for (var E = 0; E < L.length; E++) {
        var x = L[E];
        x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(N, x.key, x);
      }
    }
    return function(N, L, E) {
      return L && A(N.prototype, L), E && A(N, E), N;
    };
  }(), o = re, s = Ui, l = $(s), d = Xe, c = b(d), u = od, h = $(u), p = qe, m = b(p), _ = Lt, T = b(_), y = je, v = $(y), g = xt, S = $(g);
  function b(A) {
    if (A && A.__esModule)
      return A;
    var N = {};
    if (A != null)
      for (var L in A)
        Object.prototype.hasOwnProperty.call(A, L) && (N[L] = A[L]);
    return N.default = A, N;
  }
  function $(A) {
    return A && A.__esModule ? A : { default: A };
  }
  function P(A, N) {
    if (!(A instanceof N))
      throw new TypeError("Cannot call a class as a function");
  }
  function G(A, N) {
    if (!A)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return N && (typeof N == "object" || typeof N == "function") ? N : A;
  }
  function w(A, N) {
    if (typeof N != "function" && N !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof N);
    A.prototype = Object.create(N && N.prototype, { constructor: { value: A, enumerable: !1, writable: !0, configurable: !0 } }), N && (Object.setPrototypeOf ? Object.setPrototypeOf(A, N) : A.__proto__ = N);
  }
  var D = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  }, H = function(N) {
    return N.code === "Tab" || N.keyCode === 9;
  }, W = function(N) {
    return N.code === "Escape" || N.keyCode === 27;
  }, B = 0, I = function(A) {
    w(N, A);
    function N(L) {
      P(this, N);
      var E = G(this, (N.__proto__ || Object.getPrototypeOf(N)).call(this, L));
      return E.setOverlayRef = function(x) {
        E.overlay = x, E.props.overlayRef && E.props.overlayRef(x);
      }, E.setContentRef = function(x) {
        E.content = x, E.props.contentRef && E.props.contentRef(x);
      }, E.afterClose = function() {
        var x = E.props, X = x.appElement, O = x.ariaHideApp, R = x.htmlOpenClassName, J = x.bodyOpenClassName, Z = x.parentSelector, z = Z && Z().ownerDocument || document;
        J && T.remove(z.body, J), R && T.remove(z.getElementsByTagName("html")[0], R), O && B > 0 && (B -= 1, B === 0 && m.show(X)), E.props.shouldFocusAfterRender && (E.props.shouldReturnFocusAfterClose ? (c.returnFocus(E.props.preventScroll), c.teardownScopedFocus()) : c.popWithoutFocus()), E.props.onAfterClose && E.props.onAfterClose(), S.default.deregister(E);
      }, E.open = function() {
        E.beforeOpen(), E.state.afterOpen && E.state.beforeClose ? (clearTimeout(E.closeTimer), E.setState({ beforeClose: !1 })) : (E.props.shouldFocusAfterRender && (c.setupScopedFocus(E.node), c.markForFocusLater()), E.setState({ isOpen: !0 }, function() {
          E.openAnimationFrame = requestAnimationFrame(function() {
            E.setState({ afterOpen: !0 }), E.props.isOpen && E.props.onAfterOpen && E.props.onAfterOpen({
              overlayEl: E.overlay,
              contentEl: E.content
            });
          });
        }));
      }, E.close = function() {
        E.props.closeTimeoutMS > 0 ? E.closeWithTimeout() : E.closeWithoutTimeout();
      }, E.focusContent = function() {
        return E.content && !E.contentHasFocus() && E.content.focus({ preventScroll: !0 });
      }, E.closeWithTimeout = function() {
        var x = Date.now() + E.props.closeTimeoutMS;
        E.setState({ beforeClose: !0, closesAt: x }, function() {
          E.closeTimer = setTimeout(E.closeWithoutTimeout, E.state.closesAt - Date.now());
        });
      }, E.closeWithoutTimeout = function() {
        E.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, E.afterClose);
      }, E.handleKeyDown = function(x) {
        H(x) && (0, h.default)(E.content, x), E.props.shouldCloseOnEsc && W(x) && (x.stopPropagation(), E.requestClose(x));
      }, E.handleOverlayOnClick = function(x) {
        E.shouldClose === null && (E.shouldClose = !0), E.shouldClose && E.props.shouldCloseOnOverlayClick && (E.ownerHandlesClose() ? E.requestClose(x) : E.focusContent()), E.shouldClose = null;
      }, E.handleContentOnMouseUp = function() {
        E.shouldClose = !1;
      }, E.handleOverlayOnMouseDown = function(x) {
        !E.props.shouldCloseOnOverlayClick && x.target == E.overlay && x.preventDefault();
      }, E.handleContentOnClick = function() {
        E.shouldClose = !1;
      }, E.handleContentOnMouseDown = function() {
        E.shouldClose = !1;
      }, E.requestClose = function(x) {
        return E.ownerHandlesClose() && E.props.onRequestClose(x);
      }, E.ownerHandlesClose = function() {
        return E.props.onRequestClose;
      }, E.shouldBeClosed = function() {
        return !E.state.isOpen && !E.state.beforeClose;
      }, E.contentHasFocus = function() {
        return document.activeElement === E.content || E.content.contains(document.activeElement);
      }, E.buildClassName = function(x, X) {
        var O = (typeof X > "u" ? "undefined" : a(X)) === "object" ? X : {
          base: D[x],
          afterOpen: D[x] + "--after-open",
          beforeClose: D[x] + "--before-close"
        }, R = O.base;
        return E.state.afterOpen && (R = R + " " + O.afterOpen), E.state.beforeClose && (R = R + " " + O.beforeClose), typeof X == "string" && X ? R + " " + X : R;
      }, E.attributesFromObject = function(x, X) {
        return Object.keys(X).reduce(function(O, R) {
          return O[x + "-" + R] = X[R], O;
        }, {});
      }, E.state = {
        afterOpen: !1,
        beforeClose: !1
      }, E.shouldClose = null, E.moveFromContentToOverlay = null, E;
    }
    return i(N, [{
      key: "componentDidMount",
      value: function() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function(E, x) {
        process.env.NODE_ENV !== "production" && (E.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), E.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !E.isOpen ? this.open() : !this.props.isOpen && E.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !x.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function() {
        var E = this.props, x = E.appElement, X = E.ariaHideApp, O = E.htmlOpenClassName, R = E.bodyOpenClassName, J = E.parentSelector, Z = J && J().ownerDocument || document;
        R && T.add(Z.body, R), O && T.add(Z.getElementsByTagName("html")[0], O), X && (B += 1, m.hide(x)), S.default.register(this);
      }
      // Don't steal focus from inner elements
    }, {
      key: "render",
      value: function() {
        var E = this.props, x = E.id, X = E.className, O = E.overlayClassName, R = E.defaultStyles, J = E.children, Z = X ? {} : R.content, z = O ? {} : R.overlay;
        if (this.shouldBeClosed())
          return null;
        var k = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", O),
          style: r({}, z, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, F = r({
          id: x,
          ref: this.setContentRef,
          style: r({}, Z, this.props.style.content),
          className: this.buildClassName("content", X),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", r({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), K = this.props.contentElement(F, J);
        return this.props.overlayElement(k, K);
      }
    }]), N;
  }(o.Component);
  I.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, I.propTypes = {
    isOpen: l.default.bool.isRequired,
    defaultStyles: l.default.shape({
      content: l.default.object,
      overlay: l.default.object
    }),
    style: l.default.shape({
      content: l.default.object,
      overlay: l.default.object
    }),
    className: l.default.oneOfType([l.default.string, l.default.object]),
    overlayClassName: l.default.oneOfType([l.default.string, l.default.object]),
    parentSelector: l.default.func,
    bodyOpenClassName: l.default.string,
    htmlOpenClassName: l.default.string,
    ariaHideApp: l.default.bool,
    appElement: l.default.oneOfType([l.default.instanceOf(v.default), l.default.instanceOf(y.SafeHTMLCollection), l.default.instanceOf(y.SafeNodeList), l.default.arrayOf(l.default.instanceOf(v.default))]),
    onAfterOpen: l.default.func,
    onAfterClose: l.default.func,
    onRequestClose: l.default.func,
    closeTimeoutMS: l.default.number,
    shouldFocusAfterRender: l.default.bool,
    shouldCloseOnOverlayClick: l.default.bool,
    shouldReturnFocusAfterClose: l.default.bool,
    preventScroll: l.default.bool,
    role: l.default.string,
    contentLabel: l.default.string,
    aria: l.default.object,
    data: l.default.object,
    children: l.default.node,
    shouldCloseOnEsc: l.default.bool,
    overlayRef: l.default.func,
    contentRef: l.default.func,
    id: l.default.string,
    overlayElement: l.default.func,
    contentElement: l.default.func,
    testId: l.default.string
  }, t.default = I, n.exports = t.default;
})(sr, sr.exports);
var Ud = sr.exports;
function ji() {
  var n = this.constructor.getDerivedStateFromProps(this.props, this.state);
  n != null && this.setState(n);
}
function Yi(n) {
  function t(r) {
    var a = this.constructor.getDerivedStateFromProps(n, r);
    return a ?? null;
  }
  this.setState(t.bind(this));
}
function zi(n, t) {
  try {
    var r = this.props, a = this.state;
    this.props = n, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      r,
      a
    );
  } finally {
    this.props = r, this.state = a;
  }
}
ji.__suppressDeprecationWarning = !0;
Yi.__suppressDeprecationWarning = !0;
zi.__suppressDeprecationWarning = !0;
function Hd(n) {
  var t = n.prototype;
  if (!t || !t.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof n.getDerivedStateFromProps != "function" && typeof t.getSnapshotBeforeUpdate != "function")
    return n;
  var r = null, a = null, i = null;
  if (typeof t.componentWillMount == "function" ? r = "componentWillMount" : typeof t.UNSAFE_componentWillMount == "function" && (r = "UNSAFE_componentWillMount"), typeof t.componentWillReceiveProps == "function" ? a = "componentWillReceiveProps" : typeof t.UNSAFE_componentWillReceiveProps == "function" && (a = "UNSAFE_componentWillReceiveProps"), typeof t.componentWillUpdate == "function" ? i = "componentWillUpdate" : typeof t.UNSAFE_componentWillUpdate == "function" && (i = "UNSAFE_componentWillUpdate"), r !== null || a !== null || i !== null) {
    var o = n.displayName || n.name, s = typeof n.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + o + " uses " + s + " but also contains the following legacy lifecycles:" + (r !== null ? `
  ` + r : "") + (a !== null ? `
  ` + a : "") + (i !== null ? `
  ` + i : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof n.getDerivedStateFromProps == "function" && (t.componentWillMount = ji, t.componentWillReceiveProps = Yi), typeof t.getSnapshotBeforeUpdate == "function") {
    if (typeof t.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    t.componentWillUpdate = zi;
    var l = t.componentDidUpdate;
    t.componentDidUpdate = function(c, u, h) {
      var p = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : h;
      l.call(this, c, u, p);
    };
  }
  return n;
}
const Wd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: Hd
}, Symbol.toStringTag, { value: "Module" })), Vd = /* @__PURE__ */ bs(Wd);
Object.defineProperty($t, "__esModule", {
  value: !0
});
$t.bodyOpenClassName = $t.portalClassName = void 0;
var ha = Object.assign || function(n) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var a in r)
      Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
  }
  return n;
}, Gd = function() {
  function n(t, r) {
    for (var a = 0; a < r.length; a++) {
      var i = r[a];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, r, a) {
    return r && n(t.prototype, r), a && n(t, a), t;
  };
}(), Xi = re, Tn = tn(Xi), Kd = Lo, vn = tn(Kd), jd = Ui, oe = tn(jd), Yd = Ud, pa = tn(Yd), zd = qe, Xd = Zd(zd), ot = je, ma = tn(ot), qd = Vd;
function Zd(n) {
  if (n && n.__esModule)
    return n;
  var t = {};
  if (n != null)
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  return t.default = n, t;
}
function tn(n) {
  return n && n.__esModule ? n : { default: n };
}
function Jd(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $a(n, t) {
  if (!n)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : n;
}
function Qd(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(n, t) : n.__proto__ = t);
}
var ec = $t.portalClassName = "ReactModalPortal", tc = $t.bodyOpenClassName = "ReactModal__Body--open", dt = ot.canUseDOM && vn.default.createPortal !== void 0, ur = function(t) {
  return document.createElement(t);
}, _a = function() {
  return dt ? vn.default.createPortal : vn.default.unstable_renderSubtreeIntoContainer;
};
function sn(n) {
  return n();
}
var Ft = function(n) {
  Qd(t, n);
  function t() {
    var r, a, i, o;
    Jd(this, t);
    for (var s = arguments.length, l = Array(s), d = 0; d < s; d++)
      l[d] = arguments[d];
    return o = (a = (i = $a(this, (r = t.__proto__ || Object.getPrototypeOf(t)).call.apply(r, [this].concat(l))), i), i.removePortal = function() {
      !dt && vn.default.unmountComponentAtNode(i.node);
      var c = sn(i.props.parentSelector);
      c && c.contains(i.node) ? c.removeChild(i.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
    }, i.portalRef = function(c) {
      i.portal = c;
    }, i.renderPortal = function(c) {
      var u = _a(), h = u(i, Tn.default.createElement(pa.default, ha({ defaultStyles: t.defaultStyles }, c)), i.node);
      i.portalRef(h);
    }, a), $a(i, o);
  }
  return Gd(t, [{
    key: "componentDidMount",
    value: function() {
      if (ot.canUseDOM) {
        dt || (this.node = ur("div")), this.node.className = this.props.portalClassName;
        var a = sn(this.props.parentSelector);
        a.appendChild(this.node), !dt && this.renderPortal(this.props);
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function(a) {
      var i = sn(a.parentSelector), o = sn(this.props.parentSelector);
      return { prevParent: i, nextParent: o };
    }
  }, {
    key: "componentDidUpdate",
    value: function(a, i, o) {
      if (ot.canUseDOM) {
        var s = this.props, l = s.isOpen, d = s.portalClassName;
        a.portalClassName !== d && (this.node.className = d);
        var c = o.prevParent, u = o.nextParent;
        u !== c && (c.removeChild(this.node), u.appendChild(this.node)), !(!a.isOpen && !l) && !dt && this.renderPortal(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (!(!ot.canUseDOM || !this.node || !this.portal)) {
        var a = this.portal.state, i = Date.now(), o = a.isOpen && this.props.closeTimeoutMS && (a.closesAt || i + this.props.closeTimeoutMS);
        o ? (a.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, o - i)) : this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function() {
      if (!ot.canUseDOM || !dt)
        return null;
      !this.node && dt && (this.node = ur("div"));
      var a = _a();
      return a(Tn.default.createElement(pa.default, ha({
        ref: this.portalRef,
        defaultStyles: t.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function(a) {
      Xd.setElement(a);
    }
    /* eslint-disable react/no-unused-prop-types */
    /* eslint-enable react/no-unused-prop-types */
  }]), t;
}(Xi.Component);
Ft.propTypes = {
  isOpen: oe.default.bool.isRequired,
  style: oe.default.shape({
    content: oe.default.object,
    overlay: oe.default.object
  }),
  portalClassName: oe.default.string,
  bodyOpenClassName: oe.default.string,
  htmlOpenClassName: oe.default.string,
  className: oe.default.oneOfType([oe.default.string, oe.default.shape({
    base: oe.default.string.isRequired,
    afterOpen: oe.default.string.isRequired,
    beforeClose: oe.default.string.isRequired
  })]),
  overlayClassName: oe.default.oneOfType([oe.default.string, oe.default.shape({
    base: oe.default.string.isRequired,
    afterOpen: oe.default.string.isRequired,
    beforeClose: oe.default.string.isRequired
  })]),
  appElement: oe.default.oneOfType([oe.default.instanceOf(ma.default), oe.default.instanceOf(ot.SafeHTMLCollection), oe.default.instanceOf(ot.SafeNodeList), oe.default.arrayOf(oe.default.instanceOf(ma.default))]),
  onAfterOpen: oe.default.func,
  onRequestClose: oe.default.func,
  closeTimeoutMS: oe.default.number,
  ariaHideApp: oe.default.bool,
  shouldFocusAfterRender: oe.default.bool,
  shouldCloseOnOverlayClick: oe.default.bool,
  shouldReturnFocusAfterClose: oe.default.bool,
  preventScroll: oe.default.bool,
  parentSelector: oe.default.func,
  aria: oe.default.object,
  data: oe.default.object,
  role: oe.default.string,
  contentLabel: oe.default.string,
  shouldCloseOnEsc: oe.default.bool,
  overlayRef: oe.default.func,
  contentRef: oe.default.func,
  id: oe.default.string,
  overlayElement: oe.default.func,
  contentElement: oe.default.func
};
Ft.defaultProps = {
  isOpen: !1,
  portalClassName: ec,
  bodyOpenClassName: tc,
  role: "dialog",
  ariaHideApp: !0,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: !0,
  shouldCloseOnEsc: !0,
  shouldCloseOnOverlayClick: !0,
  shouldReturnFocusAfterClose: !0,
  preventScroll: !1,
  parentSelector: function() {
    return document.body;
  },
  overlayElement: function(t, r) {
    return Tn.default.createElement(
      "div",
      t,
      r
    );
  },
  contentElement: function(t, r) {
    return Tn.default.createElement(
      "div",
      t,
      r
    );
  }
};
Ft.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, qd.polyfill)(Ft);
process.env.NODE_ENV !== "production" && (Ft.setCreateHTMLElement = function(n) {
  return ur = n;
});
$t.default = Ft;
(function(n, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = $t, a = i(r);
  function i(o) {
    return o && o.__esModule ? o : { default: o };
  }
  t.default = a.default, n.exports = t.default;
})(ir, ir.exports);
var nc = ir.exports;
const qi = /* @__PURE__ */ Nr(nc), rc = "DIALOG_IMAGE_TEST_ID", ac = "DIALOG_CONTENT_TEST_ID", ic = "DIALOG_DATA_TEST_ID", Zi = "FDSDialogContentTitle", Ji = "FDSDialogContentBody", ln = {
  MEDIA: "fmc-dialog__media-area",
  VIDEO: "fmc-dialog__video",
  VIDEO_COVER: "fmc-dialog__video-cover",
  VIDEO_FULL: "fmc-dialog__video--full",
  VIDEO_PLAYING: "fmc-dialog__video--playing"
}, oc = {
  title: /* @__PURE__ */ f(He, { children: "You are now leaving fordpro.ca" }),
  body: /* @__PURE__ */ U(He, { children: [
    "You are now leaving",
    " ",
    /* @__PURE__ */ f("a", { href: "https://www.fordpro.ca/en-ca/", target: "_self", children: /* @__PURE__ */ f("u", { children: "fordpro.ca" }) }),
    ". Ford of Canada's privacy policy will no longer apply. Please refer to the redirected website for its privacy policy."
  ] }),
  buttonOneText: "Continue",
  ariaLabelButtonOne: "Continue to the site. Opens in a new window.",
  buttonTwoText: "Cancel",
  ariaLabelButtonTwo: "Cancel this action.",
  ariaLabelCloseButton: "close"
}, sc = {
  title: /* @__PURE__ */ f(He, { children: "Vous êtes sur le point de quitter fordpro.ca" }),
  body: /* @__PURE__ */ U(He, { children: [
    "Vous êtes sur le point de quitter",
    " ",
    /* @__PURE__ */ f("a", { href: "https://www.fordpro.ca/fr-ca/", children: /* @__PURE__ */ f("u", { children: "fordpro.ca" }) }),
    ". La politique de confidentialité de Ford Canada cessera de s'appliquer. Veuillez-vous reporter à la politique de confidentialité du site auquel vous serez redirigé.",
    /* @__PURE__ */ f("br", {})
  ] }),
  buttonOneText: "Continuer",
  ariaLabelButtonOne: "Continuer vers le site. S’ouvre dans une nouvelle fenêtre.",
  buttonTwoText: "Annuler",
  ariaLabelButtonTwo: "Annuler cette action.",
  ariaLabelCloseButton: "fermer"
}, lc = ({
  type: n = "standard",
  children: t,
  visible: r = !1,
  onRequestClose: a,
  closeOnBackdropClick: i = !1,
  style: o,
  className: s,
  titleId: l = Zi,
  bodyId: d = Ji,
  closeButtonProps: c = { ariaLabel: "Close" }
}) => {
  const u = Y.useRef();
  Y.useEffect(() => {
    if (i) {
      const p = (m) => {
        m.target === u.current && a();
      };
      return window.addEventListener("click", p), () => {
        window.removeEventListener("click", p);
      };
    }
  }, [i, a]);
  const h = /* @__PURE__ */ f(
    Zt,
    {
      name: "clear",
      className: C(
        "fmc-dialog__close",
        "fds-icon",
        "fds-font--ford-icons__clear"
      ),
      onClick: a,
      type: "button",
      "aria-label": c.ariaLabel,
      size: 24,
      autoFocus: "true"
    }
  );
  return /* @__PURE__ */ f(
    qi,
    {
      style: o,
      isOpen: r,
      onRequestClose: a,
      className: C("fds-app"),
      appElement: document.getElementsByClassName("fds-app"),
      children: /* @__PURE__ */ f(
        "div",
        {
          id: "FDSDialog",
          className: C(
            "fmc-dialog",
            r && "fmc-dialog--opened",
            s
          ),
          "aria-labelledby": l,
          "aria-describedby": d,
          role: "dialog",
          ref: u,
          "data-testid": ic,
          children: /* @__PURE__ */ U("div", { className: C("fmc-dialog__content"), children: [
            n === "standard" && h,
            t
          ] })
        }
      )
    }
  );
}, dc = ({
  title: n,
  subtitle: t,
  body: r,
  buttonOneText: a,
  buttonOneOnClick: i,
  buttonOneStyle: o = "primary",
  buttonOneLink: s,
  buttonOneTarget: l,
  buttonTwoText: d,
  buttonTwoOnClick: c,
  buttonTwoStyle: u = "outlined",
  buttonTwoLink: h,
  alignment: p = "left",
  className: m,
  dataTestId: _ = ac,
  ariaLabelButtonOne: T,
  ariaLabelButtonTwo: y,
  titleId: v = Zi,
  bodyId: g = Ji,
  disclosureContent: S
}) => {
  const b = (D, H, W, B, I, A) => {
    const L = {
      title: H,
      onClick: W,
      href: B,
      as: B ? "a" : "button",
      ariaLabel: A,
      ...l && { target: l }
    };
    return D === "primary" ? /* @__PURE__ */ f("div", { className: I, children: /* @__PURE__ */ f(Ot, { ...L }) }) : D === "outlined" ? /* @__PURE__ */ f("div", { className: I, children: /* @__PURE__ */ f(Ot, { outlined: !0, ...L }) }) : null;
  }, $ = "fmc-m--b-2", P = "fmc-mb-3-xs fmc-mb-3-sm fmc-mb-3-md", G = `fmc-mr-5-lg fmc-mr-5-xl fmc-mr-5-md fmc-mr-3-sm ${p === "left" ? "fmc-mr-3-xs" : ""}`, w = p === "left" ? "flex-start" : "center";
  return /* @__PURE__ */ U(
    "div",
    {
      id: "FDSDialogContent",
      "data-testid": _,
      className: C(p === "center" && "fds-align--center", m),
      children: [
        /* @__PURE__ */ f(
          "h2",
          {
            id: v,
            className: C(
              "fmc-type--heading5",
              "fmc-mb-3",
              "fmc-dialog__heading-title"
            ),
            children: n
          }
        ),
        t && /* @__PURE__ */ f("h4", { className: C("fmc-type--subtitle1", "fmc-mb-2"), children: t }),
        /* @__PURE__ */ f("p", { id: g, className: C("fmc-type--body1", "fmc-mb-5"), children: r }),
        /* @__PURE__ */ U(
          "div",
          {
            style: {
              display: "flex",
              flexWrap: "wrap",
              justifyContent: w
            },
            children: [
              a && b(
                o,
                a,
                i,
                s,
                `${$} ${G} ${P} `,
                T
              ),
              d && b(
                u,
                d,
                c,
                h,
                $,
                y
              )
            ]
          }
        ),
        S && /* @__PURE__ */ f(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: w
            },
            children: /* @__PURE__ */ f(
              yi,
              {
                disclosureContent: S?.disclosureContent,
                id: S?.id,
                className: S?.className,
                disclosureTitleColor: S?.disclosureTitleColor,
                style: S?.style
              }
            )
          }
        )
      ]
    }
  );
}, F1 = ({
  alt: n,
  className: t,
  imageClassName: r,
  dataTestId: a = rc,
  ...i
}) => /* @__PURE__ */ f(
  "div",
  {
    className: C(t),
    style: { display: "flex", justifyContent: "center" },
    children: /* @__PURE__ */ f(
      "img",
      {
        "data-testid": a,
        className: C("fmc-pb-5", r),
        alt: n,
        ...i
      }
    )
  }
), cc = "CARD_VIDEO_MEDIA_TEST_ID", uc = "CARD_VIDEO_COVER_TEST_ID", fc = "CARD_HTML5_VIDEO_TEST_ID", hc = "CARD_HTML5_VIDEO_TRACK_TEST_ID", pc = "CARD_HTML5_VIDEO_SOURCE_TEST_ID", M1 = ({
  children: n,
  videoCover: t,
  isVideoPlaying: r = !1,
  videoTrackProps: a,
  videoSources: i,
  videoRef: o,
  onPlayCustomVideoMedia: s,
  className: l,
  dataTestId: d = cc,
  ...c
}) => {
  const [u, h] = Y.useState(!1), p = Y.useRef(null);
  Y.useEffect(() => {
    p?.current && u && p.current.play();
  }, [u]);
  const m = () => {
    n && s ? s() : p?.current && p.current.paused && h(!0);
  };
  return /* @__PURE__ */ U(
    "div",
    {
      id: "FDSDialogVideo",
      "data-testid": d,
      "aria-label": "Video media",
      role: "button",
      tabIndex: 0,
      className: C(
        ln.MEDIA,
        ln.VIDEO,
        (r || u) && ln.VIDEO_PLAYING,
        "fds-m--b-2",
        l
      ),
      onClick: m,
      onKeyPress: (_) => _.key === "Enter" && m(),
      children: [
        /* @__PURE__ */ f(
          "div",
          {
            "data-testid": uc,
            className: C(ln.VIDEO_COVER),
            style: t ? {
              backgroundImage: `url(${t})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              zIndex: r || u ? 0 : 1
            } : {}
          }
        ),
        n,
        !n && i ? /* @__PURE__ */ U(
          "video",
          {
            "data-testid": fc,
            width: "100%",
            ref: void 0,
            controls: r || u,
            style: { zIndex: r || u ? 1 : 0 },
            ...c,
            children: [
              /* @__PURE__ */ f(
                "track",
                {
                  "data-testid": hc,
                  default: !0,
                  kind: "captions",
                  ...a
                }
              ),
              i.map((_, T) => /* @__PURE__ */ f(
                "source",
                {
                  "data-testid": `${pc}_${T}`,
                  ..._
                },
                T
              )),
              "Sorry, your browser doesn't support embedded videos."
            ]
          }
        ) : null
      ]
    }
  );
}, k1 = ({
  isVisible: n,
  onClickFunction: t,
  buttonOneLink: r,
  buttonOneAriaLabel: a
}) => {
  const i = window.location.pathname.split("/")[1], o = i.includes("ca"), l = i.includes("fr") ? sc : oc, d = (c) => {
    t && t(), o && window?._satellite && window?._satellite.track("globalInteraction", {
      onclickLinkName: `exit modal:${c}`,
      onclick: `exit modal:${c}`,
      tool: "event:exit modal",
      toolDescriptor: `exit modal:${c}`
    });
  };
  return Y.useEffect(() => {
    n && window?._satellite && o && window?._satellite.track("globalInteraction", {
      onclickLinkName: "exit modal",
      onclick: "exit modal:modal displayed",
      tool: "event:exit modal",
      toolDescriptor: "exit modal:display"
    });
  }, [o, n]), /* @__PURE__ */ f(
    lc,
    {
      visible: n,
      closeButtonProps: { ariaLabel: l.ariaLabelCloseButton },
      onRequestClose: () => d("cancel"),
      children: /* @__PURE__ */ f(
        dc,
        {
          title: l.title,
          body: l.body,
          buttonOneText: l.buttonOneText,
          buttonOneOnClick: () => d("continue"),
          buttonOneLink: r,
          buttonOneTarget: "_blank",
          ariaLabelButtonOne: a ?? l.ariaLabelButtonOne,
          buttonTwoText: l.buttonTwoText,
          buttonTwoOnClick: () => d("cancel"),
          alignment: "left",
          ariaLabelButtonTwo: l.ariaLabelButtonTwo
        }
      )
    }
  );
}, vt = {
  HORIZONTAL: "fmc-divider--horizontal",
  FULL_HORIZONTAL: "fmc-divider--horizontal-full",
  VERTICAL: "fmc-divider--vertical",
  FULL_VERTICAL: "fmc-divider--vertical-full",
  LAYOUT_GRID: "fds-layout-grid__cell--span-2"
}, B1 = ({
  full: n = !0,
  className: t,
  horizontal: r = !0
}) => /* @__PURE__ */ f(
  "hr",
  {
    className: C(
      r && n && vt.FULL_HORIZONTAL,
      r && !n && vt.HORIZONTAL,
      !r && n && `${vt.FULL_VERTICAL} ${vt.LAYOUT_GRID}`,
      !r && !n && `${vt.VERTICAL} ${vt.LAYOUT_GRID}`,
      t
    )
  }
), Qi = "FILTER_CHIPS_DATA_TEST_ID", bt = {
  FILTER_CHIPS: "fmc-filter-chips",
  FILTER_CHIPS_SCROLLABLE: "fmc-filter-chips--scrollable",
  FILTER_CHIPS_CHIP: "fmc-filter-chips__chip",
  FILTER_CHIPS_DISABLED: "fmc-filter-chips__chip--disabled",
  TEXT_BUTTON: "fmc-text-button",
  ICON_CLEAR: "fds-icon fds-icon--24 fds-icon--offset-right-sm fds-font--ford-icons__clear",
  ICON_OFFSET: "fds-icon fds-icon--24 fds-icon--offset-left"
}, U1 = ({
  isScrollable: n,
  children: t,
  dataTestId: r = Qi
}) => /* @__PURE__ */ f(
  "div",
  {
    className: C(
      bt.FILTER_CHIPS,
      n && bt.FILTER_CHIPS_SCROLLABLE
    ),
    "data-testid": r,
    children: t
  }
), H1 = ({
  text: n,
  isDisabled: t,
  thumbnail: r,
  onDelete: a,
  dataTestId: i = Qi
}) => /* @__PURE__ */ U(
  "div",
  {
    className: C(
      bt.FILTER_CHIPS_CHIP,
      t && bt.FILTER_CHIPS_DISABLED
    ),
    "data-testid": i,
    children: [
      r && /* @__PURE__ */ f("span", { className: C(bt.ICON_OFFSET), children: Y.cloneElement(r, {
        style: { height: "24px", width: "24px" }
      }) }),
      n,
      /* @__PURE__ */ f(
        "button",
        {
          className: C(bt.ICON_CLEAR),
          "aria-label": "clear",
          ...t && { disabled: t },
          onClick: a
        }
      )
    ]
  }
);
function ga(n) {
  return n != null && !(Array.isArray(n) && n.length === 0);
}
function un(n, t = !1) {
  return n && (ga(n.value) && n.value !== "" || t && ga(n.defaultValue) && n.defaultValue !== "");
}
const Gn = {
  INPUT_DISABLED: "cxc-input-field__input--disabled",
  STATUS: "cxc-input-field__status",
  MESSAGE: "cxc-input-field__message"
}, mc = "TextField", gt = Y.forwardRef(
  ({
    onChange: n,
    onFocus: t,
    onBlur: r,
    onClick: a,
    defaultValue: i,
    role: o,
    multiline: s = !1,
    hideDateFormat: l,
    disabled: d = !1,
    hideSuccess: c = !1,
    error: u,
    placeholder: h,
    message: p,
    value: m,
    required: _,
    inputRef: T,
    className: y,
    success: v,
    label: g,
    pattern: S,
    labelIsVisibleWhenDisabled: b = !1,
    warning: $,
    ...P
  }, G) => {
    const [w, D] = ee(!1), [H, W] = ee(!1), [B, I] = ee(!1), { current: A } = le(m != null), N = le(ze(P.id ?? mc)), L = (F) => {
      r && r(F), W(!1);
    }, E = (F) => {
      W(!0), D(!0), a && a(F);
    }, x = (F) => {
      W(!0), D(!0), t && t(F);
    }, X = (F) => {
      F.key === "Tab" && E(F);
    }, O = (F, ...K) => {
      if (!A) {
        const j = F.target || T.current;
        Z({
          value: j.value
        });
      }
      let q = !1;
      S && new RegExp(S).test(F.target.value) && (q = !0), n && n(F, S ? q : !0, ...K);
    }, R = Y.useCallback(() => {
      I(!0);
    }, []), J = Y.useCallback(() => {
      I(!1);
    }, []), Z = Y.useCallback(
      (F) => {
        un(F) ? R && R() : J && J();
      },
      [R, J]
    );
    de(() => {
      A && Z({ value: m });
    }, [m, Z, A]);
    const z = h || g, k = g || h;
    return /* @__PURE__ */ f(
      "div",
      {
        className: C(
          "fds-app",
          "cxc-input-field",
          B && "cxc-input-field-filled",
          H && "cxc-input-field-active",
          d && Gn.INPUT_DISABLED,
          y
        ),
        ref: G,
        children: /* @__PURE__ */ U(
          "div",
          {
            className: C(
              "fmc-floating-label",
              u && "fmc-floating-label--error",
              $ && "fmc-floating-label--warning",
              !c && v && "fmc-floating-label--success"
            ),
            children: [
              s ? /* @__PURE__ */ f(
                "textarea",
                {
                  id: N.current,
                  className: C(
                    "cxc-multiline",
                    u && "fmc-input--error",
                    $ && "fmc-input--warning",
                    !c && v && "fmc-input--success",
                    "fmc-input"
                  ),
                  disabled: d,
                  value: m,
                  placeholder: H ? void 0 : z,
                  defaultValue: i,
                  onBlur: L,
                  onChange: O,
                  onFocus: x,
                  onClick: E,
                  onKeyUp: X,
                  required: _,
                  ref: T,
                  "data-testid": "textareaf_for_multiline",
                  "aria-invalid": u ? !0 : void 0,
                  "aria-disabled": d,
                  "aria-describedby": `${N.current}_message_id`,
                  "aria-required": _
                }
              ) : /* @__PURE__ */ f(
                "input",
                {
                  className: C(
                    u && "fmc-input--error",
                    $ && "fmc-input--warning",
                    !c && v && "fmc-input--success",
                    "fmc-input"
                  ),
                  disabled: d,
                  value: m,
                  placeholder: H ? void 0 : z,
                  defaultValue: i,
                  onBlur: L,
                  onChange: O,
                  onFocus: x,
                  onClick: E,
                  onKeyUp: X,
                  required: _,
                  ref: T,
                  role: o,
                  "aria-labelledby": `${N.current}_label_id`,
                  "aria-describedby": `${N.current}_message_id`,
                  "aria-required": _,
                  "aria-disabled": d,
                  "aria-invalid": u ? !0 : void 0,
                  ...P,
                  id: N.current
                }
              ),
              /* @__PURE__ */ f(
                "label",
                {
                  htmlFor: N.current,
                  className: C(
                    w && !H && !B && u && o !== "date" && "cxc-base-text-label-error"
                  ),
                  children: /* @__PURE__ */ f(
                    "span",
                    {
                      "data-testid": "error_label",
                      id: `${N.current}_label_id`,
                      className: C(
                        "fmc-floating-label__text",
                        o === "date" && "fmc-floating-label__text-date",
                        w && !H && !B && o !== "date" && "cxc-base-text-no-icon",
                        d && "cxc-disabled-label"
                      ),
                      children: d && b && k || !d && (!H && !B && z || (H || B) && k)
                    }
                  )
                }
              ),
              /* @__PURE__ */ f("div", { className: Gn.STATUS, children: /* @__PURE__ */ f(
                "span",
                {
                  className: Gn.MESSAGE,
                  role: "alert",
                  id: `${N.current}_message_id`,
                  children: p
                }
              ) })
            ]
          }
        )
      }
    );
  }
);
gt.displayName = "BaseTextField";
const Kn = {
  INPUT_INVALID: "cxc-password-field__input--invalid",
  INPUT_DIRTY: "cxc-password-field__input--dirty",
  INPUT_ACTIVE: "cxc-password-field__input--active"
}, $c = "BASE_PASSWORD_TEXTFIELD_DATA_TEST_ID", _c = "PASSWORD_TEXTFIELD_DATA_TEST_ID", gc = "PasswordField", Tc = Y.forwardRef(
  ({
    onChange: n,
    onFocus: t,
    onBlur: r,
    onClick: a,
    defaultValue: i,
    disabled: o = !1,
    error: s,
    placeholder: l,
    message: d,
    value: c,
    required: u,
    inputRef: h,
    rules: p,
    newPasswordValidation: m = !1,
    hideSuccess: _ = !1,
    className: T,
    name: y,
    label: v,
    ...g
  }, S) => {
    const [b, $] = ee(!1), [P, G] = ee(!1), [w, D] = ee(!1), [H, W] = Y.useState(!1), [B, I] = Y.useState(!1), { current: A } = Y.useRef(c != null), [N, L] = ee(!1), E = le(ze(gc));
    function x(me, Ae) {
      let xe = 0;
      return Ae ? (Ae.forEach((We) => {
        O(We.pattern, me) === !1 && xe++;
      }), H ? xe === Ae.length ? "weak" : xe < Ae.length && xe !== 0 ? "better" : "strong" : null) : [];
    }
    const X = (me, Ae) => {
      const xe = [];
      return Ae.forEach((We, rt) => {
        xe.push(
          /* @__PURE__ */ f(
            "li",
            {
              className: C(
                "cxc-password-field__password-reqs-list-item",
                O(We.pattern, me) && "cxc-password-field__password-reqs-list-item--success"
              ),
              children: /* @__PURE__ */ f("span", { children: We.message })
            },
            rt
          )
        );
      }), xe;
    }, O = (me, Ae) => new RegExp(me).test(Ae), R = (me) => {
      r && r(me), D(!1);
    }, J = (me) => {
      D(!0), $(!0), a && a(me);
    }, Z = (me) => {
      me.key === "Tab" && J(me);
    }, z = Y.useCallback(() => {
      W(!0);
    }, []), k = Y.useCallback(() => {
      W(!1);
    }, []), F = Y.useCallback(
      (me) => {
        un(me) ? z && z() : k && k();
      },
      [z, k]
    );
    de(() => {
      A && F({ value: c });
    }, [c, F, A]), de(() => {
      I(un({ value: c }) && !s);
    }, [s, w, c]);
    const K = (me) => {
      if (I(!1), !A) {
        const Ae = me.target;
        F({
          value: Ae.value
        });
      }
      n && n(me);
    }, q = (me) => {
      D(!0), $(!0), t && t(me);
    }, j = () => {
      L(!N);
    }, te = () => {
      G(!1);
    }, se = (me) => {
      me.key === "Tab" && G(!0);
    }, V = x(c, p);
    de(() => {
      un({ value: c }) && V == "strong" && I(!0);
    }, [c, V]);
    function ye() {
      if (m) {
        if (c)
          if (w)
            switch (V) {
              case "weak":
                return "Password is weak";
              case "better":
                return "Password is better";
              case "strong":
                return "Password is strong";
            }
          else
            return "Password doesn't meet the criteria.";
        return d;
      } else
        return d;
    }
    const De = l || v, Ze = v || l;
    return /* @__PURE__ */ U(
      "div",
      {
        "data-testid": _c,
        className: C(
          "fds-app",
          "cxc-input-field",
          H && `${Kn.INPUT_DIRTY} cxc-input-field-filled`,
          w && `${Kn.INPUT_ACTIVE} cxc-input-field-active`,
          s && !o && `${Kn.INPUT_INVALID}`,
          o && "cxc-input-field__input--disabled",
          "cxc-password-field",
          m && V === "weak" && "cxc-password-field__strength--weak",
          m && V === "better" && "cxc-password-field__strength--better",
          m && V === "strong" && "cxc-password-field__strength--strong",
          // newPasswordValidation &&
          //   strength === 'strong' &&
          //   success &&
          //   !hideSuccess &&
          //   value &&
          //   !disabled &&
          //   classes.INPUT_VALID,
          // !newPasswordValidation &&
          //   success &&
          //   !hideSuccess &&
          //   value &&
          //   !disabled &&
          //   classes.INPUT_VALID,
          T
        ),
        ref: S,
        children: [
          /* @__PURE__ */ f("div", { className: "cxc-password-field__mask-container", children: /* @__PURE__ */ f(
            "button",
            {
              tabIndex: c ? 0 : -1,
              className: C(
                "cxc-password-field__mask-button",
                P && "cxc-password-field__mask-button--focused"
              ),
              "aria-label": "Reveal Password",
              onClick: j,
              onKeyUp: se,
              onBlur: te,
              type: "button",
              children: /* @__PURE__ */ f(
                "span",
                {
                  className: C(
                    "fds-icon",
                    N ? "fds-font--ford-icons__unmask" : "fds-font--ford-icons__mask"
                  )
                }
              )
            }
          ) }),
          /* @__PURE__ */ U(
            "div",
            {
              className: C(
                "fmc-floating-label",
                s && "fmc-floating-label--error",
                !_ && !o && B && "fmc-floating-label--success"
              ),
              children: [
                /* @__PURE__ */ f(
                  "input",
                  {
                    id: E.current,
                    name: y,
                    "aria-disabled": o,
                    className: C(
                      s && "fmc-input--error",
                      !_ && !o && B && "fmc-input--success",
                      "fmc-input"
                    ),
                    autoComplete: "off",
                    disabled: o,
                    value: c,
                    placeholder: w ? void 0 : De,
                    defaultValue: i,
                    onBlur: R,
                    onChange: K,
                    onFocus: q,
                    onClick: J,
                    onKeyUp: Z,
                    ref: h,
                    required: u,
                    type: N ? "text" : "password",
                    "data-testid": $c,
                    ...g
                  }
                ),
                /* @__PURE__ */ f(
                  "label",
                  {
                    htmlFor: E.current,
                    className: C(
                      b && !w && !H && s && "cxc-base-text-label-error"
                    ),
                    children: /* @__PURE__ */ f(
                      "span",
                      {
                        className: C(
                          "fmc-floating-label__text",
                          b && !w && !H && "cxc-base-text-no-icon"
                        ),
                        children: !o && (!w && !H && De || (w || H) && Ze)
                      }
                    )
                  }
                ),
                /* @__PURE__ */ U("div", { className: "cxc-input-field__status", children: [
                  /* @__PURE__ */ f(
                    "span",
                    {
                      className: C("cxc-input-field__message"),
                      "aria-live": "assertive",
                      role: "alert",
                      id: `${E.current}_message_id`,
                      children: ye()
                    }
                  ),
                  m && /* @__PURE__ */ f("span", { className: C("cxc-password-field__strength"), children: /* @__PURE__ */ U("span", { className: "cxc-password-field__strength-inner", children: [
                    /* @__PURE__ */ f("span", { className: "cxc-password-field__strength-tick" }),
                    /* @__PURE__ */ f("span", { className: "cxc-password-field__strength-tick" }),
                    /* @__PURE__ */ f("span", { className: "cxc-password-field__strength-tick" })
                  ] }) })
                ] }),
                m && /* @__PURE__ */ U("div", { className: "cxc-password-field__password-reqs", children: [
                  /* @__PURE__ */ f("p", { className: "cxc-password-field__password-reqs-message", children: "Please make sure your password meets all the requirements." }),
                  /* @__PURE__ */ f("ul", { className: C("cxc-password-field__password-reqs-list"), children: X(c, p) })
                ] })
              ]
            }
          )
        ]
      }
    );
  }
);
Tc.displayName = "BasePasswordField";
const wr = (n) => n.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), Lr = ({
  value: n,
  groupSeparator: t = ",",
  decimalSeparator: r = ".",
  allowDecimals: a = !0,
  decimalsLimit: i = 2,
  allowNegativeValue: o = !0,
  prefix: s = ""
}) => {
  if (n === "-")
    return n;
  const l = [], c = new RegExp(`((^|\\D)-\\d)|(-${wr(s)})`).test(n), u = vc(n, t), h = yc(u, [
    t,
    r,
    ...l
  ]), p = h, m = c && o ? "-" : "";
  if (r && p.includes(r)) {
    const [_, T] = h.split(r), y = i && T ? T.slice(0, i) : T, v = a ? `${r}${y}` : "";
    return `${m}${_}${v}`;
  }
  return `${m}${p}`;
}, vc = (n, t = ",") => {
  const r = new RegExp(wr(t), "g");
  return n.replace(r, "");
}, yc = (n, t) => {
  const r = wr(t.join("")), a = new RegExp(`[^\\d${r}]`, "gi");
  return n.replace(a, "");
}, W1 = ({
  currency: n = "USD",
  locale: t = "en",
  onChange: r,
  onValueChange: a,
  defaultValue: i = "",
  padZeroes: o = !1,
  onBlur: s,
  ...l
}) => {
  const [d, c] = ee(i), u = le(), [h, p] = ee(null);
  de(() => {
    const g = u.current;
    g && g.setSelectionRange(h, h);
  }, [u, h, d]);
  const m = (g, S = !1) => {
    const b = Intl.NumberFormat(t, {
      style: "currency",
      currency: n,
      maximumSignificantDigits: 18
    }).formatToParts(1111.11), $ = b.find(
      (I) => I.type === "decimal"
    )?.value, P = b.find(
      (I) => I.type === "literal"
    )?.value, G = b.find(
      (I) => I.type === "currency"
    )?.value, w = b.find(
      (I) => I.type === "group"
    )?.value;
    let D = Lr({
      value: g,
      groupSeparator: w,
      decimalSeparator: $
    });
    D = D.replace(",", ".");
    const H = Ec(".", D), W = parseFloat(D);
    let B = "";
    if (D.charAt(D.length - 1) !== ".") {
      let I = 2;
      S || (I = Math.min(H, 2));
      const A = new Intl.NumberFormat(t, {
        style: "currency",
        currency: n,
        minimumFractionDigits: I,
        maximumFractionDigits: I
      }).format(W);
      isNaN(W) || (B = A), p(
        P ? A.length - // @ts-ignore
        (P.length + G.length) : A.length
      );
    } else {
      const I = new Intl.NumberFormat(t, {
        style: "currency",
        currency: n,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(W);
      if (P) {
        const A = I.replace(
          `${P}${G}`,
          ""
        );
        B = `${A}${$}${P}${G}`, p(`${A}${$}`.length);
      } else
        B = `${I}${$}`, p(`${I}${$}`.length);
    }
    B !== d && (c(B), a(_(B, D)));
  }, _ = (g, S) => {
    const b = parseFloat(S);
    return {
      formattedValue: g,
      value: S,
      floatValue: isNaN(b) ? void 0 : b
    };
  }, T = (g) => {
    m(g.target.value), r?.(g);
  }, y = (g) => {
    m(g.target.value, o), s?.(g);
  };
  return /* @__PURE__ */ f(
    gt,
    {
      onChange: (g) => T(g),
      onBlur: (g) => y(g),
      onFocus: () => {
        const g = u.current;
        g && setTimeout(function() {
          g.setSelectionRange(h, h);
        }, 0);
      },
      value: d,
      inputRef: u,
      "data-testid": "currency-input",
      maxLength: 18,
      ...l
    }
  );
}, Ec = function(n, t) {
  return t.split(n)[1]?.length || 0;
}, eo = {
  COMPONENT: "fmc-check__button",
  SUB_TEXT: "cxc-checkbox__sub-text"
}, bc = "CHECKBOX_DATA_TEST_ID", Cc = ({
  checked: n,
  children: t,
  defaultChecked: r,
  disabled: a,
  id: i = "FDSCheckboxComponent",
  key: o,
  onChange: s,
  value: l,
  className: d,
  dataTestId: c = bc,
  inputClassName: u,
  ariaLabelledBy: h,
  ...p
}) => /* @__PURE__ */ U("div", { className: C(eo.COMPONENT, d), children: [
  /* @__PURE__ */ f(
    "input",
    {
      id: i,
      "data-testid": c,
      type: "checkbox",
      value: l,
      defaultChecked: r,
      checked: n,
      disabled: a,
      onChange: s,
      "aria-checked": n,
      "aria-disabled": a,
      "aria-labelledby": typeof t == "string" ? t : h,
      className: u,
      ...p
    }
  ),
  /* @__PURE__ */ f("label", { htmlFor: i, children: t })
] }, o), Nc = "CHECKBOX_DATA_TEST_ID", V1 = ({
  checked: n,
  children: t,
  defaultChecked: r,
  disabled: a,
  id: i = "FDSCheckboxComponent",
  key: o,
  subText: s,
  onChange: l,
  value: d,
  className: c,
  dataTestId: u = Nc,
  ...h
}) => /* @__PURE__ */ U("div", { children: [
  /* @__PURE__ */ f(
    Cc,
    {
      children: t,
      value: d,
      checked: n,
      defaultChecked: r,
      disabled: a,
      id: i,
      onChange: l,
      dataTestId: u,
      className: c,
      ...h
    },
    o
  ),
  s && /* @__PURE__ */ f("span", { className: C(eo.SUB_TEXT), children: s })
] }), Sc = "CHECKBOX_GROUP_DATA_TEST_ID", G1 = ({
  children: n,
  disabled: t,
  horizontal: r,
  legend: a,
  onChange: i,
  legendClassName: o,
  className: s,
  dataTestId: l = Sc
}) => {
  const d = Array.isArray(n) ? n : [n], [c, u] = ee(
    d.map((m) => m?.props.defaultChecked ?? !1)
  ), h = ze(), p = (m) => {
    const _ = [...c];
    _[m] = !_[m], u(_);
  };
  return /* @__PURE__ */ U(
    "fieldset",
    {
      className: C(
        "fmc-check",
        r && "fmc-check--horizontal",
        s
      ),
      "aria-labelledby": a || "checkbox group",
      "data-testid": l,
      children: [
        a && /* @__PURE__ */ f("legend", { id: a, className: o, children: a }),
        d.map((m, _) => {
          const T = _ + 1;
          if (!m)
            return null;
          const y = t || m.props.disabled, v = m.props.checked ?? (c[_] && !y);
          return Y.cloneElement(m, {
            checked: v,
            defaultChecked: void 0,
            disabled: y,
            onChange(g) {
              m.props.onChange?.(g), i?.(g);
            },
            onClick() {
              p(_);
            },
            onKeyUp(g) {
              g.key === "Enter" && p(_);
            },
            id: m.props.id ?? `FDSCheckboxComponent${T}-${h}`,
            dataTestId: m.props.dataTestId ?? `${l}_CHECKBOX_BUTTON_${T}`
          });
        })
      ]
    }
  );
}, pe = {
  COMPONENT: "js-fds-dropdown",
  DROPDOWN: "fds-dropdown",
  PLACEHOLDER: "fds-dropdown__placeholder",
  BUTTON_WRAPPER: "fds-dropdown__button-wrapper",
  BUTTON: "fds-dropdown__button",
  SELECT: "fds-dropdown__select",
  FOCUSED: "fds-dropdown--focused",
  HOVER: "fds-dropdown--hover",
  ACTIVE: "fds-dropdown--active",
  TOUCH: "fds-dropdown--touch",
  DIRTY: "fds-dropdown--dirty",
  FOCUS_OUTLINE: "fds-dropdown__focus-outline",
  EYEBROW: "fds-dropdown__eyebrow",
  LABEL_WRAPPER: "fds-dropdown__label-wrapper",
  LABEL: "fds-dropdown__label",
  LABEL_ICON: "fds-dropdown__label-icon",
  FDS_ICON: "fds-icon",
  LIST_WRAPPER: "fds-dropdown__list-wrapper",
  LIST: "fds-dropdown__list",
  LIST_SHOW: "fds-dropdown__list--show",
  LIST_OPTION: "fds-dropdown__list-option",
  LIST_OPTION_DISABLED: "cxc-dropdown__list-option--disabled",
  LIST_OPTION_FOCUSED: "fds-dropdown__list-option--focused",
  SELECT_OPTION: "fds-dropdown__select-option",
  SELECT_OPTION_HIDE: "fds-dropdown__select-option--hide",
  HIDE: "fds-hide",
  DISABLED: "fds-dropdown--disabled",
  STATUS: "fds-dropdown__status",
  MESSAGE: "fds-dropdown__message",
  INVALID: "fds-dropdown__invalid",
  VALID: "fds-dropdown__valid",
  ERROR: "fds-font--ford-icons__error",
  SUCCESS: "fds-font--ford-icons__success",
  ICON_SUCCESS_FONT_SIZE: "fds-font--ford-icons__success_fontsize"
}, Oc = 500, at = {
  HOME: "home",
  END: "end",
  PREV: "prev",
  NEXT: "next"
}, jn = (n, t) => {
  for (let r = 0, a = t.length; r < a; r++)
    if (typeof t[r].value < "u" && t[r].value === n || typeof t[r].value < "u" && typeof n < "u" && typeof n.value < "u" && t[r].value === n.value)
      return r;
  return -1;
}, Ac = "Dropdown", Ic = "DROPDOWN_ERROR_DATA_TEST_ID", Rc = "DROPDOWN_BUTTON_DATA_TEST_ID", K1 = Y.forwardRef(
  ({
    placeholder: n = "Please Select",
    label: t,
    options: r = [],
    onChange: a,
    disabled: i = !1,
    value: o,
    tabIndex: s,
    error: l = !1,
    className: d,
    id: c,
    hideLabel: u = !1,
    onBlur: h,
    success: p = !1,
    dataTestId: m,
    role: _ = "combobox",
    ariaRequired: T
  }, y) => {
    const [v, g] = ee(!1), [S, b] = ee(!1), [$, P] = Y.useState(), [G, w] = Y.useState(!1), [D, H] = ee(
      jn(o, r)
    ), [W, B] = ee(
      jn(o, r)
    ), I = le(null), [A, N] = ee(""), [L, E] = ee(null), x = le(null), X = le(ze(Ac));
    de(() => {
      const Q = jn(o, r);
      Q !== W && B(Q);
    }, [r, o]);
    const { STATUS: O, MESSAGE: R } = pe, J = async (Q) => {
      Q.preventDefault(), K();
    }, Z = () => {
      b(!0);
    }, z = (Q) => {
      Q.relatedTarget !== x.current && Q.relatedTarget !== I && F();
    }, k = (Q) => {
      (Q.relatedTarget === null || !Q.relatedTarget.contains(I.current)) && F(), h && h();
    }, F = () => {
      j(), g(!1), b(!1);
    }, K = () => {
      i || ($ ? j() : q());
    }, q = () => {
      $ || (P(!0), b(!0), w(!1));
    }, j = () => {
      P(!1);
    }, te = (Q) => () => {
      H(Q);
    }, se = (Q) => (fe) => {
      fe.preventDefault(), B(Q), j(), I.current && I.current.focus(), a && a(r[Q]);
    }, V = (Q) => {
      if (x.current) {
        const fe = x.current.querySelectorAll("div[data-index]"), Oe = x.current;
        let Pe = 0;
        if (Q > 2)
          for (let ne = 0; ne < Q - 2; ne++)
            Pe += fe[ne].clientHeight;
        Oe.scrollTop = Pe;
      }
    }, ye = ({ children: Q, value: fe, index: Oe, disabled: Pe }) => /* @__PURE__ */ f(
      "div",
      {
        role: "option",
        "aria-selected": Oe === W ? "true" : "false",
        id: fe,
        onMouseOver: te(Oe),
        onMouseDown: Pe ? () => {
        } : se(Oe),
        className: C(
          pe.LIST_OPTION,
          !Pe && Oe === D && pe.LIST_OPTION_FOCUSED,
          Pe && pe.LIST_OPTION_DISABLED
        ),
        "aria-disabled": Pe,
        "data-index": Oe,
        children: Q
      }
    ), De = (Q) => {
      let fe = 0;
      switch (Q) {
        case at.HOME:
          fe = 0;
          break;
        case at.END:
          fe = r.length - 1;
          break;
        case at.NEXT:
          D >= r.length - 1 ? fe = 0 : fe = D + 1, V(fe);
          break;
        case at.PREV:
          D <= 0 ? fe = r.length - 1 : fe = D - 1, V(fe);
          break;
      }
      H(fe), B(fe), a && a(r[fe]);
    }, Ze = (Q) => {
      if ($)
        switch (Q.keyCode) {
          case ve.TAB:
            F();
            break;
          case ve.SPACE:
            Q.preventDefault();
            break;
          case ve.ENTER:
            return Q.stopPropagation(), Q.preventDefault(), a && a(r[D > -1 ? D : 0]), B(
              D > -1 ? D : 0
            ), j(), I.current && I.current.focus(), !1;
          case ve.ESC:
            j(), I.current && I.current.focus();
            break;
          case ve.HOME:
            De(at.HOME);
            break;
          case ve.END:
            De(at.END);
            break;
          case ve.UP:
            Q.preventDefault(), De(at.PREV);
            break;
          case ve.DOWN:
            Q.preventDefault(), De(at.NEXT);
            break;
          default:
            Q.preventDefault(), We(Q.keyCode);
            break;
        }
    }, me = (Q) => {
      Q.keyCode === ve.TAB && (g(!0), b(!0));
    }, Ae = (Q) => {
      L && clearTimeout(L), E(
        // @ts-ignore
        setTimeout(() => {
          N(""), E(null);
        }, Q)
      );
    }, xe = (Q) => {
      for (let fe = 0; fe < r.length; fe++)
        if (r[fe]?.label?.toUpperCase().startsWith(Q))
          return fe;
      return null;
    }, We = (Q) => {
      const fe = String.fromCharCode(Q), Oe = A + fe;
      N(Oe), Ae(Oc);
      const Pe = xe(Oe);
      return Pe !== null ? (H(Pe), B(Pe), a?.(r[Pe]), !0) : !1;
    }, rt = (Q) => {
      switch (Q.keyCode) {
        case ve.TAB:
          F();
          break;
        case ve.ENTER:
        case ve.SPACE:
          return Q.stopPropagation(), Q.preventDefault(), q(), Ze(Q), !1;
        case ve.UP:
        case ve.DOWN:
        case ve.HOME:
        case ve.END:
        case ve.ESC:
          Q.preventDefault(), Ze(Q);
          break;
        default:
          Q.preventDefault(), We(Q.keyCode) && q();
          break;
      }
    };
    return /* @__PURE__ */ U(
      "div",
      {
        "data-testid": m || pe.DROPDOWN,
        "aria-disabled": i,
        className: C(
          pe.DROPDOWN,
          $ && pe.LIST_SHOW,
          $ && pe.ACTIVE,
          $ && pe.HOVER,
          W > -1 && pe.DIRTY,
          v && pe.FOCUSED,
          l && pe.INVALID,
          p && pe.VALID,
          S && !i && pe.HOVER,
          i && pe.DISABLED,
          d
        ),
        id: c,
        ref: y,
        children: [
          /* @__PURE__ */ f(
            "span",
            {
              className: "fds-dropdown__focus-outline",
              style: { height: 84 }
            }
          ),
          !u && /* @__PURE__ */ f("div", { className: pe.EYEBROW, children: /* @__PURE__ */ U("div", { className: pe.LABEL_WRAPPER, children: [
            /* @__PURE__ */ f(
              "label",
              {
                htmlFor: X.current,
                className: pe.LABEL,
                "data-testid": pe.LABEL,
                id: `${X.current}-label`,
                children: t === "" || t ? t : n
              }
            ),
            /* @__PURE__ */ f(
              "span",
              {
                className: C(
                  pe.FDS_ICON,
                  pe.LABEL_ICON,
                  p && !i && pe.ICON_SUCCESS_FONT_SIZE,
                  l && pe.ERROR
                )
              }
            )
          ] }) }),
          /* @__PURE__ */ U("div", { className: pe.BUTTON_WRAPPER, children: [
            /* @__PURE__ */ f("span", { className: "fds-dropdown__icon" }),
            /* @__PURE__ */ f(
              "span",
              {
                className: C(
                  !G && pe.HIDE,
                  pe.PLACEHOLDER
                ),
                "aria-hidden": "false",
                children: n
              }
            ),
            /* @__PURE__ */ f("div", { tabIndex: -1, onBlur: z, children: /* @__PURE__ */ f(
              "button",
              {
                "data-testid": Rc,
                id: X.current,
                className: pe.BUTTON,
                onKeyDown: rt,
                onKeyUp: me,
                "data-label": t,
                "aria-expanded": $ ? "true" : "false",
                "aria-required": T,
                onClick: J,
                onFocus: Z,
                ref: I,
                disabled: i,
                "aria-disabled": i,
                tabIndex: 0,
                "aria-labelledby": `${X.current}-label`,
                role: _,
                "aria-haspopup": "listbox",
                "aria-controls": `${X.current}-ul`,
                "aria-activedescendant": $ && `${r[D]?.value}` || void 0,
                children: W > -1 ? r[W]?.label : n
              }
            ) })
          ] }),
          /* @__PURE__ */ f("div", { className: O, children: /* @__PURE__ */ f(
            "span",
            {
              "data-testid": Ic,
              className: R,
              role: "alert",
              "aria-live": "assertive",
              children: p || l
            }
          ) }),
          /* @__PURE__ */ f(
            "div",
            {
              "data-testid": pe.LIST_WRAPPER,
              className: pe.LIST_WRAPPER,
              children: /* @__PURE__ */ f(
                "div",
                {
                  "data-testid": pe.LIST,
                  className: pe.LIST,
                  id: `${X.current}-ul`,
                  role: "listbox",
                  ref: x,
                  onBlur: k,
                  "aria-expanded": !0,
                  "aria-required": T,
                  tabIndex: 0,
                  children: r.map(
                    (Q, fe) => /* @__PURE__ */ f(
                      ye,
                      {
                        index: fe,
                        disabled: Q.disabled,
                        value: Q?.value,
                        children: Q?.label
                      },
                      "key" + Q?.value
                    )
                  )
                }
              )
            }
          )
        ]
      }
    );
  }
), Dc = {
  COMPONENT: "fmc-check__button"
}, Pc = "RADIO_WRAPPER_DATA_TEST_ID", wc = "RADIO_DATA_TEST_ID", j1 = ({
  checked: n,
  children: t,
  disabled: r,
  id: a = "FDSRadioComponent",
  key: i,
  onChange: o,
  value: s,
  className: l,
  dataTestId: d = wc,
  ariaLabelledBy: c,
  ...u
}) => {
  const h = (p) => {
    (p.key === "Enter" || p.key === " ") && (p.preventDefault(), o?.(s));
  };
  return /* @__PURE__ */ U(
    "div",
    {
      className: C(Dc.COMPONENT, l),
      "data-testid": Pc,
      children: [
        /* @__PURE__ */ f(
          "input",
          {
            id: a,
            "data-testid": d,
            type: "radio",
            value: s,
            checked: n,
            disabled: r,
            onChange: () => o?.(s),
            onKeyDown: h,
            "aria-checked": n,
            "aria-disabled": r,
            "aria-labelledby": c,
            ...u
          }
        ),
        /* @__PURE__ */ f("label", { htmlFor: a, children: t })
      ]
    },
    i
  );
}, Lc = "RADIO_GROUP_DATA_TEST_ID", Y1 = ({
  children: n = [],
  disabled: t,
  horizontal: r,
  legend: a,
  onChange: i,
  value: o,
  className: s,
  legendClassName: l,
  dataTestId: d = Lc
}) => {
  const c = Array.isArray(n) ? n : [n], u = () => {
    let _ = -1;
    return o === null ? null : (o && (_ = c.findIndex((T) => T?.props.value === o)), _ > -1 ? _ : c.findIndex((T) => !T?.props.disabled));
  }, [h, p] = ee(
    u()
  );
  de(() => {
    const _ = u();
    _ !== h && p(_);
  }, [o]);
  const m = ze();
  return /* @__PURE__ */ U(
    "fieldset",
    {
      role: "radiogroup",
      className: C(
        "fmc-check",
        r && "fmc-check--horizontal",
        s
      ),
      "aria-labelledby": a || "radio group",
      "data-testid": d,
      children: [
        a && /* @__PURE__ */ f("legend", { id: a, className: l, children: a }),
        c.map((_, T) => {
          if (!_)
            return null;
          const y = T + 1, v = t || _.props.disabled, g = h === T && !v;
          return Y.cloneElement(_, {
            checked: g,
            disabled: v,
            onChange() {
              i?.(_.props.value);
            },
            onClick() {
              p(T);
            },
            onKeyUp(S) {
              S.key === "Enter" && p(T);
            },
            id: _.props.id ?? `FDSRadioComponent${y}-${m}`,
            dataTestId: _.props.dataTestId ?? `${d}_RADIO_BUTTON_${y}`
          });
        })
      ]
    }
  );
}, z1 = ({
  value: n,
  region: t = "us",
  id: r = "FDSPhoneTextFieldComponent",
  placeholder: a,
  label: i,
  error: o,
  message: s,
  patternMismatchErrorMessage: l = "Phone number is invalid",
  requiredErrorMessage: d,
  required: c = !1,
  hideSuccess: u = !1,
  hideError: h = !1,
  disabled: p = !1,
  onValueChange: m,
  ..._
}) => {
  const [T, y] = ee(n || ""), [v, g] = ee(), [S, b] = ee(), $ = /^\([2-9]\d{2}\)\s\d{3}-\d{4}$/i, P = /^\+[1-9]{1,6}\s\d{3}\s\d{3}\s\d{4}$/i, G = "us", w = t === G ? $ : P, D = (A) => {
    y(A), g(w.test(A));
  }, H = (A) => {
    let N;
    n && !A.target ? N = n : N = A.target.value.replace(/\D/g, "");
    const L = N.substring(0, 3), E = N.substring(3, 6), x = N.substring(6, 10);
    let X;
    switch (!0) {
      case N.length > 6:
        X = `(${L}) ${E}-${x}`, D(X);
        break;
      case N.length > 3:
        X = `(${L}) ${E}`, D(X);
        break;
      default:
        D(N), y(N);
        break;
    }
    m && m({
      //@ts-ignore
      formattedValue: X,
      value: N,
      //@ts-ignore
      isValid: w.test(X)
    });
  }, W = (A) => {
    let N;
    n && !A.target ? N = n : N = A.target.value.replace(/\D/g, "");
    const L = N.length > 10 ? N.length - 10 : 1, E = N.substring(0, L), x = N.substring(L, L + 3), X = N.substring(
      L + 3,
      L + 6
    ), O = N.substring(L + 6, L + 10);
    let R;
    switch (!0) {
      case N.length > 7:
        R = `+${E} ${x} ${X} ${O}`, D(R);
        break;
      case N.length > 4:
        R = `+${E} ${x} ${X}`, D(R);
        break;
      case N.length > 3:
        R = `+${E} ${x}`, D(R);
        break;
      default:
        D(N), y(N);
        break;
    }
    m && m({
      //@ts-ignore
      formattedValue: R,
      value: N,
      //@ts-ignore
      isValid: w.test(R)
    });
  }, B = Y.useCallback(() => {
    v ? b("") : T.length === 0 ? b(
      c ? d || "Phone number is required" : ""
    ) : b(l);
  }, [
    T,
    v,
    l,
    c,
    d
  ]);
  de(() => {
    B();
  }, [B]);
  const I = Y.useCallback(() => {
    b(""), n && (t === "us" ? H(n) : W(n));
  }, []);
  return de(() => {
    I();
  }, [I]), /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f(
    gt,
    {
      id: r,
      label: i,
      "aria-labelledby": i,
      name: i,
      type: "tel",
      placeholder: a,
      onChange: t === G ? H : W,
      value: T,
      error: o || (h ? void 0 : S),
      message: s || (h ? void 0 : S),
      maxLength: t === G ? 14 : 20,
      hideSuccess: u || !v,
      disabled: p,
      required: c,
      ..._
    }
  ) });
}, xc = (n) => {
  const [, t] = Ro((d) => d + 1, 0), r = le(null), {
    replace: a,
    append: i
  } = n, o = a ? a(n.format(n.value)) : n.format(n.value), s = le(!1), l = (d) => {
    if (process.env.NODE_ENV !== "production") {
      if (d.target.type === "number") {
        console.error("Rifm does not support input type=number, use type=tel instead.");
        return;
      }
      if (d.target.type === "date") {
        console.error("Rifm does not support input type=date.");
        return;
      }
    }
    const c = d.target.value;
    if (r.current = [
      c,
      // eventValue
      d.target,
      // input
      c.length > o.length,
      // isSizeIncreaseOperation
      s.current,
      // isDeleleteButtonDown
      o === n.format(c)
      // isNoOperation
    ], process.env.NODE_ENV !== "production") {
      const u = n.format(c);
      c !== u && c.toLowerCase() === u.toLowerCase() && console.warn("Case enforcement does not work with format. Please use replace={value => value.toLowerCase()} instead");
    }
    t();
  };
  return (process.env.NODE_ENV === "production" || typeof window < "u") && yr(() => {
    if (r.current == null)
      return;
    let [
      d,
      c,
      u,
      h,
      // No operation means that value itself hasn't been changed, BTW cursor, selection etc can be changed
      p
    ] = r.current;
    r.current = null;
    const m = h && p, T = d.slice(c.selectionStart).search(n.accept || /\d/g), y = T !== -1 ? T : 0, v = (P) => (P.match(n.accept || /\d/g) || []).join(""), g = v(d.substr(0, c.selectionStart)), S = (P) => {
      let G = 0, w = 0;
      for (let D = 0; D !== g.length; ++D) {
        let H = P.indexOf(g[D], G) + 1, W = v(P).indexOf(g[D], w) + 1;
        W - w > 1 && (H = G, W = w), w = Math.max(W, w), G = Math.max(G, H);
      }
      return G;
    };
    if (n.mask === !0 && u && !p) {
      let P = S(d);
      const G = v(d.substr(P))[0];
      P = d.indexOf(G, P), d = `${d.substr(0, P)}${d.substr(P + 1)}`;
    }
    let b = n.format(d);
    i != null && // cursor at the end
    c.selectionStart === d.length && !p && (u ? b = i(b) : v(b.slice(-1)) === "" && (b = b.slice(0, -1)));
    const $ = a ? a(b) : b;
    return o === $ ? t() : n.onChange($), () => {
      let P = S(b);
      if (n.mask != null && (u || h && !m))
        for (; b[P] && v(b[P]) === ""; )
          P += 1;
      c.selectionStart = c.selectionEnd = P + (m ? 1 + y : 0);
    };
  }), de(() => {
    const d = (u) => {
      u.code === "Delete" && (s.current = !0);
    }, c = (u) => {
      u.code === "Delete" && (s.current = !1);
    };
    return document.addEventListener("keydown", d), document.addEventListener("keyup", c), () => {
      document.removeEventListener("keydown", d), document.removeEventListener("keyup", c);
    };
  }, []), {
    value: r.current != null ? r.current[0] : o,
    onChange: l
  };
}, to = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[2378]\\d|62|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:4722|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "810", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function An(n, t) {
  var r = Array.prototype.slice.call(t);
  return r.push(to), n.apply(this, r);
}
function fr(n) {
  "@babel/helpers - typeof";
  return fr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fr(n);
}
function Ta(n, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, a.key, a);
  }
}
function Fc(n, t, r) {
  return t && Ta(n.prototype, t), r && Ta(n, r), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function Mc(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function kc(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && Xt(n, t);
}
function Bc(n) {
  var t = ro();
  return function() {
    var a = qt(n), i;
    if (t) {
      var o = qt(this).constructor;
      i = Reflect.construct(a, arguments, o);
    } else
      i = a.apply(this, arguments);
    return Uc(this, i);
  };
}
function Uc(n, t) {
  if (t && (fr(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return no(n);
}
function no(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function hr(n) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return hr = function(a) {
    if (a === null || !Hc(a))
      return a;
    if (typeof a != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(a))
        return t.get(a);
      t.set(a, i);
    }
    function i() {
      return fn(a, arguments, qt(this).constructor);
    }
    return i.prototype = Object.create(a.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), Xt(i, a);
  }, hr(n);
}
function fn(n, t, r) {
  return ro() ? fn = Reflect.construct : fn = function(i, o, s) {
    var l = [null];
    l.push.apply(l, o);
    var d = Function.bind.apply(i, l), c = new d();
    return s && Xt(c, s.prototype), c;
  }, fn.apply(null, arguments);
}
function ro() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Hc(n) {
  return Function.toString.call(n).indexOf("[native code]") !== -1;
}
function Xt(n, t) {
  return Xt = Object.setPrototypeOf || function(a, i) {
    return a.__proto__ = i, a;
  }, Xt(n, t);
}
function qt(n) {
  return qt = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, qt(n);
}
var et = /* @__PURE__ */ function(n) {
  kc(r, n);
  var t = Bc(r);
  function r(a) {
    var i;
    return Mc(this, r), i = t.call(this, a), Object.setPrototypeOf(no(i), r.prototype), i.name = i.constructor.name, i;
  }
  return Fc(r);
}(/* @__PURE__ */ hr(Error)), xr = 2, Wc = 17, Vc = 3, Le = "0-9０-９٠-٩۰-۹", Gc = "-‐-―−ー－", Kc = "／/", jc = "．.", Yc = "  ­​⁠　", zc = "()（）［］\\[\\]", Xc = "~⁓∼～", Ye = "".concat(Gc).concat(Kc).concat(jc).concat(Yc).concat(zc).concat(Xc), In = "+＋";
function va(n, t) {
  n = n.split("-"), t = t.split("-");
  for (var r = n[0].split("."), a = t[0].split("."), i = 0; i < 3; i++) {
    var o = Number(r[i]), s = Number(a[i]);
    if (o > s)
      return 1;
    if (s > o)
      return -1;
    if (!isNaN(o) && isNaN(s))
      return 1;
    if (isNaN(o) && !isNaN(s))
      return -1;
  }
  return n[1] && t[1] ? n[1] > t[1] ? 1 : n[1] < t[1] ? -1 : 0 : !n[1] && t[1] ? 1 : n[1] && !t[1] ? -1 : 0;
}
var qc = {}.constructor;
function Vt(n) {
  return n != null && n.constructor === qc;
}
function pr(n) {
  "@babel/helpers - typeof";
  return pr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pr(n);
}
function Rn(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ya(n, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, a.key, a);
  }
}
function Dn(n, t, r) {
  return t && ya(n.prototype, t), r && ya(n, r), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var Zc = "1.2.0", Jc = "1.7.35", Ea = " ext. ", Qc = /^\d+$/, Re = /* @__PURE__ */ function() {
  function n(t) {
    Rn(this, n), ru(t), this.metadata = t, ao.call(this, t);
  }
  return Dn(n, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(r) {
        return r !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(r) {
      return this.metadata.countries[r];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(r) {
      return this.getCountryMetadata(r) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(r) {
      if (this.getCountryCodesForCallingCode(r))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[r])
          return !0;
      } else {
        var a = this.countryCallingCodes()[r];
        if (a && a.length === 1 && a[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(r) {
      return this.nonGeographic() ? !!this.nonGeographic()[r] : !this.getCountryCodesForCallingCode(r);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(r, a) {
      if (r && Qc.test(r) && (a = r, r = null), r && r !== "001") {
        if (!this.hasCountry(r))
          throw new Error("Unknown country: ".concat(r));
        this.numberingPlan = new ba(this.getCountryMetadata(r), this);
      } else if (a) {
        if (!this.hasCallingCode(a))
          throw new Error("Unknown calling code: ".concat(a));
        this.numberingPlan = new ba(this.getNumberingPlanMetadata(a), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(r) {
      var a = this.countryCallingCodes()[r];
      if (a)
        return a.length === 1 && a[0].length === 3 ? void 0 : a;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(r) {
      var a = this.getCountryCodesForCallingCode(r);
      if (a)
        return a[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(r) {
      var a = this.getCountryCodeForCallingCode(r);
      if (a)
        return this.getCountryMetadata(a);
      if (this.nonGeographic()) {
        var i = this.nonGeographic()[r];
        if (i)
          return i;
      } else {
        var o = this.countryCallingCodes()[r];
        if (o && o.length === 1 && o[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(r) {
      return this.numberingPlan.type(r);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), n;
}(), ba = /* @__PURE__ */ function() {
  function n(t, r) {
    Rn(this, n), this.globalMetadataObject = r, this.metadata = t, ao.call(this, r.metadata);
  }
  return Dn(n, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(r) {
      return r[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var r = this, a = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return a.map(function(i) {
        return new eu(i, r);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(r) {
      return r[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(r) {
      if (this.hasTypes() && Ca(this.types(), r))
        return new nu(Ca(this.types(), r), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? Ea : this.metadata[13] || Ea;
    }
  }]), n;
}(), eu = /* @__PURE__ */ function() {
  function n(t, r) {
    Rn(this, n), this._format = t, this.metadata = r;
  }
  return Dn(n, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !tu.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), n;
}(), tu = /^\(?\$1\)?$/, nu = /* @__PURE__ */ function() {
  function n(t, r) {
    Rn(this, n), this.type = t, this.metadata = r;
  }
  return Dn(n, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), n;
}();
function Ca(n, t) {
  switch (t) {
    case "FIXED_LINE":
      return n[0];
    case "MOBILE":
      return n[1];
    case "TOLL_FREE":
      return n[2];
    case "PREMIUM_RATE":
      return n[3];
    case "PERSONAL_NUMBER":
      return n[4];
    case "VOICEMAIL":
      return n[5];
    case "UAN":
      return n[6];
    case "PAGER":
      return n[7];
    case "VOIP":
      return n[8];
    case "SHARED_COST":
      return n[9];
  }
}
function ru(n) {
  if (!n)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Vt(n) || !Vt(n.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Vt(n) ? "an object of shape: { " + Object.keys(n).join(", ") + " }" : "a " + au(n) + ": " + n, "."));
}
var au = function(t) {
  return pr(t);
};
function Fr(n, t) {
  if (t = new Re(t), t.hasCountry(n))
    return t.country(n).countryCallingCode();
  throw new Error("Unknown country: ".concat(n));
}
function iu(n, t) {
  return t.countries.hasOwnProperty(n);
}
function ao(n) {
  var t = n.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? va(t, Zc) === -1 ? this.v2 = !0 : va(t, Jc) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var ou = ";ext=", yt = function(t) {
  return "([".concat(Le, "]{1,").concat(t, "})");
};
function io(n) {
  var t = "20", r = "15", a = "9", i = "6", o = "[  \\t,]*", s = "[:\\.．]?[  \\t,-]*", l = "#?", d = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", c = "(?:[xｘ#＃~～]|int|ｉｎｔ)", u = "[- ]+", h = "[  \\t]*", p = "(?:,{2}|;)", m = ou + yt(t), _ = o + d + s + yt(t) + l, T = o + c + s + yt(a) + l, y = u + yt(i) + "#", v = h + p + s + yt(r) + l, g = h + "(?:,)+" + s + yt(a) + l;
  return m + "|" + _ + "|" + T + "|" + y + "|" + v + "|" + g;
}
var su = "[" + Le + "]{" + xr + "}", lu = "[" + In + "]{0,1}(?:[" + Ye + "]*[" + Le + "]){3,}[" + Ye + Le + "]*", du = new RegExp("^[" + In + "]{0,1}(?:[" + Ye + "]*[" + Le + "]){1,2}$", "i"), cu = lu + // Phone number extensions
"(?:" + io() + ")?", uu = new RegExp(
  // Either a short two-digit-only phone number
  "^" + su + "$|^" + cu + "$",
  "i"
);
function oo(n) {
  return n.length >= xr && uu.test(n);
}
function fu(n) {
  return du.test(n);
}
var Na = new RegExp("(?:" + io() + ")$", "i");
function hu(n) {
  var t = n.search(Na);
  if (t < 0)
    return {};
  for (var r = n.slice(0, t), a = n.match(Na), i = 1; i < a.length; ) {
    if (a[i])
      return {
        number: r,
        ext: a[i]
      };
    i++;
  }
}
function pu(n, t) {
  var r = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (r)
    return (r = r.call(n)).next.bind(r);
  if (Array.isArray(n) || (r = mu(n)) || t && n && typeof n.length == "number") {
    r && (n = r);
    var a = 0;
    return function() {
      return a >= n.length ? { done: !0 } : { done: !1, value: n[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mu(n, t) {
  if (n) {
    if (typeof n == "string")
      return Sa(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    if (r === "Object" && n.constructor && (r = n.constructor.name), r === "Map" || r === "Set")
      return Array.from(n);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Sa(n, t);
  }
}
function Sa(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var r = 0, a = new Array(t); r < t; r++)
    a[r] = n[r];
  return a;
}
var $u = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function so(n) {
  return $u[n];
}
function yn(n) {
  for (var t = "", r = pu(n.split("")), a; !(a = r()).done; ) {
    var i = a.value, o = so(i);
    o && (t += o);
  }
  return t;
}
function _u(n, t) {
  var r = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (r)
    return (r = r.call(n)).next.bind(r);
  if (Array.isArray(n) || (r = gu(n)) || t && n && typeof n.length == "number") {
    r && (n = r);
    var a = 0;
    return function() {
      return a >= n.length ? { done: !0 } : { done: !1, value: n[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gu(n, t) {
  if (n) {
    if (typeof n == "string")
      return Oa(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    if (r === "Object" && n.constructor && (r = n.constructor.name), r === "Map" || r === "Set")
      return Array.from(n);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Oa(n, t);
  }
}
function Oa(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var r = 0, a = new Array(t); r < t; r++)
    a[r] = n[r];
  return a;
}
function Aa(n) {
  for (var t = "", r = _u(n.split("")), a; !(a = r()).done; ) {
    var i = a.value;
    t += Tu(i, t) || "";
  }
  return t;
}
function Tu(n, t) {
  return n === "+" ? t ? void 0 : "+" : so(n);
}
function vu(n, t) {
  var r = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (r)
    return (r = r.call(n)).next.bind(r);
  if (Array.isArray(n) || (r = yu(n)) || t && n && typeof n.length == "number") {
    r && (n = r);
    var a = 0;
    return function() {
      return a >= n.length ? { done: !0 } : { done: !1, value: n[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yu(n, t) {
  if (n) {
    if (typeof n == "string")
      return Ia(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    if (r === "Object" && n.constructor && (r = n.constructor.name), r === "Map" || r === "Set")
      return Array.from(n);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Ia(n, t);
  }
}
function Ia(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var r = 0, a = new Array(t); r < t; r++)
    a[r] = n[r];
  return a;
}
function Eu(n, t) {
  for (var r = n.slice(), a = vu(t), i; !(i = a()).done; ) {
    var o = i.value;
    n.indexOf(o) < 0 && r.push(o);
  }
  return r.sort(function(s, l) {
    return s - l;
  });
}
function Pn(n, t) {
  return lo(n, void 0, t);
}
function lo(n, t, r) {
  var a = r.type(t), i = a && a.possibleLengths() || r.possibleLengths();
  if (!i)
    return "IS_POSSIBLE";
  if (t === "FIXED_LINE_OR_MOBILE") {
    if (!r.type("FIXED_LINE"))
      return lo(n, "MOBILE", r);
    var o = r.type("MOBILE");
    o && (i = Eu(i, o.possibleLengths()));
  } else if (t && !a)
    return "INVALID_LENGTH";
  var s = n.length, l = i[0];
  return l === s ? "IS_POSSIBLE" : l > s ? "TOO_SHORT" : i[i.length - 1] < s ? "TOO_LONG" : i.indexOf(s, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function bu(n, t, r) {
  if (t === void 0 && (t = {}), r = new Re(r), t.v2) {
    if (!n.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r.selectNumberingPlan(n.countryCallingCode);
  } else {
    if (!n.phone)
      return !1;
    if (n.country) {
      if (!r.hasCountry(n.country))
        throw new Error("Unknown country: ".concat(n.country));
      r.country(n.country);
    } else {
      if (!n.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r.selectNumberingPlan(n.countryCallingCode);
    }
  }
  if (r.possibleLengths())
    return co(n.phone || n.nationalNumber, r);
  if (n.countryCallingCode && r.isNonGeographicCallingCode(n.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function co(n, t) {
  switch (Pn(n, t)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function nt(n, t) {
  return n = n || "", new RegExp("^(?:" + t + ")$").test(n);
}
function Cu(n, t) {
  var r = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (r)
    return (r = r.call(n)).next.bind(r);
  if (Array.isArray(n) || (r = Nu(n)) || t && n && typeof n.length == "number") {
    r && (n = r);
    var a = 0;
    return function() {
      return a >= n.length ? { done: !0 } : { done: !1, value: n[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Nu(n, t) {
  if (n) {
    if (typeof n == "string")
      return Ra(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    if (r === "Object" && n.constructor && (r = n.constructor.name), r === "Map" || r === "Set")
      return Array.from(n);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Ra(n, t);
  }
}
function Ra(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var r = 0, a = new Array(t); r < t; r++)
    a[r] = n[r];
  return a;
}
var Su = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function Mr(n, t, r) {
  if (t = t || {}, !(!n.country && !n.countryCallingCode)) {
    r = new Re(r), r.selectNumberingPlan(n.country, n.countryCallingCode);
    var a = t.v2 ? n.nationalNumber : n.phone;
    if (nt(a, r.nationalNumberPattern())) {
      if (Yn(a, "FIXED_LINE", r))
        return r.type("MOBILE") && r.type("MOBILE").pattern() === "" || !r.type("MOBILE") || Yn(a, "MOBILE", r) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var i = Cu(Su), o; !(o = i()).done; ) {
        var s = o.value;
        if (Yn(a, s, r))
          return s;
      }
    }
  }
}
function Yn(n, t, r) {
  return t = r.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(n.length) < 0 ? !1 : nt(n, t.pattern());
}
function uo(n, t, r) {
  if (t = t || {}, r = new Re(r), r.selectNumberingPlan(n.country, n.countryCallingCode), r.hasTypes())
    return Mr(n, t, r.metadata) !== void 0;
  var a = t.v2 ? n.nationalNumber : n.phone;
  return nt(a, r.nationalNumberPattern());
}
function Ou(n, t, r) {
  var a = new Re(r), i = a.getCountryCodesForCallingCode(n);
  return i ? i.filter(function(o) {
    return Au(t, o, r);
  }) : [];
}
function Au(n, t, r) {
  var a = new Re(r);
  return a.selectNumberingPlan(t), a.numberingPlan.possibleLengths().indexOf(n.length) >= 0;
}
function fo(n) {
  return n.replace(new RegExp("[".concat(Ye, "]+"), "g"), " ").trim();
}
var ho = /(\$\d)/;
function po(n, t, r) {
  var a = r.useInternationalFormat, i = r.withNationalPrefix;
  r.carrierCode, r.metadata;
  var o = n.replace(new RegExp(t.pattern()), a ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    i && t.nationalPrefixFormattingRule() ? t.format().replace(ho, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return a ? fo(o) : o;
}
var Iu = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function Ru(n, t, r) {
  var a = new Re(r);
  if (a.selectNumberingPlan(n, t), a.defaultIDDPrefix())
    return a.defaultIDDPrefix();
  if (Iu.test(a.IDDPrefix()))
    return a.IDDPrefix();
}
function Du(n) {
  var t = n.number, r = n.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(r ? ";ext=" + r : "");
}
function Pu(n, t) {
  var r = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (r)
    return (r = r.call(n)).next.bind(r);
  if (Array.isArray(n) || (r = wu(n)) || t && n && typeof n.length == "number") {
    r && (n = r);
    var a = 0;
    return function() {
      return a >= n.length ? { done: !0 } : { done: !1, value: n[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wu(n, t) {
  if (n) {
    if (typeof n == "string")
      return Da(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    if (r === "Object" && n.constructor && (r = n.constructor.name), r === "Map" || r === "Set")
      return Array.from(n);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Da(n, t);
  }
}
function Da(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var r = 0, a = new Array(t); r < t; r++)
    a[r] = n[r];
  return a;
}
function Pa(n, t) {
  var r = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    t && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function wa(n) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pa(Object(r), !0).forEach(function(a) {
      Lu(n, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : Pa(Object(r)).forEach(function(a) {
      Object.defineProperty(n, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return n;
}
function Lu(n, t, r) {
  return t in n ? Object.defineProperty(n, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = r, n;
}
var La = {
  formatExtension: function(t, r, a) {
    return "".concat(t).concat(a.ext()).concat(r);
  }
};
function xu(n, t, r, a) {
  if (r ? r = wa(wa({}, La), r) : r = La, a = new Re(a), n.country && n.country !== "001") {
    if (!a.hasCountry(n.country))
      throw new Error("Unknown country: ".concat(n.country));
    a.country(n.country);
  } else if (n.countryCallingCode)
    a.selectNumberingPlan(n.countryCallingCode);
  else
    return n.phone || "";
  var i = a.countryCallingCode(), o = r.v2 ? n.nationalNumber : n.phone, s;
  switch (t) {
    case "NATIONAL":
      return o ? (s = En(o, n.carrierCode, "NATIONAL", a, r), zn(s, n.ext, a, r.formatExtension)) : "";
    case "INTERNATIONAL":
      return o ? (s = En(o, null, "INTERNATIONAL", a, r), s = "+".concat(i, " ").concat(s), zn(s, n.ext, a, r.formatExtension)) : "+".concat(i);
    case "E.164":
      return "+".concat(i).concat(o);
    case "RFC3966":
      return Du({
        number: "+".concat(i).concat(o),
        ext: n.ext
      });
    case "IDD":
      if (!r.fromCountry)
        return;
      var l = Mu(o, n.carrierCode, i, r.fromCountry, a);
      return zn(l, n.ext, a, r.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function En(n, t, r, a, i) {
  var o = Fu(a.formats(), n);
  return o ? po(n, o, {
    useInternationalFormat: r === "INTERNATIONAL",
    withNationalPrefix: !(o.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && i && i.nationalPrefix === !1),
    carrierCode: t,
    metadata: a
  }) : n;
}
function Fu(n, t) {
  for (var r = Pu(n), a; !(a = r()).done; ) {
    var i = a.value;
    if (i.leadingDigitsPatterns().length > 0) {
      var o = i.leadingDigitsPatterns()[i.leadingDigitsPatterns().length - 1];
      if (t.search(o) !== 0)
        continue;
    }
    if (nt(t, i.pattern()))
      return i;
  }
}
function zn(n, t, r, a) {
  return t ? a(n, t, r) : n;
}
function Mu(n, t, r, a, i) {
  var o = Fr(a, i.metadata);
  if (o === r) {
    var s = En(n, t, "NATIONAL", i);
    return r === "1" ? r + " " + s : s;
  }
  var l = Ru(a, void 0, i.metadata);
  if (l)
    return "".concat(l, " ").concat(r, " ").concat(En(n, null, "INTERNATIONAL", i));
}
function xa(n, t) {
  var r = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    t && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function Fa(n) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xa(Object(r), !0).forEach(function(a) {
      ku(n, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : xa(Object(r)).forEach(function(a) {
      Object.defineProperty(n, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return n;
}
function ku(n, t, r) {
  return t in n ? Object.defineProperty(n, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = r, n;
}
function Bu(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ma(n, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, a.key, a);
  }
}
function Uu(n, t, r) {
  return t && Ma(n.prototype, t), r && Ma(n, r), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var mo = /* @__PURE__ */ function() {
  function n(t, r, a) {
    if (Bu(this, n), !t)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!r)
      throw new TypeError("`nationalNumber` not passed");
    if (!a)
      throw new TypeError("`metadata` not passed");
    var i = Wu(t, a), o = i.country, s = i.countryCallingCode;
    this.country = o, this.countryCallingCode = s, this.nationalNumber = r, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return a;
    };
  }
  return Uu(n, [{
    key: "setExt",
    value: function(r) {
      this.ext = r;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : Ou(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return bu(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return uo(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var r = new Re(this.getMetadata());
      return r.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(r) {
      return this.number === r.number && this.ext === r.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return Mr(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(r, a) {
      return xu(this, r, a ? Fa(Fa({}, a), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(r) {
      return this.format("NATIONAL", r);
    }
  }, {
    key: "formatInternational",
    value: function(r) {
      return this.format("INTERNATIONAL", r);
    }
  }, {
    key: "getURI",
    value: function(r) {
      return this.format("RFC3966", r);
    }
  }]), n;
}(), Hu = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function Wu(n, t) {
  var r, a, i = new Re(t);
  return Hu(n) ? (r = n, i.selectNumberingPlan(r), a = i.countryCallingCode()) : a = n, {
    country: r,
    countryCallingCode: a
  };
}
var Vu = new RegExp("([" + Le + "])");
function $o(n, t, r, a) {
  if (t) {
    var i = new Re(a);
    i.selectNumberingPlan(t, r);
    var o = new RegExp(i.IDDPrefix());
    if (n.search(o) === 0) {
      n = n.slice(n.match(o)[0].length);
      var s = n.match(Vu);
      if (!(s && s[1] != null && s[1].length > 0 && s[1] === "0"))
        return n;
    }
  }
}
function mr(n, t) {
  if (n && t.numberingPlan.nationalPrefixForParsing()) {
    var r = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), a = r.exec(n);
    if (a) {
      var i, o, s = a.length - 1, l = s > 0 && a[s];
      if (t.nationalPrefixTransformRule() && l)
        i = n.replace(r, t.nationalPrefixTransformRule()), s > 1 && (o = a[1]);
      else {
        var d = a[0];
        i = n.slice(d.length), l && (o = a[1]);
      }
      var c;
      if (l) {
        var u = n.indexOf(a[1]), h = n.slice(0, u);
        h === t.numberingPlan.nationalPrefix() && (c = t.numberingPlan.nationalPrefix());
      } else
        c = a[0];
      return {
        nationalNumber: i,
        nationalPrefix: c,
        carrierCode: o
      };
    }
  }
  return {
    nationalNumber: n
  };
}
function $r(n, t) {
  var r = mr(n, t), a = r.carrierCode, i = r.nationalNumber;
  if (i !== n) {
    if (!Gu(n, i, t))
      return {
        nationalNumber: n
      };
    if (t.possibleLengths() && !Ku(i, t))
      return {
        nationalNumber: n
      };
  }
  return {
    nationalNumber: i,
    carrierCode: a
  };
}
function Gu(n, t, r) {
  return !(nt(n, r.nationalNumberPattern()) && !nt(t, r.nationalNumberPattern()));
}
function Ku(n, t) {
  switch (Pn(n, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function _o(n, t, r, a) {
  var i = t ? Fr(t, a) : r;
  if (n.indexOf(i) === 0) {
    a = new Re(a), a.selectNumberingPlan(t, r);
    var o = n.slice(i.length), s = $r(o, a), l = s.nationalNumber, d = $r(n, a), c = d.nationalNumber;
    if (!nt(c, a.nationalNumberPattern()) && nt(l, a.nationalNumberPattern()) || Pn(c, a) === "TOO_LONG")
      return {
        countryCallingCode: i,
        number: o
      };
  }
  return {
    number: n
  };
}
function go(n, t, r, a) {
  if (!n)
    return {};
  var i;
  if (n[0] !== "+") {
    var o = $o(n, t, r, a);
    if (o && o !== n)
      i = !0, n = "+" + o;
    else {
      if (t || r) {
        var s = _o(n, t, r, a), l = s.countryCallingCode, d = s.number;
        if (l)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: l,
            number: d
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: n
      };
    }
  }
  if (n[1] === "0")
    return {};
  a = new Re(a);
  for (var c = 2; c - 1 <= Vc && c <= n.length; ) {
    var u = n.slice(1, c);
    if (a.hasCallingCode(u))
      return a.selectNumberingPlan(u), {
        countryCallingCodeSource: i ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: u,
        number: n.slice(c)
      };
    c++;
  }
  return {};
}
function ju(n, t) {
  var r = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (r)
    return (r = r.call(n)).next.bind(r);
  if (Array.isArray(n) || (r = Yu(n)) || t && n && typeof n.length == "number") {
    r && (n = r);
    var a = 0;
    return function() {
      return a >= n.length ? { done: !0 } : { done: !1, value: n[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Yu(n, t) {
  if (n) {
    if (typeof n == "string")
      return ka(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    if (r === "Object" && n.constructor && (r = n.constructor.name), r === "Map" || r === "Set")
      return Array.from(n);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return ka(n, t);
  }
}
function ka(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var r = 0, a = new Array(t); r < t; r++)
    a[r] = n[r];
  return a;
}
function To(n, t) {
  var r = t.countries, a = t.defaultCountry, i = t.metadata;
  i = new Re(i);
  for (var o = [], s = ju(r), l; !(l = s()).done; ) {
    var d = l.value;
    if (i.country(d), i.leadingDigits()) {
      if (n && n.search(i.leadingDigits()) === 0)
        return d;
    } else if (Mr({
      phone: n,
      country: d
    }, void 0, i.metadata))
      if (a) {
        if (d === a)
          return d;
        o.push(d);
      } else
        return d;
  }
  if (o.length > 0)
    return o[0];
}
var zu = !1;
function vo(n, t) {
  var r = t.nationalNumber, a = t.defaultCountry, i = t.metadata;
  if (zu && i.isNonGeographicCallingCode(n))
    return "001";
  var o = i.getCountryCodesForCallingCode(n);
  if (o)
    return o.length === 1 ? o[0] : To(r, {
      countries: o,
      defaultCountry: a,
      metadata: i.metadata
    });
}
var yo = "+", Xu = "[\\-\\.\\(\\)]?", Ba = "([" + Le + "]|" + Xu + ")", qu = "^\\" + yo + Ba + "*[" + Le + "]" + Ba + "*$", Zu = new RegExp(qu, "g"), _r = Le, Ju = "[" + _r + "]+((\\-)*[" + _r + "])*", Qu = "a-zA-Z", ef = "[" + Qu + "]+((\\-)*[" + _r + "])*", tf = "^(" + Ju + "\\.)*" + ef + "\\.?$", nf = new RegExp(tf, "g"), Ua = "tel:", gr = ";phone-context=", rf = ";isub=";
function af(n) {
  var t = n.indexOf(gr);
  if (t < 0)
    return null;
  var r = t + gr.length;
  if (r >= n.length)
    return "";
  var a = n.indexOf(";", r);
  return a >= 0 ? n.substring(r, a) : n.substring(r);
}
function of(n) {
  return n === null ? !0 : n.length === 0 ? !1 : Zu.test(n) || nf.test(n);
}
function sf(n, t) {
  var r = t.extractFormattedPhoneNumber, a = af(n);
  if (!of(a))
    throw new et("NOT_A_NUMBER");
  var i;
  if (a === null)
    i = r(n) || "";
  else {
    i = "", a.charAt(0) === yo && (i += a);
    var o = n.indexOf(Ua), s;
    o >= 0 ? s = o + Ua.length : s = 0;
    var l = n.indexOf(gr);
    i += n.substring(s, l);
  }
  var d = i.indexOf(rf);
  if (d > 0 && (i = i.substring(0, d)), i !== "")
    return i;
}
var lf = 250, df = new RegExp("[" + In + Le + "]"), cf = new RegExp("[^" + Le + "#]+$");
function Eo(n, t, r) {
  if (t = t || {}, r = new Re(r), t.defaultCountry && !r.hasCountry(t.defaultCountry))
    throw t.v2 ? new et("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var a = ff(n, t.v2, t.extract), i = a.number, o = a.ext, s = a.error;
  if (!i) {
    if (t.v2)
      throw s === "TOO_SHORT" ? new et("TOO_SHORT") : new et("NOT_A_NUMBER");
    return {};
  }
  var l = pf(i, t.defaultCountry, t.defaultCallingCode, r), d = l.country, c = l.nationalNumber, u = l.countryCallingCode, h = l.countryCallingCodeSource, p = l.carrierCode;
  if (!r.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new et("INVALID_COUNTRY");
    return {};
  }
  if (!c || c.length < xr) {
    if (t.v2)
      throw new et("TOO_SHORT");
    return {};
  }
  if (c.length > Wc) {
    if (t.v2)
      throw new et("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var m = new mo(u, c, r.metadata);
    return d && (m.country = d), p && (m.carrierCode = p), o && (m.ext = o), m.__countryCallingCodeSource = h, m;
  }
  var _ = (t.extended ? r.hasSelectedNumberingPlan() : d) ? nt(c, r.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: d,
    countryCallingCode: u,
    carrierCode: p,
    valid: _,
    possible: _ ? !0 : !!(t.extended === !0 && r.possibleLengths() && co(c, r)),
    phone: c,
    ext: o
  } : _ ? hf(d, c, o) : {};
}
function uf(n, t, r) {
  if (n) {
    if (n.length > lf) {
      if (r)
        throw new et("TOO_LONG");
      return;
    }
    if (t === !1)
      return n;
    var a = n.search(df);
    if (!(a < 0))
      return n.slice(a).replace(cf, "");
  }
}
function ff(n, t, r) {
  var a = sf(n, {
    extractFormattedPhoneNumber: function(s) {
      return uf(s, r, t);
    }
  });
  if (!a)
    return {};
  if (!oo(a))
    return fu(a) ? {
      error: "TOO_SHORT"
    } : {};
  var i = hu(a);
  return i.ext ? i : {
    number: a
  };
}
function hf(n, t, r) {
  var a = {
    country: n,
    phone: t
  };
  return r && (a.ext = r), a;
}
function pf(n, t, r, a) {
  var i = go(Aa(n), t, r, a.metadata), o = i.countryCallingCodeSource, s = i.countryCallingCode, l = i.number, d;
  if (s)
    a.selectNumberingPlan(s);
  else if (l && (t || r))
    a.selectNumberingPlan(t, r), t && (d = t), s = r || Fr(t, a.metadata);
  else
    return {};
  if (!l)
    return {
      countryCallingCodeSource: o,
      countryCallingCode: s
    };
  var c = $r(Aa(l), a), u = c.nationalNumber, h = c.carrierCode, p = vo(s, {
    nationalNumber: u,
    defaultCountry: t,
    metadata: a
  });
  return p && (d = p, p === "001" || a.country(d)), {
    country: d,
    countryCallingCode: s,
    countryCallingCodeSource: o,
    nationalNumber: u,
    carrierCode: h
  };
}
function Ha(n, t) {
  var r = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    t && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function Wa(n) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ha(Object(r), !0).forEach(function(a) {
      mf(n, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : Ha(Object(r)).forEach(function(a) {
      Object.defineProperty(n, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return n;
}
function mf(n, t, r) {
  return t in n ? Object.defineProperty(n, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = r, n;
}
function bo(n, t, r) {
  return Eo(n, Wa(Wa({}, t), {}, {
    v2: !0
  }), r);
}
function Va(n, t) {
  var r = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    t && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function $f(n) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Va(Object(r), !0).forEach(function(a) {
      _f(n, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : Va(Object(r)).forEach(function(a) {
      Object.defineProperty(n, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return n;
}
function _f(n, t, r) {
  return t in n ? Object.defineProperty(n, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = r, n;
}
function gf(n, t) {
  return Ef(n) || yf(n, t) || vf(n, t) || Tf();
}
function Tf() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vf(n, t) {
  if (n) {
    if (typeof n == "string")
      return Ga(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    if (r === "Object" && n.constructor && (r = n.constructor.name), r === "Map" || r === "Set")
      return Array.from(n);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Ga(n, t);
  }
}
function Ga(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var r = 0, a = new Array(t); r < t; r++)
    a[r] = n[r];
  return a;
}
function yf(n, t) {
  var r = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (r != null) {
    var a = [], i = !0, o = !1, s, l;
    try {
      for (r = r.call(n); !(i = (s = r.next()).done) && (a.push(s.value), !(t && a.length === t)); i = !0)
        ;
    } catch (d) {
      o = !0, l = d;
    } finally {
      try {
        !i && r.return != null && r.return();
      } finally {
        if (o)
          throw l;
      }
    }
    return a;
  }
}
function Ef(n) {
  if (Array.isArray(n))
    return n;
}
function kr(n) {
  var t = Array.prototype.slice.call(n), r = gf(t, 4), a = r[0], i = r[1], o = r[2], s = r[3], l, d, c;
  if (typeof a == "string")
    l = a;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!i || typeof i == "string")
    s ? (d = o, c = s) : (d = void 0, c = o), i && (d = $f({
      defaultCountry: i
    }, d));
  else if (Vt(i))
    o ? (d = i, c = o) : c = i;
  else
    throw new Error("Invalid second argument: ".concat(i));
  return {
    text: l,
    options: d,
    metadata: c
  };
}
function bf() {
  var n = kr(arguments), t = n.text, r = n.options, a = n.metadata;
  return bo(t, r, a);
}
function Ka(n, t) {
  var r = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    t && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function ja(n) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ka(Object(r), !0).forEach(function(a) {
      Cf(n, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : Ka(Object(r)).forEach(function(a) {
      Object.defineProperty(n, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return n;
}
function Cf(n, t, r) {
  return t in n ? Object.defineProperty(n, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = r, n;
}
function Co(n, t, r) {
  t && t.defaultCountry && !iu(t.defaultCountry, r) && (t = ja(ja({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return bo(n, t, r);
  } catch (a) {
    if (!(a instanceof et))
      throw a;
  }
}
function Ya(n, t) {
  var r = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    t && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function za(n) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ya(Object(r), !0).forEach(function(a) {
      Nf(n, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : Ya(Object(r)).forEach(function(a) {
      Object.defineProperty(n, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return n;
}
function Nf(n, t, r) {
  return t in n ? Object.defineProperty(n, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = r, n;
}
function Sf() {
  var n = kr(arguments), t = n.text, r = n.options, a = n.metadata;
  r = za(za({}, r), {}, {
    extract: !1
  });
  var i = Co(t, r, a);
  return i && i.isValid() || !1;
}
function Xa(n, t) {
  var r = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    t && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function qa(n) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xa(Object(r), !0).forEach(function(a) {
      Of(n, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : Xa(Object(r)).forEach(function(a) {
      Object.defineProperty(n, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return n;
}
function Of(n, t, r) {
  return t in n ? Object.defineProperty(n, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : n[t] = r, n;
}
function Af() {
  var n = kr(arguments), t = n.text, r = n.options, a = n.metadata;
  r = qa(qa({}, r), {}, {
    extract: !1
  });
  var i = Co(t, r, a);
  return i && i.isPossible() || !1;
}
function If(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Za(n, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, a.key, a);
  }
}
function Rf(n, t, r) {
  return t && Za(n.prototype, t), r && Za(n, r), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var Df = /* @__PURE__ */ function() {
  function n(t) {
    var r = t.onCountryChange, a = t.onCallingCodeChange;
    If(this, n), this.onCountryChange = r, this.onCallingCodeChange = a;
  }
  return Rf(n, [{
    key: "reset",
    value: function(r) {
      var a = r.country, i = r.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(a, i);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(r) {
      for (var a = 0, i = Object.keys(r); a < i.length; a++) {
        var o = i[a];
        this[o] = r[o];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(r, a) {
      this.setCountry(r), this.setCallingCode(a);
    }
  }, {
    key: "setCountry",
    value: function(r) {
      this.country = r, this.onCountryChange(r);
    }
  }, {
    key: "setCallingCode",
    value: function(r) {
      this.callingCode = r, this.onCallingCodeChange(r, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(r, a) {
      this.international = !0, this.initCountryAndCallingCode(r, a);
    }
  }, {
    key: "appendDigits",
    value: function(r) {
      this.digits += r;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(r) {
      this.nationalSignificantNumber += r;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), n;
}();
function Pf(n, t) {
  var r = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (r)
    return (r = r.call(n)).next.bind(r);
  if (Array.isArray(n) || (r = wf(n)) || t && n && typeof n.length == "number") {
    r && (n = r);
    var a = 0;
    return function() {
      return a >= n.length ? { done: !0 } : { done: !1, value: n[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wf(n, t) {
  if (n) {
    if (typeof n == "string")
      return Ja(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    if (r === "Object" && n.constructor && (r = n.constructor.name), r === "Map" || r === "Set")
      return Array.from(n);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Ja(n, t);
  }
}
function Ja(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var r = 0, a = new Array(t); r < t; r++)
    a[r] = n[r];
  return a;
}
var Ge = "x", Xn = new RegExp(Ge);
function hn(n, t) {
  if (t < 1)
    return "";
  for (var r = ""; t > 1; )
    t & 1 && (r += n), t >>= 1, n += n;
  return r + n;
}
function Qa(n, t) {
  return n[t] === ")" && t++, Lf(n.slice(0, t));
}
function Lf(n) {
  for (var t = [], r = 0; r < n.length; )
    n[r] === "(" ? t.push(r) : n[r] === ")" && t.pop(), r++;
  var a = 0, i = "";
  t.push(n.length);
  for (var o = 0, s = t; o < s.length; o++) {
    var l = s[o];
    i += n.slice(a, l), a = l + 1;
  }
  return i;
}
function xf(n, t, r) {
  for (var a = Pf(r.split("")), i; !(i = a()).done; ) {
    var o = i.value;
    if (n.slice(t + 1).search(Xn) < 0)
      return;
    t = n.search(Xn), n = n.replace(Xn, o);
  }
  return [n, t];
}
function Ff(n, t, r) {
  var a = r.metadata, i = r.shouldTryNationalPrefixFormattingRule, o = r.getSeparatorAfterNationalPrefix, s = new RegExp("^(?:".concat(t.pattern(), ")$"));
  if (s.test(n.nationalSignificantNumber))
    return kf(n, t, {
      metadata: a,
      shouldTryNationalPrefixFormattingRule: i,
      getSeparatorAfterNationalPrefix: o
    });
}
function Mf(n, t) {
  return Pn(n, t) === "IS_POSSIBLE";
}
function kf(n, t, r) {
  var a = r.metadata, i = r.shouldTryNationalPrefixFormattingRule, o = r.getSeparatorAfterNationalPrefix;
  if (n.nationalSignificantNumber, n.international, n.nationalPrefix, n.carrierCode, i(t)) {
    var s = ei(n, t, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: o,
      metadata: a
    });
    if (s)
      return s;
  }
  return ei(n, t, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: o,
    metadata: a
  });
}
function ei(n, t, r) {
  var a = r.metadata, i = r.useNationalPrefixFormattingRule, o = r.getSeparatorAfterNationalPrefix, s = po(n.nationalSignificantNumber, t, {
    carrierCode: n.carrierCode,
    useInternationalFormat: n.international,
    withNationalPrefix: i,
    metadata: a
  });
  if (i || (n.nationalPrefix ? s = n.nationalPrefix + o(t) + s : n.complexPrefixBeforeNationalSignificantNumber && (s = n.complexPrefixBeforeNationalSignificantNumber + " " + s)), Bf(s, n))
    return s;
}
function Bf(n, t) {
  return yn(n) === t.getNationalDigits();
}
function Uf(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ti(n, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, a.key, a);
  }
}
function Hf(n, t, r) {
  return t && ti(n.prototype, t), r && ti(n, r), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var Wf = /* @__PURE__ */ function() {
  function n() {
    Uf(this, n);
  }
  return Hf(n, [{
    key: "parse",
    value: function(r) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(r), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var a = this.context[0], i = a.branches, o = a.instructions;
      if (i)
        return {
          op: "|",
          args: i.concat([qn(o)])
        };
      if (o.length === 0)
        throw new Error("Pattern is required");
      return o.length === 1 ? o[0] : o;
    }
  }, {
    key: "startContext",
    value: function(r) {
      this.context.push(r);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(r) {
      if (!r)
        throw new Error("Pattern is required");
      var a = r.match(Kf);
      if (!a) {
        if (Gf.test(r))
          throw new Error("Illegal characters found in a pattern: ".concat(r));
        this.getContext().instructions = this.getContext().instructions.concat(r.split(""));
        return;
      }
      var i = a[1], o = r.slice(0, a.index), s = r.slice(a.index + i.length);
      switch (i) {
        case "(?:":
          o && this.parsePattern(o), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (o && this.parsePattern(o), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var l = this.getContext(), d = l.branches;
          d.push(qn(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: d
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (o && this.parsePattern(o), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(qn(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          o && this.parsePattern(o), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: Vf(o)
          });
          break;
        default:
          throw new Error("Unknown operator: ".concat(i));
      }
      s && this.parsePattern(s);
    }
  }]), n;
}();
function Vf(n) {
  for (var t = [], r = 0; r < n.length; ) {
    if (n[r] === "-") {
      if (r === 0 || r === n.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(n));
      for (var a = n[r - 1].charCodeAt(0) + 1, i = n[r + 1].charCodeAt(0) - 1, o = a; o <= i; )
        t.push(String.fromCharCode(o)), o++;
    } else
      t.push(n[r]);
    r++;
  }
  return t;
}
var Gf = /[\(\)\[\]\?\:\|]/, Kf = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function qn(n) {
  return n.length === 1 ? n[0] : n;
}
function ni(n, t) {
  var r = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (r)
    return (r = r.call(n)).next.bind(r);
  if (Array.isArray(n) || (r = jf(n)) || t && n && typeof n.length == "number") {
    r && (n = r);
    var a = 0;
    return function() {
      return a >= n.length ? { done: !0 } : { done: !1, value: n[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jf(n, t) {
  if (n) {
    if (typeof n == "string")
      return ri(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    if (r === "Object" && n.constructor && (r = n.constructor.name), r === "Map" || r === "Set")
      return Array.from(n);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return ri(n, t);
  }
}
function ri(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var r = 0, a = new Array(t); r < t; r++)
    a[r] = n[r];
  return a;
}
function Yf(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ai(n, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, a.key, a);
  }
}
function zf(n, t, r) {
  return t && ai(n.prototype, t), r && ai(n, r), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var Xf = /* @__PURE__ */ function() {
  function n(t) {
    Yf(this, n), this.matchTree = new Wf().parse(t);
  }
  return zf(n, [{
    key: "match",
    value: function(r) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = a.allowOverflow;
      if (!r)
        throw new Error("String is required");
      var o = Tr(r.split(""), this.matchTree, !0);
      if (o && o.match && delete o.matchedChars, !(o && o.overflow && !i))
        return o;
    }
  }]), n;
}();
function Tr(n, t, r) {
  if (typeof t == "string") {
    var a = n.join("");
    return t.indexOf(a) === 0 ? n.length === t.length ? {
      match: !0,
      matchedChars: n
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : a.indexOf(t) === 0 ? r && n.length > t.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: n.slice(0, t.length)
    } : void 0;
  }
  if (Array.isArray(t)) {
    for (var i = n.slice(), o = 0; o < t.length; ) {
      var s = t[o], l = Tr(i, s, r && o === t.length - 1);
      if (l) {
        if (l.overflow)
          return l;
        if (l.match) {
          if (i = i.slice(l.matchedChars.length), i.length === 0)
            return o === t.length - 1 ? {
              match: !0,
              matchedChars: n
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (l.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(l, null, 2)));
        }
      } else
        return;
      o++;
    }
    return r ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: n.slice(0, n.length - i.length)
    };
  }
  switch (t.op) {
    case "|":
      for (var d, c = ni(t.args), u; !(u = c()).done; ) {
        var h = u.value, p = Tr(n, h, r);
        if (p) {
          if (p.overflow)
            return p;
          if (p.match)
            return {
              match: !0,
              matchedChars: p.matchedChars
            };
          if (p.partialMatch)
            d = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(p, null, 2)));
        }
      }
      return d ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var m = ni(t.args), _; !(_ = m()).done; ) {
        var T = _.value;
        if (n[0] === T)
          return n.length === 1 ? {
            match: !0,
            matchedChars: n
          } : r ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [T]
          };
      }
      return;
    default:
      throw new Error("Unsupported instruction tree: ".concat(t));
  }
}
function ii(n, t) {
  var r = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (r)
    return (r = r.call(n)).next.bind(r);
  if (Array.isArray(n) || (r = qf(n)) || t && n && typeof n.length == "number") {
    r && (n = r);
    var a = 0;
    return function() {
      return a >= n.length ? { done: !0 } : { done: !1, value: n[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qf(n, t) {
  if (n) {
    if (typeof n == "string")
      return oi(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    if (r === "Object" && n.constructor && (r = n.constructor.name), r === "Map" || r === "Set")
      return Array.from(n);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return oi(n, t);
  }
}
function oi(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var r = 0, a = new Array(t); r < t; r++)
    a[r] = n[r];
  return a;
}
function Zf(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function si(n, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, a.key, a);
  }
}
function Jf(n, t, r) {
  return t && si(n.prototype, t), r && si(n, r), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var vr = "9", Qf = 15, e0 = hn(vr, Qf), t0 = /[- ]/, n0 = function() {
  return /\[([^\[\]])*\]/g;
}, r0 = function() {
  return /\d(?=[^,}][^,}])/g;
}, a0 = new RegExp("[" + Ye + "]*\\$1[" + Ye + "]*(\\$\\d[" + Ye + "]*)*$"), li = 3, i0 = /* @__PURE__ */ function() {
  function n(t) {
    t.state;
    var r = t.metadata;
    Zf(this, n), this.metadata = r, this.resetFormat();
  }
  return Jf(n, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(r, a) {
      this.resetFormat(), r ? (this.isNANP = r.callingCode() === "1", this.matchingFormats = r.formats(), a.nationalSignificantNumber && this.narrowDownMatchingFormats(a)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(r, a) {
      var i = this;
      if (Mf(a.nationalSignificantNumber, this.metadata))
        for (var o = ii(this.matchingFormats), s; !(s = o()).done; ) {
          var l = s.value, d = Ff(a, l, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(u) {
              return i.shouldTryNationalPrefixFormattingRule(u, {
                international: a.international,
                nationalPrefix: a.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(u) {
              return i.getSeparatorAfterNationalPrefix(u);
            }
          });
          if (d)
            return this.resetFormat(), this.chosenFormat = l, this.setNationalNumberTemplate(d.replace(/\d/g, Ge), a), this.populatedNationalNumberTemplate = d, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(Ge), d;
        }
      return this.formatNationalNumberWithNextDigits(r, a);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(r, a) {
      var i = this.chosenFormat, o = this.chooseFormat(a);
      if (o)
        return o === i ? this.formatNextNationalNumberDigits(r) : this.formatNextNationalNumberDigits(a.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(r) {
      var a = this, i = r.nationalSignificantNumber, o = r.nationalPrefix, s = r.international, l = i, d = l.length - li;
      d < 0 && (d = 0), this.matchingFormats = this.matchingFormats.filter(function(c) {
        return a.formatSuits(c, s, o) && a.formatMatches(c, l, d);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(r, a, i) {
      return !(i && !r.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !r.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !a && !i && r.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(r, a, i) {
      var o = r.leadingDigitsPatterns().length;
      if (o === 0)
        return !0;
      i = Math.min(i, o - 1);
      var s = r.leadingDigitsPatterns()[i];
      if (a.length < li)
        try {
          return new Xf(s).match(a, {
            allowOverflow: !0
          }) !== void 0;
        } catch (l) {
          return console.error(l), !0;
        }
      return new RegExp("^(".concat(s, ")")).test(a);
    }
  }, {
    key: "getFormatFormat",
    value: function(r, a) {
      return a ? r.internationalFormat() : r.format();
    }
  }, {
    key: "chooseFormat",
    value: function(r) {
      for (var a = this, i = function() {
        var c = s.value;
        return a.chosenFormat === c ? "break" : a0.test(a.getFormatFormat(c, r.international)) ? a.createTemplateForFormat(c, r) ? (a.chosenFormat = c, "break") : (a.matchingFormats = a.matchingFormats.filter(function(u) {
          return u !== c;
        }), "continue") : "continue";
      }, o = ii(this.matchingFormats.slice()), s; !(s = o()).done; ) {
        var l = i();
        if (l === "break")
          break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(r, a) {
      if (!(r.pattern().indexOf("|") >= 0)) {
        var i = this.getTemplateForFormat(r, a);
        if (i)
          return this.setNationalNumberTemplate(i, a), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(r) {
      return this.isNANP || r && r.nationalPrefixFormattingRule() && t0.test(r.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(r, a) {
      var i = r.IDDPrefix, o = r.missingPlus;
      return i ? a && a.spacing === !1 ? i : i + " " : o ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(r) {
      if (this.template) {
        for (var a = -1, i = 0, o = r.international ? this.getInternationalPrefixBeforeCountryCallingCode(r, {
          spacing: !1
        }) : ""; i < o.length + r.getDigitsWithoutInternationalPrefix().length; )
          a = this.template.indexOf(Ge, a + 1), i++;
        return Qa(this.template, a + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(r, a) {
      this.nationalNumberTemplate = r, this.populatedNationalNumberTemplate = r, this.populatedNationalNumberTemplatePosition = -1, a.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(a).replace(/[\d\+]/g, Ge) + hn(Ge, a.callingCode.length) + " " + r : this.template = r;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(r, a) {
      var i = a.nationalSignificantNumber, o = a.international, s = a.nationalPrefix, l = a.complexPrefixBeforeNationalSignificantNumber, d = r.pattern();
      d = d.replace(n0(), "\\d").replace(r0(), "\\d");
      var c = e0.match(d)[0];
      if (!(i.length > c.length)) {
        var u = new RegExp("^" + d + "$"), h = i.replace(/\d/g, vr);
        u.test(h) && (c = h);
        var p = this.getFormatFormat(r, o), m;
        if (this.shouldTryNationalPrefixFormattingRule(r, {
          international: o,
          nationalPrefix: s
        })) {
          var _ = p.replace(ho, r.nationalPrefixFormattingRule());
          if (yn(r.nationalPrefixFormattingRule()) === (s || "") + yn("$1") && (p = _, m = !0, s))
            for (var T = s.length; T > 0; )
              p = p.replace(/\d/, Ge), T--;
        }
        var y = c.replace(new RegExp(d), p).replace(new RegExp(vr, "g"), Ge);
        return m || (l ? y = hn(Ge, l.length) + " " + y : s && (y = hn(Ge, s.length) + this.getSeparatorAfterNationalPrefix(r) + y)), o && (y = fo(y)), y;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(r) {
      var a = xf(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, r);
      if (!a) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = a[0], this.populatedNationalNumberTemplatePosition = a[1], Qa(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(r, a) {
      var i = a.international, o = a.nationalPrefix;
      if (r.nationalPrefixFormattingRule()) {
        var s = r.usesNationalPrefix();
        if (s && o || !s && !i)
          return !0;
      }
    }
  }]), n;
}();
function No(n, t) {
  return d0(n) || l0(n, t) || s0(n, t) || o0();
}
function o0() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function s0(n, t) {
  if (n) {
    if (typeof n == "string")
      return di(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    if (r === "Object" && n.constructor && (r = n.constructor.name), r === "Map" || r === "Set")
      return Array.from(n);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return di(n, t);
  }
}
function di(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var r = 0, a = new Array(t); r < t; r++)
    a[r] = n[r];
  return a;
}
function l0(n, t) {
  var r = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (r != null) {
    var a = [], i = !0, o = !1, s, l;
    try {
      for (r = r.call(n); !(i = (s = r.next()).done) && (a.push(s.value), !(t && a.length === t)); i = !0)
        ;
    } catch (d) {
      o = !0, l = d;
    } finally {
      try {
        !i && r.return != null && r.return();
      } finally {
        if (o)
          throw l;
      }
    }
    return a;
  }
}
function d0(n) {
  if (Array.isArray(n))
    return n;
}
function c0(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ci(n, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, a.key, a);
  }
}
function u0(n, t, r) {
  return t && ci(n.prototype, t), r && ci(n, r), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var f0 = "[" + Ye + Le + "]+", h0 = new RegExp("^" + f0 + "$", "i"), p0 = "(?:[" + In + "][" + Ye + Le + "]*|[" + Ye + Le + "]+)", m0 = new RegExp("[^" + Ye + Le + "]+.*$"), $0 = /[^\d\[\]]/, _0 = /* @__PURE__ */ function() {
  function n(t) {
    var r = t.defaultCountry, a = t.defaultCallingCode, i = t.metadata, o = t.onNationalSignificantNumberChange;
    c0(this, n), this.defaultCountry = r, this.defaultCallingCode = a, this.metadata = i, this.onNationalSignificantNumberChange = o;
  }
  return u0(n, [{
    key: "input",
    value: function(r, a) {
      var i = v0(r), o = No(i, 2), s = o[0], l = o[1], d = yn(s), c;
      return l && (a.digits || (a.startInternationalNumber(), d || (c = !0))), d && this.inputDigits(d, a), {
        digits: d,
        justLeadingPlus: c
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(r, a) {
      var i = a.digits, o = i.length < 3 && i.length + r.length >= 3;
      if (a.appendDigits(r), o && this.extractIddPrefix(a), this.isWaitingForCountryCallingCode(a)) {
        if (!this.extractCountryCallingCode(a))
          return;
      } else
        a.appendNationalSignificantNumberDigits(r);
      a.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(a.getNationalDigits(), function(s) {
        return a.update(s);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(r) {
      var a = r.international, i = r.callingCode;
      return a && !i;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(r) {
      var a = go("+" + r.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), i = a.countryCallingCode, o = a.number;
      if (i)
        return r.setCallingCode(i), r.update({
          nationalSignificantNumber: o
        }), !0;
    }
  }, {
    key: "reset",
    value: function(r) {
      if (r) {
        this.hasSelectedNumberingPlan = !0;
        var a = r._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = a && $0.test(a);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(r, a) {
      if (this.hasSelectedNumberingPlan) {
        var i = mr(r, this.metadata), o = i.nationalPrefix, s = i.nationalNumber, l = i.carrierCode;
        if (s !== r)
          return this.onExtractedNationalNumber(o, l, s, r, a), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(r, a, i) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(r, i);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var o = mr(r, this.metadata), s = o.nationalPrefix, l = o.nationalNumber, d = o.carrierCode;
        if (l !== a)
          return this.onExtractedNationalNumber(s, d, l, r, i), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(r, a, i, o, s) {
      var l, d, c = o.lastIndexOf(i);
      if (c >= 0 && c === o.length - i.length) {
        d = !0;
        var u = o.slice(0, c);
        u !== r && (l = u);
      }
      s({
        nationalPrefix: r,
        carrierCode: a,
        nationalSignificantNumber: i,
        nationalSignificantNumberMatchesInput: d,
        complexPrefixBeforeNationalSignificantNumber: l
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(r) {
      if (this.extractAnotherNationalSignificantNumber(r.getNationalDigits(), r.nationalSignificantNumber, function(a) {
        return r.update(a);
      }))
        return !0;
      if (this.extractIddPrefix(r))
        return this.extractCallingCodeAndNationalSignificantNumber(r), !0;
      if (this.fixMissingPlus(r))
        return this.extractCallingCodeAndNationalSignificantNumber(r), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(r) {
      var a = r.international, i = r.IDDPrefix, o = r.digits;
      if (r.nationalSignificantNumber, !(a || i)) {
        var s = $o(o, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (s !== void 0 && s !== o)
          return r.update({
            IDDPrefix: o.slice(0, o.length - s.length)
          }), this.startInternationalNumber(r, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(r) {
      if (!r.international) {
        var a = _o(r.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), i = a.countryCallingCode;
        if (a.number, i)
          return r.update({
            missingPlus: !0
          }), this.startInternationalNumber(r, {
            country: r.country,
            callingCode: i
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(r, a) {
      var i = a.country, o = a.callingCode;
      r.startInternationalNumber(i, o), r.nationalSignificantNumber && (r.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(r) {
      this.extractCountryCallingCode(r) && this.extractNationalSignificantNumber(r.getNationalDigits(), function(a) {
        return r.update(a);
      });
    }
  }]), n;
}();
function g0(n) {
  var t = n.search(p0);
  if (!(t < 0)) {
    n = n.slice(t);
    var r;
    return n[0] === "+" && (r = !0, n = n.slice(1)), n = n.replace(m0, ""), r && (n = "+" + n), n;
  }
}
function T0(n) {
  var t = g0(n) || "";
  return t[0] === "+" ? [t.slice(1), !0] : [t];
}
function v0(n) {
  var t = T0(n), r = No(t, 2), a = r[0], i = r[1];
  return h0.test(a) || (a = ""), [a, i];
}
function y0(n, t) {
  return N0(n) || C0(n, t) || b0(n, t) || E0();
}
function E0() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function b0(n, t) {
  if (n) {
    if (typeof n == "string")
      return ui(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    if (r === "Object" && n.constructor && (r = n.constructor.name), r === "Map" || r === "Set")
      return Array.from(n);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return ui(n, t);
  }
}
function ui(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var r = 0, a = new Array(t); r < t; r++)
    a[r] = n[r];
  return a;
}
function C0(n, t) {
  var r = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (r != null) {
    var a = [], i = !0, o = !1, s, l;
    try {
      for (r = r.call(n); !(i = (s = r.next()).done) && (a.push(s.value), !(t && a.length === t)); i = !0)
        ;
    } catch (d) {
      o = !0, l = d;
    } finally {
      try {
        !i && r.return != null && r.return();
      } finally {
        if (o)
          throw l;
      }
    }
    return a;
  }
}
function N0(n) {
  if (Array.isArray(n))
    return n;
}
function S0(n, t) {
  if (!(n instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function fi(n, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, a.key, a);
  }
}
function O0(n, t, r) {
  return t && fi(n.prototype, t), r && fi(n, r), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var So = /* @__PURE__ */ function() {
  function n(t, r) {
    S0(this, n), this.metadata = new Re(r);
    var a = this.getCountryAndCallingCode(t), i = y0(a, 2), o = i[0], s = i[1];
    this.defaultCountry = o, this.defaultCallingCode = s, this.reset();
  }
  return O0(n, [{
    key: "getCountryAndCallingCode",
    value: function(r) {
      var a, i;
      return r && (Vt(r) ? (a = r.defaultCountry, i = r.defaultCallingCode) : a = r), a && !this.metadata.hasCountry(a) && (a = void 0), [a, i];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(r) {
      var a = this.parser.input(r, this.state), i = a.digits, o = a.justLeadingPlus;
      if (o)
        this.formattedOutput = "+";
      else if (i) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var s;
        if (this.metadata.hasSelectedNumberingPlan() && (s = this.formatter.format(i, this.state)), s === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var l = this.state.getNationalDigits();
          l && (s = this.formatter.format(l, this.state));
        }
        this.formattedOutput = s ? this.getFullNumber(s) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var r = this;
      return this.state = new Df({
        onCountryChange: function(i) {
          r.country = i;
        },
        onCallingCodeChange: function(i, o) {
          r.metadata.selectNumberingPlan(o, i), r.formatter.reset(r.metadata.numberingPlan, r.state), r.parser.reset(r.metadata.numberingPlan);
        }
      }), this.formatter = new i0({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new _0({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          r.determineTheCountryIfNeeded(), r.formatter.reset(r.metadata.numberingPlan, r.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var r = this.state.digits;
      if (r)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var r = this.state.country;
      return r;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(r) {
      var a = this;
      if (this.isInternational()) {
        var i = function(l) {
          return a.formatter.getInternationalPrefixBeforeCountryCallingCode(a.state, {
            spacing: !!l
          }) + l;
        }, o = this.state.callingCode;
        return i(o ? r ? "".concat(o, " ").concat(r) : o : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return r;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var r = this.state, a = r.nationalSignificantNumber, i = r.complexPrefixBeforeNationalSignificantNumber, o = r.nationalPrefix, s = a, l = i || o;
      return l && (s = l + s), s;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var r = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(r ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var r = this.getNonFormattedNumber();
      if (r)
        return r.replace(/[\+\d]/g, Ge);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var r = this.state.callingCode, a = this.metadata.getCountryCodesForCallingCode(r);
      return a && a.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(vo(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var r = this.state, a = r.digits, i = r.callingCode, o = r.country, s = r.nationalSignificantNumber;
      if (a) {
        if (this.isInternational())
          return i ? "+" + i + s : "+" + a;
        if (o || i) {
          var l = o ? this.metadata.countryCallingCode() : i;
          return "+" + l + s;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var r = this.state, a = r.nationalSignificantNumber, i = r.carrierCode, o = r.callingCode, s = this._getCountry();
      if (a && !(!s && !o)) {
        if (s && s === this.defaultCountry) {
          var l = new Re(this.metadata.metadata);
          l.selectNumberingPlan(s);
          var d = l.numberingPlan.callingCode(), c = this.metadata.getCountryCodesForCallingCode(d);
          if (c.length > 1) {
            var u = To(a, {
              countries: c,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            u && (s = u);
          }
        }
        var h = new mo(s || o, a, this.metadata.metadata);
        return i && (h.carrierCode = i), h;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var r = this.getNumber();
      return r ? r.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var r = this.getNumber();
      return r ? r.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), n;
}();
function X1() {
  return An(bf, arguments);
}
function q1() {
  return An(Sf, arguments);
}
function Z1() {
  return An(Af, arguments);
}
function bn(n) {
  return So.call(this, n, to);
}
bn.prototype = Object.create(So.prototype, {});
bn.prototype.constructor = bn;
function A0(n, t, r, a) {
  return r = r || {}, n.country === t && uo(n, r, a);
}
function I0(n, t, r) {
  if (typeof n != "string")
    throw new TypeError("number must be a string");
  if (typeof t != "string")
    throw new TypeError("country must be a string");
  var a;
  return oo(n) ? a = Eo(n, {
    defaultCountry: t
  }, r) : a = {}, A0(a, t, void 0, r);
}
function J1() {
  return An(I0, arguments);
}
const R0 = Y.forwardRef(
  ({
    id: n = "FDSPhoneTextFieldComponent",
    country: t = "US",
    placeholder: r,
    label: a,
    error: i,
    message: o,
    required: s = !1,
    hideSuccess: l = !1,
    hideError: d = !1,
    disabled: c = !1,
    value: u = "",
    onChange: h,
    ...p
  }, m) => {
    const T = xc({
      accept: /\d+/g,
      value: u,
      onChange: h,
      format: (y) => new bn(t).input(y)
    });
    return /* @__PURE__ */ f(
      gt,
      {
        id: n,
        ...p,
        type: "tel",
        placeholder: r,
        onChange: T.onChange,
        value: T.value,
        error: i,
        message: o,
        hideSuccess: l,
        disabled: c,
        required: s,
        inputRef: m
      }
    );
  }
);
R0.displayName = "PhoneTextField2";
const lt = {
  INPUT_WRAPPER: "cxc-search__input-wrapper",
  FOCUSED: "cxc-search--focused",
  ACTIVE: "cxc-search--active",
  DIRTY: "cxc-search--dirty",
  INPUT: "cxc-search__input",
  WRAPPER: "AppMenu",
  // ICON: 'Icon',
  SEARCH_BAR: "SearchBar",
  DROPDOWN: "Dropdown",
  DROPDOWN_ITEM: "DropdownItem",
  CLEAR_BUTTON_FOCUSED: "cxc-section-search__clear-button--focused",
  CLEAR_BUTTON_HIDDEN: "fds-hide",
  CLEAR_BUTTON: "cxc-section-search__clear-button",
  ICON: "fds-icon",
  ICON_CLEAR: "fds-font--ford-icons__clear"
}, D0 = {
  PLACEHOLDER: "placeholder",
  FOR: "for",
  ID: "id",
  ARIA_DESCRIBEDBY: "aria-describedby",
  ARIA_OWNS: "aria-owns",
  ARIA_EXPANDED: "aria-expanded",
  ARIA_ACTIVEDESCENDANT: "aria-activedescendant",
  ARIA_SELECTED: "aria-selected",
  DATA_OPTIONS: "data-options"
}, Q1 = ({
  onChange: n,
  placeholder: t,
  value: r = "",
  additionalStyles: a,
  className: i,
  inputProps: o,
  hasError: s,
  message: l,
  label: d,
  title: c = "Start typing to find your location.",
  accessibility: u,
  id: h = "FDSLocation"
}) => {
  const p = {
    button: { ariaLabel: "clear search" },
    ...u
  }, [m, _] = ee(!1), T = le(null), y = (G) => {
    G.preventDefault(), n?.(G.currentTarget.value);
  }, v = () => {
    T && T.current && (_(!0), P || T.current.setAttribute(D0.PLACEHOLDER, ""));
  }, g = () => {
    _(!1);
  }, S = () => {
    n && n(""), T && T.current && (T.current.click(), T.current.focus());
  }, b = (G) => {
    G.currentTarget.classList.remove(lt.CLEAR_BUTTON_FOCUSED);
  }, $ = (G) => {
    const w = G.target;
    G.keyCode === ve.TAB && w.classList.add(lt.CLEAR_BUTTON_FOCUSED);
  }, P = r && r !== "";
  return /* @__PURE__ */ f(
    "div",
    {
      className: C(
        "cxc-section-search",
        "cxc-search",
        "cxc-color__bg--light",
        P && "cxc-search--dirty",
        s && "cxc-search--invalid",
        m && lt.ACTIVE,
        i
      ),
      children: /* @__PURE__ */ U("div", { className: "cxc-section-search__combobox-wrapper", children: [
        d && /* @__PURE__ */ f("label", { htmlFor: h, style: { fontSize: "11px" }, children: d }),
        /* @__PURE__ */ U("div", { className: "cxc-search__combobox-wrapper", children: [
          /* @__PURE__ */ U(
            "div",
            {
              className: C(
                "cxc-search__input-wrapper",
                s && "cxc-search__input-wrapper--error"
              ),
              children: [
                /* @__PURE__ */ f(
                  "input",
                  {
                    onChange: y,
                    onClick: v,
                    onBlur: g,
                    id: h,
                    value: r,
                    className: C("cxc-search__input"),
                    type: "text",
                    placeholder: m ? void 0 : t,
                    "aria-label": p?.input?.ariaLabel,
                    "aria-autocomplete": "list",
                    "aria-describedby": "FDSLocationInstructions",
                    "aria-activedescendant": "",
                    autoComplete: "off",
                    ref: T,
                    title: c,
                    style: a,
                    ...o
                  }
                ),
                /* @__PURE__ */ f(
                  "button",
                  {
                    className: C(
                      lt.CLEAR_BUTTON,
                      lt.ICON,
                      lt.ICON_CLEAR,
                      !r && lt.CLEAR_BUTTON_HIDDEN
                    ),
                    "aria-label": p?.button?.ariaLabel,
                    onClick: S,
                    onKeyUp: $,
                    onBlur: b
                  }
                )
              ]
            }
          ),
          s && l && /* @__PURE__ */ f("div", { className: C("cxc-text-field__status"), children: /* @__PURE__ */ f(
            "span",
            {
              className: "cxc-search__message",
              "aria-live": "polite",
              role: "alert",
              children: l
            }
          ) })
        ] })
      ] })
    }
  );
}, P0 = "SELECT_DATA_TEST_ID", Ne = {
  SELECT_WRAPPER: "fmc-select-wrapper",
  SELECT_EYEBROW: "fds-select__eyebrow",
  SELECT_LABEL_WRAPPER: "fds-select__label-wrapper",
  SELECT_ICON_WRAPPER: "fmc-select-icon-wrapper",
  LABEL: "fmc-label",
  ICON: "fds-icon",
  ICON_SUCCESS: "fds-font--ford-icons__success",
  ICON_ERROR: "fds-font--ford-icons__error",
  SELECT: "fmc-select",
  INPUT_ERROR: "fmc-input--error",
  INPUT_SUCCESS: "fmc-input--success",
  INPUT_DISABLED: "fds-set-disabled",
  SELECT_STATUS: "fds-select__status",
  SELECT_MESSAGE: "fds-select__message",
  SELECT_MESSAGE_SUCCESS: "fds-select__message--success",
  SELECT_MESSAGE_ERROR: "fds-select__message--error",
  DARK_MODE: "fds-color__bg--dark",
  ICON_SUCCESS_FONT_SIZE: "fds-font--ford-icons__success_fontsize"
}, e2 = ({
  className: n,
  value: t,
  success: r = !1,
  error: a = !1,
  disabled: i = !1,
  label: o,
  message: s,
  mode: l = "light",
  children: d,
  onChange: c,
  dataTestId: u = P0
}) => {
  const h = "SelectInputField", [p, m] = ee(t), _ = Y.useRef(`${ze()}_${h}`), T = (y, ...v) => {
    m(y.target.value), c && c(y, ...v);
  };
  return Y.useEffect(() => {
    m(t);
  }, [t]), /* @__PURE__ */ U(
    "div",
    {
      className: C(
        n,
        l === "dark" && Ne.DARK_MODE,
        Ne.SELECT_WRAPPER
      ),
      "data-testid": u,
      children: [
        (o || r || a) && /* @__PURE__ */ f("div", { className: Ne.SELECT_EYEBROW, children: /* @__PURE__ */ U("div", { className: Ne.SELECT_LABEL_WRAPPER, children: [
          o && /* @__PURE__ */ f(
            "label",
            {
              htmlFor: _.current,
              className: C(
                Ne.LABEL,
                l === "dark" && Ne.DARK_MODE
              ),
              children: o
            }
          ),
          /* @__PURE__ */ f(
            "span",
            {
              className: C(
                Ne.ICON,
                r && !i && Ne.ICON_SUCCESS_FONT_SIZE,
                a && !i && Ne.ICON_ERROR
              )
            }
          )
        ] }) }),
        /* @__PURE__ */ f(
          "div",
          {
            className: C(
              Ne.SELECT_ICON_WRAPPER,
              i && Ne.INPUT_DISABLED
            ),
            children: /* @__PURE__ */ f(
              "select",
              {
                id: _.current,
                value: p,
                className: C(
                  Ne.SELECT,
                  a && !i && Ne.INPUT_ERROR,
                  r && !i && Ne.INPUT_SUCCESS,
                  l === "dark" && Ne.DARK_MODE
                ),
                onChange: T,
                disabled: i,
                "aria-label": o,
                "aria-disabled": i,
                children: d
              }
            )
          }
        ),
        /* @__PURE__ */ f("div", { className: Ne.SELECT_STATUS, children: /* @__PURE__ */ f(
          "span",
          {
            className: C(
              Ne.SELECT_MESSAGE,
              r && !i && Ne.SELECT_MESSAGE_SUCCESS,
              a && !i && Ne.SELECT_MESSAGE_ERROR,
              l === "dark" && Ne.DARK_MODE
            ),
            "aria-live": "assertive",
            role: "alert",
            children: s
          }
        ) })
      ]
    }
  );
}, ce = {
  PREDICTIVE_SEARCH: "cxc-predictive-search",
  LIGHT_BG: "cxc-color__bg--light",
  DARK_BG: "cxc-color__bg--dark",
  SHOW_OPTIONS: "cxc-show-options",
  ACTIVE: "cxc-predictive-search--active",
  FOCUSED: "cxc-predictive-search--focused",
  DIRTY: "cxc-predictive-search--dirty",
  INPUT: "cxc-predictive-search__input",
  TEXT_FIELD_EYEBROW: "cxc-text-field__eyebrow",
  TEXT_FIELD_LABEL_WRAPPER: "cxc-text-field__label-wrapper",
  TEXT_FIELD_LABEL: "cxc-text-field__label",
  SEARCH_COMBOBOX_WRAPPER: "cxc-predictive-search__combobox-wrapper",
  SEARCH_INPUT_WRAPPER: "cxc-predictive-search__input-wrapper",
  SEARCH_INPUT: "cxc-predictive-search__input",
  SEARCH_OPTIONS_WRAPPER: "cxc-predictive-search__options-wrapper",
  SEARCH_OPTION: "cxc-predictive-search__option",
  SEARCH_OPTION_HIGHLIGHT: "cxc-predictive-search__option--highlight",
  CLEAR_BUTTON_FOCUSED: "fds-section-search__clear-button--focused",
  CLEAR_BUTTON_HIDDEN: "fds-hide",
  CLEAR_BUTTON: "fds-section-search__clear-button",
  ICON: "fds-icon",
  ICON_CLEAR: "fds-font--ford-icons__clear",
  ICON_LEFT_OFFSET: "fds-icon--offset-left",
  ICON_RIGHT_OFFSET: "fds-icon--offset-right",
  STATUS: "cxc-search-input-field__status",
  MESSAGE: "cxc-predictive-search__message",
  ERROR_MESSAGE: "cxc-predictive-search-field-error",
  SEARCH_INPUT_ERROR_BORDER: "cxc-predictive-search-input--error",
  BUTTON_FOCUS: "cxc-predictive-search_search_button_focus",
  INPUT_WRAPPER_DISABLED: "cxc-search-input-wrapper--disabled",
  INPUT_DISABLED: "cxc-search-input-field--disabled",
  BUTTON_DISABLED: "button-disabled"
}, it = {
  HOME: "home",
  END: "end",
  PREV: "prev",
  NEXT: "next"
}, w0 = 500, L0 = ({
  mode: n,
  filled: t,
  active: r,
  focused: a,
  showOptions: i
}) => {
  const o = [];
  return n && (n === "light" && o.push(ce.LIGHT_BG), n === "dark" && o.push(ce.DARK_BG)), t && o.push(ce.DIRTY), r && o.push(ce.ACTIVE), a && o.push(ce.FOCUSED), i && o.push(ce.SHOW_OPTIONS), o;
}, x0 = "PREDICTIVE_SEARCH_FIELD_DATA_TEST_ID", t2 = ({
  onChange: n,
  onInputChange: t,
  onOptionClick: r,
  placeholder: a,
  additionalStyles: i,
  defaultInputValue: o = "",
  value: s = "",
  className: l,
  options: d = [],
  mode: c = "light",
  title: u,
  dataTestId: h = x0,
  icon: p = /* @__PURE__ */ f(Zt, { name: "search" }),
  showClearButton: m = !0,
  disableFiltering: _ = !1,
  message: T,
  error: y,
  onSubmit: v,
  searchBtnAriaLabel: g = "search button",
  clearBtnAriaLabel: S = "clear button",
  inputAriaLabel: b = "Search",
  disabled: $,
  ...P
}) => {
  let G;
  const [w, D] = ee(!1), [H, W] = ee([]), [B, I] = ee(o), [A, N] = ee(!1), [L, E] = ee(-1), [x, X] = ee(!1), [O, R] = ee(""), [J, Z] = ee(null), [
    z,
    k
  ] = ee(!1), F = le(null), K = { maxWidth: "16px", maxHeight: "16px" };
  p && (G = /* @__PURE__ */ f("span", { className: ce.ICON_RIGHT_OFFSET, children: /* @__PURE__ */ f(
    "button",
    {
      className: C(
        ce.BUTTON_FOCUS,
        $ && ce.BUTTON_DISABLED
      ),
      "aria-label": g,
      onClick: v,
      tabIndex: 0,
      disabled: $,
      children: re.cloneElement(p, {
        style: K
      })
    }
  ) })), de(() => {
    (s || s === "") && I(s);
  }, [s]);
  const q = (ne) => {
    r && r(ne), I(ne.label), W([]);
  }, j = (ne) => {
    ne.preventDefault(), D(!0);
    const he = ne.currentTarget;
    let Me = [];
    he.value.length > 0 && (Me = d?.filter(
      (Tt) => Tt.label.toLocaleLowerCase().includes(he.value.toLocaleLowerCase())
    ) ?? [], Me.length > 0 && k(!0)), t?.(ne, he.value), W(Me), I(he.value), N(!0);
  }, te = () => {
    N(B !== "");
  }, se = (ne) => {
    D(!0), te();
  }, V = () => {
    W([]), D(!1), X(!1), te();
  }, ye = (ne) => {
    ne.key === "Tab" && (se(), X(!0));
  }, De = (ne) => {
    t?.(ne, ""), F && F.current && (F.current.click(), F.current.focus()), I("");
  }, Ze = (ne) => {
    ne.currentTarget.classList.remove(ce.CLEAR_BUTTON_FOCUSED);
  }, me = (ne) => {
    const he = ne.target;
    ne.keyCode === ve.TAB && he.classList.add(ce.CLEAR_BUTTON_FOCUSED);
  }, Ae = () => {
    E(-1), D(!1), k(!1);
  }, xe = (ne) => {
    for (let he = 0; he < d.length; he++)
      if (H[he]?.value.toUpperCase().startsWith(ne))
        return he;
    return null;
  }, We = (ne) => {
    J && clearTimeout(J), Z(
      // @ts-ignore
      setTimeout(() => {
        R(""), Z(null);
      }, ne)
    );
  }, rt = (ne) => {
    const he = String.fromCharCode(ne), Me = O + he;
    R(Me), We(w0);
    const Tt = xe(Me);
    return Tt !== null ? (E(Tt), !0) : !1;
  }, Q = (ne) => {
    let he = -1;
    switch (ne) {
      case it.HOME:
        he = -1;
        break;
      case it.END:
        he = d.length - 1;
        break;
      case it.NEXT:
        L >= d.length - 1 ? he = -1 : he = L + 1;
        break;
      case it.PREV:
        L <= -1 ? he = d.length - 1 : he = L - 1;
        break;
    }
    E(he);
  };
  de(() => {
    H.length === 0 && k(!1);
  }, [H]);
  const fe = (
    // boolean condition for showing options when `disableFiltering` is false
    z && !_ || // boolean condition for showing options when `disableFiltering` is true
    _ && !!d.length && w
  ), Oe = _ ? d : H, Pe = (ne) => {
    switch (ne.keyCode) {
      case ve.ENTER:
        return ne.stopPropagation(), ne.preventDefault(), L < 0 && n?.(
          ne,
          L >= 0 ? Oe[L > -1 ? L : 0].value : B
        ), L >= 0 && q(
          Oe[L > -1 ? L : 0]
        ), Ae(), !1;
      case ve.ESC:
        ne.target.blur(), F?.current?.focus(), Ae();
        break;
      case ve.UP:
        ne.preventDefault(), Q(it.PREV);
        break;
      case ve.DOWN:
        ne.preventDefault(), Q(it.NEXT);
        break;
      case ve.HOME:
        ne.preventDefault(), Q(it.HOME);
        break;
      case ve.END:
        ne.preventDefault(), Q(it.END);
        break;
      default:
        ne.preventDefault(), rt(ne.keyCode);
        break;
    }
  };
  return /* @__PURE__ */ U(
    "div",
    {
      className: C(
        ce.PREDICTIVE_SEARCH,
        L0({ mode: c, filled: A, active: w, focused: x, showOptions: fe }),
        l
      ),
      children: [
        /* @__PURE__ */ f("div", { className: C(ce.TEXT_FIELD_EYEBROW), children: /* @__PURE__ */ f("div", { className: C(ce.TEXT_FIELD_LABEL_WRAPPER), children: /* @__PURE__ */ f(
          "label",
          {
            htmlFor: "FMCPredictiveSearch",
            className: C(ce.TEXT_FIELD_LABEL),
            children: a
          }
        ) }) }),
        /* @__PURE__ */ U(
          "div",
          {
            className: C(ce.SEARCH_COMBOBOX_WRAPPER),
            "aria-haspopup": "listbox",
            children: [
              /* @__PURE__ */ U(
                "div",
                {
                  className: C(
                    ce.SEARCH_INPUT_WRAPPER,
                    y && !$ && ce.SEARCH_INPUT_ERROR_BORDER,
                    $ && ce.INPUT_WRAPPER_DISABLED
                  ),
                  children: [
                    G,
                    /* @__PURE__ */ f(
                      "input",
                      {
                        onChange: j,
                        id: "FMCPredictiveSearch",
                        value: B,
                        className: C(
                          ce.SEARCH_INPUT,
                          $ && ce.INPUT_DISABLED
                        ),
                        type: "text",
                        onKeyUp: ye,
                        onKeyDown: (ne) => {
                          (ne.key === "ArrowDown" || ne.key === "ArrowUp" || ne.key === "Enter" || ne.key === "Escape" || ne.key === "HOME" || ne.key === "END") && Pe(ne);
                        },
                        placeholder: w ? "" : a,
                        "aria-label": b,
                        "aria-describedby": "FMCPredictiveSearchInstructions",
                        autoComplete: "off",
                        ref: F,
                        title: u,
                        "data-testid": "predictive-search",
                        style: i,
                        onClick: se,
                        onBlur: () => {
                          setTimeout(() => {
                            V();
                          }, 150), E(-1);
                        },
                        disabled: $,
                        role: "combobox",
                        "aria-controls": "FMCPredictiveSearchResults",
                        "aria-expanded": Oe && fe,
                        "aria-autocomplete": "list",
                        "aria-owns": "FMCPredictiveSearchResults",
                        "aria-activedescendant": L > -1 ? `dropdown-suggestion-${L}` : "",
                        ...P
                      }
                    ),
                    m && /* @__PURE__ */ f(
                      "button",
                      {
                        className: C(
                          ce.CLEAR_BUTTON,
                          ce.ICON,
                          ce.ICON_CLEAR,
                          ce.BUTTON_FOCUS,
                          !B && ce.CLEAR_BUTTON_HIDDEN,
                          $ && ce.BUTTON_DISABLED
                        ),
                        "aria-label": S,
                        "data-testid": "clear_search_button",
                        tabIndex: 0,
                        onClick: De,
                        onKeyUp: me,
                        onBlur: Ze,
                        disabled: $
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ f("div", { className: ce.STATUS, children: /* @__PURE__ */ f(
                "span",
                {
                  className: C(ce.MESSAGE, y && ce.ERROR_MESSAGE),
                  role: "alert",
                  children: T
                }
              ) }),
              Oe && fe && /* @__PURE__ */ f(
                "ul",
                {
                  "data-testid": h,
                  className: C(ce.SEARCH_OPTIONS_WRAPPER),
                  id: "FMCPredictiveSearchResults",
                  role: "listbox",
                  children: Oe.map((ne, he) => /* @__PURE__ */ f(
                    "li",
                    {
                      onMouseOver: () => E(he),
                      className: C(
                        ce.SEARCH_OPTION,
                        he === L && ce.SEARCH_OPTION_HIGHLIGHT
                      ),
                      onClick: () => q(ne),
                      id: `dropdown-suggestion-${he}`,
                      "aria-selected": he === L,
                      role: "option",
                      children: ne.label
                    },
                    he
                  ))
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Nt = {
  UK: /^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9][A-Z]|[A-Z][0-9][0-9]|[A-Z][0-9]|[0-9][A-Z]){1}([ ])?([0-9][A-z][A-z]){1}$/i,
  GB: /^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9][A-Z]|[A-Z][0-9][0-9]|[A-Z][0-9]|[0-9][A-Z]){1}([ ])?([0-9][A-z][A-z]){1}$/i,
  // JE: /^JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  // GG: /^GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  // IM: /^IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  US: /^([0-9]{5})(?:-([0-9]{4}))?$/,
  CA: /^([ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ])\s*([0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])$/i,
  IE: /^(([AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4})?$/,
  DE: /^\d{5}$/,
  // JP: /^\d{3}-\d{4}$/,
  FR: /^\d{2}[ ]?\d{3}$/,
  // AU: /^\d{4}$/,
  IT: /^\d{5}$/,
  // CH: /^\d{4}$/,
  AT: /^(?!0)\d{4}$/,
  ES: /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/,
  NL: /^\d{4}[ ]?[A-Z]{2}$/,
  // BE: /^\d{4}$/,
  // DK: /^\d{4}$/,
  // SE: /^(SE-)?\d{3}[ ]?\d{2}$/,
  // NO: /^\d{4}$/,
  // BR: /^\d{5}[\-]?\d{3}$/,
  PT: /^\d{4}([\-]\d{3})?$/,
  // FI: /^(FI-|AX-)?\d{5}$/,
  // AX: /^22\d{3}$/,
  // KR: /^\d{5}$/,
  // CN: /^\d{6}$/,
  // TW: /^\d{3}(\d{2})?$/,
  // SG: /^\d{6}$/,
  // DZ: /^\d{5}$/,
  // AD: /^AD\d{3}$/,
  // AR: /^([A-HJ-NP-Z])?\d{4}([A-Z]{3})?$/,
  // AM: /^(37)?\d{4}$/,
  // AZ: /^\d{4}$/,
  // BH: /^((1[0-2]|[2-9])\d{2})?$/,
  // BD: /^\d{4}$/,
  // BB: /^(BB\d{5})?$/,
  // BY: /^\d{6}$/,
  // BM: /^[A-Z]{2}[ ]?[A-Z0-9]{2}$/,
  // BA: /^\d{5}$/,
  // IO: /^BBND 1ZZ$/,
  // BN: /^[A-Z]{2}[ ]?\d{4}$/,
  // BG: /^\d{4}$/,
  // KH: /^\d{5}$/,
  // CV: /^\d{4}$/,
  // CL: /^\d{7}$/,
  // CR: /^(\d{4,5}|\d{3}-\d{4})$/,
  // HR: /^(HR-)?\d{5}$/,
  // CY: /^\d{4}$/,
  // CZ: /^\d{3}[ ]?\d{2}$/,
  // DO: /^\d{5}$/,
  // EC: /^([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?$/,
  // EG: /^\d{5}$/,
  // EE: /^\d{5}$/,
  // FO: /^\d{3}$/,
  // GE: /^\d{4}$/,
  // GR: /^\d{3}[ ]?\d{2}$/,
  // GL: /^39\d{2}$/,
  // GT: /^\d{5}$/,
  // HT: /^\d{4}$/,
  // HN: /^(?:\d{5})?$/,
  // HU: /^\d{4}$/,
  // IS: /^\d{3}$/,
  // IN: /^\d{6}$/,
  // ID: /^\d{5}$/,
  // IL: /^\d{5,7}$/,
  // JO: /^\d{5}$/,
  // KZ: /^\d{6}$/,
  // KE: /^\d{5}$/,
  // KW: /^\d{5}$/,
  // KY: /^KY[123]-\d{4}$/,
  // LA: /^\d{5}$/,
  // LV: /^(LV-)?\d{4}$/,
  // LB: /^(\d{4}([ ]?\d{4})?)?$/,
  // LI: /^(948[5-9])|(949[0-7])$/,
  // LT: /^(LT-)?\d{5}$/,
  // LU: /^(L-)?\d{4}$/,
  // MK: /^\d{4}$/,
  // MY: /^\d{5}$/,
  // MV: /^\d{5}$/,
  // MT: /^[A-Z]{3}[ ]?\d{2,4}$/,
  // MU: /^((\d|[A-Z])\d{4})?$/,
  MX: /^\d{5}$/,
  // MD: /^\d{4}$/,
  // MC: /^980\d{2}$/,
  // MA: /^\d{5}$/,
  // NP: /^\d{5}$/,
  // NZ: /^\d{4}$/,
  // NI: /^((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?$/,
  // NG: /^(\d{6})?$/,
  // OM: /^(PC )?\d{3}$/,
  // PA: /^\d{4}$/,
  // PK: /^\d{5}$/,
  // PY: /^\d{4}$/,
  // PH: /^\d{4}$/,
  // PL: /^\d{2}-\d{3}$/,
  // PR: /^00[679]\d{2}([ \-]\d{4})?$/,
  // RO: /^\d{6}$/,
  // RU: /^\d{6}$/,
  // SM: /^4789\d$/,
  // SA: /^\d{5}$/,
  // SN: /^\d{5}$/,
  // SK: /^\d{3}[ ]?\d{2}$/,
  // SI: /^(SI-)?\d{4}$/,
  // ZA: /^\d{4}$/,
  // LK: /^\d{5}$/,
  // TJ: /^\d{6}$/,
  // TH: /^\d{5}$/,
  // TN: /^\d{4}$/,
  // TR: /^\d{5}$/,
  // TM: /^\d{6}$/,
  // UA: /^\d{5}$/,
  // UY: /^\d{5}$/,
  // UZ: /^\d{6}$/,
  // VA: /^00120$/,
  // VE: /^\d{4}$/,
  // ZM: /^\d{5}$/,
  // AS: /^96799$/,
  // CC: /^6799$/,
  // CK: /^\d{4}$/,
  // RS: /^\d{5,6}$/,
  // ME: /^8\d{4}$/,
  // CS: /^\d{5}$/,
  // YU: /^\d{5}$/,
  // CX: /^6798$/,
  // ET: /^\d{4}$/,
  // FK: /^FIQQ 1ZZ$/,
  // NF: /^2899$/,
  // FM: /^(9694[1-4])([ \-]\d{4})?$/,
  // GF: /^9[78]3\d{2}$/,
  // GN: /^\d{3}$/,
  // GP: /^9[78][01]\d{2}$/,
  // GS: /^SIQQ 1ZZ$/,
  // GU: /^969[123]\d([ \-]\d{4})?$/,
  // GW: /^\d{4}$/,
  // HM: /^\d{4}$/,
  // IQ: /^\d{5}$/,
  // KG: /^\d{6}$/,
  // LR: /^\d{4}$/,
  // LS: /^\d{3}$/,
  // MG: /^\d{3}$/,
  // MH: /^969[67]\d([ \-]\d{4})?$/,
  // MN: /^\d{6}$/,
  // MP: /^9695[012]([ \-]\d{4})?$/,
  // MQ: /^9[78]2\d{2}$/,
  // NC: /^988\d{2}$/,
  // NE: /^\d{4}$/,
  // VI: /^008(([0-4]\d)|(5[01]))([ \-]\d{4})?$/,
  // VN: /^\d{6}$/,
  // PF: /^987\d{2}$/,
  // PG: /^\d{3}$/,
  // PM: /^9[78]5\d{2}$/,
  // PN: /^PCRN 1ZZ$/,
  // PW: /^96940$/,
  // RE: /^9[78]4\d{2}$/,
  // SH: /^(ASCN|STHL) 1ZZ$/,
  // SJ: /^\d{4}$/,
  // SO: /^\d{5}$/,
  // SZ: /^[HLMS]\d{3}$/,
  // TC: /^TKCA 1ZZ$/,
  // WF: /^986\d{2}$/,
  // XK: /^\d{5}$/,
  // YT: /^976\d{2}$/,
  INTL: /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/i
}, n2 = ({
  value: n,
  id: t = "FDSPostalCodeTextFieldComponent",
  country: r = "US",
  placeholder: a,
  label: i,
  error: o,
  message: s,
  patternMismatchErrorMessage: l = "Postal code is invalid",
  requiredErrorMessage: d,
  required: c = !1,
  hideSuccess: u = !1,
  hideError: h = !1,
  disabled: p = !1,
  autoFormat: m = !0,
  onValueChange: _,
  ...T
}) => {
  function y(I) {
    Nt[I] || console.error("PostalCodeTextField does not support this country code!");
  }
  const v = r.toUpperCase();
  y(v);
  const [g, S] = ee(), [b, $] = ee(), P = (I) => G(I, v), G = (I, A) => /^[a-z0-9\- ]{0,12}$/gi.test(I) && Nt[A]?.test(I), w = (I) => {
    const N = I.target.value.replace(/\s\s+/g, " ");
    let L = N;
    m && (L = H(
      N,
      v
    ));
    const E = P(L);
    S(E), _ && _({
      value: N,
      formattedValue: L,
      isValid: E,
      countryCode: v
    });
  }, D = (I, A) => I.length >= A && I.charAt(A - 1) != "-" ? I.slice(0, A - 1) + "-" + I.slice(A - 1, A === 6 && 11 || 7) : I;
  function H(I, A) {
    const N = Nt[A], L = I.toUpperCase();
    if (!N)
      return "";
    switch (A) {
      case "US":
        return D(L, 6);
      case "PT":
        return D(L, 5);
    }
    return L.replace(N, function(E) {
      switch (A) {
        case "AT":
          return E;
        case "CA":
          return E.length === 6 ? E.slice(0, 3) + " " + E.slice(3, 6) : E;
        case "DE":
          return E;
        case "ES":
          return E;
        case "FR":
          return E;
        case "IE":
          return E.length === 7 ? E.slice(0, 3) + " " + E.slice(3, 7) : E;
        case "IT":
          return E;
        case "INTL":
          return E;
        case "MX":
          return E;
        case "NL":
          return E.length === 6 ? E.slice(0, 4) + " " + E.slice(4, 6) : E;
        case "GB":
        case "UK":
          return E = E.replace(/\s/g, ""), E.slice(0, E.length - 3) + " " + E.slice(E.length - 3);
        default:
          return "";
      }
    });
  }
  const W = Y.useCallback(() => {
    g ? $("") : typeof n > "u" || n.length === 0 ? $(
      c ? d || "Postal code is required" : ""
    ) : $(l);
  }, [
    r,
    n,
    g,
    l,
    c,
    d
  ]);
  de(() => {
    W();
  }, [W]);
  const B = Y.useCallback(() => {
    $(""), n && w({ target: { value: n } });
  }, []);
  return de(() => {
    B();
  }, [B]), /* @__PURE__ */ f(
    gt,
    {
      id: t,
      label: i,
      name: i,
      placeholder: a,
      onChange: w,
      value: n,
      error: o || (h ? void 0 : b),
      message: s || (h ? void 0 : b),
      hideSuccess: u || !g,
      disabled: p,
      required: c,
      ...T
    }
  );
}, r2 = (n, t) => (t = t.toUpperCase(), Nt[t]?.test(n));
function F0(n) {
  Nt[n] || console.error("PostalCodeTextField does not support this country code!");
}
const a2 = Y.forwardRef(
  ({
    value: n,
    id: t = "FDSPostalCodeTextFieldComponent",
    country: r = "US",
    placeholder: a,
    label: i,
    error: o,
    message: s,
    required: l = !1,
    disabled: d = !1,
    autoFormat: c = !0,
    onChange: u,
    ...h
  }, p) => {
    const m = r.toUpperCase();
    F0(m);
    const _ = (v) => {
      const g = v.target.value;
      if (/^[a-z0-9\- ]{0,12}$/gi.test(g)) {
        const S = g.replace(/\s\s+/g, " ");
        let b = S;
        c && (b = T(
          S,
          m
        )), u && u(b);
      }
    };
    function T(v, g) {
      const S = Nt[g], b = v.toUpperCase().replace(/[-]/g, "");
      return S ? g === "US" ? b.length >= 6 && b.charAt(5) !== "-" ? b.slice(0, 5) + "-" + b.slice(5, 11) : b : g === "PT" ? b.length >= 5 && b.charAt(4) !== "-" ? b.slice(0, 4) + "-" + b.slice(4, 7) : b : b.replace(S, function($) {
        switch (g) {
          case "AT":
            return $;
          case "CA":
            return $.length === 6 ? $.slice(0, 3) + " " + $.slice(3, 6) : $;
          case "DE":
            return $;
          case "ES":
            return $;
          case "FR":
            return $;
          case "IE":
            return $.length === 7 ? $.slice(0, 3) + " " + $.slice(3, 7) : $;
          case "IT":
            return $;
          case "INTL":
            return $;
          case "MX":
            return $;
          case "NL":
            return $.length === 6 ? $.slice(0, 4) + " " + $.slice(4, 6) : $;
          case "GB":
          case "UK":
            return $ = $.replace(/\s/g, ""), $.slice(0, $.length - 3) + " " + $.slice($.length - 3);
          default:
            return "";
        }
      }) : "";
    }
    const y = Y.useCallback(() => {
      n && _({ target: { value: n } });
    }, []);
    return de(() => {
      y();
    }, [y]), /* @__PURE__ */ f(
      gt,
      {
        id: t,
        label: i,
        name: i,
        placeholder: a,
        onChange: _,
        value: n,
        error: o,
        message: s,
        disabled: d,
        required: l,
        inputRef: p,
        ...h
      }
    );
  }
), i2 = (n, t = !1, r = "USD", a = "en") => {
  const i = Intl.NumberFormat(a, {
    style: "currency",
    currency: r,
    maximumSignificantDigits: Oo
  }).formatToParts(1111.11), o = i.find(
    (m) => m.type === "decimal"
  )?.value, s = i.find(
    (m) => m.type === "literal"
  )?.value, l = i.find(
    (m) => m.type === "currency"
  )?.value, d = i.find(
    (m) => m.type === "group"
  )?.value;
  let c = Lr({
    value: n,
    groupSeparator: d,
    decimalSeparator: o
  });
  c = c.replace(",", ".");
  const u = Ao(".", c), h = parseFloat(c);
  let p = "";
  if (c.charAt(c.length - 1) !== ".") {
    let m = 2;
    t || (m = Math.min(u, 2));
    const _ = new Intl.NumberFormat(a, {
      style: "currency",
      currency: r,
      minimumFractionDigits: m,
      maximumFractionDigits: m
    }).format(h);
    isNaN(h) || (p = _);
  } else {
    const m = new Intl.NumberFormat(a, {
      style: "currency",
      currency: r,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(h);
    s ? p = `${m.replace(
      `${s}${l}`,
      ""
    )}${o}${s}${l}` : p = `${m}${o}`;
  }
  return M0(p, c);
}, Oo = 18, Ao = function(n, t) {
  return t.split(n)[1]?.length || 0;
}, M0 = (n, t) => {
  const r = parseFloat(t);
  return {
    formattedValue: n,
    value: t,
    floatValue: isNaN(r) ? void 0 : r
  };
}, o2 = Y.forwardRef(
  ({
    currency: n = "USD",
    locale: t = "en",
    onChange: r,
    value: a,
    padZeroes: i = !1,
    onBlur: o,
    message: s,
    error: l,
    ...d
  }, c) => {
    const u = le(), [h, p] = ee(null);
    de(() => {
      const v = u.current;
      v && v.setSelectionRange(h, h);
    }, [u, h, a]);
    const m = ({
      value: v,
      diff: g,
      total: S,
      literalCharacter: b,
      setCursor: $
    }) => {
      v.length === 0 && b ? $(1) : g === 0 ? $(S) : g < 0 ? $(S + Math.abs(g) - 1) : $(S - Math.abs(g) + 1);
    }, _ = (v, g, S = !1) => {
      const b = Intl.NumberFormat(t, {
        style: "currency",
        currency: n,
        maximumSignificantDigits: 18
      }).formatToParts(1111.11), $ = b.find(
        (N) => N.type === "decimal"
      )?.value, P = b.find(
        (N) => N.type === "literal"
      )?.value, G = b.find((N) => N.type === "currency")?.value || "", w = b.find(
        (N) => N.type === "group"
      )?.value;
      let D = Lr({
        value: g,
        groupSeparator: w,
        decimalSeparator: $
      });
      D = D.replace(",", ".");
      const H = Ao(".", D), W = parseFloat(D);
      let B = "";
      if (D.charAt(D.length - 1) !== ".") {
        let N = 2;
        S || (N = Math.min(H, 2));
        const L = new Intl.NumberFormat(t, {
          style: "currency",
          currency: n,
          minimumFractionDigits: N,
          maximumFractionDigits: N
        }).format(W);
        isNaN(W) || (B = L);
      } else {
        const N = new Intl.NumberFormat(t, {
          style: "currency",
          currency: n,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(W);
        P ? B = `${N.replace(
          `${P}${G}`,
          ""
        )}${$}${P}${G}` : B = `${N}${$}`;
      }
      const I = v.target.selectionEnd, A = a.length - B.length;
      m({ value: a, diff: A, total: I, literalCharacter: P, setCursor: p }), B !== a && r(B);
    }, T = (v) => {
      _(v, v.target.value);
    }, y = (v) => {
      _(v, v.target.value, i);
    };
    return /* @__PURE__ */ f("div", { ref: c, children: /* @__PURE__ */ f(
      gt,
      {
        onChange: (v) => T(v),
        onBlur: (v) => y(v),
        onFocus: () => {
          const v = u.current;
          v && setTimeout(function() {
            v.setSelectionRange(h, h);
          }, 0);
        },
        value: a,
        inputRef: u,
        "data-testid": "currency-input",
        maxLength: Oo,
        message: s,
        error: l,
        ...d
      }
    ) });
  }
), s2 = ({
  url: n = "",
  openInNewTab: t = !1,
  children: r,
  className: a
}) => t ? /* @__PURE__ */ f(
  "a",
  {
    href: n,
    "data-testid": "link-wrapper",
    target: "_blank",
    rel: "noreferrer",
    className: C(a),
    children: r
  }
) : /* @__PURE__ */ f("a", { href: n, "data-testid": "link-wrapper", className: C(a), children: r });
const l2 = ({
  isOpen: n = !1,
  toggleModal: t,
  extraContentStyles: r,
  children: a,
  className: i
}) => {
  const o = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: "60vw",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      alignItems: "center",
      padding: 0,
      zIndex: 3e3,
      ...r
    },
    base: "ReactModal__Overlay",
    afterOpen: "ReactModal__Overlay--after-open",
    beforeClose: "ReactModal__Overlay--before-close"
  };
  return /* @__PURE__ */ f(
    qi,
    {
      isOpen: n,
      onRequestClose: t,
      style: o,
      className: C(i),
      children: a
    }
  );
}, d2 = () => {
  const [n, t] = ee(!1);
  return {
    visible: n,
    toggle: () => t(!n),
    setVisibility: (i) => t(i)
  };
}, k0 = ({
  className: n,
  square: t = !0,
  elevated: r = !1,
  ...a
}) => /* @__PURE__ */ f(
  "div",
  {
    className: C(
      "cxc-table-container",
      t && "cxc-table-container--square",
      r && "cxc-table-container--elevated",
      n
    ),
    ...a
  }
);
k0.displayName = "TableContainer";
const Br = Y.createContext({
  padding: "normal",
  size: "medium",
  stickyHeader: !1
});
Br.displayName = "TableContext";
const Ht = {
  TABLE: "fmc-table",
  ALTERNATING_ROWS: "fmc-table--alternating-rows",
  STICKY_HEADER: "cxc-table--sticky-header",
  HEADER_COLUMN: "fmc-table--header-column",
  NO_BORDERS: "fmc-table--no-borders"
}, B0 = ({
  className: n,
  padding: t = "normal",
  size: r = "medium",
  stickyHeader: a = !1,
  alternateRows: i = !0,
  headerColumn: o = !1,
  borders: s = !0,
  children: l,
  ...d
}) => {
  const c = Y.useMemo(
    () => ({ padding: t, size: r, stickyHeader: a, alternateRows: i }),
    [t, r, a, i]
  ), u = [Ht.TABLE];
  return /* @__PURE__ */ f(Br.Provider, { value: c, children: /* @__PURE__ */ U(
    "table",
    {
      role: "table",
      className: C(
        u,
        a && Ht.STICKY_HEADER,
        i && Ht.ALTERNATING_ROWS,
        o && Ht.HEADER_COLUMN,
        !s && Ht.NO_BORDERS,
        n
      ),
      ...d,
      children: [
        /* @__PURE__ */ f("caption", { children: /* @__PURE__ */ f(
          "span",
          {
            style: {
              position: "absolute",
              left: "-9999px",
              width: "1px",
              height: "1px",
              overflow: "hidden",
              whiteSpace: "nowrap"
            },
            children: "All table columns are sortable"
          }
        ) }),
        l
      ]
    }
  ) });
};
B0.displayName = "Table";
const nn = Y.createContext({});
nn.displayName = "TableInnerContext";
const U0 = ({
  className: n,
  padding: t,
  scope: r,
  sortDirection: a,
  variant: i,
  size: o,
  align: s = "left",
  style: l,
  ...d
}) => {
  const c = Y.useContext(Br), u = Y.useContext(nn), h = (
    //@ts-ignore
    u && u.variant === "head" || !1
  ), p = h ? "th" : "td", m = o || (c && c.size ? c.size : "medium");
  let _ = r;
  !_ && h && (_ = "col");
  let T = "none";
  return a && (T = a === "asc" ? "ascending" : "descending"), /* @__PURE__ */ f(
    p,
    {
      className: C(
        "fds-app",
        "cxc-table-cell",
        h && "cxc-table-cell--head-cell",
        s === "right" && "cxc-table-cell--align-right",
        s === "center" && "cxc-table-cell--align-center",
        s === "left" && "cxc-table-cell--align-left",
        s === "justify" && "cxc-table-cell--align-justify",
        t === "none" && "cxc-table-cell--padding-none",
        t === "checkbox" && "cxc-table-cell--padding-checkbox",
        m === "small" && "cxc-table-cell--size-small",
        i === "head" && c && c.stickyHeader && "cxc-table-cell--sticky-header",
        i === "body" && "cxc-table-cell--body-cell",
        i === "footer" && "cxc-table-cell--footer-cell",
        n
      ),
      ...h && T !== "none" && { "aria-sort": T },
      scope: _,
      style: l,
      ...d
    }
  );
};
U0.displayName = "TableCell";
const H0 = {
  variant: "body"
}, W0 = ({ className: n, ...t }) => /* @__PURE__ */ f(nn.Provider, { value: H0, children: /* @__PURE__ */ f("tbody", { className: C("cxc-table-body", n), ...t }) });
W0.displayName = "TableBody";
const V0 = ({
  className: n,
  hover: t = !1,
  selected: r = !1,
  onClick: a,
  ...i
}) => {
  const o = Y.useContext(nn), s = o && //@ts-ignore
  o.variant === "head", l = o && //@ts-ignore
  o.variant === "footer";
  return /* @__PURE__ */ f(
    "tr",
    {
      role: "row",
      className: C(
        "cxc-table-row",
        r && "cxc-table-row--selected-enabled",
        t && "cxc-table-row--hover-enabled",
        s && "cxc-table-row--head-row",
        l && "cxc-table-cell--footer-row",
        n
      ),
      onClick: a,
      ...i
    }
  );
};
V0.displayName = "TableRow";
const G0 = {
  variant: "head"
}, K0 = ({ ...n }) => /* @__PURE__ */ f(nn.Provider, { value: G0, children: /* @__PURE__ */ f("thead", { ...n }) });
K0.displayName = "TableHead";
const Wt = "...", dn = (n, t) => {
  const r = t - n + 1;
  return Array.from({ length: r }, (a, i) => i + n);
}, j0 = ({
  totalCount: n,
  pageSize: t = 1,
  siblingCount: r = 1,
  currentPage: a
}) => St(() => {
  const o = Math.ceil(n / t);
  if (r + 6 >= o)
    return dn(1, o);
  const l = Math.max(a - r, 1), d = Math.min(
    a + r,
    o
  ), c = l > 2, u = d < o - 2, h = 1, p = o;
  if (!c && u) {
    const m = 3 + 2 * r;
    return [...dn(1, m), Wt, o];
  }
  if (c && !u) {
    const m = 3 + 2 * r, _ = dn(
      o - m + 1,
      o
    );
    return [h, Wt, ..._];
  }
  if (c && u) {
    const m = dn(l, d);
    return [h, Wt, ...m, Wt, p];
  }
}, [n, t, r, a]), Y0 = ({
  page: n,
  count: t,
  onPageChange: r,
  siblingCount: a = 1,
  pageSize: i = 1,
  className: o,
  nextButtonText: s = "Next",
  prevButtonText: l = "Prev"
}) => {
  const d = j0({
    currentPage: n,
    totalCount: t,
    siblingCount: a,
    pageSize: i
  });
  if (n === 0 || d && d.length < 2)
    return null;
  const c = () => {
    r(n + 1);
  }, u = () => {
    r(n - 1);
  }, h = d && d[d.length - 1] || 1;
  return /* @__PURE__ */ f("nav", { className: "fds-app cxc-pagination__nav", children: /* @__PURE__ */ U("ul", { className: C("cxc-pagination", o), children: [
    /* @__PURE__ */ f("li", { className: "cxc-pagination__item", children: n !== 1 ? (
      // TODO: Refactor to use button tag instead of a tag
      /* @__PURE__ */ U(
        "a",
        {
          className: "cxc-pagination__prev",
          onClick: u,
          onKeyDown: (p) => {
            (p.code === "Enter" || p.code === "Space") && u();
          },
          tabIndex: 0,
          children: [
            l,
            /* @__PURE__ */ f("span", { className: "fds-hide--visually", children: " page" })
          ]
        }
      )
    ) : /* @__PURE__ */ f(
      "span",
      {
        className: C(
          "cxc-pagination__prev",
          "cxc-pagination__disabled"
        ),
        children: l
      }
    ) }),
    d && d.map((p, m) => p === Wt ? /* @__PURE__ */ f(
      "li",
      {
        className: "cxc-pagination__link cxc-pagination__item cxc-pagination__disabled",
        children: /* @__PURE__ */ f("span", { children: "…" })
      },
      m
    ) : /* @__PURE__ */ f(
      "li",
      {
        className: "cxc-pagination__item",
        onClick: () => r(p),
        onKeyDown: (_) => {
          (_.code === "Enter" || _.code === "Space") && r(p);
        },
        tabIndex: 0,
        children: /* @__PURE__ */ U(
          "a",
          {
            className: C(
              {
                "cxc-pagination--active": p === n
              },
              "cxc-pagination__link"
            ),
            "aria-current": "page",
            children: [
              /* @__PURE__ */ f("span", { className: "fds-hide--visually", children: "Page " }),
              " ",
              p
            ]
          }
        )
      },
      m
    )),
    /* @__PURE__ */ f("li", { className: "cxc-pagination__item", children: n !== h ? /* @__PURE__ */ U(
      "a",
      {
        className: "cxc-pagination__next",
        onClick: c,
        onKeyDown: (p) => {
          (p.code === "Enter" || p.code === "Space") && c();
        },
        tabIndex: 0,
        children: [
          s,
          /* @__PURE__ */ f("span", { className: "fds-hide--visually", children: " page" })
        ]
      }
    ) : /* @__PURE__ */ f(
      "span",
      {
        className: C(
          "cxc-pagination__next",
          "cxc-pagination__disabled"
        ),
        children: s
      }
    ) })
  ] }) });
};
Y0.displayName = "TablePagination";
const z0 = (n) => /* @__PURE__ */ f(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    color: "#fff",
    fill: "#FFFFFF",
    "aria-hidden": "false",
    focusable: !1,
    height: "24px",
    width: "24px",
    ...n,
    children: /* @__PURE__ */ f("path", { d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8l8-8z" })
  }
), X0 = ({
  active: n = !1,
  children: t,
  className: r,
  direction: a = "asc",
  hideSortIcon: i = !1,
  onClick: o,
  tableHeadClassName: s,
  accessibilityOptions: l = {
    header: {
      defaultAriaLabel: "sortable",
      sortedAscAriaLabel: "sorted",
      sortedDesAriaLabel: "sorted in reverse order"
    }
  },
  sortAlwaysVisible: d = !1,
  ...c
}) => {
  const {
    excludeTableHeaderLabel: u,
    defaultAriaLabel: h,
    sortedAscAriaLabel: p,
    sortedDesAriaLabel: m
  } = l.header, _ = a === "asc" ? p : m, T = `${u ? "" : `${typeof t == "string" ? t : t && t[0]}, `} ${n ? _ : h}`;
  return Y.useEffect(() => {
    const y = document.querySelector(
      `.${s} .cxc-table-sort-label--active`
    );
    y instanceof HTMLElement && y.focus();
  }), /* @__PURE__ */ U(
    "button",
    {
      className: C(
        d ? "cxc-table-sort-label cxc-table-sort-label-visible" : "cxc-table-sort-label",
        n && "cxc-table-sort-label--active",
        r
      ),
      "aria-disabled": !1,
      "aria-label": T,
      onClick: o,
      ...c,
      children: [
        t,
        i && !n ? null : /* @__PURE__ */ f(
          z0,
          {
            className: C(
              "cxc-table-sort-label__icon",
              a === "asc" && "cxc-table-sort-label__icon--direction-asc",
              (a === "desc" || a === "des") && "cxc-table-sort-label__icon--direction-desc"
            )
          }
        ),
        n && /* @__PURE__ */ f(
          "div",
          {
            role: "alert",
            "aria-live": "assertive",
            "aria-atomic": "true",
            style: {
              position: "absolute",
              height: "1px",
              width: "1px",
              overflow: "hidden"
            },
            children: /* @__PURE__ */ f("span", { children: T })
          }
        )
      ]
    }
  );
};
X0.displayName = "TableSortLabel";
const hi = () => /* @__PURE__ */ f(He, {}), ke = {
  COMPONENT: "js-fmc-tabs",
  HORIZONTAL: "fmc-tabs--horizontal",
  VERTICAL: "fmc-tabs--vertical",
  TAB_LIST_WRAPPER: "fmc-tabs__tablist-wrapper",
  TAB_LIST: "fmc-tabs__tablist",
  TAB: "fmc-tabs__tab",
  TAB_BORDER: "fmc-tabs__tab-border",
  TAB_PANELS: "fmc-tabs__tabpanels",
  TAB_PANEL: "fmc-tabs__tabpanel",
  HOVER: "fmc-tabs__tab--hover",
  ACTIVE: "fmc-tabs__tab--active",
  ACTIVE_PANEL: "fmc-tabs__tabpanel--active",
  FOCUSED_PANEL: "fmc-tabs__tabpanel--focus",
  FOCUSED: "fmc-tabs__tab--focused",
  VERTICAL_TAB: "cxc-vertical-tab"
  // Needed to support vertical tabs
}, Zn = {
  TABLIST_ROLE: "tablist",
  TAB_ROLE: "tab",
  TABPANEL_ROLE: "tabpanel",
  PANEL1_ID: "Panel1",
  PANEL2_ID: "Panel2",
  TAB_WIDTH: "60px"
}, pi = {
  UP: 38,
  DOWN: 40,
  LEFT: "ArrowLeft",
  RIGHT: "ArrowRight",
  TAB: "Tab",
  ENTER: 13,
  HOME: 36,
  END: 35
}, c2 = ({
  defaultActiveTabIndex: n,
  onTabChange: t,
  children: r,
  className: a,
  variant: i = "horizontal",
  ...o
}) => {
  const [s, l] = ee(0), [d, c] = ee(-1), [u, h] = ee([]), { width: p } = Er(), m = p < Vo, _ = Y.Children.toArray(
    r
  ), T = St(() => `tab_${ze("")}`, []), y = St(
    () => `tab_border_${ze("")}`,
    []
  );
  function v(w, D) {
    const W = typeof getComputedStyle == "function" ? getComputedStyle(D) : {
      paddingTop: "10",
      paddingBottom: "0"
    }, B = parseInt(
      typeof getComputedStyle == "function" ? W.getPropertyValue("padding-top") : W.paddingTop
    ), I = D.clientHeight - parseFloat(W.paddingTop) - parseFloat(W.paddingBottom), A = `${B + I + 10}px`;
    w.style.setProperty("top", A);
    const N = document.querySelectorAll(
      `.${ke.VERTICAL_TAB}`
    );
    for (let L = 0; L < N.length; L++)
      N[L].style.setProperty(
        "--hover-offset",
        A
      );
  }
  de(() => {
    (n && n !== s || n === 0) && l(n);
  }, [n]), de(() => {
    const w = () => {
      h(
        //@ts-ignore
        Y.Children.map(r, (D) => {
          if (D?.type === hi)
            return Do();
        })
      );
    };
    if (!m) {
      const D = () => {
        const H = document.querySelectorAll(`.${T}`)[s], W = document.querySelector(
          `.${y}`
        );
        !W || !H || (i === "vertical" && v(W, H), W.style.setProperty("transform", `translateX(${H.offsetLeft}px)`), W.style.setProperty("width", `${H.offsetWidth}px`), i === "vertical" && W.style.setProperty("transform", `translateY(${H.offsetTop}px)`), W.style.setProperty("display", "block"), W.style.setProperty("transition", "none"));
      };
      window.addEventListener("load", w), window.addEventListener("resize", w), window.addEventListener("load", D), w();
    }
  }, [r, s, m]), de(() => {
    (() => {
      const D = document.querySelectorAll(`.${T}`)[s], H = document.querySelector(
        `.${y}`
      );
      !H || !D || (i === "vertical" && v(H, D), H.style.setProperty("transition", "transform 0.3s linear"), H.style.setProperty("transform", `translateX(${D.offsetLeft}px)`), i === "vertical" && H.style.setProperty("transform", `translateY(${D.offsetTop}px)`), H.style.setProperty("width", `${D.offsetWidth}px`), H.style.setProperty("display", "block"));
    })();
  }, [s, u]);
  function g(w) {
    l(w), u[w]?.current.focus(), t?.(w);
  }
  function S(w) {
    c(w);
  }
  function b(w) {
    c(w);
  }
  function $(w) {
    switch (w.code) {
      case pi.RIGHT:
        w.preventDefault(), s === u.length - 1 ? (g(0), S(0)) : g(s + 1);
        break;
      case pi.LEFT:
        g(s === 0 ? u.length - 1 : s - 1);
        break;
      default:
        return;
    }
  }
  function P() {
    return Y.Children.map(
      _,
      (w, D) => w?.type === hi ? /* @__PURE__ */ f(
        "button",
        {
          className: C(
            ke.TAB,
            s === D && ke.ACTIVE,
            d === D && ke.HOVER,
            i === "vertical" && ke.VERTICAL_TAB,
            T
          ),
          role: Zn.TAB_ROLE,
          "aria-selected": s === D ? "true" : "false",
          "aria-controls": `FDShTabsImagesPanel${w.props.label.replace(
            /\s/g,
            ""
          )}`,
          id: `FDShTabsImagesTab${w.props.label.replace(/\s/g, "")}`,
          disabled: w.props.disabled,
          onClick: () => g(D),
          onMouseOver: () => S(D),
          onFocus: () => S(D),
          onMouseOut: () => b(D),
          onBlur: () => b(D),
          onKeyUp: $,
          ref: u[D],
          tabIndex: s === D ? 0 : -1,
          children: w.props.label
        },
        `FDShTabsImagesTab${w.props.label.replace(/\s/g, "")}`
      ) : null
    );
  }
  function G() {
    const w = _[s];
    return w ? /* @__PURE__ */ f(
      "div",
      {
        id: `FDShTabsImagesPanel${w.props.label.replace(
          /\s/g,
          ""
        )}`,
        className: C(
          ke.TAB_PANEL,
          ke.ACTIVE_PANEL,
          "fds-color--gray3"
        ),
        role: Zn.TABPANEL_ROLE,
        "aria-labelledby": `FDShTabsImagesTab${w.props.label.replace(
          /\s/g,
          ""
        )}`,
        children: w.props.children
      }
    ) : null;
  }
  return /* @__PURE__ */ U(
    "div",
    {
      className: C(
        ke.COMPONENT,
        ke.TAB_LIST_WRAPPER,
        "fmc-tabs",
        a
      ),
      ...o,
      children: [
        /* @__PURE__ */ f("div", { className: C(ke.TAB_LIST_WRAPPER), children: /* @__PURE__ */ U(
          "div",
          {
            className: C(ke.TAB_LIST),
            role: Zn.TABLIST_ROLE,
            "aria-label": "Features",
            style: { flexDirection: i === "vertical" ? "column" : "row" },
            children: [
              P(),
              /* @__PURE__ */ f(
                "span",
                {
                  className: C(ke.TAB_BORDER, y)
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ f("div", { className: C(ke.TAB_PANELS, "fds-color--gray3"), children: G() })
      ]
    }
  );
}, Qe = {
  COMPONENT: "fmc-toggle",
  SKEUOMORPHIC: "fmc-toggle--skeuomorphic",
  LABEL: "fmc-toggle__label",
  TRACK: "fmc-toggle__track",
  CHECKED_VALUE: "fmc-toggle__checked-option",
  UNCHECKED_VALUE: "fmc-toggle__unchecked-option",
  FOCUSED: "cxc-toggle__focused",
  INPUT_WRAPPER: "cxc-toggle__input-wrapper"
}, u2 = ({
  checked: n,
  disabled: t = !1,
  labelText: r,
  optionTextinTrack: a = !1,
  onChange: i,
  checkedTitle: o = "On",
  unCheckedTitle: s = "Off",
  enableValidation: l = !1,
  className: d,
  labelHidden: c = !1,
  role: u,
  hideCheckedLabelSC: h = !1,
  validationMessageType: p = "error",
  ...m
}) => {
  const [_, T] = ee(!1), y = (g) => {
    switch (g.key) {
      case "Tab":
        T(!0);
        break;
      case "Enter":
      case "Space":
        i && i();
        break;
    }
  }, v = () => {
    T(!1);
  };
  return /* @__PURE__ */ U(
    "label",
    {
      className: C(
        Qe.COMPONENT,
        Qe.SKEUOMORPHIC,
        _ && Qe.FOCUSED,
        d
      ),
      "aria-disabled": t,
      children: [
        r ? /* @__PURE__ */ f("span", { style: { visibility: c ? "hidden" : void 0, position: c ? "absolute" : void 0 }, "aria-hidden": "false", className: C(Qe.LABEL), children: r }) : null,
        a ? null : /* @__PURE__ */ f("span", { "aria-hidden": h ? "true" : void 0, className: C(Qe.UNCHECKED_VALUE), children: s }),
        /* @__PURE__ */ f(
          "input",
          {
            id: "ToggleDefault",
            "data-testid": "toggle",
            type: "checkbox",
            disabled: t,
            checked: n,
            onKeyUp: y,
            onBlur: v,
            onChange: i,
            role: u
          }
        ),
        /* @__PURE__ */ U("span", { className: C(Qe.TRACK), children: [
          a ? /* @__PURE__ */ f("span", { "aria-hidden": h ? "true" : void 0, className: C(Qe.CHECKED_VALUE), children: o.substring(0, 4) }) : null,
          a ? /* @__PURE__ */ f("span", { "aria-hidden": h ? "true" : void 0, className: C(Qe.UNCHECKED_VALUE), children: s.substring(0, 4) }) : null
        ] }),
        a ? null : /* @__PURE__ */ f("span", { "aria-hidden": h ? "true" : void 0, className: C(Qe.CHECKED_VALUE), children: o }),
        l && /* @__PURE__ */ f(
          gi,
          {
            validationMessageType: p,
            ...m
          }
        )
      ]
    }
  );
}, ge = {
  COMPONENT: "js-fmc-tooltip",
  TOOLTIP: "fmc-tooltip",
  POPUP_TOOLTIP: "fmc-tooltip--popup",
  TRIGGER: "fmc-tooltip__trigger",
  CONTENT: "fmc-tooltip__content",
  WRAPPER: "fmc-tooltip__wrapper",
  POINTER: "fmc-tooltip__pointer",
  POINTER_FIX: "fmc-tooltip__pointer-fix",
  OPENED: "fmc-tooltip--opened",
  FOCUSED: "fmc-tooltip--focused",
  TOP: "fmc-tooltip--top",
  RIGHT: "fmc-tooltip--right",
  BOTTOM: "fmc-tooltip--bottom",
  LEFT: "fmc-tooltip--left",
  MEASURE: "fmc-tooltip__content--measure",
  CLOSE_BTN: "fmc-tooltip__close",
  CLEAR_ICON: "fds-font--ford-icons__clear",
  FDS_ICON: "fds-icon",
  HEADER: "fmc-tooltip__header",
  BODY: "fmc-tooltip__body",
  MOBILE: "fmc-tooltip--mobile"
}, Jn = 1023, q0 = ({
  className: n,
  position: t = "auto",
  tooltipContent: r,
  isPopupTip: a = !1,
  popupTipHeader: i,
  popupTipBody: o,
  uniqueIdentifier: s = "tooltip-unique-identifier",
  children: l,
  closeOnOutsideClick: d = !1,
  onClose: c
}) => {
  const [u, h] = ee(!1), [p, m] = ee(!1), [_, T] = ee(null), y = le(null), v = le(null), g = le(null), S = le(null), b = le(null);
  let $;
  de(() => {
    t === "auto" && B(), a && window.addEventListener("resize", A);
  }, []), yr(() => {
    a && window.innerWidth < Jn && m(!0);
  }, [g]);
  const P = (N) => {
    N.key === "Escape" && W();
  }, G = (N) => {
    N.key === "Tab" && (a || H());
  }, w = () => {
    u ? W() : (I(), H());
  }, D = () => {
    W(), S.current?.focus();
  }, H = () => {
    I(), h(!0);
  }, W = Po(() => {
    h(!1), a && c && c();
  }, [c, a]);
  de(() => {
    if (d) {
      const N = (L) => {
        if (y.current && !y.current.contains(L.target)) {
          const E = document.querySelector("body");
          E.style.setProperty("overflow", "unset"), E.style.setProperty("pointer-events", "unset"), u && W();
        }
      };
      return window.addEventListener("click", N), () => {
        window.removeEventListener("click", N);
      };
    } else
      return;
  }, [u, W]), de(() => {
    u && b.current && b.current.focus();
  }, [u]);
  const B = () => {
    if (y.current?.classList.add(ge.TOP), T("top"), !v.current)
      return;
    let N = v.current.getBoundingClientRect();
    N.top < 0 && (N = v.current.getBoundingClientRect(), y.current?.classList.remove(ge.TOP), y.current?.classList.add(ge.RIGHT), T("right")), N.right > window.innerWidth && (N = v.current.getBoundingClientRect(), y.current?.classList.remove(ge.RIGHT, ge.TOP), y.current?.classList.add(ge.BOTTOM), T("bottom")), N.bottom > window.innerHeight && N.right > window.innerWidth && (N = v.current.getBoundingClientRect(), y.current?.classList.remove(ge.RIGHT, ge.TOP, ge.BOTTOM), y.current?.classList.add(ge.LEFT), T("left"));
  }, I = async () => {
    if (g.current) {
      g.current.style.removeProperty("top"), g.current.style.removeProperty("right"), g.current.style.removeProperty("bottom"), g.current.style.removeProperty("left");
      const N = g.current.getBoundingClientRect();
      window.innerWidth <= Jn || (N.top < 0 ? g.current.style.top = `${Math.abs(N.top)}px` : g.current.style.removeProperty("top"), window.innerWidth - N.right < 0 ? g.current.style.right = `${Math.abs(
        window.innerWidth - N.right
      )}px` : g.current.style.removeProperty("right"), N.bottom > window.innerHeight ? g.current.style.bottom = `${Math.abs(
        N.bottom - window.innerHeight
      )}px` : g.current.style.removeProperty("bottom"), N.left < 0 ? g.current.style.left = `${Math.abs(N.left)}px` : g.current.style.removeProperty("left"));
    }
  }, A = () => {
    a && window.innerWidth <= Jn ? m(!0) : m(!1);
  };
  return a && ($ = [
    /* @__PURE__ */ f(
      "div",
      {
        id: `${s}-header`,
        className: ge.HEADER,
        children: i
      },
      "header"
    ),
    /* @__PURE__ */ f(
      "div",
      {
        id: `${s}-body`,
        className: ge.BODY,
        children: o
      },
      "body"
    ),
    /* @__PURE__ */ f(
      "button",
      {
        className: C(
          ge.CLOSE_BTN,
          ge.CLEAR_ICON,
          ge.FDS_ICON
        ),
        "aria-label": "close tooltip",
        onClick: D,
        ref: b
      },
      "close"
    )
  ]), // eslint-disable-next-line
  /* @__PURE__ */ U(
    "div",
    {
      className: C(
        ge.COMPONENT,
        ge.TOOLTIP,
        a && ge.POPUP_TOOLTIP,
        u && ge.OPENED,
        p && ge.MOBILE,
        (t === "top" || _ === "top") && ge.TOP,
        (t === "bottom" || _ === "bottom") && ge.BOTTOM,
        (t === "left" || _ === "left") && ge.LEFT,
        (t === "right" || _ === "right") && ge.RIGHT,
        n
      ),
      "data-slug": s,
      "data-position": t,
      onKeyUp: () => P,
      ref: y,
      children: [
        /* @__PURE__ */ f(
          "button",
          {
            className: ge.TRIGGER,
            "aria-describedby": a ? void 0 : s,
            onClick: a ? w : void 0,
            onKeyUp: () => G,
            onMouseOver: a ? void 0 : H,
            onMouseOut: a ? void 0 : W,
            onBlur: a ? void 0 : W,
            ref: S,
            type: "button",
            children: l
          }
        ),
        /* @__PURE__ */ U(
          "div",
          {
            id: s,
            className: ge.WRAPPER,
            role: a ? "dialog" : "tooltip",
            "aria-hidden": !u,
            "aria-modal": a ? "true" : void 0,
            "aria-labelledby": a ? `${s}-header` : void 0,
            "aria-describedby": a ? `${s}-body` : void 0,
            ref: v,
            children: [
              /* @__PURE__ */ U("div", { className: ge.CONTENT, ref: g, children: [
                !a && r,
                a && $
              ] }),
              /* @__PURE__ */ f("span", { className: ge.POINTER, children: /* @__PURE__ */ f("span", { className: ge.POINTER_FIX }) })
            ]
          }
        )
      ]
    }
  );
}, Ee = {
  COMPONENT: "js-fmc-overflow-menu",
  OVERFLOW_MENU: "fmc-overflow-menu",
  POPUP_OVERFLOW_MENU: "fmc-overflow-menu--popup",
  TRIGGER: "fmc-overflow-menu__trigger",
  CONTENT: "fmc-overflow-menu__content",
  WRAPPER: "fmc-overflow-menu__wrapper",
  POINTER: "fmc-overflow-menu__pointer",
  POINTER_FIX: "fmc-overflow-menu__pointer-fix",
  OPENED: "fmc-overflow-menu--opened",
  FOCUSED: "fmc-overflow-menu--focused",
  TOP: "fmc-overflow-menu--top",
  RIGHT: "fmc-overflow-menu--right",
  BOTTOM: "fmc-overflow-menu--bottom",
  LEFT: "fmc-overflow-menu--left",
  MEASURE: "fmc-overflow-menu--measure",
  CLOSE_BTN: "fmc-overflow-menu",
  CLEAR_ICON: "fds-font--ford-icons__clear",
  FDS_ICON: "fds-icon",
  MOBILE: "fmc-overflow-menu--mobile",
  DIVIDER: "fmc-overflow-menu__divider"
}, Z0 = 600;
const f2 = ({
  overflowMenuIcon: n,
  children: t,
  position: r = "auto",
  uniqueIdentifier: a = "overflowmenu-unique-identifier"
}) => {
  const [i, o] = ee(!1), [s, l] = ee(null), d = le(null), c = le(null), u = le(null), h = le(null), p = () => {
    i ? T() : _();
  }, m = (g) => {
    g.key === "Tab" && _();
  }, _ = () => {
    y(), o(!0);
  }, T = Y.useCallback(() => {
    o(!1);
  }, []), y = async () => {
    if (u.current) {
      u.current.style.removeProperty("top"), u.current.style.removeProperty("right"), u.current.style.removeProperty("bottom"), u.current.style.removeProperty("left");
      const g = u.current.getBoundingClientRect();
      window.innerWidth <= Z0 || (g.top < 0 ? u.current.style.top = `${Math.abs(g.top)}px` : u.current.style.removeProperty("top"), window.innerWidth - g.right < 0 ? u.current.style.right = `${Math.abs(
        window.innerWidth - g.right
      )}px` : u.current.style.removeProperty("right"), g.bottom > window.innerHeight ? u.current.style.bottom = `${Math.abs(
        g.bottom - window.innerHeight
      )}px` : u.current.style.removeProperty("bottom"), g.left < 0 ? u.current.style.left = `${Math.abs(g.left)}px` : u.current.style.removeProperty("left"));
    }
  };
  de(() => {
    const g = (S) => {
      d.current && !d.current.contains(S.target) && i && T();
    };
    return window.addEventListener("click", g), () => {
      window.removeEventListener("click", g);
    };
  }, [i, T]);
  const v = () => {
    if (d.current?.classList.add(Ee.TOP), l("top"), !c.current)
      return;
    let g = c.current.getBoundingClientRect();
    c.current.offsetTop < 0 && (g = c.current.getBoundingClientRect(), d.current?.classList.remove(Ee.TOP), d.current?.classList.add(Ee.RIGHT), l("right")), g.right > window.innerWidth && (g = c.current.getBoundingClientRect(), d.current?.classList.remove(Ee.RIGHT, Ee.TOP), d.current?.classList.add(Ee.BOTTOM), l("bottom")), g.bottom > window.innerHeight && g.right > window.innerWidth && (g = c.current.getBoundingClientRect(), d.current?.classList.remove(Ee.RIGHT, Ee.TOP, Ee.BOTTOM), d.current?.classList.add(Ee.LEFT), l("left"));
  };
  return de(() => {
    r === "auto" && v();
  }, []), /* @__PURE__ */ U(
    "div",
    {
      className: C(
        Ee.COMPONENT,
        Ee.OVERFLOW_MENU,
        i && Ee.OPENED,
        (r === "top" || s === "top") && Ee.TOP,
        (r === "bottom" || s === "bottom") && Ee.BOTTOM,
        (r === "left" || s === "left") && Ee.LEFT,
        (r === "right" || s === "right") && Ee.RIGHT
      ),
      "data-slug": a,
      "data-position": r,
      ref: d,
      children: [
        /* @__PURE__ */ f(
          "button",
          {
            className: Ee.TRIGGER,
            "aria-describedby": a,
            onKeyUp: () => m,
            onClick: p,
            type: "button",
            ref: h,
            children: n
          }
        ),
        /* @__PURE__ */ U(
          "div",
          {
            id: a,
            className: Ee.WRAPPER,
            role: "menu",
            "aria-hidden": !i,
            ref: c,
            children: [
              /* @__PURE__ */ f("ul", { className: Ee.CONTENT, children: t }),
              /* @__PURE__ */ f("span", { className: Ee.POINTER, children: /* @__PURE__ */ f("span", { className: Ee.POINTER_FIX }) })
            ]
          }
        )
      ]
    }
  );
}, J0 = {
  COMPONENT: "cxc-overflow-menu-item"
}, h2 = ({
  onClick: n,
  children: t
}) => /* @__PURE__ */ f(
  "li",
  {
    className: J0.COMPONENT,
    tabIndex: 0,
    onKeyDown: (r) => {
      (r.code === "Space" || r.code === "Enter") && n();
    },
    children: /* @__PURE__ */ f("div", { className: "item-text", onClick: n, children: t })
  }
), p2 = () => /* @__PURE__ */ f("div", { className: Ee.DIVIDER }), mi = {
  SLIDER: "fmc-slider",
  SLIDER_INPUT: "fmc-slider__input"
}, Q0 = "SLIDER_DATA_TEST_ID", e1 = "Slider", m2 = ({
  label: n,
  min: t,
  max: r,
  value: a,
  step: i,
  onChange: o,
  name: s,
  id: l,
  dataTestId: d = Q0
}) => {
  const [c, u] = ee(a || t), h = le(ze(l ?? e1));
  de(() => {
    typeof a == "number" && u(a);
  }, [a]);
  const p = (m) => {
    u(m.target.value), o && o(m, m.target.value);
  };
  return /* @__PURE__ */ U("div", { className: mi.SLIDER, role: "group", children: [
    /* @__PURE__ */ f("label", { htmlFor: h.current, id: `${h.current}-slider`, children: n }),
    /* @__PURE__ */ f(
      "input",
      {
        className: mi.SLIDER_INPUT,
        type: "range",
        id: h.current,
        "data-testid": d,
        name: s,
        min: t,
        max: r,
        value: c,
        step: i,
        onChange: p,
        "aria-labelledby": `${h.current}-slider`
      }
    )
  ] });
}, wn = Y.createContext({});
wn.displayName = "TrackerContext";
const be = {
  TRACKER: "fmc-tracker",
  EDIT_ICON: "fds-font--ford-icons__edit",
  SUCCESS_ICON: "fds-font--ford-icons__success",
  PAST_STEP: "fmc-tracker__step--complete",
  DOT_FILLED: "fmc-tracker__dot--filled",
  DISABLED_STEP: "fds__step--disabled",
  SIMPLE_TRACKER: "fmc-tracker--simple",
  TRACKER_TITLE_DISABLED: "fmc-tracker__title--disabled",
  TRACKER_TITLE_FUTURE: "fmc-tracker__title--future",
  TRACKER_STEP_DOT: "fmc-tracker__dot",
  TRACKER_STEP_ACTIVE_DOT: "fmc-tracker__dot--active",
  TRACKER_STEP_FILLED_DOT: "fmc-tracker__dot--filled cxc-tracker__dot--filled",
  TRACKER_STEP_SUCCESS_DOT: "fmc-tracker__dot--success",
  TRACKER_STEP_HOVER_DOT: "fds__step--hover",
  TRACKER_STEP_DISABLED_DOT: "fds__step--disabled",
  TRACKER_STEP_SIMPLE_DOT: "cxc-tracker__dot-simple",
  TRACKER_STEP_DIRTY_DOT: "cxc-tracker__dot--dirty",
  TRACKER_STEP_ICON: "cxc-tracker__dot_icon",
  TRACKER_STEP: "fmc-tracker__step",
  TRACKER_STEP_CURRENT: "fmc-tracker__step--current",
  TRACKER_STEP_COMPLETE: "fmc-tracker__step--complete",
  TRACKER_STEP_TOOOLTIP: "cxc-tracker__simple__step__tooltip",
  TRACKER_STEP_TOOOLTIP_VERTICAL: "cxc-tracker__simple__step__tooltip__vertical",
  TRACKER_STEP_CONTENT: "fmc-tracker__step__content",
  TRACKER_STEP_LABEL: "fmc-tracker__title",
  TRACKER_STEP_LABEL_VERTICAL: "cxc-tracker__title--vertical",
  VERTICAL_TRACKER: "cxc-tracker__vertical",
  VERTICAL_TRACKER_ANIMATION: "cxc-tracker__vertical__animation",
  VERTICAL_TRACKER_TITLE: "cxc-tracker__title--vertical"
}, t1 = "TRACKER_WRAPPER_ELEMENT_DATA_TEST_ID", n1 = ({
  disabled: n = !1,
  type: t = "progress",
  nonLinear: r = !1,
  animation: a = !1,
  children: i,
  orientation: o = "horizontal",
  activeStep: s,
  className: l
}) => {
  const d = o === "horizontal", c = t === "simple", [u, h] = Y.useState([]), [p, m] = Y.useState(0), _ = Y.useRef([]), T = i.type === Y.Fragment ? i.props.children : i, y = Y.Children.map(
    T,
    (b, $) => b.type.displayName === "TrackerStep" ? Y.cloneElement(b, {
      _stepIndex: $,
      disabled: n || b.props.disabled,
      ref: (P) => _.current[$] = P
    }) : Y.cloneElement(b, {
      ref: (P) => _.current[$] = P
    })
  );
  Y.useEffect(() => {
    if (a) {
      const b = [];
      for (let $ = 0; $ < y.length; $++)
        d ? b.push(
          _.current[$]?.getBoundingClientRect().width
        ) : b.push(
          _.current[$]?.getBoundingClientRect().height
        );
      h(b);
    }
    s > p && m(s);
  }, [_, s]);
  const v = T[s]?.props?.children?.find(
    (b) => b.type.displayName === "TrackerStepContent"
  ), g = a ? d ? {
    left: `calc(50% - (${u[s]}px / 2) - ${u.reduce(
      (b, $, P) => b + (P < s ? $ : 0),
      0
    )}px)`,
    transition: "left 0.3s ease-in-out"
  } : {
    top: `calc(50% - (${u[s]}px / 2) - ${u.reduce(
      (b, $, P) => b + (P < s ? $ : 0),
      0
    )}px)`,
    transition: "top 0.3s ease-in-out"
  } : {}, S = /* @__PURE__ */ f(
    "ul",
    {
      style: g,
      className: C(
        be.TRACKER,
        !d && be.VERTICAL_TRACKER,
        a && !d && be.VERTICAL_TRACKER_ANIMATION,
        c && be.SIMPLE_TRACKER,
        l
      ),
      "data-testid": t1,
      children: y
    },
    "TRACKER_STEPS_WRAPPER"
  );
  return /* @__PURE__ */ U(
    wn.Provider,
    {
      value: {
        activeStep: s,
        numberOfSteps: y.length,
        isHorizontal: d,
        type: t,
        nonLinear: r,
        highestViewedStep: p
      },
      children: [
        S,
        d && v
      ]
    }
  );
};
n1.displayName = "Tracker";
const r1 = "STEP_LABEL_DATA_TEST_ID", Io = ({
  children: n,
  className: t,
  dataTestId: r = r1
}) => {
  const { isHorizontal: a } = Y.useContext(wn), i = ["number", "string"].includes(typeof n) ? "p" : "div";
  return /* @__PURE__ */ f(
    i,
    {
      className: C(
        be.TRACKER_STEP_LABEL,
        !a && be.TRACKER_STEP_LABEL_VERTICAL,
        t
      ),
      "data-testid": r,
      children: n
    }
  );
};
Io.displayName = "TrackerStepLabel";
const a1 = "TRACKER_STEP_ICON_ELEMENT_DATA_TEST_ID", i1 = "BUTTON_DATA_TEST_ID", o1 = "TRACKER_STEP_LABEL_TEST_ID", s1 = Y.forwardRef(
  ({
    key: n,
    _stepIndex: t,
    disabled: r,
    onClick: a,
    children: i,
    completed: o,
    editable: s = !1,
    className: l,
    dataTestId: d = "TRACKER_STEP_DATA_TEST_ID"
  }, c) => {
    const {
      isHorizontal: u,
      activeStep: h,
      type: p,
      numberOfSteps: m,
      nonLinear: _,
      highestViewedStep: T
    } = wo(wn), y = h === t, v = h > t, g = h < t, S = o === void 0 ? v : o, b = v || S, $ = p === "simple", P = p !== "simple" && t <= T && !y && !S, [G, w] = ee(!1);
    de(() => {
      s && S && (w(!0), setTimeout(() => w(!1), 300));
    }, [S]);
    const D = Array.isArray(i) ? i : [i], H = D.find(
      (X) => X.type?.displayName === "TrackerStepContent"
    ), W = ["number", "string", "boolean"].includes(
      typeof i
    ) ? /* @__PURE__ */ f(Io, { children: i }) : Y.Children.map(
      D.filter(
        (X) => X.type.displayName !== "TrackerStepContent"
      ),
      (X) => X.type.displayName === "TrackerStepLabel" ? Y.cloneElement(X, {
        className: C(
          r && be.TRACKER_TITLE_DISABLED,
          g && be.TRACKER_TITLE_FUTURE,
          X.props.className
        )
      }) : X
    ), B = () => $ ? !1 : b || P || y, I = () => y && !o && !s || y && s ? "edit" : P ? "warning-filled" : s && !G ? "edit" : "success", A = B() ? /* @__PURE__ */ f(
      Zt,
      {
        name: I(),
        dataTestId: `${a1}_${t}`,
        className: be.TRACKER_STEP_ICON
      }
    ) : $ ? "" : p === "timeline" ? t + 1 : `${t + 1}/${m}`, N = `${t + 1} of ${m}`, L = _ || s && v || $ && v, E = /* @__PURE__ */ f(
      "button",
      {
        className: C(
          be.TRACKER_STEP_DOT,
          y && be.TRACKER_STEP_ACTIVE_DOT,
          b && be.TRACKER_STEP_FILLED_DOT,
          v && be.TRACKER_STEP_SUCCESS_DOT,
          L && be.TRACKER_STEP_HOVER_DOT,
          r && be.TRACKER_STEP_DISABLED_DOT,
          $ && be.TRACKER_STEP_SIMPLE_DOT,
          P && be.TRACKER_STEP_DIRTY_DOT
        ),
        disabled: r,
        onClick: L ? (X) => a?.(X) : void 0,
        "aria-label": S ? "Complete" : void 0,
        "aria-current": y ? "step" : void 0,
        "data-testid": `${i1}_${t}`,
        children: A
      }
    ), x = /* @__PURE__ */ f(
      q0,
      {
        className: C(
          be.TRACKER_STEP_TOOOLTIP,
          !u && be.TRACKER_STEP_TOOOLTIP_VERTICAL
        ),
        position: "top",
        tooltipContent: N,
        children: E
      }
    );
    return /* @__PURE__ */ U(
      "li",
      {
        className: C(
          be.TRACKER_STEP,
          y && be.TRACKER_STEP_CURRENT,
          v && be.TRACKER_STEP_COMPLETE,
          l
        ),
        "data-testid": d,
        ref: c,
        children: [
          $ ? x : E,
          /* @__PURE__ */ U("div", { "data-testid": `${o1}_${t}`, children: [
            W,
            y && !u && H
          ] })
        ]
      },
      n
    );
  }
);
s1.displayName = "TrackerStep";
const l1 = "TRACKER_STEP_CONTENT_DATA_TEST_ID", d1 = ({
  children: n,
  className: t,
  dataTestId: r = l1
}) => /* @__PURE__ */ f(
  "div",
  {
    "data-testid": r,
    className: C(be.TRACKER_STEP_CONTENT, t),
    children: n
  }
);
d1.displayName = "TrackerStepContent";
const c1 = 7e3, $2 = () => {
  const [n, t] = re.useState(""), [r, a] = ee(void 0), i = le(null), o = () => {
    t(""), a(void 0);
  }, s = (c = "   Success ✔︎") => {
    t(c), a("success");
  };
  return {
    validationMessage: n,
    validationMessageType: r,
    clearValidation: o,
    setValidationSuccess: s,
    setValidationError: (c = "An error occurred") => {
      t(c), a("error");
    },
    setTimedValidationSuccess: (c = c1) => {
      i.current && clearTimeout(i.current), s(), i.current = setTimeout(() => {
        t("");
      }, c);
    }
  };
}, u1 = ({ title: n, ...t }) => /* @__PURE__ */ U("svg", { width: 24, height: 24, viewBox: "-32 0 512 512", ...t, children: [
  n && /* @__PURE__ */ f("title", { children: n }),
  /* @__PURE__ */ f("path", { d: "M433.941 65.941l-51.882-51.882A48 48 0 00348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 00-14.059-33.941zM266 464H54a6 6 0 01-6-6V150a6 6 0 016-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 01-6 6zm128-96H182a6 6 0 01-6-6V54a6 6 0 016-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 01-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 011.757 4.243V112z" })
] });
const _2 = ({
  label: n,
  copyContent: t,
  className: r
}) => {
  const a = {
    WRAPPER: "fds-copy-to-clipboard",
    LABEL: "fds-copy-label"
  };
  function i() {
    navigator.clipboard.writeText(t);
  }
  return /* @__PURE__ */ U(
    "div",
    {
      className: C(a.WRAPPER, r),
      onClick: i,
      onKeyDown: (o) => {
        o.code === "Enter" && i();
      },
      tabIndex: 0,
      children: [
        n && /* @__PURE__ */ f("span", { className: C(a.LABEL), children: n }),
        /* @__PURE__ */ f(u1, {})
      ]
    }
  );
};
export {
  m1 as Accordion,
  $1 as AccordionPanel,
  T1 as Badge,
  P1 as BannerNotification,
  gt as BaseTextField,
  E1 as Billboard,
  I1 as BillboardCarousel,
  Nl as BreadcrumbItem,
  Sl as BreadcrumbLink,
  L1 as Breadcrumbs,
  Bl as Calendar,
  x1 as CalendarPicker,
  k1 as CanadaPopUp,
  b1 as Card,
  C1 as CardAlert,
  R1 as CardCarousel,
  N1 as CardContent,
  ps as CardGroup,
  S1 as CardImageMedia,
  A1 as CardOverflowMenu,
  O1 as CardVideoMedia,
  D1 as Carousel,
  Cc as Checkbox,
  V1 as CheckboxForDropdown,
  G1 as CheckboxGroup,
  _1 as CircularActivityIndicator,
  Mo as Collapse,
  _2 as CopyToClipboard,
  W1 as CurrencyTextField,
  o2 as CurrencyTextField2,
  lc as Dialog,
  dc as DialogContent,
  F1 as DialogImage,
  M1 as DialogVideo,
  B1 as Divider,
  K1 as Dropdown,
  H1 as FilterChip,
  U1 as FilterChipGroup,
  v1 as FloatingActionButton,
  Zt as Icon,
  y1 as IconButton,
  l2 as InfoModal,
  g1 as LinearActivityIndicator,
  s2 as LinkWrapper,
  Cr as MediaDisclosureButton,
  f2 as OverflowMenu,
  p2 as OverflowMenuDivider,
  h2 as OverflowMenuItem,
  Tc as PasswordField,
  z1 as PhoneTextField,
  R0 as PhoneTextField2,
  n2 as PostalCodeTextField,
  a2 as PostalCodeTextField2,
  t2 as PredictiveSearchField,
  Ot as PrimaryButton,
  j1 as Radio,
  Y1 as RadioGroup,
  Q1 as SearchBar,
  Ti as SecondaryButton,
  e2 as Select,
  m2 as Slider,
  Ot as StandardButton,
  hi as Tab,
  B0 as Table,
  W0 as TableBody,
  U0 as TableCell,
  k0 as TableContainer,
  K0 as TableHead,
  Y0 as TablePagination,
  V0 as TableRow,
  X0 as TableSortLabel,
  c2 as Tabs,
  Ti as TextButton,
  gt as TextField,
  u2 as Toggle,
  q0 as Tooltip,
  n1 as Tracker,
  s1 as TrackerStep,
  d1 as TrackerStepContent,
  Io as TrackerStepLabel,
  ls as Typography,
  gi as ValidationMessage,
  Je as classes,
  i2 as getCurrencyObject,
  Z1 as isPossiblePhoneNumber,
  J1 as isValidNumberForRegion,
  q1 as isValidPhoneNumber,
  r2 as isValidPostalCode,
  X1 as parsePhoneNumber,
  Ie as secondaryButtonClasses,
  Ie as textButtonClasses,
  w1 as useBannerNotification,
  d2 as useModal,
  $2 as useValidationMessage,
  Er as useWindowDimensions
};
